export const KimbalLogoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={186}
    height={38}
    fill="none"
    {...props}
  >
    <path
      fill="#0081FF"
      d="M75.704 6.796h-4.59v4.973h4.59V6.796ZM63.234 6.796l-8.308 12.396h-8.623V6.796h-4.59v29.037h4.59V23.699h8.695l8.208 12.134h5.434l-9.896-14.701 9.939-14.336h-5.449ZM75.704 14.292h-4.59v21.555h4.59V14.292ZM113.613 15.022a8.47 8.47 0 0 0-4.59-1.167 8.502 8.502 0 0 0-4.376 1.02 7.272 7.272 0 0 0-2.688 2.611 10.324 10.324 0 0 0-1.23 3.486h-.272a10.933 10.933 0 0 0-.744-2.698 7.414 7.414 0 0 0-2.688-3.223 7.903 7.903 0 0 0-4.533-1.181 8.637 8.637 0 0 0-4.333.977 7.007 7.007 0 0 0-2.588 2.566 10.035 10.035 0 0 0-1.173 3.37h-.257v-6.505h-4.205v21.555h4.59v-10.66a8.709 8.709 0 0 1 1.36-5.353 5.596 5.596 0 0 1 4.747-1.852c.786-.088 1.573 0 2.33.247a5.675 5.675 0 0 1 2.046 1.182 6.844 6.844 0 0 1 1.33 4.652v11.799h4.533V25.187a8.598 8.598 0 0 1 1.373-5.353 5.71 5.71 0 0 1 2.159-1.487 5.764 5.764 0 0 1 2.574-.365c.786-.087 1.601 0 2.359.248a5.796 5.796 0 0 1 2.074 1.181 6.842 6.842 0 0 1 1.33 4.653v11.798h4.533V22.897a11.53 11.53 0 0 0-.901-4.652 7.414 7.414 0 0 0-2.746-3.209l-.014-.014ZM140.44 15.27a10.065 10.065 0 0 0-5.448-1.415 8.813 8.813 0 0 0-5.906 1.852 8.098 8.098 0 0 0-2.789 4.506h-.257V6.796h-4.733v29.051h4.204V29.65h.314a7.941 7.941 0 0 0 2.918 4.93 9.552 9.552 0 0 0 5.863 1.706 10.626 10.626 0 0 0 5.677-1.415c1.53-.919 2.731-2.304 3.489-3.937a15.511 15.511 0 0 0 1.158-5.863c0-2.013-.4-4.01-1.158-5.863a8.886 8.886 0 0 0-3.318-3.923l-.014-.015Zm-.844 13.883a4.72 4.72 0 0 1-2.431 2.246c-1.258.467-2.588.7-3.918.642a9.7 9.7 0 0 1-3.904-.7c-1.058-.438-1.93-1.24-2.502-2.246a7.266 7.266 0 0 1-.873-3.704v-.35a6.543 6.543 0 0 1 .358-2.771 6.583 6.583 0 0 1 1.459-2.363 7.866 7.866 0 0 1 5.448-1.721 9.892 9.892 0 0 1 3.832.67 5.061 5.061 0 0 1 2.431 2.203 8.499 8.499 0 0 1 .83 4.113 8.48 8.48 0 0 1-.73 3.981ZM165.923 6.796h-13.171l-2.231 2.275v1.05h13.171l2.231-2.275v-1.05ZM163.935 15.007a11.547 11.547 0 0 0-5.449-1.152 13.438 13.438 0 0 0-5.748 1.108 8.91 8.91 0 0 0-3.632 3.078 7.93 7.93 0 0 0-1.273 4.39v.189h4.547v-.19a4.099 4.099 0 0 1 .286-1.895 3.873 3.873 0 0 1 1.144-1.532 7.608 7.608 0 0 1 4.39-1.035 6.822 6.822 0 0 1 4.305 1.05c.457.496.8 1.079 1.015 1.706.214.627.3 1.313.229 1.998v1.254l-9.595 1.036c-1.245.131-2.46.437-3.633.904a5.793 5.793 0 0 0-2.359 1.852 4.813 4.813 0 0 0-.83 2.859c-.028.802.129 1.59.458 2.304a4.89 4.89 0 0 0 1.473 1.823 8.233 8.233 0 0 0 5.205 1.502c2.102.088 4.19-.437 6.006-1.531a7.598 7.598 0 0 0 3.246-4.273h.315v5.381h4.204V22.737a9.726 9.726 0 0 0-1.058-4.609 7.657 7.657 0 0 0-3.289-3.135l.043.014Zm-4.104 17.253a12.852 12.852 0 0 1-4.205.627 5.131 5.131 0 0 1-2.86-.627 2.048 2.048 0 0 1-.686-.802 2.216 2.216 0 0 1-.229-1.05c-.043-.365.029-.73.172-1.05.143-.321.4-.598.701-.802a7.148 7.148 0 0 1 2.674-.875l8.265-.948a5.488 5.488 0 0 1-1.015 3.456 6.055 6.055 0 0 1-2.789 2.056l-.028.015ZM176.805 6.796h-4.59v29.051h4.59V6.796ZM182.239 6.884a3.928 3.928 0 0 1-1.816-.438 3.182 3.182 0 0 1-1.287-1.225 3.719 3.719 0 0 1-.444-1.78c0-.612.158-1.239.444-1.778.3-.525.758-.948 1.287-1.225a4.586 4.586 0 0 1 1.916-.423 4.59 4.59 0 0 1 1.916.423c.529.277.958.7 1.273 1.225.314.54.472 1.166.472 1.779 0 .612-.158 1.24-.472 1.78a3.153 3.153 0 0 1-1.273 1.224 3.89 3.89 0 0 1-2.016.438Zm0-1.007c.486.015.958-.058 1.415-.247.372-.16.673-.423.873-.773.2-.453.314-.934.314-1.43 0-.496-.1-.991-.314-1.429a1.693 1.693 0 0 0-.873-.773 4.283 4.283 0 0 0-2.831 0 1.746 1.746 0 0 0-.872.773c-.2.452-.315.933-.315 1.43 0 .495.1.991.315 1.429.2.35.5.627.872.773.458.175.93.262 1.416.247Z"
    />
    <path
      fill="#0081FF"
      d="M181.709 4.827h-.786V1.954h1.644c.243 0 .458.03.63.102.171.073.3.16.386.292a.867.867 0 0 1 .128.481c0 .19-.028.277-.085.394a.54.54 0 0 1-.244.262.932.932 0 0 1-.429.132v.043c.143.044.244.088.315.16.057.074.114.161.172.278l.343.715h-.915l-.329-.7s-.072-.132-.1-.16a.297.297 0 0 0-.143-.088 1.013 1.013 0 0 0-.243-.03h-.329v.978l-.015.014Zm0-2.144v.57h.844c.114 0 .2-.016.243-.06.043-.043.072-.116.072-.233 0-.116-.029-.19-.072-.218a.456.456 0 0 0-.243-.059h-.844ZM15.181 38H13.46v-4.836c0-.662.17-1.296.508-1.86a3.457 3.457 0 0 1 1.425-1.311l3.217-1.607.762 1.494-3.217 1.607a1.88 1.88 0 0 0-.72.69c-.17.297-.268.635-.254.973V38Z"
    />
    <path
      fill="#0081FF"
      d="M19.823 20.295h-1.68V38h1.68V20.295ZM3.879 32.207l-1.171-1.17 3.414-3.426a3.567 3.567 0 0 1 1.68-.944 3.421 3.421 0 0 1 1.918.084l3.414 1.17-.522 1.593-3.414-1.17a1.833 1.833 0 0 0-1.03-.042 1.82 1.82 0 0 0-.889.507l-3.414 3.37.014.028Z"
    />
    <path
      fill="#0081FF"
      d="M18.52 21.808 6.013 34.331 7.2 35.516l12.507-12.523-1.188-1.185ZM8.098 24.354l-1.608-3.2a1.924 1.924 0 0 0-.677-.747 1.859 1.859 0 0 0-.974-.282H0v-1.663h4.84c.648 0 1.297.183 1.847.521a3.422 3.422 0 0 1 1.298 1.424l1.609 3.214-1.496.747v-.014Z"
    />
    <path
      fill="#0081FF"
      d="M17.706 23.142H0v1.677h17.706v-1.677ZM10.13 18.11l-1.58-.522 1.171-3.411c.113-.324.127-.677.043-1.015a1.863 1.863 0 0 0-.494-.874L5.855 8.862l1.171-1.17 3.415 3.426c.465.465.79 1.043.945 1.677a3.413 3.413 0 0 1-.085 1.918l-1.156 3.397h-.015Z"
    />
    <path
      fill="#0081FF"
      d="m3.669 10.991-1.186 1.184 12.515 12.518 1.199-1.184L3.669 10.99ZM14.39 14.6l-.747-1.494 3.202-1.607c.31-.155.565-.395.748-.677.183-.296.282-.634.282-.972V5.015h1.665V9.85c0 .648-.183 1.297-.522 1.86a3.334 3.334 0 0 1-1.425 1.297l-3.217 1.607.014-.014Z"
    />
    <path
      fill="#0081FF"
      d="M14.857 5h-1.68v17.705h1.68V5ZM24.52 16.433a3.68 3.68 0 0 1-1.17-.17l-3.415-1.17.523-1.592 3.414 1.17c.31.084.649.098.973.014.31-.085.607-.24.847-.466l3.499-3.425 1.17 1.17-3.498 3.44c-.62.62-1.453.986-2.342 1.029Z"
    />
    <path
      fill="#0081FF"
      d="M25.794 7.477 13.287 20l1.188 1.185L26.983 8.662l-1.189-1.185ZM33 24.538h-4.84a3.554 3.554 0 0 1-1.848-.522 3.423 3.423 0 0 1-1.298-1.424l-1.664-3.214 1.495-.76 1.665 3.2c.155.31.395.563.677.746.296.183.635.282.974.282H33v1.692Z"
    />
    <path
      fill="#0081FF"
      d="M33 18.166H15.294v1.677H33v-1.677ZM26.017 35.307l-3.415-3.425a3.563 3.563 0 0 1-.945-1.678 3.413 3.413 0 0 1 .085-1.917l1.17-3.411 1.58.521-1.142 3.426a1.774 1.774 0 0 0-.042 1.015c.07.338.254.634.494.888l3.428 3.425-1.2 1.17-.013-.014Z"
    />
    <path
      fill="#0081FF"
      d="m18.003 18.293-1.2 1.184 12.53 12.518 1.184-1.184-12.514-12.518Z"
    />
  </svg>
);

export const NMSRedWarningIcon = (props) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.9997 8.80176C13.5232 8.80176 13.9476 9.22615 13.9476 9.74967V15.1663C13.9476 15.6899 13.5232 16.1143 12.9997 16.1143C12.4762 16.1143 12.0518 15.6899 12.0518 15.1663V9.74967C12.0518 9.22615 12.4762 8.80176 12.9997 8.80176Z"
      fill="#E63D46"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.9999 3.75618C12.2012 3.75618 11.1901 4.30503 10.3189 5.87608L3.75393 17.6844C2.94441 19.1444 2.99589 20.2631 3.40521 20.9604C3.814 21.6568 4.76357 22.246 6.43491 22.246H12.9999C13.0488 22.246 13.0968 22.2497 13.1437 22.2568H19.5649C21.2299 22.2568 22.1806 21.6682 22.591 20.9705C23.0016 20.2725 23.0547 19.1539 22.2459 17.6952L15.6814 5.87688C14.8102 4.30582 13.7987 3.75618 12.9999 3.75618ZM12.8561 24.1418H6.43491C4.34709 24.1418 2.63166 23.3876 1.77024 21.9201C0.909347 20.4535 1.08541 18.5876 2.0959 16.7651L8.66092 4.9567C8.66082 4.95687 8.66101 4.95653 8.66092 4.9567C9.71807 3.05055 11.253 1.86035 12.9999 1.86035C14.7469 1.86035 16.2815 3.05008 17.3387 4.95627C17.3386 4.95613 17.3387 4.95641 17.3387 4.95627L23.9037 16.7755C24.9149 18.5992 25.0874 20.4657 24.2251 21.9317C23.3626 23.3979 21.6483 24.1526 19.5649 24.1526H12.9999C12.951 24.1526 12.903 24.1489 12.8561 24.1418Z"
      fill="#E63D46"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0459 18.4157C12.0459 17.8922 12.4703 17.4678 12.9938 17.4678H13.0035C13.5271 17.4678 13.9515 17.8922 13.9515 18.4157C13.9515 18.9392 13.5271 19.3636 13.0035 19.3636H12.9938C12.4703 19.3636 12.0459 18.9392 12.0459 18.4157Z"
      fill="#E63D46"
    />
  </svg>
);
export const CopyIcon = (props: any) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.91872 8.91872C3.2631 9.57434 2.875 10.6863 2.875 12.6V16.4C2.875 18.3137 3.2631 19.4257 3.91872 20.0813C4.57434 20.7369 5.6863 21.125 7.6 21.125H11.4C13.3137 21.125 14.4257 20.7369 15.0813 20.0813C15.7369 19.4257 16.125 18.3137 16.125 16.4V13.4C16.125 12.9168 16.5168 12.525 17 12.525C17.4832 12.525 17.875 12.9168 17.875 13.4V16.4C17.875 18.4863 17.4631 20.1743 16.3187 21.3187C15.1743 22.4631 13.4863 22.875 11.4 22.875H7.6C5.5137 22.875 3.82566 22.4631 2.68128 21.3187C1.5369 20.1743 1.125 18.4863 1.125 16.4V12.6C1.125 10.5137 1.5369 8.82566 2.68128 7.68128C3.82566 6.5369 5.5137 6.125 7.6 6.125H10.6C11.0832 6.125 11.475 6.51675 11.475 7C11.475 7.48325 11.0832 7.875 10.6 7.875H7.6C5.6863 7.875 4.57434 8.2631 3.91872 8.91872Z"
      fill="#27272A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2652 6.19163C10.5922 6.0562 10.9686 6.13106 11.2188 6.38131L17.6188 12.7813C17.8691 13.0316 17.9439 13.4079 17.8085 13.7349C17.6731 14.0618 17.354 14.275 17.0001 14.275H13.8001C12.5516 14.275 11.4409 14.0782 10.6814 13.3187C9.92189 12.5593 9.7251 11.4485 9.7251 10.2V7.00003C9.7251 6.64612 9.93828 6.32706 10.2652 6.19163ZM11.4751 9.11246V10.2C11.4751 11.3516 11.6783 11.8408 11.9188 12.0813C12.1593 12.3218 12.6486 12.525 13.8001 12.525H14.8877L11.4751 9.11246Z"
      fill="#27272A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.7251 2C10.7251 1.51675 11.1168 1.125 11.6001 1.125H15.6001C16.0833 1.125 16.4751 1.51675 16.4751 2C16.4751 2.48325 16.0833 2.875 15.6001 2.875H11.6001C11.1168 2.875 10.7251 2.48325 10.7251 2Z"
      fill="#27272A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 2.875C8.82325 2.875 7.875 3.82325 7.875 5C7.875 5.48325 7.48325 5.875 7 5.875C6.51675 5.875 6.125 5.48325 6.125 5C6.125 2.85675 7.85675 1.125 10 1.125H12.62C13.1032 1.125 13.495 1.51675 13.495 2C13.495 2.48325 13.1032 2.875 12.62 2.875H10Z"
      fill="#27272A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.9999 7.125C22.4832 7.125 22.8749 7.51675 22.8749 8V14.19C22.8749 16.2232 21.2232 17.875 19.1899 17.875C18.7067 17.875 18.3149 17.4832 18.3149 17C18.3149 16.5168 18.7067 16.125 19.1899 16.125C20.2567 16.125 21.1249 15.2568 21.1249 14.19V8C21.1249 7.51675 21.5167 7.125 21.9999 7.125Z"
      fill="#27272A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.6652 1.19163C15.9921 1.0562 16.3685 1.13106 16.6187 1.38131L22.6187 7.38131C22.869 7.63156 22.9438 8.00791 22.8084 8.33487C22.673 8.66184 22.3539 8.87503 22 8.87503H19C17.8265 8.87503 16.7658 8.69074 16.0375 7.96249C15.3093 7.23425 15.125 6.1735 15.125 5.00003V2.00003C15.125 1.64612 15.3382 1.32706 15.6652 1.19163ZM16.875 4.11246V5.00003C16.875 6.07655 17.0657 6.5158 17.275 6.72506C17.4842 6.93432 17.9235 7.12503 19 7.12503H19.8876L16.875 4.11246Z"
      fill="#27272A"
    />
  </svg>
);

export const ApraavaLogoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={178}
    height={73}
    fill="none"
    {...props}
  >
    <path fill="url(#a)" d="M0 .082h178v72.847H0z" />
    <defs>
      <pattern
        id="a"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#b" transform="matrix(.00085 0 0 .00207 -.007 0)" />
      </pattern>
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABLAAAAHkCAYAAAAuBtaJAAFBaklEQVR42uyd7a7bug5EDb7/Q1/c86PBwenuysxYjayMgGA3sT4oLrmJaIq8rleZ37yuP3z2n7b0gna/3oM84rVXgTqj6uEnXaBeXgXGBX3zfAd0fNF16NeSE/olvnz95z4vdUxFBl5zfD+Bfmgd83pmvuNwYDlYBwfzhfoiYyhQB/vmksvA8+c+3XsnG+/Vd/mWb/luw3cUvipn6/ekXHh84uDOB77/7ryfpnzLt3zLt3zLN+GrGlzGMTgldUnh4hgXjSVsXuE9GH9gfGIBCzrn+Coqn3ENiIoedUMq8+W6zCQ3wjJvqpuuc+bK6yeR4TC+ryJuXtW61M7/suPrybxWy+ozYJnLt3zLdyu+4/BdMC9pMxAYICeQewS+ud6EUr7lW77lW77lC3riTSIAEQxN4JWhWB+5LXuXcP/zbh1BD4KhBvrU+mKdMZPL8brihc4ygP7wMxpbmIehZzZA6brJZQG5LsU4Fhpg52C+l3AfuGXuq8fzy+XL+wtknDvnWL7lW75b8c1LPvdx5HLarOTrccjXdvmWb/mWb/mWrzAuey7AdekoD4xpG5lAJseLauiv4BmGn6leLgGnyY9osqGF+iWWiuGLX8yZ1mHiXehw8TwlWeeKnoDbm3VY5wfzlTbC1kZv/SZ6hIcIK57KDHyelnGul2/5lu8WfGPd5pyZATDBtsrYSt8befmVb/mWb/mWb/kyXwbHG2cYBGAKG0hxQ67G2OI+WEbWR24s/ETbTFfMTfX84/HX684w2E4aL05/5cYgx2idsDiM768ieCU61ybs43LHXvuUiBms0wXLUb7lW77r+Gq8+LvIZ5XzIQ99QX8WB0NW/s3Oe4VRdVG+5Vu+5Vu+5Yt8eQCGrcFhcIL3DQJgiGxgUqy6bswnox4vZPYO4755nqN6p+g6ZxbCDYz8qb7vecPcVSYsE8vgxxhjmUUD53Uw352OxdxR5iF9Li3lW77lu+283d8a3M/HSm4IVedavr9K+V6vUr7lW77luwFf3hyqf3PYuevfYvf8cd7bizdvN9l1Hpvb5dedgLeaEZONaG5776kyF8WjyjeuMge8T3jdzeF8QS/6MRzbBXr906HJZM+LPy63Kd/yLd8t+L7KM41+LfuU8j27lO/ZpXzPLmNFzheO2SjtLqWdE+PG81rhcZKA3IIsQowo5DNptsg1xx75iCrNnT/n/vjfzFudL/CF+cBr6XyZP3CjNnMgXyl2X2rMXm1Ag7nE8YFCY8II48ZylG/5lu8H+EIBLsERSpZl+cPTPL7aQHtsS3pL9FK+5Vu+5Vu+5UtzBYUKGz4hIHsaQwdAAXzP0MN9s/Eqj9vFnymGNZ4b61nQId4kqu55rrkxhmVkjpEu8/vicnQC9ayA5l/M19x45R4eaj83fj5ivXHlTusmHqDlW77luy3fT2WUmk08DOaLPRfKt3zL97mlfMtXa58bV/jzOwOpux4e0BZlZT28Suq94sYj8tmw8ZLm4IzrBqJz1pH34rEyvTBv0/B1pVkGlRdzYW6H8Z3EM0G7lqekF9oo10aLkcb3wcpU/kpctfIt3/L9LF8z2dCsDW6fh9XQj/Qze69f1hXNwTFslm/5lm/5lm/5YnGyBsL1i+vx5pyAkTEgb8t9ARSYawR79COSXMc0sozATgq+T/0lRljV9RF0EnpI8SYs6QvkimJO0b8Vw/aBfP9UZvenGlLJjQDzhCc9/y/lW77l+zi+8wDOP+p7Ix3PzX1O+ZZv+ZZv+ZavML5vUbs3K1luhUyOKJK8wsb8Srxm3LbQRvCmymSmes64wEKV+VrigcO6ZZm5z/Uy5/2Oe5T4UL6v1weKy/XmpyTzyWNAQnxFOStn+ZZv+X6SLz9MfEC2povk5PnlCYY20dWv8cq3fDeRuXzLt3w35gsbWd603RjoeNRjgKpxi8fivvMjWKzbJN6Y60WygczjrCPun/nCdZQz1xkbJx8kszXugXzTLK6jBkRMvNPoflNkBq6GzDweyA0ya/+3lW/5lu8n+DJn5YezryPuK9nAkN5hjcfjpOsc+qF6V/mWb/mWb/mW77t8xzX2QOeR1wbJpcBSz2PyuCwLwQA92Bnr3EyQnlGA+TFXljHNekCyUntVR9DeHI95ivO+SFZ4wfgo8xzMd9fgwz/+3TDApBCvaOl486Dg0uVbvt/KVys5v6HrmwblHXWeXxBsuHzLt3yfW8r3+/iCIUTZ6EFJ40GRjNgu9ya63AxkqfeKE+QdZKe+Z/XRLlgPkWfOqjkI7fHzxDAlrNU4i6TSLl37h/EVNmrAEOqsCXjJMq7oS2H5wfP9V/mWb/mu5ZtzzrM/qscjzGtj8pl0g6N40CdzUoya5Vu+5Vu+5Vu+6MyixmECRaKRgsZW20KbS92ck+LyAOV5tjlhXGSWtlUWuC4DL3Ih4yW2zeJwsBFH9W5U7h9Vx7qHYy4DMJ5D+d5WNkzVa34ZMwdzDvMg3T1BxvL9XSnf3fneUWaTNfFrvAd4Ce54H5Vv+Zbvnv2W7x4cjuBrn/ekvtSsgqphzQ3Gmsf7Ymsu9BfFjmBPFda76z0Gc4CFyTKkhpcsrgjzW8GXeBNfPSYZczX4Xo5cB/K1v9zcNvETlXwTPaaM1wdkjMYt3/It3+34/qv+xsdFZtPskj/qasOMmuVbvr8r5Vu+5ftlfIVsWnxsyM3spRk98qNpbqwewdAmbHzt453DnzFfT2Y2VJL+nCDdzJZZrc6Cp8ZkA73COOp9yHx1bhzLjF6H8RU2hPTvx5y3l2PcEHeoG83RmXf5lm/5PpKvUDeXHfSxci6jcrUe8ORlyrd8y7d8y7d8Bb720a5J4+qonh7qOc70OGQSPJ774jrOJlpvy3KtkjkNSE68F2SXE/pY28a713JW+RxYtkP54pdTuuGFvqVNNhnjkydBwNiRbdbJxrou3/It3y35wucygwE2Ee+k75TvuwwEmWeXoyTlW77lW77l+1185fhWP3UK9eLU9iSzK0dufGLDFo/Ffaf6F67DTSF51U0U64j7GZaH2wm8L7cevIQ5u2uUda/+m3XAYx/K1/KcWOlVmx+p4vd4D0ORZAiKkwGzfMu3fLfkC0wy3SV6DTwAJ9ct68LhskrP5Vu+5Vu+5Vu+eF3IZBYJEcbXGdfiB/1LMaZoLjBfuP4quj5YTtewptZXjmSwzFxfzYSnMFXqO8Y64A7cQGaRKVnsXd2yPK9yGF/bKwPapf3OpkEfR6uX95MYFMq3fMv3k3zzp+kLxrLabZCVkWSZXWKdlG/5lm/5lm/5CoKsPafpBJt23OnV7GGKvCCrYIghvbEsoCPBAAjzAM6u9x7MB+ciMBSMIMxX7ZuYQb0h+VSDIvQry1G+f75XNsxcuHSDKfCdh2VOKd/yLV+R70aZlOZOvWxiSMz6zjdts5Guyrd8y7d8y/dQvgOKto7+UV/aEcI8c5g5p8v3PGEZBbdB5/jjpcivHr0yvcEmPc7gHjuDunAdX5cgD/IGHoLM3nxYZl4T6v15GF9lozuC0U4ozv3GYwgyWl6lbnbO+54EMcPyLd/y/QBfs3gPO3J+6RwcFt4cWCcbb+TKt3zLt3zL90v5Dg2aKkDYDKIxyDe05TEfQPkAy4/7RcChL/n8LdXXx2PDlxO8PjfAsB7VOavcnXGpTyW+i3d/8riKAe5Avjt7lERu09R20yNOu6Re/kMp343LU2Qu3+8u1f3ZpXzPLuV7dinfu4vg6QMwZOPD5aSqV4/7qGO6x9yM855D7Z2sja4xJDFYACNhXC0bIfRvG2Oca8qRQJVlbtBiHaix3YCnvJYP5YubRscbQW3jHh1W64MswFOaAzOHogSpLt/yLd/t+AJTq+2468fhlMnJXvAr6r8nH49VvuVbvuVbvuUb802PHqnxmpwMg5JHF5R7vZ0YBMxPqCvol/hwGeDlGggvXWZe0GpQcR6X41QRz2St03XV+OkaUIkvF9bzF/CVNsCpBywwDzbU7L1H7YCB+AMhd8t2NunlW77luwVfgY/aFzO0058LJZSfC/OYG7NdTfmWb/mWb/mWb8iXFaT8KEoMM8qmXDEqwVhGW36fxhhy41DJbde/rlSORLfeWByz6u+P+yoPklke9zC+VOZTWVUeNu4TZS7fs2Uu3/1lTsebTeKG7DzuE2Uu37NlLt+zZS7fs2UWxg2O+FEd1/VczdqmBiXneeaGmMSrBvSizn/U2F6C7gUPFoGzEEvMjofE8x2Nb34EE8a1ZOb6rKsk6Lq61g/ke/Ffvif8v2y4Bw6pzONkclNjGH5C5vIt3/L9AF8YX5CfZMpTlOfHJi6XRe7lx3zlvvj9lG/5lm/5lm/5wphswKK67qYtaaO46itHq1gWHntx/Kq584c9zAX4CC9x/ajZGJMA8xoX7h94RRnuHMMY8+f5unNw6h/Gl8p2TzOgj6jeg8ffuZTv2aV8U93kOp/NA/vORk/Pd1v75btvKd/yLd/nli35WgYm8sDS4v2wp0oaeN013MC4KCPXYf0nXiKqoSmPX8Qyq+d7oT4w9Pgqaw76x7aCdfsT872ctf8m3zmQL/z/mgVbztPU5mfotYcHzJrXFOsTxsVrpJPyLd/y3Y7vq5hzAnlkvgGfWWgEHEcXTtBj58l++ZZv+ZZv+ZYvjYuZxswJjjqpmwGP43EmKxdLfoSO6is6EbP+4NoQ5B9gr8yF1x7/HdKne+yTZFfGoLagY+wvDTZ+d/aLQ/na2T028T5ZkmVkvcx8za1TvuVbvsfx3fkJfsv+utxRpqeWHXW5o0xPLTvqckeZnlo+o0vneJfjxaN6mzhH+bgu9wPzgzrsrQHwB3QhjC3MDRhCPdR36nGWe8XkmTWTcV2+htyj82XZM4Mk6+BAvkGGLvYcpf7MPofai94Vk2SDiTOycT/jeNiUb/mW7xZ85WLqZNaNxyyS8WmOAuvl8y3f8i3f8i3f8oXrUEndSApF3UAr0J2YWYl7uuL54mcXZD6+cY4/Y/asg1xXPH96MTceQ5mvwFm459z3zFwYE9aSp6sD+S794nu15zoPzAw29P4hMpdv+ZbvDXw/oJdJ261rz9+doa4mfe/IXL7lW77lW77li/2p2bq4HhtT2JrIMjjeX85mOJlHGKh9kox/zsuTmWVnFjxulg0vD/Kt1HeNL7ym83Wb1eU+UpkP42tvIpMYOI4XWC4je0/A++Vp/tUYeyRX+ZZv+Wp8NzsaqM55hLpRceONCHLJIRs2NWqWb/mWb/mW7/fy1YJxO0eKxCDd4wdyzoO6Cf1Ex+9Abpgvg/UMDiwr6FPm5AWuZ50DSzuILugsihHGjHhsZc04XoTifOfL+dppcfM+eFP/AfdrkiufL5SN2JRv+ZZvrkf+jQZF9PxnHnnf485hhWHQ1qVXpnzLt3zLt3zLF4rmsUDXE08gY4GMHhyaN/6Bokcw/mR1+C8b3bQyapa1UOYR24wvM+uK5pYYDK1jpOv5zt18abwD+QqG+jwryF36UTlCe2GO+Tq4J3UxXy/f8i3fLfgO6Zn1yjzVMBIq2yTLortmlQc6an0xruuUb/mWb/mWb/kqjCzLoBPrRQ3QrHp6kDIdL48VsXIAqPBvGDebw4C8Egeoi0xSTyQ3y5wXcJf7SZIKKPxZ/6yLwKA8qhfigXyh/8gjYVan64X3VrbFTZ4+Qd/cX/mWb/n+Bb4HZ0v6V+l8/yXnZv08pTxlvuV79nzL9+z5bskXPDB4U6i1502ev7nPYzbwOGydVY1pTkwwpy7oa/x1whyBv2XlTgxmIFNsLBXWexyXTBnXZWR4Qo2wXudAvviEQeAD74kjswcOdjwdkfOofSheKjw+G1PLt3zLdyu+IL9vQAO5JWNiXlhHue64bTrH8i3f8i3f8i1fi2/ydC5MjXyp3ilCezs2FenCNNQNyau672XXWCfEjHRF/cXeelDSYN7EVv2bt83b55k7+G/S7+F8fyybPimZTZ4cTbh2ZtMsduVbvruxejrfuV5lHs787QegD1/3/8hUvuVbvuX70FK+m/GFDZ2XKQ7aw3hcL8kU5h/H4/nA2LZRgD1jeBxNZm4D8oHMzNU1XhAHc57jtWG+3AfPcY3MvP6SY4MH893RlfgtPafHse7W0QIj6jiy7+Y6Xb7l+8V8b2X0kDUgHBmVdDUf1seUb/mWb/mWb/kKRTl6xxtYEMA8Csib1XUeHZxpjcZQxkmO9XleY7mOgGscIDvzGMuD5dHnCzykRJm5jcs38Y4UjEPXwXx/lQ03y0J7ZmKNt76vayMdlW/5lu/exzlmE2+6n8psuC7elqF8y7d8y7d8y3eBAUvzpKLrideIuHke02NslMDVSowNRzaoi3rTjyJyPZaZdQCfQz3mIrAeZp+vE163zELhq95vLC+P4RhfSbYv4PtDUftjg5lT10kEoLS/z8uP5+tlMeO1X77lW75b8CUe4z50oX75c2al6pL6UcajOQErMwYN6718y7d8y7d8y5f4onJAsZZRyU33COOigh1jjGAgAzny411UXzUmCTfx8qwDolzDL2YE7eUxkvG8LI3cl69v5qB6BH4p3w+cBQ/5sryzVr58vMVzmY3iGJRv+X4z3/hIIRnslN+++nv+68i5Yo7ZRo37KN/yLd/yLd/yFeTVBmYQuVKhnrlRzNNgw6JP2wyOn2dWHOO41SR8Ff6pnkg3qk5IBs3LLt8EqHwF46209rNxeS4H8m1paWlpeU7p/+ln67l8z9Zz+Z6t5/I9W8/CuKKnh7A5xKDdQl94rMrZhMK4MKZlPGO5WJbxdcNtWaesV5q7bx3mdSFwQp0L7FKXy6G2Cl/HY9KZA60BcS3NgXxf7+PkDXl2xNwQzjp17oE0ZhjwsuZLcyjf8i3f7fhCYTaqpy9cg7a6XjV+zN+Wn6+NIdOUb/mWb/mWb/nSHFUjxwSR6cc5bgR9UBv7mKQKAhaNeK42H5/74I27chM6Mqu60tcLF26TG9o8Prx2g7bXYpnH1NUcyHdAL8BWMyw7X45QRzbQ6160XNfZzCY6pLblW77luwVfIdOt8OBSfAAKckhrg2XkAnqwE78Ac2FDxbop3/It3/It3/LFa+kPC20TmgeDV5Xjxr/R2+eW0ba95m9wbdvt257A95I9DqCIbcdsOx8cdx6mq/It391k/ia+o3rU2W2huOO27ZZty/fstuV7dtvyPbut5okBn2sB1/PjUaNaXN1sQjwWzxn0ALJ6x7LgBXw9Dy8nsDXpypmrExdMCHaPfBULPrVjHjx3mBdcB77S+uUjOofxfWKZd+s98Jz9U5mU735j7VrK9/36s4kcd/U1G6VCf7dM+ZZv+ZZv+ZZv2u+kgtKmnF4sB7fz0+fn3lOCrNL7oO1s2DbKsKiOn9fJvfLcMTf0KhpfP9znYXztLJxwbfUX6Pj95FlO9ba5XpyNf/mWb/l+mm/+A1sZ3/WAW9BW4uLrav18y7d8y7d8y7d8o4R/WfAvNkIAONkDB8aA91B3gYeYlqmQ+wBdu8Gqx6nj6YfnJHCAdqq3D3uZOWwcow9zYxbKPUnyeG1ZL4fyfbUVs7Mm3pfJlwWs02VfXsAExlK8APONfvmWb/luwVcPY8F8Wc6ksKz8eV4mWafqb3kleUL5lm/5lm/5lq/A199oe1nDXi+AgX3RZAFi6mE2KXAYNww4z31n8vGcqW1i2AKZxWOurBeXL9VfzmM93+ExWBeH8Q03w7ksRttxMqh5+mW+7vpyMsSpfZdv+Zbvx/mOqtN1bZnjirbu7yuqr/IS5oSylm/5lm/5lm/5Ulv2PMiNOQN1Bcsn/1hLjmlB31I6f9IjyGPJncYm4rY8J20c1hW0s7lC/UQXI1yXs0Kk/PI58Rydfg/ka3ktAHs0wgtMBI9W/WGB7gnDc3Njv+l6ZA/I8i3f8t2Cr2T8gjFivornPPSLn1uZNuXC8mv8WP7yLd/yLd/yLV/UFQ/EHg9pfAj+y3XTGFihxXAEF8DwGsuh12F95PPJZVX5pmMk89LbsczJtYDT9a7M5UvepHkMnuT/2fRJUy5zrvNcV/n/8+VbvuW7DV+89uAgvd+qqyfKXF2dLXN1dbbM1dUDZUZvByejmBvQWXVLTwKzOx5EjrugEqja0RmMKfVvjj0wT+DneQHy+uE15XrCCf2MKjOPy2MKfAOZ2RtM1PccyNfavEKbcAPM80qzlSQeKXkCD96Aqx4m5Vu+5bstXyG2FrAN9GbKPws2BVn8VihqTFqHU/mWb/mWb/mWr/CDyQ/AbFnseEIDLyG2w99rK3xGPC7HCELX9DFymUFnhucfy5wbTnP9wY1s8fBe3N8qmcv3vs/SmDDqGFxYFu6LZZHrQUlkLt/yLd8t+ApzjusP9SN+V3A/ef25U1eLZJ7yLd/yLd/yLV+DLz+9c2NY6dnDcs8UUA601bMXuh5YqgfYGm8m1t/flZl15XrHkGyKXhwZ3H5AJ/Hcfa8t5uXo6jC+l7oWzGDP43wxe14g3D+xcLxWsC0UPZsmsyvf8i3fz/FVY3n4R715HH7PLNOj/ao+1IyRCV9F5vIt3/It3/ItXxhHCLYMJY5nBcU5HpS95z4BKG7wvTqsE6dPRyfREYzcaDhOZsyEr8KO6gn9XA5fdb5wHfmCnt/W22F87XPoG7adB8r8o/wPlLl8y7d8y7dt27Zt27Zt27ZtjXg3l59RLD+6Z3hjjRNAO9bBf0p+LMrxiHN0lsUyy2U2DH6z7ngZr2tfN2wMBU4SqwVeYKgzNXbLF/C9gKPEXTUQcz+8xlZmQRP+HWVoSTxry7d8y3cLvl7g2fVBbyc55pq2k4+gLiipB175lm/5lm/5li+0hx8oAQzluFsePysPSAayWa79whFHZGPAHretIecIcw7HZU7AeRK3RpqrG7A/CIY3AivUlcOX9cTjHswXZPYyJi7KQDbr6uZBpB8ic/mWb/mu5ztQf0Vw+HF08AmZV29Y0t+5m+qqfMt3N5nLt3zLV537XR5YqqKgrdDHfUcUBT2NC1PVFbyEdtIGf3yZ83FTK3jSpy4j88+O4XKJea7X1XwBX+FsPJc0i4fAF2SOyggyre5z1HVWvuVbvtvwlTzyvIxQ+dpyAtqrmZuk31O5UXKce4bel2/5lm/5lm/5At/YQID9eUd38k021Av7YKWnBh7F00RdLK5FVZjvpMc3YSyoD2OFBhXmy8HtmS/LQNepPjCwg/YH63oO49sCpTo7vpTv2aV89y5TvkeX8j27lO/ZpXyTwoal9en7uS3XSeJaQV3YwILh7WaZYHwpsxHIHcls6GsEBtIYTuBuNVaSKjPoVZBBqw98Qf9gtArv6wP5Bq65eaDjBf0ZddiI/olA1km78i3f8n0E30nbOXWXHGFZv4Zno/ugfMu3fMu3fMtXKKFhRGgfBDDnrHSu95GVVprlHXXu0C4OOk3X6dqitqyrPCD+9SHD7JUlD+B6GxqdL2ftHcoXY3Olx6DVGGJ64EiWVR+b49twX9zW9RgmD9LyLd//sXdGu40dORAVCkGw2KfFYpHHbJD8/z+us8GMM/HYx6VS57JbRUCwLV12s3na9hVFssv3Ur4K3oSEzXf9MW3+KHl57FV9Zuj18i3f8i3f8i1f0OfgA13jjcHPGdcGp6zR9xxggcAYju/rcrbSOl1mmM4Lfrf7eBlZQriuzeadbLPem3ewzXfNm/xzpNcWn2ySn/TF8wrG5DHyf5xKys/Lt3zL9zq+ARdFnFh0QQYbsOOAai55/7fyLd/yLd/yLd+pdZtx9M0A4HwKqTxDizdicix3cMO9oKcSrkFBH7T4Rj8PdrBe+MZoYm016Pg92dxsrCfju2P9uoaNM1l2XGP5nr3Gk/lq+Hg7+mCSlO+eNpfv2TaX79k2j+YLpWl2uaBoTJo/O2nQL+che8KT+ERAWJftcY/5Zqbrbfa58l5lHszNHE9xOqgfBFRgs8E3sPm+wNPtQL7C8Zh9XttvSMo/Of4fmAeluPScX9ZavuVbvtfxdfp6ehxZNz3Jdr2sPx3SLUcxDvW5lW/5lm/5lm/58s9+QEtp2RAt9D09I1gCUBC62GYGTPBhbAiycUnjokb3t4CrVYbpcWe/wutWsIfGdV7nebkMMzh8ICrxdPYZBaoO4xsEvEEXhHXZDnN+AatoXj+DLj8Blmwu3/It3xF8FZRx2OWiC0ogUptZ2GaF84g4OGOVb/mWb/mWb/kCXxgQgj7pKYakB4vGgJJro6fLwab8BDh+ALulzbcT7mwzc7umybcfAHRt5TWvt/mKRuiH8bVKmnkMFtA3fk7ekPM6ODCY22z+LMd35Vu+5TuGr9XiIf/gjHkGrMlGfzwWmW0Bcr+ClG/5lm/5lm/5GnyjRSjt3USQeSzfDudGF8aJsmLShqnkr2AjWal92RsM9iXbxL7mcViAb3waU2BL3D8ObA72IPLVoXy/ysD05Sly4trL9+y1l+9ea9cTrHGKr76VPWzecc3PtNbyPXut5Xv2Wq/ky5k5cJ2TvSRjvqDEjXWNcid4o09z8rpo/at1mZd/HQcM/BJXp67Wb0zOflmse1s0r4as90S+8HfKCL49LtNDQcDPsB10QYgZSFBKxTaWb/mW73V83z5YnBYN5CNXl/TND3gEOgbrvA0AjGmVsJRv+ZZv+ZZv+dp83QBP/uA5acPk/Zr8fjhuwAt0jDkYcN7rKNcNMsuQb1pGF+zl8HrmkgR3nGsf6zve/0/K19rvsHYIyuX95dKj//1MPn4tyLzDeUAH11u+5Vu+I/gaN+h54DLIfhb63BDWZb/xHma+5B8n4Fq+5Vu+5Vu+5ct82UkKMnPMTCUeixyXnjpE+k7/KhOewH8wPvHgXwC/F4Zvs/96fkKdwTeyPdlXQSDI1jVPoFBgt6ujg/mCz8032sxWfm06Z0wG82Cw0znAwLD1FtiK2YnlW77lO46vKFgG4wD/vP+IESyUwwbmwfHd9fIe5LHKt3zLt3zLt3zv4WtMbsAz3uTy3LyB0tI/gGbOy34guxgi+5Q58uv5mni8bF08T3DiozGHwRH4Bse8W+td4aswuHQ7mO8je3JpVUNF4w0yiPtpGI/tXhunNPN4Kt/yLd8r+bIfkv6NtFeyMtB8LwaN7heIx57WUr7lW77lW77la6zFHTRvmp7ps12LdRWsK/GdEn8lNg+YVwt+qZWudwHHdM8oGDfQ9187mO+kBohfRJvMC7pbNJ3cwc/lu9dc5TuTkZwxhvyP+64cfPhB+b5I+Y7yc/mW7zTZka/fi8kpuUvLgvxsKwZh2As2+cE48A2kFhqlA8iW10v+WmUzX8vrDfpu2Z8w0xik42TPGZwDX3k12GwLcz6Yr938OfhUIjrFNOgFEGVyBH12SOT5mzmWb/mW7yi+j7vXzUTAJBLjf7/FNuPrC2VFlG/5lm/5lm/5gvg9FJx+V0YdJ4zrBVJgfmsNefd/vyQsaBALNhsBqNBm8IdRopn1YDMa9MVlbMZrMG9Wege8gavXsM+wGa85jG9Q7sKc/MAl/2wH/P01anFGh9zn3SBH+ZZv+Y7gC/eZxCDfHwYTeTZzG42oVDZnI+Ora7PKt3zLt3zLt3zhdch+iN7M5W84/d5Zvu3G9aD7RgBY0Kjc9EuQ8WJl39C8YHOQ9UcPZrr21Dt/LmBl6vIYuX/yXlgH8o1POYHropJi8FdcIutkwnmZLX4DbbrePdmlfMu3fMfxhZ9BgnETvej1PLtAjq08fu6v8i3f8i3f8i1f+HlZbx2FABQ2TNMFfZ2WpyMOqqUN18oZPBv20CARfd241hvtGWrf1N+JSqVSqczs7TGtR2I890LfaIN5y7d8y7d8/yTlO2jev4qiE+fSo//hGqOXEtojNy3Q6XkFIMwsIi5fDLLSwOdgs809tzk75ZLX7GcL8nhJaqrDJ9i/yPeRNruMDuNrZLQGBxx4fXjkXc9rpNdWZoWQvfBcVJ5VvuVbviP4wjWsk56uyFzWl1Kyrm/nip4qdF9YvuVbvuVbvuULc3OafNJDx2tEzeMFwTPMBslLBbmxu9vTxwmS5emJbDNwjI4Jj2qI/TJNsc3MHfZX3O+KOfFa2WbWJ1/RXnUCZ0/CF5j6nCkI6O4hmIN8L+LgBlvBL3YQkcfgErHyLd/yHcM3uIk2GGb3Pew/kGA9wMufk/g6lRjlW77lW77lW75BJZoRsIJBnT5ZYGxgp7GxvYbbyrK08ptQw69RUM25OSWbwZbo9Ega3/e1vyfID2Rvlkno2wzXIfcFvtKBfK1/bMAibo4cBLXhmiCzM+gXBAyNGxQ/yFm+5Vu+I/g6wtwCSfgOOSEK/cz7iqV8y7d8y7d8y/dRfBU6TQTShu7bxXbmEBkAwxDo2bpuhg29HvAV6voN8HmNgcD8gV5eWpK86Vq/JtZz/HA4X5hrbK19KnoSm8v3bJvLd3+bF7xBWW/zYh4KPs3XcF+Vb/lOs7l8y7d8V/BNT/Zye2oZpYhBlghnSK06Pp9sTvqPBfrBOnnOcF7m6/tDuU15f6XAz/EphHx9bjPvC9Y5kO+nMkOCQJ7fG4zXx+JnY8rPVmHb3CzhR/XVKd/yLd8RfK1Mr6BlQlKOL0M3ONTGskOWjbmujHviW/mWb/mWb/mWL/INnG70rwLIQZmUM46jQw5210ibhdYYnBRpjM2c/bXzhmSb+eY3yNgKMtK4dM/vccLX+fPy3vev47pk1+aD+RqZi3ytFZjPT4NUngLM18Bz6AfyCev6ay7f8i3fa/ka/rvjfxn7JOiXyh+ggvh+ydtWgE4QXH59rXzLt3zLt3zL91O+9rML+Br4Ck6MnMV256cQyoh2WvMxCw5wkD5z5ABCch3xcHyVZPXxgzmnGXxGE357vtz3vJZHj3cYX5K8tt6/XoPKh5S9AWfdYAy86Sjf8i3fS/kqbQob7gcF/jHm5jnTeYKWGJxd6DNS+ZZv+ZZv+ZYvrD9ozB684QQIcePoPIXdz2YBgOgzp8N/mjFnR2mZrYJ5yGY5QU7XBi/VMQ+kBOURLl8ZfL2STUMc+w/kS/4SPEA8NsAbBa9nX8rVB7sD9pHPb+VbvuV7HV9+Pi+7xHuPnC/rmgLzwc9GJQHoJr06y7d8y7d8y7d8kW8WAfQNWPCJJkYm03kYUH66ke9vDo6sWI9V2pAfE87iM1AQUTfsXN0on/3jX+OnlNL1tH+fiO+0ZscLhP2z6Zo1qKHoNCnfs+UEvrvbfrvVRyfbfrvVRyfbfrvVRyfbfrvVR9fZHhyJrOyksTz6B3ODDZFfZMwXg76zebTSYEIeDOMMOX/cvC9YkC6qhGsyr9+XKbfZsD31lQ7ju4NMOymscoafy/dsP+/AV/Tz5uv7RgadfJv4WeVbvuVbvuU7wo4t+OqK6JtTvxmMp7Qe1K1JjQMzvmhVqiSxorGS+eB72+ZwzbnfLcnLSkJf5fXRPl8dyNcM1PsncwJ/e4xgvltgY2Rz7iv/pNvyLd/yvZyvnMa4YB9ytHq4so3itfDYQTsNe+35ycW8nvIt3/It3/ItX+bBouy1vLdDeiQl2Ru8DsCMQFpgV+Arh6/gcZcu8F9QEhntPz0q0yixe5luHsVXGmQ7lO9tCO84KD6ogfSkcct3BofyfS6+J3wKXzmzTKZSvs8q5Xu2jOQ7ypgsmMYS9bjJ4WqojzSQzZQ9fpmuOwYHlY79AzeNr7Lgnv+a8z18tbJDgvHR/txXflCcdMu3fMv3Gr784E+//Uw7toN8RJlmZCvMjWMkhyw5n9TzWvmT+/It3/It3/ItX/CD0ZR5QblZkL4OtgdZSp6OwCYA5AfGghthtIGev+B1BXsG+Pn7hLgkc4YNyJUcVeqeeLGo350O5jslaDclmDxRJvqmfMt3+hqmyse+2tsGfW/8DTK3v8ohPSfLt3zLd5Zvy3fmGrYVo48E10FekAWilScvJmV9CzKwVukq8FXCRfF6WPK1sa80MMMIdDxOT8L3FEH/bnrjUSnfZ5AT+X4dszfeKBq2H8q3fMu3fMu3fPXQvjBJM3UwzpgjaQqf65LNSdPm3Fd5Js1gm0GCOfKsJC34o2OVswTNjFf5Svf66mC+ggen6vq6gvnBhyvm5fVuZHP5lm/5Xs6X/c028tzJvAfYfDvA5vIt3/Ld1+byLd83163sYaRwLPEjzyJC57Cu8pP5GFj6phnGcn0nN/BpBiFlZLqI9fxg0upywKTsjvgCqyizj65JG6UfyHdSj7APZcOMi6k2l+8eUr7le9qan2mt5Xv2Wsv37LWW79lrXcWXgwgXpb7l/ahyZ2pl+VJog+A51y49st+ZVy64vpzAZO6PySLT51phw4NL4jSkB9QOfCeK/iZ9DUxN7k1D+Zbv8/B9lN3aYE/tGFTVhj7bydb35TlsLt+zbS7fs20e4TM9qL+SBvZ3CrKvYh9q2EmB4AN/DiihQ2YwHtoezKuAr4zx1gV58kxHuXMeyPfNmImuU7LklouCrnxd38e+zbmvnFPNyrd8y3cUX2hdEfwPgXlwXtb1r/XXqyAjGWSNzeVbvuVbvuVbvgZfevPHg+SNy9nReVCJdbNgFtvs+TsvYYpLxpiN3DEWZB3hL9ImJ08AlySg5bOxbQ3kSfla1wR6q7NXNfBQAS3cryrf8i3fa/l++XnYB3lB9vIam4ceNPJdO8q3fMu3fMv3QynfgcdAK9ANx8thOs+x5I2oB5UP3Ls+DTlNL99PeTmqAo7wfciDbdYT8xUFmyEjBB5us2juLQbXoc3AXqQLY+D6HduCppMq3/It36v5sq+57QKvhf2Y7wXQNzLtKGMut485MD/a2+VbvuVbvuVbvsB3mcjNpIifz8uzBA7CawE2jL00Y0vgE8GYRlkCXcNz5c3B34rBH/3u8c0b3ZO/gKkSvswyD4YdyndxED//IGFoRpk+Y/NgP5dv+ZbvQr4DP5i1P7zcMCtums3lW77lW77lO9PmRLQarNJmal7ZYt57YmXZEJ4Gx6LkBENYZ3S6X9C7Aq/3GXMALmxoL8NODXnDAOz9fU3M3aDyk/PVoDdm35XhbyYNiWzT4OzR8i3f8t03+3t3H/0he66pfGdJ+c62adqayneWjOWrrK8CGxJkUSjcuAKbFDSExp9Nv2qNffx8kgVj2iyXH32f8F1gC+7hoLmvXavMfHne8nX4chAQvrfKfJgb68JaYB8Eqdt+2vXNXRvtT7qufMu3fMfxlfE3G/aHVybhzEO6QVN/5Gj0hDX0U5u5MqJ8y7d8y7d8y5f55v2lZC5OxvhxE2cCRU5MfMKbhnXTgFngI9NGrgtOfBUER8jOvNyB2WrZSY/re0rpc3xZqBb7UL4TP4XRkPGn+WanNOvyLd/y3dO2VQeFqBl6o6V8y7d859tWvgfwtUrOVi06CMhcpatA94LNkc+7aL2699oh6709Gd9b+UJwK8zcDHRhrGheGeuFr3ZWjIavt3zLt3yX8+U3GWkPUBgjaDcB7GAd6XqdUnvOkvPnLd/yLd/yLd/ydfhe0Jg9KUXkDCk3Rd9Zb9DAHNZnr1OBP+8poxCO5ffYUpjhwzp5TzHhGpivAr63Bdl/yJfWznz9P1hPwHeyvGfvzp/O7OL78p039m5SvqAX6AZBxmDe4D55WNPgT5WzlG/5lm/5lm/5enzzTCKtz2ZiG4N55W4sp3Y0nFe+bu7ngTbLYHLFHzsFfkXdYdmIS/x8MN/7bGTRBVlzPrO836L+bpsd3uVbvuV7Dd/F96IanJW/XNfh+uD1qnzLt3zLt3zLF3Vz4UHSnjkBYEi5s+ZR3uuKA29uRhTYGKT2gZ3AN8nMCdaWNPvX2r5TbLMb2Scd4Md8mYcMW2/ly/7kZoVcikNzGo2tI5vdeVf4KrOZ92j5lm/5juGrO+8BZWSC07wiW1Hf3xsCHwU9J90se7aZssLLt3zLt3zLt3w/yZfL/7Imzf5x+VEfLNZnqCxiXd7EABRsN+dlXbm6vIH9NRu/RCDGHw8QWL81T/BmKhyL+cL+DgOf7Ksn4fsp/w1r1JyOpXTefIz8tN3yLd/yHcV3ee/V4D50Yhnnx9efbXP5nm1z+Z5tc/mebfN98z44myLPWshvEhWcaBjBczJEKCIMOoFvFpzmhl/zk+pyNr7ugkwf+/eM+Ab+CPa8YaPhj0P5fkY06B/ZlNNVTlpr+f5Vzlpr+e4lOnBNuCc36LGm8i3f8i3f8i3fdED5unmwJJtj/frMIJOCzRvrBoGvBbqsH/llfaM9rd5//rx5wHnx2lS+n8p608G6X7+vzUfq7uirHW2ur/BvtJ+h7JZnXnC6tDUvvf6RT4f1dinf8i3f8i3f8tVdzLz+OXk/H7f3QZ7lwgC9cqW81xaNAeOuuonk+VlXNCZ8vzAjcH0GkXvEOPsxz6hz9Ux/y+R7O5DvidkLO2Zo6D1Gw9Kid5TyPVsm831PNKw84otM5PWurwaXoZRv+ZZv+ZZv+T5GMT0pJghGuSV8It0AjFyQQbDGKrEzdRX0K3M4co8kv0RRji6zyEtgfTZ5Q3IeO7fZ8VX5wrV38h1yLO9bFuvXy9xzX6h8y7d8R/OVMW54n8MNfflQgPUZwmD/kv2c9MYs3/It3/It3/J1+IblMiwOHDOrSsZpgcbcebke2ACg2Ae8IXJ+1Oidr89LIM1xlQRXaN2GfcCM7aT5gwxHub3X6FqHwZPznSx61DgHfkq2o+3lW77l275e0w4c+JQt5Vu+5Vu+5Vu+ruieLCDQRRhBjWMKVQ/U16LIKAc6QnGCLNkcPO+gX+gP7d18XhhvHe9Bby51yD/FiW+EHzmv2sS5fMu3fA/m+11bN7kPmG77x1K+5TvDz+U7V6b7qHz/JNroTZ4CeHIAuJk0AyKfPIY/voKAA+lpgS+WrDNd60q+6V4MbIx8dThfM2uRX4MH6FpjcmNJf16BPXCNW3bk2/xJf6h8y7d8L+crfw7fZzCeYG/A4yPx2bKv2M+J3cAf91r5lm/5lm/5li/xNUpieAKjfEnguKihOugJxrGvBb8AYNggRlnf+tfY/vyGnudnX/t9l+h7sBWfo7Gd7MUh6wWGnq2H8l2VAaYLymuAB+hdsF7YI7HPyrd8y3crvjAOy+Jx8jX6zLTpesu3fMu3fHdZb/kuGTMX+Ybnx98v3lQiGzhK6jesTzK/Ep/z+HkZpREFNyRt2p83nA/+SAFfb7712UnMN2jMq0P5Tk65nZRNe7qU79lSvm9kRBa+ff836ARZffD8s+yv8i3f8i3f8i1fe/0CSEFJDejA83YX+zwIo6CUK93sfpaavw6B/+w1GLoBG+M1h5d/rRJdw9Z4vbCXwj2d+/dAvvy7xuPL5CnzdRmMkYXV55DHUxBItQKRbOvro3zLt3zH8P3g4ZdPwHWwX8LreF+KrnV1cV/lmck3U/9WvuVbvuVbvuULfD4JCIUDPelJfnlj+PyNLPkK9PEaF3h2nCWLr8e+YlvZfmAWn76Y+Mqd0+ATcskz+IBNXApyIN8ln55cYIMGfgJk27xh8+ryLd/y/UM09NTCHT9hn7TW6adS7uj/SWst3/3GnyTle7bEfOVmTwUBCRk9tuQGkNz+VKBrZWk5TZyDqCXoMw/SzWx+FcNm4OsHWJw95vamMvjifoA5MQAIOrBetgEYg2/tPm46jC+sk57PdZ3Gysn4MJ89b6CrwFfO/lH5lm/5XsAX5qN7wuDex7SF9d1P+9l3PCf4CvknDZPp+vIt3/It3/ItX4OPkRnlXOsHxFiH5+dFo/i67sYgH8ED/evqDrIZMq3YTsfe4BfYGCd40Lysq+ts9nkfxrdSqVQqlUqlUqlUKqkEGS0g8RH+MoJlcfbUgn45RmkjjivQD0oJ7XIwBT+7kWE/aJiXnSlep28Trw8ktZElH9PJgDyMb6VSqVQqlUqlUqlUBokWd/EXfB/1e0pPH3OO0rdsdyXXV8Drsl4e1+jmAaZ03gvWq00ZXcI36CH4nq5CXQXNFON53dRup4T57/ZV+ZZv+Y7hiz7nrF3mzuUafG8a2pzPy/euPC/7RsN8Vb7lW77lW77n8v30jZoGNl9Tll2Wz8XOZx8DcPNUQn6N1hfehMsYI820UpTplPd4uxm2BCcyRVmOzA0E+N7SUywP5XuCaLNxd/TF92XvNe3oqx1tLl/D5idc8xTf7WDjDmuc6rsdbNxhjVN9t4ONO6xxqu92sFGTjTMynSB66Y0tS9dvPK0VWU3xqYD+vEpLJ9fsi3yP/vbfX/Trz7/8+PLVOuXQCS4FunL5km5gmxE9f/Xty+PfL/796eXr/x9fv//96zfPv359eXz7+tef3+i/Xv86xuvrb5//9vo/rnt9/s0135vzVffXb3Tf2Povo7Fj0GA66X3GX3kstu+3P36/flr8eGXKj1eO6Xw874+n8w3GD3rVsc/IFrI5/v193f//KN+crzMXzZsdbc5+N3tasm9e/47+ADbDqbseI/f37MW+3238T/y3/Gf4+XGPH6fw/fJ1Mt/XB2eKvPj2n6974QK+/j77YTLfF1v1+36dwvfL8/37fObv7yZ8/8feFYTWVUTRz9CFiJSQlQR5Ka8lSCkiIpKFSBEJWRYJLqUEFyKuQpZSEAnFlavioohIyEpKFlJEJBQX4ip0IUVKyTKUIqFIFiF8gj0/zOfm/fsnJze372feyx843Ddv7n0zb+68efPuv3d+/fvtMOOTP4TNv/+W414dfKwPNK/fMMflLEYMx7GjTZyflouRpQS+AF6x7hfGeC3eb+Q6Dv3yeozX4oZk6dsJGHdWQTdOhcLLWz/Kfr2a/gq6BqwC3wBLwAL43wOdOke/ngTc79Vh+iorfaiPNU/MK/4KREauI/kUhtYrkHoZVJvvIb8GfI/jr4DPgXnk3zqcc/JIIddfxkaZ+I9R9vuPY3/xOJ6xfhuRzrwfMJ/cwFh6v5NxQvveAO7GeVDNz6Wal4WCF5BjNscC6Xm90O9mQOqROhZz0W+bUu/dhn5fAv39jPWr65Lyo9deR36ik3GKRrZl4LXOOGU3P4/TGejXG5pD+F0f0tZ/DCPnJRmsiZ6QOVZOqCRjX3k83Az9zNrkN17ycl7GXwrf4oW2xxaGtjhlu+HVcc9+wyzns3/gyQt3C/j/ciEoAVDBdITkwSPntKwuU3UQ/nJanVfHQKINgPDo+uL5MiLez0EPOO5GPAMeQOYO6CLodWAGxxOm/frcqf697tAHs7gv6XcLClu59DeREX5bPWn96vsrANWeyjjYB88WZNZxvAIsALNA0fO2aIp+vfvJ1bT3Y6i5r4Smx/0kdPkzdPkY9B2gkc9vpvqtvc9qlA2nMF5dwfh5AnofmHReN9TVj2hjwHhfBrrWuV3eo4SPzONA4vpD6XPg0qj1y+Rz1e9Jy3vraeDfs9dvZV0WqZLv4ngFCLnqN3o23kY/7IDOsQoatA9yK+bntj2/DdHviVPIbBPuYOWv4V/bgk02zZPxZufueh2eR7TPqSw3sMwAT+NLbb2Ey7OlL+vw9nMYkIms18Bm128MsdtSRgbJJwxHRhQVSB1yPGwBpcvjsVDSzkL4pO3KQKbqKocbvp7j3EPQX0BvAddV6BFz6ZXEy/zl3OAtHzWzevEqfRSp1ouSSZSnZEVGl+tFsZaNVI2haat+I/j9HoBuo/zP6Ln3WfxwzVq/zF3c0+b6ZYXaZLlrPvR2A7rdiUbL70Ab+fxmql9H6KgjXHLUkLC8r+OH9h7G0sfWcBHGT+RMiKFZj0/3LrfxlQZ59X4X3tv9d21DUL9+/WP2bgb6PekPWo9Ar2aiWwBJr6HeBrZim++fVL+Z3E+r5+c2Pr8N0W+/wB9K6Ah7Cw4jRbCHZ/nDD61hbPy8lDN5Vq+SpXy8nAwulQwPmtl4w+UEJKzpIrB65AN2F1hMfCySOkjbapB3ekEG+lz4jWToYzFgAdS7qdRlwk/K9LVJWeWcQV4orb8ElCGE3Z8YMrrg3QZdQ/4TlF8DvdBpYMJ9zKqFKPHIkvEgPNrbCRCaWOTSawPEECX1+fWr+LRMWTVo7QObOF4B/QCYAtrsLh8aKh8GxvyrhwZp0e8ecK0zTsf2b0aeXOZ6avRqehd4emSO2ASmMr2HfptvxjHPPWX0/F3lIXM7fTdzY9k28KG6k/Y+C/XVKT9Y7WShX0B5YGm5m8iHXPUb9xJbO3Lf++Xh85Vvm8/T/Ny257et+g01Xy8Yyhx7dNXeF8FXrz0Mz7HvVXAMrGDQndWLzR+aqJLaYPwj4NnAy/AvFcLlHHeWdvtDNep3teX9IFQMWGQhElGqcrL4FZByg6ziJeXcSKGhQ92EDpftAv8Ad4D5phkwYlic9lxLGY+UbviCtpR8wtsvUZ/KE6OU5N361W2lYY07wB/AMnCpAeMgZLTYHGmCbj4dMi5+ymjfs7F+8/oYOi588MeBeWIv7tsZctUr5q7X0b4N5anMQPmIZw65TpkO877XOT+J6Nc1711EH/8AepCVfoukJ9bfl4u895Qqi8P10+6A1+AGjqdaPi83Yn4eSI1+foekrPVLvZ+Y/HjgvTwLZcYDOmSm3+AwuPX/HeVBwoixNOoPwxqMrkHT0bZdGbBSYIsNsudVQk7yRF48eNLlcp6cI4Y3CRcUyH0KJb8o7qO9m8h/Ccwgf8FgoDbwGP7QgVyztwBTHkwslFPQl9M8SXnJCxJGJdWetNeXlNeh36ShS45jefTM+g9YA+aByVHr1x6Cxj2zDeM2wjYHpmRJveb9KaGPK8Cm1i3ChOFNCVSukfvzm6l+SZ/ZtiBgPKSc9IUup/XKv/jOAzuDYdc4fgK8SfQnyaavwHSheXXb0dY5tHU3bfyvzpOSV+Uio/nkvJKpUkDzSHkXx3Oj1K8u07K56lfy6h+He+N1N0P96nK8Q0EXwJOtfmOkyG9D1gcHoMuj1i+bN8/T/NzG57eB+vW6dfEyS4hfjWF+wcprf0jk2NE3wcEXCCSZ8rz9lgfF8NFAdXAaj7TeSwvYTxhDHgEzfqOT3/Dm+UtT795v3BjGeXt/UYx+3iJhBIn9gijV4V2FBvf+ot5VXL66UNKGMUUBlWebkKuwtwPgIeRuAS/Yux5IO66tf4zrioioiIqIo6ZVEVVVFRFP1FNVVdUvPvWpeqqqPlUVT1VVlain6qmqqnqqqqKqqiqep6IqKqKqqiKiqiIiKiIiIuK6rvP6/SZ351tv7jrr/s7qOnuy59w7/Oz5t/fsvdbee2bWXn+2rmRESUL628WEULdTUn2O+MMQGhOtt6HxXFtgqcuW80B2/krKV6evAl8AD+P8fI8XYWZiq5dDnb+iNBBkbjh6++p8Km789oS/1Qy15YYW05YaY1vmCoU3SuYv6j+HOn4V0rrSYyh+bJup/RPYOih/K4K/47aGhkXyd7wp42GkWwblbdVABNhPoM5XjPacAbb1ZE6bufl5FsfvrPG3KsjOkkg04xELugit7V05duyHtZYymWZWJWkpNRG+gGOrOBRfAt4CNuRuQ08c+Ts2pXnTOHM9zZyta14Y10y/BsCkvjW0xgwXeukypf4NHJpltanJJWW17uVmcyMcnwVeqZf7NhV8knlLgQjtqYAa9dojbTTaK9BtN4RcWqNLo6ZadNwnlxYedslffVyP76MLuH4Ex49if1NX/PWUladPcq2rTsaCCLDqRuvE4m/C07UdkbC48Vsof2XfQUNSjqNvRWnN6d38vKZxbQl+ziO9j9R5mrTii5Ba23138uU4QVRfNX9qk3Oy+NW6zjS89XvmGvBsbv56+VAyf2+koGkFWj7cLKiUyt8VGl4Nr3eXzF/UcVvyd6e+P1M6kgAEefjrnaPX0vw8S+O3p/zt1q9UoBxV6VzO5qMCMA/zuUaX36RTwAeLV63Pc53TlreVt8NvKpdMr5a0vyUBrl0kDncZf1PKQcogkyvdKgd/6WTki2IoJoRkNY6d16mGjnBH8hnnAEc+vrLMfSMZ/p+Q2to748sf4fxRpI8Dc4WE3hUNLNV+7izf1kBSTty54MnS4rL6ii5Dntsdf7n/Lp3ncooAdcck/O1B9OFSVggprZpFD+Atxl/g+3Gh+wsMnd0n/s6Uf5VGe7npJ0RbZQS8X7IPn+Su4W1gRH0ecfD3rDXvSsrKOjVjfuo62erlb73DpfO3luuHBoVvzb+K1Nmkx1ng3sHsbkXOz+tbWfwl0q4MGjru0In+SHrk2RQBZ+cVg0eaqUD44MvPpbB+aXV8VZX503AJY8Q+f0d9I5oPj2LyifUh4w2RGljhDttBR8Kre1fWdRj5ZEJoaTIBWgjlc5bOTRMBalamnmvAqoM+rolfLi1ASWCmZRwLwCHgrqlF1olHZNvDPioB+5rjY7hW/IkLpbRA7abxl0c6lPQ80heArdivCvroKKJPhjbb58/D1+nO+bsEHMT5uRmkVV9/OKpSfIQ2JqbAS8AiC+6Ac1eQPjQoeEP9atTzzKrvYPMdar9/eYRBjza1INF+bhL+FtwnO91Ar/8BFovn7/Lxr9i/r2T+on67UM9f7G+ZFv0+/39fqGXPkzMxP/eAVn2sc5fP5QKivM/heQT+55E0rKmVg1Zxk8e4Tyy/87s4b5wfhQcbk6vVhBV1WwvrIf2cOA9CeYGI6WaXeeuhOHFv09YhkFIfIjxSHecv+cAiJoEEStVdPdvw46T9M6lyeSrlnsTxfuzPE2GkSv2CdH1eOXE3Hd7r9tZEsw7QfckXudDWvhxTJ7mvHP5qWul7U7Syz4A7M/FX5/cfDxyLK2E4yjXbbThunwP+RfkrvDmP/eFk9eVtWecv/waM1iuw8OoybUlBAH5W892YBaB0z1c4v5Esngmc/ktD7ZY2vazrLqiZsAKojQUBtQhhBvQgwkA5PgXsysNfgTdAQqn8rZe/rY/1gr/L515HOl8qf5Mm7xvA0ng3A4pOV7G/N+f4nWT+XCvz86yN357zt9NIZ5XfaXX8R9trAkWIHhZIsc4daZunvpy2nA7+vuD3keHtj8ZLYR9wtvUi4L6KvgK2kLY7+kTMHDbAB8ZLP585f0Bz8YHFhQhasMGdt5NzXEAATOhLyRJUAbZZF2Dcb5SXQCLvqGeb5nGXcd9b2N+eeRGhIqZVe6T9CSt9VSge2eZ4khITPkuwaPJFl69NEcvhbzrHaDNKP8P7UeaGP8rfklbOSlzRA30fA0Ye/mL/vWmbK60h/s7klgSh7+j5b1VcBZ4G5gaFbmjDEPX7lmlE87Ya48uaxwUuP5fAu4P1bdL++iSwAPzeA/6eQRm3DAreUMd7UMdLrXpTIWBvAhCsb+tblo374glsIc0fIFZ/OY5qzcTCRfM6ROjlLzsuUPH6tyJptjphgv+MO+xW50dNxEJCbwd/OY+i/Ankd7aDm/eCfkkDK6D95BBsefgr0BoTXDBm3UM+OBwrk7XetyPZpdQwWxsBn+FcPci28SiElqlgzWigrjPhgKRuv2tD5nOrPP7W7Ply/0WU8+L1lef1barfSaDrNuAbzl91/BvSfYP1rU9blXmuvDtp57nmFPSl75DuKFUIibpVqOMzSdBhB7DwmFETUBNzLhS8c1DGVpUkrF/hHmBHo331n/womL+LwPOD8rZqhaXIIa9PsDSunhysbyUuuBQ7fnu4VZkEXf4yCjLLmp5JF1BohMepOKr3ng8IQeN0lNW/B9QKEYuGJ/vfI92Rh6/5o0d236fkfJ0EWNQMytDCqqkGlr7Hz1/A4USURsvTgoN2StTfVV6glVep3AvknGrXCMc/4Pq92M8xR1Xko2xPmw+WxpPil0EXJmhSSNdVebJv0FPzo0j+pn26an0Vx+8i3TZN/ro0geN+OKtC5r4b2oUV6PsCsOjir/DkC0DMv6a0uLAG+Eu3gFa4kZebXERogH6wGf3jYzWnDK3oq63rIxy/KEXzOnstD6J9NJlGHa3bc5Oeb1tR54wxpBYtDFopjV6dV56p5s5DDU+i/GU09Hw7l8Zf0Od/l78vhI6l8hfpV0i3raRVKfytl4W8jyb3JdJWq706MvHPuHZLhvHrateszs+zOH5ngL8BwQJhlM+MjBM6aBbFw1cCfqZzu1Gaj5etobZwWyq/xhnnD3kuuS8uNGvUaoHDpmNI7ux7AXgJmGfO4uN9kbeT9YGgNmXl2K8E3ITQxFDDvm6fr/38BZgJoVEOUWNn9dCaQkSYQ1bga7NNqg0nkHcf0q7Nq/ao+hmmgxSadrY5qElDzUMd3lsLrQSF8jfBNJGUyGX/uP5jtr7FNnm/nPbzt8WPBwbr25rf0F8eQl+5RPz3mfNR0nYeluykH3V8BHW84o9E56AFcXxtl6uuXQQewn7fNCTy8ld4uQk4Oe6dUxp/0zz76KDgrRE+JVNAw48mpcUIeAGYW9f26fW2FoOoZG9sdZP9M1RRaSITfPlXIOPmjg7JY0C4lNd3U8bncvrzl8JTwALAHEXrSGJy/gxwJ3tegC9RulUOM9bQ2PP0fzEhZCref9w8sE4I8Jc+T8OOBKdXcS3Bg2HmpsqQY90OSj8N9GWk93ujhBp8posRIsAy+E2cr3LhluK5WY7mC9fE036wCucvUHPzikWkHwLbovyVVOC7n4PVx+MY1VUmj2o7D5q+NgX+fi28EHDa8vE7w/wdBMpUeR20UudCdZa+tAn4xphz9DlbOP02zm10trdyXA+h+UkHPm7qasypCVTIpOkiqRmNTmhF6Cx5jgMbuu2TPCjCzeZv8n31V2BJff+ktCT+Al8C8xYtS+Bv8iW21KKlaodBX8Ep4O4Og6AM1sL8PGvjd1b4W3UVepJUjB5768kJES/XKyCLOsh2lOFWg4z41or63hL4zDcJTWSFCJM8ATVBA97ym5LqcwGV0JCKZvd22SLAAtyO2fk9gih//X6uBKvlqUlURacQQu4nzsx1HdQ9J4BdGcMR2wIsQwhkf6ia5gCSN4GafRLBVSrHpKfUq3j+ts6r+ojJ0fvA/CR8LCw8dRErkaDjfWl+C/EX568Bz+UKhT6j/J2pDf3gCeCaGuN+/z/nkG93KWPEaOt9wAU9pzk0coZkbBnHxMWAgWU/qD2cs6qMPLwTOKF5JiiIv+cL0XJdzUfvdtTze90G4g5D02l0/V9lfVPb+vid/S2DDwanYCWufVXxvP4yBGzzh+D2mPwxevpWpvmzPYKsQPRCSmuXpFicIR4ARoAOi+83XToH7AOIpNkhgCMp41lAUBYIGUvL1yaE5KPEoVJuIs5fUjeP9pblVHzo0JZJcHy8edo8Ao4BteJjVhNCmx41oQXhEwFzcs5p3O5XxfNXjQujTgu49pr4YJKtBx97VUiLNx5VbT5psY2mxN9fgO1eTdiCP3hL529l7PvrEg8CUKOv/KD6kPddKMLpT0UwnTXAk59WSXsHff5N/s6lAhC+uGTPgxzDloP82yK0KnB8hfgLerzanvs0SuFvvez3cUOAdvn4K/8qr6ANi6nOxD8bpfNVpLtyjd+V6azPz7M4ftcwf6OOwuMaIUGtlcp7HHhOFTOd5HXwMjZutsbzxsuPm9xhEt/VqNPWRkQ7Adf4qeX8R0g3BXhBBZL+CcP/jPzjXjSw6mRCaNLajk4IcG2nKfLXfr4uW/Kq8s2ybSfyUq7On1J1nPLp+4w2j3emegj7mwN+AQHu6w7P3ANIe1u0I+1f6dBc0d8SYhJn/UY/UoK1sdd7w187iqccX0b6RIS/bB6TVMOj0cqukec4NJj5WADd9oKuC1Pm76uOceiq8wzyNxBZV53z9yNeNueZCENfFGGAIfBkgvL2uSs4ftCvqS9w8p/3AS3E2gX83HbIbZluC+w5TpWjUimLaghpk2vwCHCOSU43Bx1J/u74CzrcCpwZK2hRPi5vIn/l/VYHxm92/jb1Q51P2wtWSjtcjtX96l8lPH5Z+2d9fp618Ttj/FUXMvgw4uV5mJ/D74/vI5E75PYyl7eX15kw211WQCPPoL/vXlZ/Et73naROawgymNNwbYOO4wWkDwaEpJVDky40WfMyOU0DY00EWHgxU9O8hNoUPNmYDn9JOUQDCzD3a4CoxivhC/PPwcskfiPkeCGtpG7IFZ3SNCGUfR2NSK4xJHo5nLsOqbaSpKb2U2/4q+k8vpwzwH2Ws+LCViT5ffnNPW4BDmfg76/A7nF8KCxicYn8Ldls1Xwfg9c1cM4Y5zy1TZa/wvG2LtvoyY+6QQsLPpSS1kltCump6R93/m3sO7V5fxMH+Zy/BfXJ6fFXtIXeBEaEtlpI1T1/l4CDgbbn5W8aB8C7gBFYRrVvUg3tS0gfGdeW9fl57Y7fGedvfOOOUOPECEQLdAu0QppeOgXiZpgxyTF/NmlzYHXWwRPCAxL97u6kRktVlPXkb9wrL44j2N9C2hjRlqr8Evd4hMs4f/Vz2yaEbbBzAluLJAN/PRGKbO0ty3Gp/pCTY3VdCVP4D47QSa9W2h9Al3DtITZWeT/nTtzrIfN5YX/0amfpAhJN0hDiSNlGiGrjx7Bn/B1aGj9KOP8vpLd6+esxnefzOn8uF+zH60z8Klag2xPAlWnzN+FdHM876uzSLpsx/pL2ewPj8Lb6IzbbaWO6C7wFjAxhFPGNB9gC0UXgL47vZC+tKgKbtjKWtqCuP+mFBO5gXc+val7XY5NEIZTnmvtvAnOT8tczZtjYJPm64W/6tm4WJYWWnLad81fK+BHpHYHxm52/qO9e1PM3NX7TsYC5Lhh733FgPsv4Tdssz8+zOH5nkL++hsTtK/22nFH7y1xCtDhNeH4ymIx7YgLFOL39g9YjYCErRJuBQ9qciDlHNO7TZh9Xcfy0hKqNS55ZG/n1OD/j/LWduNOogYQ3xv0Z+OtYBeTPkw81ElLfiLbDyzCEP0bUmtWe9R3K2JFj1UVrYDENNeILy9C4qrmGFF91N8wd9PWe8Xdo3atWq1/F/caHQnweK8XPQaTOzU838GMu/gLXsL87J63WIH+LXCEGnxsz1HNqLnP7+TOF96dwvLULWv3Rb8tGGJw0gYnQgzivB8i7gs2VfGFt2cxrL1BNq0/2aCxUqc++rfqa2td075S/IsB9qg7wKi9/078K3DgY49fvW0xjVC+Pr2qa47egPqm3gvhb4vidVf46/Evl/WkPaIpUAW2eoKmVnCP5nRo7PK+/rZx+meos+7xsv9RWVogexYR+CfBERmnv8+MfgW0BwWHA4TrjL19xiJmH8mcrDSyhIaGrMukjmjV5+CtgKu4KtgBLC8p4NB2AO+1s32dqOq2eZxE4CGzI4vBaO3HnPGPCIUVbpk0nIEIGW7DVX/4iBRRdVN7zwL2FOCYtcgN9nu2Av58j3VyYo9i+87cqre3g8Rd/zAk20TYWLOLcS0jnSvrZWEGDrcA/HTRgJmg8oIVKXd8Bh67Ts59biL9o+52NxjbnETuXn7/AcWBjyXNX444EuKbGLwnm4KTpcdx326D8rbj5ucCtj8K+DPwlJ3M5Co87QOeCrUhENp43zhyvYMlLx4DpJaVzoM4Ap4U7CqWODLXh9iEmbOIUWh0bP8CynyBljoDXasfKRgbfcoF7A3V23H9DA4ub9Rm8kWuKX1n4SxzNE78LRCNDOSRVZWsBhYJ2jqrOM8GgpkmqzwUc36PGujvVSBpYY5+v/QURTS2DRqZgRsqXYwFxvm+ZFPaSv+nYiJIp930KbPHw1y/45mWwfJE+qa6xvG3H0yc64O9l4HHA3d5J750B/hrlkPLcQVZ4/on7l/SjCrxuFtquGGZTthN35TSbaqv8DNzNfLWS1GEZ4egXySQXeDAJRpSWtp6nuWaVNm1T5RgLFNazE8Sh+z6Dv5QGHrNbT5/Mzd9GGIR2/0Pe2+r9TP00dsjfK0j3R8Zvbv6ijluAr8n4xTHpw3JuzPtfNKvzjF/d3lmYn2dx/M44f3HQnTStmuZPPmNGZgknjxYQf2ZWh67+DhUXZubS4Gs++k1fRWnfDo/vdgx+GtgZ5wOne+FO/4w2iQmhoqcznLLKn52/Kr+JmkVYNMquWeQ6ol5Pz/OIVvp8PPw6NyE0hCy63qSuHppoIQ//MB7rk6b3/NVt0W24ivSRwfomW9t58VIn/MVCzHUtrPVt5rbmvUi1jrjTan6PHL83KHhrxhb6/CfmQgRp92QO2gW0LI4v68Y0cw1toM+fgN/8moGCrvhbN98xw3LnTtRtDnV+Jr1r6fg17vFYIFwEbh2sb+vbjG4TSgTjAp+EcL3sc7wNDtNBh+aL3wGb43zM3JJfqyL0j9XVLstzvnHWiMn9O60NYTs9tAUVxLmkaGG9g/2NBr+oqZ3HEWGMv/x+yht/f7AFWIoXptaLPp+Jv/zDgZiVKUGBoaVDtTIAlRew97mTVPO80DDtX8D+n3GtmrYAS2lZcT9PtiCI+R0aGudVGG7bMbztR6vH/JXzzNfXMeTbMFhbW0X68E7Q63JX/E3vl+eBPpoLzMIW8AVH/T49lcy2hd903hFwgYDSUrlw3a9awVtjugy6nKPtNa77FjLI4saQLnxcBZ4EqjZ/izbBifCmAj6mdNULQpru+fl7OZnBV6Wap6F+t9XJjyIdv4QGVPtNvq/eRjo/Q320WP6WNn572gbC3zyVqnKbO3GfPrxeETOtHAOHlVdo6M/KSzOSOsrWaug11GQxSS8Bk2j7COwoX7YwRXAJ1/d2PGFUhU44rWcqAZbAMhfjH51Ax/zlZo+6HgIdkU5gmYAok0XiL4eE7tdR0qg2z4fAJo+5ERvneMYe3R5DoElMrCxn2JLXoCfRWJL7BLa5Yj/5yz6K5XzSwiL8dQjkXT4R/de46Zor0IiexzYAH94E/p4A7ojRyE57zl+y+MPhMD9xm1pa9U0+n34hWqEMdsRWG4eAzey72UOvEO21u4ENoMUb9VBpOFpt5Bg6tGwBl8AADvKBRM9J+wVHIKKnkS/O37QAdW0y2vMFqJz8Rf5/THP85uAv6vmKZ/xqGjoEhrJ/DtiH/eD45X2vz/PzLI7fGeZvxGm77hCevDn9afEPWP+9ESGXgN3Dy2bP8tSf14kLriJ1CEeqlBfCtkZNdqzQATCEDfQcjjV0WZ8m59dVtM9z2sXNWx3Xw30MtLkuwKJRB5UPGWMlLs7fBeBSDeB8O03AfUjlmtyvziNNkOOFFBKdOAO3P+D8ZiWkfPaTpOl7Aft35dHAEtRE2Kg0W5TAhmgkra7NcCXxjELuI5D+g7IbPyll8rdFJ0tbTcxJb/EKrwsSslfT0j5IgUEudj1+gSUcv4775gtZxS2Jv6VEOfSaDr2chDRWv9B+1RSc0d7SnAc8GuBrdv6iLUPgV6NdtP21EWl4UtM2gAtUpGyAakhWhcxnwl9/n70FNPiMRhE0fYlp5OBvws/tICTlaaSgvjtRx19941el3MfieK3yz4H59fm5vc3y+F1r/A1oJ8Wdw3vKySgQq/J0Mi64KTgyQUXSWP64/4S3kBKBE7Gtt1KVT+W9jLIfU+3lbSwmNHwrX/hZ2oSQ0bdOxyQN8xf4Evc9BPwZfQamckiHOtXANdlP96rrD9aNX4NlTcD3kX4DnFcaPNSP0uSaZAJVBitX8qxMl3HQ7/QasJ1f7xE+tdGij2qHQPLKPhnD1g/JZewfuF34L/xtH+O6wOgb6jrS/waeQ/6DzYc/0u+BhcL4S38o0oLAfYy/3OcjzyPQeUg+l2NSDb46ChpsAi2O3KzxKwJlTiud8vE7w/xleQX+Bb2KwNIUv6cW7atJhPeAranBx7PqZ9+lyGy0DzjaSiMte5CEQiOXkCPBQQ9DcEWeqfOcagQSrC/6gyDJcYzWcf6ijQ8Dl9FOO6BIQGsqyF/BslD4ZWA+z/iN87cZe8A7wMg/flfxd6lS0xRzqfnGifUpjr7Oz7M4fmecv1wjJ+C0230vqTApp2t7VoFXiBdwNl9FtaW87cygaRV4rnISXqUfz9+0SRmJXqfOmdHw7Ag2cv5r7G/roV11xY5jK86GAIv4qTL2w/zFve8CG1jbItfxnCqZHN2awk4/gnp8muiwYKxcUnCnqITGjhR1Oon9raTNXg0s7vvCaIc+bwpy9DXdzy4A+6QtWf2GbAZ2APfh+c+jnt9j/+LN5S9gmWVqXzCvD/q7VVPi4ePAkvCi+/GLZ7yH/Q2FrSjP8jb1BaAUefB9pCO+gNbqH7bmhd+p82JyHj03KGNT9Erz5TGyGGW/K9S+Oo5DylnC/t+RzhXcJ6OLw/9UdKMLjDwITwb+nhJH5YOqRG0V1G8vcCkwfmWfueSwrx3B/vZS3rGlzM8F19neevANVQCtiPSOCiv8TqVzENgnIMs/OIhUOKtDfq8JWYa2CgJmcM2HGHCYaPfIT5k+LyCrGfo+5dD9qah2mTdcOMnr4LlOY3UXDSzQ+fSEEfxsQUWIv1qA1WmkUqHFEHV4AThumLa1U+KrSKfKvwdbyRM6afPNKzi332hzTIAF6B8zLoTSgk7TMbZOBSLAyjCf61T/EKDee9GeD7B//qbx1zLN0Mc/X9fYKHsLzLN8zALfKd50P34vNBqeA2wFa2mXxt+iaJWE2JdlfPF3nJx3CEN5pLcfkNaF/KikZyuh8RNow1Xi98eIYGeZmxGYtKNCg0vIe1fhY+CPvrcfQdtGvE+qecuHOH8XcO6pkue65OPts8D4ZX1V5xtvAnsN6bNAVUjfLGJ+nsXxW0jd8/A3ohXjNe+L+pHyqpex6yoFyLWwgM0vrIn7FouY+eUVcnFasHLr5RXNB5dXxx1OvdU97HxK+fkTwHbS12QL3ufiW/f3VS0TQkJHJrCYIn9FgBWnM+ebpsccsAP4G/Ab1eIYtlMavt8wzRSVcuL8t13WO0Ir0naA9IM95CdeCTJTajoh19cEtjAAgDAA6T7vu8KYn73viyr9oG1C++4BjmJ/oWv+aq1S01n+FdFWC4yPCJ39c0/8uTJWD4AGCzInKRp1N36xUIO8t3Ba6XOMNzPAX5qX18+fThpAIGliHqrHBQ1Jx7Y/P25CaOcd+35dQhmveaJyc9MW7v/VpVk/vG5q9ZWmFRES6+AbgCGk12XZgUS436cPRUPSHoOEVqRf+XgU4m/Snq+FB3weI4IZQ2gf5m/Cv3B8a47xq1Ivf8VSZD/SS4Hxa3/rsgU8zY/TSDfnGL99nJ9vpLM0fpt0jfB3qpK2KiCAyeeYGvCWE6CHO/pRtB6k02UQZPnaSc6T8swfjO2YiL82/eUQtWUFasJGy1tCfQ4inff2le5DxvJyohE+tQCLmQ4SXzJh/ooGVkATM6CZo36O7wdOOKIfTQncj0Wi7Y/Y3xFfpUlRCHVb+Eqkc/WWa7uIBlYJziobgQTq8lfgSkb+cprYvBkhPYi06snqXXyTn44hcI5pbHQ2fvF+QTmPFbbCWzJ/q1LqDP7tB0SjKNhPeH66+HMeuKNk/qKu9wNXdFvIMYPlTyhG54vAI0DOcVR1qV0BGj2B9lzL0CeJZqHbbO7ade3UgjfUcxvo8G18/BI6+sp9ZVVT4jU0P//nNivjd/VtdvhLJG08b0CQQsIlek3tuPSVa3DxZ8QFYFz7i9xP6BenQUDIpvYJHTjfbd8kTzfqsNpnFZn4iS8lnzNetX8GL4tdrA05tZ4sPkVXxjmv9X03TAhtmnEfWNPkb50EWKTeYb9ytEzpw/cA36iVSlXv9rWa+YawV5y1xo7t4HsRuDegOao1sFT7Eswoglqwqc3kpL2KHmoFXgRYDj7mFC7f8Jf2dN38VHbIX6GNwODNYWBLRKvYS+fA2AxETlUC5r/XmkaarkCH4/cYzt2aQ/O75/wt7YcA5YjpEPCDfodxJ/+SOs3dhgKjn42Ad2rUjbUje8Am2+H1JuCDJES3Ta0A1b4WDAfsAlWukY8F9fkS2JS1T/Lr8bzSZ48zf4vCByKAon3ez18pF3QXQUxV4s9343cOWJzK+LXzcp+x2mfY3UB4/PZ5fl55fhbG74ptzfG3KlBC6RAIZe0klUOARztAQYMsmz8YltdfXtJcgLCI+DKgjlB1SsL/Thaa+R/yQg1pJVaCAM2y5OWC5rYPLIMHis7t+6bNX+Bd3LuBCZKnOj8AxLzkDtTvZE1DJcuxFkrwvLX6+TbU9dv5nndERzGv1yLAMpyHm1F0dJ2YeRzvYxdwbp/iUzC6DKeRnbcRmKBOTyJd7JS/xlxXt6+dTkJ52ja2MOSNpEOv8zr4+Sv99Zymsy0EzD5+Raj8IjDnmYcnoVkP+WuA8Fzd5zNl8NQlCUKfRd9Ysk1GI06bBaZPNVtYeh7YR3hCaMp5FOFvE30TdT3LaKTbawXhaaf2AgDhg73o8yihi5s2rG9yfvj52/RZaTOZ4wKaWASUv/WyG4bdOcZvvN8DEpTg56mP36Gk1DeW/Y5/f/y7RDDL8/O4+2Zh/K48N8P8VQVHhCj8IfFIaFXkOl855Nf9ggb/h6GjAxMe8Y7C8hEaO7R0aFs5rWR1/GWivaPO1fTHVpfHoxDq/MD5ZB5WBSIthkxV4/ni+akPLIueiVcZ+CsmhI4twh96XvwjPIr0vNbWsMwd9Ied5DGj9AEqL4vw8/k0hKHixF3al0DDbAt/AWpKaGss1CoKYYB3OVZph9dXvd8DRnn5a40xc0wt4fjB6OJUYarxqXxT8+OjGnwgJhyKR12MX+AXYOilf2HmEaVH6J1K3mZxAvheeEx+7qW/WNFBtSYgYOcdP9fWkn6Be+ZvarQpHgX0zVRXKgDgP/2WGaG6Zvoh0oFiZD+Zie0ouU9OGGzmmCEEJLSi718pS/VnN39HwNvAxky04uXxb7t54DVgKcP4Faj8E38TX8W5e0vvk6Xytyft7fU7dKKbC4oEVMU0QuzjDHUK+3zqgeZVKHJeDg2sxvlxjY94WwOKOWnXKYf1HPO5nwG3eCfHHkwgk2kgih8FEWAB3HRQfSjF+WsLsKrcqrjUIWNbA+egtJ/4LSI+nxid5F4auelnMbnk7SEaWMoksG6gf9B1ew2zQRLRy/iZESfuUk+fc0snf/k1cZx7B9rzfTf8VSaGplAYeMXgL6EVGQuusjT4NT9/b5fAIEZwAfvno8Px+yYw51kgYzzoIX8dC2mE78a+b/VYPwO8fP26QHq4ihYFcehfq/caF9rUlnmrXgxYBB41xkfYFypfsOR8Sr7oTkm9AbZwYQigakMDq01Pqt0q0PRfQN4DSOc8C4CO8ZgQsPggz0PdnwOWdPAAImw3goE4tIN8/F3WzLst1/jl8xvnL+rcmOidyTN+DVoZvt5kDlJ0/hTYPM3x25f5WZ8X9HX8WnlnlL85fm7j5oCR/UAEm9B+xIl7G5zOBkh9CJ3j/I3Xmb8Q5pMQYnS7EZJfQJx+q7xcyCKpQEXzAlKo2oenKRBh/A0O/CoH329PAiykxo+gvSqagb+mAIvTKr8wGfXcmrSDjKhUil7EabmGbbZpRl46B9RTcGK6xxRY3oBhNkjGnKQJcmwEChgua2CVuPKF+s2hfk+l+S03f23BlxZqfVroKt+0Q/hvAf5Vq3FnCU71PV2M33rZfH43UPKiVp9Xj8MbeFOr+dyA8T4ESBQ8l5DU9Hl3BOe3DwrdUL9mTnweuCZtsH0F1YTGRNMNx8xM2M6bcBrH2wZlbZUjqMgv9dDUjNcLSuo9vPqxQPPNwd8R7nt5UPCWLEXezTB+icCbRfRWvLsMPLbiXVJMn1zfekur7urMJYvc/C5iehhwQO3yWZJf40jgzcuPBV76kue6aesSnAE+QZqdpo/2JR6pzj7HrxsvT2eZSH/QWlic3xkc7gVMbT2rC7o8JcAiAsI6pXn4q6IQBnzTAVPWJEX9KtTtYKIHjx5nwQgbTlK9urq8f5kKYnk7JQohCRFt1Z2H7jbaK1BRCAvTRP7/LZmwne6Cv7p8c7ydWNnOUj9ieF1s4WHy/XJVa1ohJQ7wBZ2N34/EaXSc/jPA36BvU30uMIY3gnfv1cHoazrV4PkFRiS+ReCFkvmL+m1NAQyIs2tbM5JrcNt01NcoL95AOhftv/n5oV1z6HYTkPv9fZbzF2j6wo7A+M3+bq+X3Yhcyj5+tdDP1ray+/VPK98lszw/T1qfPo3fArcu+cu1lSIOvLl/KQErW4E+l6vN+X7Q/Z2W0SXujNWvvSXHBM46Ezowugi0b5LNwKdmpDpiTtRKGZiquErHXr+G9BmkFae931zDMf4U+HN5yuYPFYWQYSjIw19x4u7RBPTQhM95dpoEWPcDvwFm/+P9UfZ5XqqRcw142iGcrpgAC2mbn3KeC6xUyj+ENa3EiTvnOz8OjRe7L/y9C/5KSnEhBaao8tCKp973npe/jdYE2vkjixZXT6BF0Mn4XfZfstfxAUjHb8/5G663ccyv6cAc+4DzoilKo1Zy0yLLbNW4n6Fuz5+/Yv8W92Kq/5gvotkClv3AUm38pGvtKDvCp33NJ5S2+As09LwX51T/yX/sz4t6N9iJOv+k6cGOeR/V/phsfjH+AteAvwBVrvEb5Qfq2gSZ+gR1zD1+5ZhcJ+aGI6Gpf/z2bX5eeX9hx+a1kufnm8Pf/Ct1VSBqoIsAsXLi7XVoGoXMK8n9tGxWVkgTzU8LLkgUZ55PYMK9olcjDFBHhpNrXelIZwTyjJPAnV36k6OTGd3i41dFIaRaVfJCzchf3GuYEBLaBO73mpA1JkzfqJ9hFmWJrYJSQY+pbTgCXh0ENqWBZbeBm2kZeR2ruaKBla3vx7ckyLySl7+6XKGzynvp+jw2W9vKd8xLNacraMMFTdnHr+BrnNvckxXZUrZ8vibFzcFX8ehrRn+xAlwAfC4wMQJexz1zpfaj25cjT3+GdvrpNXTQenrR9T76YwFjug/djzZUydn4yNdPOZ2lj1oCQB+PgKM4ns8wfuP3S199HPVc6HD8xgEta9ThDtr6ns/PJTkfX62cHmteda+Zlls9L2CG6BPa5K9vFVm575CmlaDbn3Anz7jmnpjVfNey3VZ2+Pqc9qvk/dlT5XLzQn38fICWzlWEeARQv8kcj0I4Kc3z8jcJsKCBlWGuojRxrDS/VauoZlbEM5UqGjlCtVtRct4EqogWBsrZs/wsKVfKtyJ9krDSglaZmkZqhVcEWBnm8VBZosGxEzjZBX9tWrVwBef+RN+H9hbXoonTWV+TxZGdaPepiTQJ5NjUMOhw/F7EPQ9I22K06jl/HZtbs4uvDKe+BH49hHTRL/xQ7zLuM832w6nL5ULSE8DOqCZjlkUgEbI8jLpfHEsran6maO8x7fJrysAUGemfAtqIDhcq/B+KCO+3J7qSqHVc0FLbAUMAko9EjUyLOg/nGL+BY0nFUuT77scv19ol/F0EngeqyPgteX7+I8d9GL/e+XmG+Du+8EJtMDN8YAXyhqPsxbXKemBLa7TNHU75GXNCNn0ecKEU11KQ/ZqXpbHsMHrPyrYWvBpQSRoXVNZEgNWmaVb+aifucZ5UfhNq/rJF+55U9daOyjXNbKEr0gTDka+lzZaufQJsDrzkB7e3NLCMNqjxRswP5NiI2mWG9b5hQlgZcJhd+/hrQtNrM3A4N3+FPuRaOyhFFYiWE6Kz/8OU87cRaBvOdpXQqVZ9c7x/rA7H70ngNmZ2PulH+gzw12ivr0+4nyumWNvBn2PEsb/AFFgSjSC1GKCEBnYfs03pPm5HIxMEIl2S/H46o47vqYAUzIefXjTRppt2XttROdc++idwyzT7pG/88eeifvPAW5bJny30s/ul9GmmaSRQPNURDUco54PURzOMXzulkGjLc40/OdR1sfPxS4RWjL/IfxbpXs/47dv8bKUMJY/f0ubnLvlLHuZ16m1vGfIGhU/x5wbaHJDGOiSwoby8XjxvvM5p1a0GfjBMyuiqm995u7XSwT5slBncKH1sbcztCNzmUf4ADOrY0MDidM3NXxFgxdvL80Yi9snP7jgTVjkm591Ovo3nfgJsDkZY3EO1T4b6mplHmZ6SdgnEhLDgLWkFfQx0wF8SuUv8jjwymMENdLgnaeUpesi+L2JU9vErP3QvDNa3fKYifo3jF8CTBa9TcbnGoyBzTRi/k/ikLXQfa3/c1D5+L+p5F9p+Ti94OH3PET4Y5Xqdxl8BHge8C4L56SqBY+4BfllN44ovDLrPcWGL5tFF4L7A+M1+L+p3B/BT5+PXsxBs8/c9YEO0n5U8P0fuLXH8ljg/d8iHOAEyqPZTEyhyLxUO+c771QLdbQTCPIibO1U+rRue301zOxTtG8BIT8K2WZm9IuTzGSNw3C/nzgB3sv7qWKl28jeuhRU0Wa2UCSFRT8/LX/GBxWnmN1N2OOhnH0F3qpU242dYa3QYK3zMMfXqH0GfYH/zpMEmLA0sxUdjnNVUq6V9TddZa19JKgIso870HRPgr5nXCIDwRn7+WmHlVdCEReA5Mhe5AqpwGnM6+/ukjviI9n6u6GfOLe0xJzRT9Opi/B4FtjJaCTitesxfcp1slA68TSni7jnDp5zxTlP9SAsz1bzJTZH4vAhI/UbYfycSCTwQNIhrCWg6zzd+GVH3xUQPPc/b2iZcw1GNs/Z5N38RGAK41ae5rRF5/wi0AEtrtNmRamsqLCQO3IlmV51gLBC/mWf8crryOUXe2Z2PX6Q6v0oZfy8At05j/JY6P0f5W+L4LXF+7py/AZM4kpd3BE4wXh/2zMC1yvuzSq8Dns4e+1CX48CHLb3Xof7v/ljGRFs3UdlMkwxiBqgwZKtqKnWiVfbLNl35eQfvSV5HmYTvTm1BLcAaWr4PuuKvEmBVDQLCKMoXQl8jBLvQRdOD/GzTD0wSkU6dEw0sPjfaAizjAxcg/uasD2mdhwtIlQDLrnMu/tJ75WP4FdR3lJm/kmf1cbMEHJhkzg68f2mZzudWpE9WwKPAJarBoa6TIBKZxy/Sy8ATAJnnfRqiPeMv26ocC7CGIGCuEaoY758JtXlIPyGBUCQP8yukzv+M43t75OZg0JjNAj+rtroiR/s1WVz8FSH0COlTN/xIFuIwukp03IU6XwV0+wRUg1CO7by1KleVZ777kz/InazduS1UiN/Ku4CzXY1fm16a5oS/S7j2CjAX7YOlzs8x/so9pY3fwp7TIX/ti6Woekc7YeXPK2nsuXEfOlHa5eRZ/sgC8iMPfKC1MQS19XI0X5bMbw7xyyP7TFjyPeq8I0xzIGDaWuV8FhWSyar0abICCnTD37oTH1jcBJdrHWqBDXcAbfqAal9jq3xKA4eZEHLhZhJgmb5D5FjX2U4BpbGiNGLGOXi/gON9XEPWbl+Av3zRQcwuX0F9R3n5m/IqWsl+whLyHSDtValf2CdpdGGN8Rft2Yp2f2uYDbX7pO6jtl8dpB2M38+QbiSCdff7u8f89fjw4tcFfH4QH39nhJfcdBewx+GYbx5VNtXCMHzitbW+lnDPi/rnldPCeRx/P+rAPk9K1DxCK00HTSvJp+isynLyN5no3entk2SMuBYjjYWyj6T+pE/qeU/TLqVs/jT8YVqm7Ys49wLSuVzj13GvbDrI1Adox6jj8du+18hD+Hsc9982zfFb2vwc469sJY3f0ufn3PzVmcIbJ/q0n5OBOYH28Y4el1zmj5SVn+f8OibUCngAE+z51mRtRH0yzT1WmiQpgZWRh6yQpH1rheoa8Cz25wL8DQqU4v01JlwVAVbdaGARh91IM/NXa2DF2xcvw/D7tln3NdnnP8GKFvbHkEqVMJf7wOLtFR9Yul7CR297FYxyqQ8sP4+6yCsaWNn5q+/XZS3h+ECptPLmTdpXTzaCOetnlvsYs4WGmcfvArCvD3ReC3lT5MH3TX5r81PuB0dgj1s5tiMa8mikZ3Dflj7QeYzQYBtwzPZzpdvLxytgCFtC/IUJNtJXgfkS6Jzmvz8B5wDaXm7+ZzkZJ/cqE1BACyRPIN1Scp9saIm6X+p+/PL+rvir8/wFqPo09tfzrueVLehEPLdD5JjaelziGVgdrMh+qE28rv7O4fWNoa5FnI7r1aEjppmRGX3GRm3dw8tAXm7GVsvxEVzbRFa4Y4PYsYXto92bduLeohfxVZWTv40GFrDBIYxlYy7OX02zuxUdGF3UCiYxyxtaQg2l+UY1sDgNJQqhFkYaq7paK0i3e1x7qBBHBFgFOZO2nIu/XQ9z81euE3OcBZx7enKheDGa3GO3Rju2MUvR48w0/+PmHa00z/hNGifvABtyEHRW+Bt9rnO+3t3mowXuxN82s7bLq7lzbA0RhD5htasP/EU7HmvMaVvtJabkRChgLHrE+YtyL2J/V5xW8Xyoyxzq9oXQjYDMfX7BCzGdlevXkO4Pj99cm0SxPdLt+DXKYO9xjSPA/CzPz4XMWVXPaNwb/lYB0yOfGR4Q1Cqq2Dmel9cxkJfcw+7jdrzct5X/uaXlTatDjwBLavVHqXWTyIAJNbHf13nNiDP2/aLu/KhfcCq8nKW8K6MQ1gbtu+GvaGDlplVQgPWgqcFBjhUNDG01y1RFPzcehVBMCKlavNbQM8JM0zrbx8CyAKtkvwGo41wjOMzNX96vRKsU6cMl0opthr+il5JWhMztxJ+VbeKq551c4xfpGRzf2wc6Tytvyc9uNEPAj8+ERypVPFXznWX+bgqbrf5mlGVoJgNfYf/WHvO4aky3QJMvbzdoadOK00znjfMX6ftAdbPpXC+/j5cMn1XqHG/3mHMOWtn3LPfRUvtk+ld5HLjW7fi1+lfbWoXw9xKwH/f0cuyv513P69v8TtUrj/ZCNIodqyM7T8pz2Wn6PPlzTQ+fw3iNiMZNxMcXp6+uc6Majon1OxpWl6yS21HrCIiTz9p+dnPtQ6SbHP2NpGmfwGFTPE3/cxV3RJ1MCBVvFC+64a9oYBGaMT5x/gZW9A5wlXGOmpyneSX9R6JZRBNvjzWmiHDT9mOiTXcltX8QRQOr4A312w4c7Ya/9kev3JcEWDOwoW13oT1nlUatcVzrFCA/GZnGL8p8abC+FSPwAq+fAl+uTsxXHlpfz4kC28k4TdWzrwB/HuitZD5Vq7xbLtl051pANck7Rf5eQPoQUHVOY6HXZuCwO2CRpTVoLPba73jrXjWPNjzdV7LGCOo3BI53N375YkdtlqPwAbChR9pEK/OXPFf19bm94y/VivFqMLHnBZynO+vI20ue64kOF6edbG4aZtAac9MrTBdxYP0cJtwFNVmTlx5XtfW+dBVYVJELwF5Gl8i4jAcl4OWwvJ6xWicn7lzrDeiCv+OduFe5aUTzS/+vUM9DVns4+McPT9Xz/uaYg3Xb0oqvfo6vLTwl0QuVCaFf0zUg6HWNX9TvHuB0Zv4KzfhP32Wk97K+H3R4H9dkBojmQUPbt3208r8bcoxf8OmXFBiEas0b5+j47Sl/jWd4I0Xz8pQm31DMUEMYTtAPmIaLQ4iNvF8infM75OV04TTl5Xr4m9xNvId0xGncAfizPwU287Zx2rjoLRpDDwEXtR++9r7d1xyQPLxcTadDwHyG8avyu2kq32rPIV3MOX45WLmav8ACsKuE8Vsqf1V+Vcf843cW5uec/O3URwIjyDQFW+p66F5eB8IsSi/7uVyjS4PTnuR1DSZCR1ed6+XwyKfVRG6GJWfCDnWd/2RYEbz4i+lNMshJ3/Nq9MQdjTv5P/BMsNoHFvGPkJ2/tgmhQzjt5q/T6X2N+v1Yk36poSLSaLrycOOAKmsJeHEKK5V7dJs4alJns71mvpAGlvA3v4+m/5Efsoz8NSI+jhlvl4AdeWmW3xcg2nB/0oKgtLJ/2nh/nPb4BaDlsxyKv7AV26L426HvpaqZFx0CEqJt5dSylHxufznAWeTZXZAZSDWF98tO4Bc9fuTYoDGZO7PwdwnYn7mvV6tE9j6m2+kSytsRHQ1hFPF1Bah854C7C5vrVtKyBs52O36tay5B4wh4C/dWpYzfEvl7YyucBr2Yn1eWVzoD6A8xF2xwDYeAkMj1LMezST0VyDWXVBPw09lRbrANPF/6KHzV/rgnjiIldX6g8LI0lL37GaQ7CU0j5rOVn0c6nycv5zEfSy0fWAT5+atNCL30cvK38jlWXfb9hvSKDqdsffwRkzkpR4VtrnV+zY9l30d/ifx8Gk7ctbq9fU6OrehPJPpkQkCAlSmQiR0h75NO+GtGR1Lnz6O8uZ45Tl0pdLglaT8ITZRpC/ErAhh9t7WfYfweQxnbrLb1SHjUhx+WSqXa782d4MkPANHWU/y0+onua2psS6rflaQeko6Qvg1sGJSzxQIGiOb+q0IjIrRPx0zrMRd/kR7FPVuy00r324fx/BHXYG6niq7q2KFZz+fAEfCW7qPx8RsvS/ob6vga0qUuxy/A5w2AaH+dAu4qafyWxt+S57rWNpt1Nvg7Gw+vbqSFSCTVvkObyS3EyBCi0mXextoa0Ti7EdbXmHyNydmc9G3bcP6i4C9hHc3nedTN7SPOe76gyYfyVzlxJzTNz19lQlg5+6qfv/6P8H+2nYA6/B5pB598HNkhwW/gIrB3KhpYDhME/bHH6OBYyRQn7mGb/0yOoe8Armbmr2Ay05FvS3eozfKniGVL1g+XGTBEgVyb5vgVc48HCv/wDfG3T747kiDgbV+fUPx1mQPRZzGBjOA0zm0vuB8NAsFPtgIn/CZXBh3z8ncBZR3A/lyuOc+ICH3Uba4v4CbotE9yGiWz3G0lC8CT37Xz3Y1fpvHr4sWz49pU8DtilXzFCm/66O+r9/x1CFgCUbhIftaJQteBUP15/rjfHCCSn50r8Tom3o3JqeDI9XIkK0Dc3IwIqEj434QTON4R9zflz1/gMyvLhFCg6Crns/KXCbDitAr+FN2Ldi60VvBamkjjTerkvH1OXzcEGNoJ6DngtrBQZig+sGpTiAIYP/VKoCLQzlJNWqXj8RpYRbzgUa851PeN7vhLBFiy/+GgxxvqvwntOEpopaBppYSqaj/D+P0SZWwq7KOzgM2h6ez5PuKC0MbNweVVzXaMfdVPvOPXuE5N8+Xcix43AwGaOd0OxPmL9mHuTP5TDTrr9w8R8ufl70nk3catLOIBk5K/pseRXpH2a+g6q/evjqBqmvEzAaHpq+lArvEbnjdEQ/qjTsevzg/IsalFp3EKuKXE8VsKf73Pn/b4ndX5OQt/SWHUTM6G39l34F7a+BlVvb+xVT0tu+WbBFgiKwlk1ZuuhsQdqmozm0Wk+wflb9XN4C9o04pCqPkrxx3xVwRYBY3LZsUR7TjCIilyrRufk++aO/n+YUqr43uUWZtA111fk9RoQzrHBZ5EgOVx/JlhvDwMXMjMX77aq/1jPRnXxM6f1zL3AA5IYBDdnyi9Hb6tpjx+zwJ7KI3ifbLqK3/Jdf8xF4R+qEPkG2Y+VmRPgRa6859cuVcLoaU8PQd8A2yftK0Fan1T/jU/52jvERGuKD4pOo/jSVf8xfHfiDN9aWPs/bsFdfgl0YUsDsm1se9sm1ayv5J26rmm8P9rXLs1MH7z9WnxT/kA6nut0/Gr6QjoPmfyVyKPPg5UpY7fEvgbE3jZ9xekvTRT/K0KUPmmGkgknyNV+zRPgMjUqblXEivwmRhGteoC9aL5k2PJwyQqCdGYclyjUaMEyjxNoxE6bI31xbiJaFTr0Z/yZysNLMbfYV7+aifufs3UHPNFvexP4ZXrpkJx0xKA+OhhZbWFRh9MS+Venmeaa8n+kITstn4aOO1EgFXYlsKbf98Zf5kfjnbEoj8Nero1P+3AD0b7iEmGpU1g/IBMf/y+B8wP1rebuVWtIACYPxymQRokKpvDZI2YI6kx/DTQRzMe7yLAI2jnki105rzJzl85fxrpXR3MgU8adaSoST793eYsV3A11bNYp9GNIBD4rOvxazzPgClo/Arp1sHsbb2Zm9ZpkLltXIjBI/WxKGoR/zOBRgfyOkPuAz3WAmP1n17kCjGZeQbpVUszQJ8X8GgdxkoSiUCo8+pnJ186fwbc0vu8WlN8LPrz8GcTAZbJR0FO/sY0sAL8ZX4p5oH/SXUkYa0V1HXqIwqgARLa+R+fmgBLmR4kmO01rrfyMbV9OwphSR8RqM8Qbfqic/5qmgHq/p+Q1oOebqj7G5aGXg1Y830tKfVdkmP84rnnsL9j/YO2o41rsWwAX44TAQA1P+Mg+dmzxp8/grTYqI5TFmBtBA4RHplC6y75C4yAD4BNGee/IfCjaoNbkOXKozWAOA4DG0ruh6jfM8BS1+NX91H3O2kRuA/7Venjty/zTI+2vtCtCmVmhTkEV/RaoByiucIJ4s/LBQLsfl/kMl4uEyZGnYSzsierE6dpigx1jPoVMMw9GHQ5Ah4umD7rE1kdJ2ODR4GMj1k+Pmz+ki3AX+XEXdM5L3/jJoR+/trn2z47UJf/BX5TP7N8FdSGNpGwzSRWF2bAX8Z0VodrEWCZbdKCFQKi0aef1zYhLCVKS6N5VS8Lr5Y65K+A973PgM2DHm6NdoMI0Jlw09AKJD8aTZph/C5h/zXsz62Rj9cCNirAegwYGT+LMRDhiUuoonEZeHit9Jvk7+mB2nKyTXxZdcpf4c9uiw9RWjR+wUS7m7xPAgjSZAHp/SXPdUlD+sfOxy9btJvMWuXzQf+3Ps5Ja2LRoDQBlusnNa/Xfl1uwZ7/g34h/A60I1pmHtrn8qmEifWlmmlYqesERHur9TyWz773PLArHKkxbf/+r8GG3x8bvAHcHe2Pob4X53tlaWBxzavc/NUCrKjdul/AK2HYgfdQr5EIX4jKONHYUKn7A0qZpX2FdKu335EohCIQsAVYvN2t87If0MAi/M4WdfJR4EfUtVP+SkrLXQSeAx+qgiMCWX1uE/BB7ROG2sekf4XGr77/ONJhD6Mn5edv999rVcMLYt4rUGanPoG8f/za5tXACHg/g4ZPBv8y+jgoxHqD8EfxqHP+Cr4CNrq/t/gcuAP4Tc1Dqv0Oh+TuOZHSagS8DWzMNX5D37WiKf8ysNTZ+HX0K8LfX4F7+zR+c/I3Z50Leu6a4i/VElHXTMR957A8uTpEYc7iZ35LP/EnJ/tZAAI+RfQ9IdXpEc79fZrOwH//r8Fe4Oy/Hxt8AGz6z3HWw/CzlURsEgEW1XjIy18twOp+paRqzBvqZUeaP2F/SUcr4lqHtRGyu3WcIPuqDO2sto0Rrh8UDRCfebWkooElz1EfXLpuxnkj1RHgLC2vlgZW3NmkW4NYfq7uQPoGcKFz/upydR6h4SXgLsbfQJScbA7E0YbdaNNlpeVp0EqOrblJ0y7X+EX6ly6FQX3kr9Q3w0e8XnA4kMxwhE+GIECNKRJoQu4xfQQCxC8bYJhZXwLuKejbtWLXE8L8beZY0OmCGu8yTtW8eFP4K3x6JODOw4rM+FdVJzuaKkDmOSOv0EDRmLrsAM5j/74c43davmPRlp2o58nux6/qb4o3jL/JhH6+b+O3S/6ScRemRQ+EWL3lb8WO/Q7YuQZR9APLkydw3qWVQtoU96uTEHhuVUqdGyFCWnUZWVo1dYKthcNAVkDI/QIl0DqB9A42AVKaivBqI3AY+B2aWJeQPhLRhvLl5XWOTNA3NLAM/iqa5+WvCLCy00qrnu/G818ATibhEHFojtQEvV+fs52iy4e61lLaO0Vh9R55rmGCJfv6WJ/X43Js+SoP9jP5wOLaVtuAB/H8d5BevSn8pWaF6mP8X0hLX7SpxvnBQZu/0W00BKg0pLlCzvF7BNg0WN+K+LBPWiwX1DvLAJnDBHT88iALAjOy6ys9GL/T3XT00UXhgb0wcrP5i3PfAtum6AtsF3BKC0rUMZkHowvCWtDX1r4qv4+ifu/Uw67GL82vz9vRhU+jTlsG69v6tr5l8QFSdagFVcWkjbxebehrUZoSrTeSn0cHjDis9tQFk+vOZtVJTbiGaQs1I3Pcp66zl4BemTvAaOkRIEJg9QCwCPPB35H+Dg2sbxy8rHKMXVJ/j7ncrXUSYBETwE74Ww9FgEXa7OOvXrHfBjwAHAS+BM7dEFzVxF+XP3oSE0KociW1HaMfFzpNLQqhbTZlCKWUlpXJ8/KiEKJOFbALz/1vpE2/OwpcKoC/Qnv+c/Jkn4QNA+lv+9H+K5rO+tj2faU1MjoYvxeBxwr+oSu1XjmFIK9T/mn+xxGM/paEFzsLC7FOtgwOzFsRSMdrXBbBX2hkA09Nqd3zwOvAoq8N3frDqtFHUZfbBthKnbsaSxHU8VIX45eX43IOPwJeHKydbSbmrLU0P+fmb5Xguq/HvheI0MHjgD6u1RanM783Ivxy0FPKk9Xxz23BlVNw4dfQ4UIU28nlN6j71rAKqmhfbQW+/XcSXiUsAk9DGyuoNitpXCDmr4P2gUV40gF/gePg38tIX5oIQ3r9INIPgY+TU/8fgN+ABWARGBnRjqjPCS5k8Ify1ir/Y+szcgguKocGlq0xNaGvK/GjZQoaAErnq8D7K/lbDxXP1Xk5lv10/i3g44TD6efxMrCI/aXC+Pv7/7F3PZCalPv/NV7Hcax1rGQdee+am5UkSVa2JMnKylrZX64kSZIkSZIkkiu5cq1ayZWVJEmSdPeulWStJEmStbLWWllZax3rOI7jbX+fOefZ+23up2+f893nnWlmO8PHM/P8m2ee7zPzvvOZ7x8iu1iroEq/BrYMerbh2q7C+A9z9EpvHbFJEbVt7/7d/2viuIt/Cv8sW7lq6nsb5HHKlxuvjTi5Ln6zNLnAmuurvz+PMhE6+FOtqfQx6W9130V873dFvsAPwCh77a6aqM+LjxbiGsRcKYwMjsbqAvAIMGxlTQKX6Lj9vXbvXztWvzlCvodQvrnP929kzD0dN21/pufzpOVbZJRnmyRyWVzTp8Hry3fIDtC+OHbyqX7g+lrVenMce98FnPEICn4JU8RHVuQ63Y/9gM8D9+G4UDJX5UnzqsKDwHxFYNVIrN2Dz5FeFZFvnuy0TxPVVhBYvhxZDu3L1ykvfUJNR/BRZIyMrBd/KWb/PYDTh5npUj9HgVFQ3prA4jEyGRX6AmmwdioKYbB/0gDrv3xLcZ6EZbT7O9KpQc+2lRd3kIY9lO8C6l3fxhxd+PdgerC+KQJrqiKkTY7qI0wcpdOfgia4ES1t3XToohxngc/9+euQfGHumJyFDzMjZr7i/D8R/v0EIlpEGl8C1cfgzr6wVyb/uKYzzd+/cUJMyHcM3DP4c2x9JWTWt/hc5U9ok5FiAn6eoiaA+cQboMv0eDKIgSBxpUm0vAiI8TFXP1h46B4UpjC0L4+5DFCmIqo+4SO0m1kbCavnEwTVHLSsfqiTV9hfTcfAM0q+0fxm9/lc5ANLzPkfI181Fu6D1q/Tf5kf7cy/Lp2v6/DxEo6fQjpsRAOLxuDMo/rTVutHyIDmKj7PvP56K98ESWD9lKKsFn36o5ZMho71Tb6JcHsZmJLzlk9eDX/59+A5pH+78O9+ybfNc1ZmxsA4I8qcQEBLI+ZnaQHpng66BWlvYy2sncAZgO7Fzsl3hGevILLFtW4HTrgkfH5QHE2GaZJwEbhr0OEtRbE93Pb9C+h1qTWyPoE8hpfD/dvx35LCL+qsKeFlKV/yqSQwEPW1P5m4YIoOLZzLcSuabouH6t/ILt+JpqGdQkZD2VK/ESwCt05ysqFl9ZSZDQK7U2pE1kmkc4P+bUVKLQqhJ99RZ+Q7KfD1+eZdvmaNiL7Hbak+4J/Pyik9BowUSRuNKPvfKIR0vgBB6c2d286Jeug54NYkq7Xpr3zXGh79tYh8RVnWR5+AtucQ1/gC0uUeyvcYcH2+z1AtD5BWNwA/Xvh08CnSK/siX1E3pIGunmOQz2z1EhjQtKnLVWrnJbhrU/i0q4HW04dIN6n/9w34yAxsLcrXyIh3gdocdli+r0UDWaV1O422b5a1MZDptD9m2/fNonU0VjaF49+ZD5E/29T9a2mWGeZ9Znra0v1rdQwjp44j36QxdufldP969Tr0HlxEFXTWn8/NyLeITzwLQdfRA84nu/S51dhz/E3RfkBoqg6VB+sobTBVFtIOs4h0cyV8BNmPm9CwEbC6Kl/U02MYA68BM8686Tln7asbQVD9CJjWle2vIDl0/yeIrWlxrrBpbSTQQI7ZKjtxV9o37cvXyjJU5Z1+9Hh9EzCuL/rwwXVGLun3BFBMMGBGQSaEHmldgfLiBKcb7RDgeeC8UvbbU/nSS4Z7/h9wvDUg38l8/Mg3V74J+Klv8kW7MfbNX1GDmvLQvNoA0upt4AL2x8CjfZFvK6bzpsXyCLAYcpzMayb+wWUU/H3h8jPArUDo2tuf5/blWz3TVv0S2hx2Vb4pUu4dQBF8Bt5YaeBp0zbnmkdxbZ8y6A4iaffeDmQ/BxqIpF6kd5US+ArjbfH+tTK1RoV8/4lxTV9u9+8k5Zs9tvy5Wn8+R+Tb+J+P/L4LQsYYmzWNjDt4V4JS7cW5Zd2IDLLk5zvWHQJPAkvCtxDA+do5pELETJFwCvnb8m58K68IKRBUe0FOjZHWNLB+uQjLPwlsV/JtIOpndh0yIZTRH9uWL/vAips36qhmVq6gnHcySmor/RxZPpd/A4yiMg+YEPpzEfMBZWnYTJT7Zofn9RTgPnoo35Q6bcy0A/tPlf30fbW/p/L91gKDNPs1GVpXN4O8Og9cSCTWsRUtrPXt1wTWJuD7BqLPCeI4v225GlBkOFjfaMM9NpWCbYyBC52X76rG2GztPtaRB98KmjDHEf4AQMf/QjrsiOaM977yTAntq5bv37g5Jrc7i3rXDC7PrY/WT3/mqIGtyLdoWP2saMuGM/+a4gROfj+avDJoMirbL5LYXDZb+0K6BjhJP6JKUybj5cHaC4fwOn0ObYfhSH1+5MFtIKsWauQVQH6wDB8Dw7YDMOQ79zcTwi7LV2gDeirc1p7KhMaPUMe365FaI1YmnFCn/hztEArf3wiBVQpZGmnAY9dff3WEH9+8k8+j57p38nW0HWkeP0e6YdDtrfifF9MCY94BnO2dfEdb5oH78zVmdH0QVRuAQ8AFEFkXCaxlpC8BXSIsi/bOw2aowNPS11nA35zwaRfQ3pVEwQmk1128tp7KpJkxm2bdtcB3fx31Qr6LwK41Xdto5dp24JlzOnBtgmCXc6Cfg/xbfwK4toNr8td+eq8CzjQvX1FXuQ/gtsvYfwEoLsf7t4G+WnlOduy8XdqKpjsrKG3Aobs6hyZQ4uVNvuAHza2KfCJJmydG5zUmXz3+Sq1VkBgJwteIMBOivumFQmnwEHkhwxrreUNq5NUM8B5Q07YypLy6X6xF4HYx98E1l282rOvpKISG9uTLMlbtdMr17cXZjjVxx07hw06h2SxPmEqUq/tvivD9+RpYQpvIJ6CI3OL8BJs/Sg1Urv0XsSx6Jt+1abedQXrHoGdbpTGDa/qwj/JF+YHStCyajDpYAPcB88CF/+LTFRLrR+zfMFjfBhUBBHzv+PnJdX6tiY+1OoZmP2rLwEvIm2r85eL//jMH3AjcnfDkYM9/nkK6Kx3fBFwJdPKlqiIoeyTfw8DMGjSGNgAfUH+CpOfzRRFqt4RzP9/lyLZJi+0VXFML8hUa6CrqMsv1W6RX95jQWN8ub8IquOVr0xQMnR8zmdOaIx0SviSCLuOFW1xyVJTRltvKVbt39hcitVwMTFBEw+2L+vyDsID0MZRNRN0ZpFQBIupepGdJy0rjAMisK/um6npRA0vLF2hWvpookHDa2xoOmQ9pvxGXjpLvKR6XpV8Do5yPEcrfH855sxiz4xiVUpvnAMmooeuWNfRKvr6jcttfRNkT2J8Ky7fJTZ+3wLjvBxZ7J1+MGdg2qY8j3nEisOaAI//VvEpphZS3Hxh2Ub5Up6HfrHL15fU1yH3sEJpaGzhwbAQzaQrasQrWYP18j/05mpssoupAAWxaIav2HLgf6bs4Por0LNJ5YAHE1QKOl7EPYH8VVdlZ4Bj23wMeAm4ANtVk3Ip/Pe4b8zWLufqqD/JF+SKOHweGQgPrdtRfFr69RDAJ9/fXILSDhOb8N9i/qmn50rF6RvI8nmr9/vWJaWtHbUn76gGlfdVARH7auizfDvlxvOTn87p8u0XeCWfUerKjjtP0fnxi4+OMa7nI8+abaxbZUcc4ms9GPFTfcb46KHVjO5aOubXDXR3xkPo+AlwR0yD0ZQ7CahbaVZ+T6aClAOcnLAIP5j0s84MX6HuANbAwv8d9uRNakK8+F5/P19rg/ol49claO2Zyl/pQZnKy3FLr62dgB/JMdg1pYBFpYnC0XByiUER55DmzdmFiE2BZAP2RL12/M7Z3kG7o2geQNayrWeDrnsr3XRxPtTF3IKceA8bAhRqMyDoLbO+afNvbkpsDmHQ691T0PmQ460Kaqek6Y+DhSc4FiKmrQDg9BXwC8uoM0gsXgWOkQO3Y8hycBj4CngTa9bnGci4w7w8hPd8T+Sbix72eaeDDqD9Z/ZEwqg0k+3pw0PEN4/ywPfkySreejNj8FTBzOT+fe7L1SsHkz74J8slS0TaLZQxE9suMSqiJNdXGoK8nQIRJok3NU+TckUiTeMDejQfrgq9m60Wlc8KZA4JocFHGIhsuov6OwHz7sjUC62GQUGMjqCh1SaxkVngMmFXylesdCBCe4YiTnhP3BIeEaEu+wlRIaoCJMYuX5NC4xLXS+ZSPJO53AfkPIx0262MgEVg0djomlLReZKQ3fd1ENCiZsYzLfsiXTWy57zHwGbAlR74NteV67K/oKVzLUg/l+yOwLeD7Koe82gocSz6vkgYWUKV1EusDYFNX5NumFjFkNwO8H3W+XHrPLWmKrvoPtTsIbI7NM88ViKUp4BrgZeAEsFwnplIK8HEisgAuM6Q+TyJ9FSTZddifyvjyn0V8Q0Yfd12+6fxj4AWPjAPuLx3i1SezwtBaqY41RWlr9Iq25Mv96rzkQ2ypcfkqLba49u88sEtdbwvP56LL8s0YcwtEkn4+r8uX8trtfHJkFafhaIBAA+aFgWOdTykhpnmm2nC/eh6F08yNeBAfEg90IPq1IaCto74k+fboHwEbYmSpXxckVAl8y+SUpZafsJtTlD8FDCNrNkrCRda0QUch1NEkW5Sv7hvQefolVpoUGgEhSApKGezQ3tdWWkKdV5FHX+0a08BynefTNVkepcInXsDnlXDITamVAR2Xb0nElUuOHQVuHPRww3VeXZlO9VG+wEvAsAXyagok1YtIl43A+jWJZfsgshawv3vwJ9uSRs4u4IzzkhmPBsb7GhGC3jAP7AGyXrSSqeCLwA91giphj0teURm35/y0fwx43kwL290wn7dWZncdl+/F+sctuhxpoH4mfvu0RmHOx0GNc8C9QGe1RCoCGDhQjlqXb1y7j8veX/GjuL5dTltn75WubpIEyZ98TSpFtLM6aBtZBJjKEOuq6ue0dcrjRBt/HX8EWCCzq4QQWRCKMFdHGfcvcwr93A5MxOcGyKcpkE4vAsvmtL1y0E7aVwTUQbmlwFGAXjjbtFOOsPWuE3fHDK9p+dp5xZoUZBmbEgpSRkXYG3Edq6sd1zN+V6tsGWVvIp2dzPrQ7Ut24s6aWMLZKUPJj+eRv646hIfUpuu0fGv4nTX5HbAN+UUDX+mofvYzi39fXin7Kd/jwGZx7XlzZQTWjcAZMhmsoUZsfY39jW3Kt91IU3wMOW6qom/WZCfWke/nBxDPLS7nczBcAv8Dc4odnCvTutoFbagvgWWHbPKIKEFgkcmhwYixZZz3K+TdBUxPVL6awJrC3L311790V742thUtrL3/ayaG4z0oHwPazI8gIjir/0VqHqzf9y1ATEvyjRNYj2Kci3+cfBOC7zrA2f/xo1h0eJ6LnrzH92mu+jjmoi2zwCIDQcevfpueMZTFn9Qe9n8JrLnKaWMp1JfLqKkWt9dt43gNGAauWRFYW0E6/QSw7yuF3ZQ3BvZ1eB2QE/fSTAgFWpLvKNJXTl3tSJX/xKyJQNOOPn1/Pcs4fhvYFDUdjWh3yiiEIyUPui7SlhGamgQ2o0vwiB53bB2WL9VxSZWjwM0oz5avu2Y4z6DPw+05WtzPfZNvMlF5EpBazFkfk4BK+wp41zSsjKgy00EispZQ93GUDduUb6BNPsnHYfPvMxMpYXJKUSypHuC8zLv1aJ3SsWM+fQ641Z0bHU1wFngGOKcIKyqnYwHdx1kQWU8j3ZhLiDr7nkP36nfpREfli/xam59XyQrTvkLeZxzsBLA2yum6pQnuuBySr15Obc4ivZlmvhX5cnuHvNoAHP9j5eufz5NvavNGrnse/Zuu23RZvhF+IfN6iybInHX5UqordcAmVPwZ0heda8YXMx/T9fJsWePjiNzcBi1/1X+yy3/W1w5w9r0HPz3k3UhkhrURZ9aH/YifRLo1+6Fjfq+mQTi9uaJ5tZvMAe1YkFsr9Y3UWgRuUPLNfwjnfwkgE0LA9VHTuHzFOgw4jOe6BPGirDSF+HriJmfUZgH9vIH9TUBc81JvWgOLoa9dmMEFIOfMe5EtaRzdk6/U0DKfV98A24Da874vH1Yq03Tg7Z7K93PUn2t6XkFGFSCjdta1rxJx5ZFXZlb4LXDtpYyjS+tkjR9Yrk73wwUFLd8ARtkfQsbYfxUQmi0ueTWC9tO7II2WsH8BqZkKIl05TvnIA8gk0OqgnNtaijpWbu0MVn8B6TvACCNsS/5D3N8vdk2+lJeQnLVPV+NG+hiwaONzxiu1woEGIjsDY9TZi3R60NENY5vC9T/3147I1wle5WkZH8P+DYP1bX1b37JIm0KV5ZsZGqLjiDtfj7OJkS/UmfWKGCkVZ2QzIxIWla2+mY0JAkKELy7/N18SDXxs+ZIwW0L/z2N/yq4zb82CcLoNZNRp06byIg4CuxWJBRiJ9Q7SDWIM0n9Z3vrTJOvFKISefC2vSflGzFIFORYgtOzFWEYnzCc4qD7VPQ+8CIgv3M35wJK+rgCqQ/Wc63ec6rvHRF5Qmeijc/KtgebK9j9Bem2X/ZGsYS3tBM72Ub5Id7UxR5UzduATI6/IVJCPUz1gjP2/Dy7zLZEAzwJL4tkeJjGYHM3UFOb2x4FroiRg8nd1NcikT9jPFWBmgUAtz5DyDA5RxcdMfnHbqux97M+1RaBXEf6AEx2Tr2e6Np+ef1cA3wpLBqHB7mj85lwHr9Hrfj3XHTH3qmnyYo6OdkW+wFotVZaBZ1B/OPjzbH2zxurER5oebVq+ujAeVbB5n1k68puuryPGRUwhA6RfltaYzs9XZQyRY1oddwZ4LdnskwaM0sAyeD8mIuS+jrjCday/r7E/yps720AybQLJ9JERVPX0ghtxkEgrgMiseeTdk2tOkWG2IUltduLuzX0b8lXnN4jzUWpjZpQivL4gMZAn2/ov3rZ/Gun9wmF74xpYgE/OkEYMEVq+tl6C9Gvkm4VoWZDmV3fk62tc1XAOef9EOtfnP1Lp9+Wz3sl3df8A+pxq4w8vSKgHQEItAURQkcbVb9c5g/zffvm8TP7cQxZlejYKv3q+GZDWuAi8AHuBSLjOGPnPmQZlSPNqC8ihw0jHiSyqk0xGShFIOyu1t3wnYqGVWX3W7jJgbMCHwJaWnikF5vNJYKkD8mXweQ4ifQHpOOyOQYxVj83PL9ldwRMYc9Hll3eM861qHjsmX6nhVZFuqL9p0M2tM/LNHlu+v8ZifQ5b2sIkCdAmC5e7sPJN7eIkT4YDXFkWJ6F02zAZxoTFrcDP7KA7FFHO19ZyiBCH7CAIdd4H1Nq2Mr0OQDTtAZYu7E6kVAVy3u5EIbQ2v0d8fQVMaeLUEDW5zbPhNgJLmPq1IN9IEAAdJpp9s/njKt1+iMDREWw8bRBf8+sw0tuQDgfYOkNg0TU4oLmmcq2JpOTJfyJZJiTLzsjX6vgmbyeBh5A33ac/I7wlf0Vwtts7+eI3EdgBFC1oX10JEuqrX4iUCmGM9m8AM4PLcEtBAF7ztMN1VDhhkp5p3szmRLX8b7F/VZy8OnAlSKH3aoSV8Hely6kfr43uh8/3HrCpsfcK9tl6+I+Tb4g8WgLOA6J9GPltbc6+qweq6N5LNcZ3PbDYQfn6kU9N/g/lzFUPyYs+nnd9zE2cV2sz8THtq/KUdtjR+aT8crUs3Hy/Yg3+KZxONvriC03IjJDbaF9G+mWQz3sQmJ3UOgXBdAXIpyN1baqUkoN2Omb/V9zPRdwPDNu8tyLkKOZ5hcBy5EsybVC+Vh4grnSEOxVhRqxlqivMaYmsc7V4zgB7k3mEIGOFeXRA7tQ3+cBS4btprsR8eY7fvTmiOaU6er39wfIlMtW9p84DH6H+jUiHTchXkuF+vtb0ZnPkLcCRv/6lf/IFXjMCMeODnLh/K+frIJ+e/iVpX7EJoYFNCc3Ze9o/i/w725BvZE2KdvI3C3Ko1tJtwKlS+VcUkcFSGT1zSkuRz/cqa/aJNWznPY/8B5EO5dzUNa9mgL3AspFX0iE7+8OyfU16JaJMEGZMYBmW0pg3Zvvv1KZkBeZ5NzD+Y+XL64zP6/4O1PvVGljcH6DHLCMwn0f6EBBQBmhSvtwPxrgReK+P8kXZJ0ivDF37vlvmgK1ZeN0r275l8Pr2K7G/oSvyzWjbqg/hSTmQ78g8t3veyERnTXb+wioMuYRM3GRKXwunGZpkStOqyBmzOK+QmzQf3A3MswaKJp8YwqRLgOv6mjIpUsruCX0dLypCCXgcRNPiL3WNK9OsYt9XrGlVq8dIdb8CyvyHbn7gAkcjbyUKoZBRk/I1UHl0LF6YfiqjfcC5H5xjS6NYBo6gr93AdFe+xFQ+sErWgvH/IAoTz9KO9R9FbZYHkCxpbLXj1uUr5oXH8wPwCLCxY1/actbQk8C4h/I9g/2yjTkC8bQV+JEIq3TsaWRZed3RO/IPYn9qcBltyQz1PbqHpGm5cGvgQK/RED4HZqP3MwikB0E6jRNJ5Jv97ZGkltWh41qfoq3j6J3Pu4A6D7ThU6Vc1cr77I+Ubxkgx0vAJULW6qMzpdRvBNz2QDlK5m0d9JmTTEb3IJ3vnXwRiAd5O+XMMIH1JgioUyCaTmF/NcUxUD/e91vltu+0PYr0EOq9jfRp4GZget3nVX3MPe+/M/ev0MCKfmHVeXFyKx5lL8MxezZ7qs6vxq3IOUrDpoTxqI7ReavUhfFwPlT+RWvacOQNqZ0ARCPKWd1Sa268g3Qm6u+phrrpYAkcS5pTNdNBI7MMrJVlJBaXUftl4AWAxtwkqSXWIvnAEqYaQJPy1XnaZIDT0lLqUxMQlMdjikVWWwZOYv8JYC6PjM1fH14UwnIkNI+EXycnbHXMfJDlp33cWJ3W5avLa5HJTmD/H0AJDHPk26U/S7iWEXCqh/JdxvFLgP9bPqEtaV+9nIgoIqiYxEIe1SNyaxHH9yBtQ+ZF4DjH783dFr3NN8O1PECQWoy4HzYG/SYuADsicwkiqAAJtA04BhCBZHCiEAIyCiFgfROoH2GKSARZGvt1aFs07QsLc70DON2+fO1Y+EgSGuHUF5tKUz9rHat+5ibz7ru68rvhEtgww+2jfJG+B0xdAoH1IQimC0gTthvSMYiolF6sY8ecz2nCMo5/Rvol8DgwArrsaL53JnO/ua2PeVA01KaI1FWpfpHmNlGSjssNop0wqVTaTPFrFHNIUG3DJJkRWA8CY6VRpVNBXFBfwgSACAfKO5tC0RYGcd1CviCYXjKi6dcp+bICBKFl9dnJu+EMyK2RXteaJKY2mZEJ2QeWiCI4OfnqL2dSxT7DX1sC9afDowMiKg1Hrjm1EmFwlBNdLp8A1T6waF5Mbs71EtlFc2SpIH0cjRrlx8jymVBvRb711Cf9FoH9wPVrlW9f/qxULxy43leQjvsm3/SidHWjE2Tmg9tANP2ciCpGynccuuOYkQiuz4GrBpfBlqLifibMPmmf77+4I2yh8eWbEFnZOzjWUWTZdHC/aV5pUz42IRRaVUw+iXqeBhcjEV5jYD+wsSXtvDfali+D2+nzyo/F+iOxvqZ6yngX6LTfvBLvKn2Ub7nqy/Jmu5IggZUIKp+EAvQxt32d89P+GOl3SJ8Erhxc3ltn/i/9mbeirbZxzSIrV8eTuo74eXnLcKodmo/ImHlfn1f4lJhLJiusTSXC+9q+0syxlM4j1G+9F53k7+Cf2J+Kk4xcVmlBgVzaBjLphBFQjimgldMxkV2A1XEJsH3AtCCfsrXz5JoCiMAabTnuyJfWwCTla5ChpgHx9cz2eezSrxOdn8YbMRNL6SLSE8CLwLVAV8x8fts8YwQCS/i+Kyt4vswCf/5Kp1yYghmUn5AW5Mtjli/Qy8h7Gel0h/8jXOpL5XbgZC/lu+I8vxXH7RuBd1yyijWvrJ7nE8v6WMLxM4NubkXAdGgI2TyKdMGRrXhxFdorar1pX2y8tq39qXQfhHzSgfS5G1hMRBFFADSzP4dAsjaAtfX9WtX65Xzrj0AmhfW+F4CdbawjzPXVwNlW5Ct8dwozcR6Xeq6llAl3gp/vf2A+AdwKZPhYbE6+5arvu62Yi6+r8fZMvmPkv2q/77G5AsmUNLASXq9wS+2YNa6IlErtXCKrXtfyF5EeBm4HpjruJzp7izyfO8TF1LYu3r903IB5Qa6Aiow+G57QuHPVCfrdKjpKQhbVAxUP1ueRLvEXHz8KIRNTUhurXo/qUxkf84vuUaTXibWnNyOwNgD7E8lEZoApn8wBDeT/yqC1uU4jvRNp0XQ0Un3MUQhJvkIFPl++CTLqpYD7x0X0x+ZLabxCG8TT5rCyBeQdQvpIMqsqOkpQFP/rA6suK4e0FGR26RCZpTJJ1M5s7ZiJM85vTL4+KcKaaNT/+VKbGBUdWydyqxzR91G+SL9pi1gGybQTmAcuSDBJZamPk8DcoMdbMq0+5j5bhMl64COFcgzP59DayK/Ke5Adt8+CEDqoogyy3yqHtPLbG0RUwnq/tq/qJxzCOGYaClkPmCkh8Hdz6N6CfLlMk0rC5FmcN7+MtRT/iXSYSyw0Jd8yyRVYvjiPfZFvIrAvWQsWpNSHRFAlsFmhT2BZPpURcJ5aH8BZ4DHkzTQhX8ptkVjpmNZ70VFisBH5FlGNHXEcIpfipnRx7a62J15os4TH3tYCisnQQtGWICj01wtApOqPIvspEtB1HwOGgetWBNYdwDkjn2qkFRNRpF3FsHzdH/I//CVpYXVljVTRUsqkgSX9A2TLV/te8+txfT3msLkjEy/aMegYOAd8D+wFtpeYU6RFTsS4YBSxIhaFjPPKRGAxISm0qUYGNvdy5t2N8CPXCMtEkGw58tXEqPYLV/L+l8CoefnG/TGGSHDzSXN3FdWqh/I9h/Qerc2af/+CWNoAMurzGjHlRR8kJ+3UxvLq+WPgZWBqEvL18/UaFG0M9QiWQ+D50uRmMuQ1wVq9RIxy3QQ+pvVH+crvzo+VVpC3PhzNqwp7QACdIwJqj2u2J8wDEyxPtCFTwNg5GfPoZzfSQq8Tvda89ilK5TXAN83KV/heo/50oAr+mCPO70bAFeAxn8LxFu95QMfi/m1CvhjnCNd25tf3b0/ku4z0KbrSyFxBA4sIJYXXad8F+l1rX+eBvcDGSctXtMtZkww95qKBMcvz5o65y/cvlauKbavXqbpxc0F9PblO2jPMEfMJLL3w8iMu6vDDb2mtFi6TTr2ZVGDzECoLRaH7DtiUvYbr2lcHPDNBy7d9yyeNLUVaWV+MHbmklfQjJzfWwCI5Ofv58tV5PkmQcQ7pf8sp883CTgMHgReAu4ANgx5vyQeWT0SpP5GWivlVDpfjjll5zLnyFUSpugagrNUhp+F7f8sPSd9MC9Oz49Neync1MMjGFjSvCuBhYIG0q4yM8sAEFo6J/DKzw5M4vnnQww3yuCGZOIl1o/wKhaDb6DW6iONnyqAmH4ieDSB63jPNKoccoiiAFcIEF7fnenQeQJsg8jneQdrKbyHm/uHm5CugI2ICyum3MHcOjF+MdSlFiO2ss26Mcarybfa/Y++DfIH0UcrZoiaErwu/VpxvKZkMGijf72cJ+CewcbC+rW9/xB9Txa41YYKnnJFHCTBRN6vvHBIgxmDqSJFxokL3VX2lAu4o7YuG+uNfR0g7pgZNgun888CDjm+SqLwKkEYV7gfOm6mgiC5odazc93OFY6vD5Fet3iHkzWV87Q604zxeJ0ZgiXWRKV9CpjaX7Ys8ynfKPCxU91Dy8XME6cvAPSV8NSC9AhDyaNYUWuTFCCyhvVJaGdWhlGShwcSD1rJzxhyRr7WVJLzTfzw61AKwG/lFA/JtLaphCgyy2EP5LiC9Kf8+1O1AQI1ALH0pzQVdf1iK8DJNrVS2Hxi2HLWyyHXMDdnsg1zG6oVRrysNWwsapa7zDTAXnSuQPFeDnJoPEFDk04pM+QCqx6D+2MeV1Aazepz3M3BdxK2JKHO35B7juwbkG/4/zJF2A+aDQd9NpVr3XP4l9kcNhMnPl6+ZhO4ATgN0HV2Wb7n6W/4A2mWRgyCOzIm7cOauzALrZBW3BZy2tXqLSJ9GOsyTr9567qanta2r92/Y9K0BYUsChdCAHWqkb00AaeIoJxpglDTw6qj8DI2KWTxY33cf7I7/KyYc2LmhJhEM9PIg+k/42NG+iqk6GoG1GeTSYaTs78pz5k55EtbGzA+pDOkC0seAwLVEndfrfPvzkEwIpZ+jfPly2SX6wdLmiYDQrOG2FdF7EukR4BPgX8CLwP3AdqDrUVrizxD2geVrV5mcRR2l9s95JWtSLCeTzCMVkA9U+0CVpmNLUz2rY/tAimRKxAmdn1KrI1IXPBemYRqMfld0yRlqIm+PxuTrRG9LULKx9cF9BOW7b9DSVjlX5+iCtB8ntPy8JRzfOujRVj1fIctznna35We91OqobXHNyzGw51LuX5BFT3AkQdJyIpNAv74iuqjvWl9cF7AyOr9Poq3UeSIg/iz3IpD5vZDBfDPydRHXlBo5Zq4BDS0rE9fAzsXv7dhLe02uGOMUcMDmlNFh+R4UfhQDPrBu8UknJprq5Qlct57H7dinluGWc8BOoLhU+faIFOrTWDt1/1raPANXdGQCaMu3t4xHZIvYwipyy89jZJg0FoE/hbuBBfVA1g4hnVR8EZWpf/4l4M4Jms0WIJMqwmiZfVINjGwSpoV0rKMQcn+G48Cm9n3H8fr2TQjpeCLy5f5o/xDSh4AHfg2sXzu2/Vzch75uRFrhWuxvBeaAK3A83bMfFXFeTWDxnzyfiCkFoSWIc+B3o9WdAe4BKlkY/mIpQPllrcyQZL3kBiUQWj4Gd40zoaVNEpeBfcCGHqyrgqPFrZikLMflaxDzTPNa2rF+KfFJkB+q+72NeQaZtBWk0vFEMJlPqwTSrCLiispSHwn/zaM2HwFEuHdRA6sy44T8PpLPDRVxcGRw/NvIe1mbB9P+x+h7U3SOQPIMQfocdE37jBAijSefdGKYRpZTT5zDI8e4jNodBFp5TkFWmyCHD7Lkq4810SGjo9J5RVsJviafYJkddHTD2Apcx85EtLn3bxfli/OcRd5dk5gHkEQfEoH0uhdBsJbvaVNRWya0KMohOYAHjqBNObj8t65yIL3fXM2gTAxEKgQr6xY9WUCX3cKttJfwcP1KPKxlyHvtl8RxriogXlreti8a+XKstK9AIH1PGlOOo3VLJww+xwtIhzT+1tY2mxCyfAn58tX1XgOmWyLfC9l3Qse+1oRIfHHd5sQ94IifzAhJc0I46K6V0Xr7GbhNXZc2xwaSqQnwDo8twQgSZ8x8zH1ZPl8jOyFPectIH2hDvpE5U2sPY76uihYXk68KuKBNaUphGqzkm8b2NGBmEc35vpoBufQqsFwjnkzDSmhfueV+G9s/j/T+S5WvSDPNVK1OCpv/N2CeiEfPhNl12p/aEOnprRMuK3/Ptx8T+GeAHWFrAwCkT2U++KORPg1hT1Z79oW1Z81+uE4Cm3N90VoqTQlvSqZc+fL1tI1JA9QjViW0BrKltL5t31KP2E0O0e/GsbBUacQljZZvijyK6zgMyPu3Y/IdA28CG+i3NjS/5sTdc6xuRFRCwIm7ta0RYgQqq5NnrzRx/zYQHTBUN+ACKVu+ue9pXb1/qU9RMdCpMJsLXEwkr6mIfkKDSbbRCzNfoBnzIsYuxsfRfB4GFomQYM0anXqmM78XdesSkaIlbgeKSZC+IIkqPAyiaOGX3Y7vK9OYMk0sS9khu+1bmwTsA7Zv56xAdY+h/U0ol6RxXr7Xf92JO8uX0nz5kn8bSh0CS12X9nP3J7SPD2tgRSKQliJlUidgjjciAitLRujLolY55xWkR/x6LU/5CfseuBbHrauBJ4S21Qhg5q+ozJsrSzMQOG9lKt2KY1qQVbeCSDoNIom0rpLDdU1ICbAGl+UB3+M8nQ4sUX08AQ5HtCN0udaE1NrAGulD23T0eZT8X+0CzrIpH0B5jvYUlZPPqlTmHQOcWrmlVE4EFpedBe4ctLSl/7z/imh7awQ00BOYIAGkv9jgMVCqY2vzLjAz6OiWfpcfBxbWdv92Sr6nkd5gV5OvgQXCyDHtc449v1eWL7W3rM8K3EfCKeRdP7g8t8v2P31XtsKQ35fyp5MXTlIzqSIvHJ0vl4UNhK8UhFc+0aDGp+YtEVhlCf8xjh8iQJp6MfFA+URYBXwc+UBfL9HXcWGuKXxfbQI+BtgMcLeT+n6y2L+V1wf145oUvoX9qQD5JKNaxgIEJBNCvNiRbESo+5h8uU9eV6SBJeWbo5HSgx+7jHNl+sASf+AYMT8eGpdIYOlr3Akssjm1T2Rx3Yi5tHP9PM/vI93YgzU5wJhvwnjPZ8mX51Zr+npEKs2rK7MF0nZrTvtqCHzkOFyP5SHVhBVSxhh1nvkth+5deXZBJo+anDIRuGdzUa4S7Ndd8tzARxQwdiIASsfrWgPqQCTPN0fUY/HqLQNPtWmqCnlcDxwDLrSGEaVSa5n3lQ9PAb+/c8DWjHluvB3GvBnXeCJy/3ZIvq9EFTUUgeVEHkwgk0CD8HNFKfu8Yk2vev0x8C8cb+jIf9o213DRwWvrxP0r2gtyo1GTPT5vXOVcl6lyA+XLtmr+lFlmwC+VIBrFdQfIQjUf6ev4S8DY+SEVRJOA9yOjzYcs9XEa2Cy0CEPEJgiia4EzREA5JJZDSNWhiS4+prKaQ/dtEVMpPtapX2YaWCzfepovX2VexARWlMDLmJuwptvl1rYisMqafA2e/KyeHyAi9cnRfKwOm+g5Gli511uuRjt786K/jdJf3zb2Wpl3bGDyi0n+ks+zlF7mO70mK5INeAfjzZEv1yHTSoNj3u4e23nIb9ZBYHPTcwUyqcIuEEfnTNsqpU4UQfJpBVhdK0uwduTAncq/Q3pdk9eboX21pfrQRvcEf+AwOPL1X371+gn9TzLfda+gbcxHomlfTQN7a2SUaV+xuV7KtzJPe6pqQ/3wMfdZJ6J4TNY/1+VjI7FeAdp5qTNH4C+G5KvXFffFv4dc5n8g4bZ8Xh2IRkd3HQMvY3846OiGMQ+BF6L3byfkiwAsghzM0MByNa6QApRaedoHamUA9ZnKuK3f/y1nsX/7oPtbl4ik9a3JTRNBcYKrWdtQTQbFSae4/5sgIRcnC3lf17evUKc9rRfKV45QR8oO3OlTanhR2SLSx3E+TSQilXI3DaxHyFyQTASpzI1OaGWcj30rs2Og1tbq2jk/RLopQmIpwjRiempO3IXTdUoj8g30YQSWlK++f/X9d5kEu8jeyqSB5YT+Rn440lySacB/UVgDKy4XnOtq9H2EriFqtiG/oodN6U4AN3b5jx3Gtwc4nyVfQYKWpDHM807npzVHa3cR6R1t3L8gjDYDh34RvqxQxsfUBsdR/1fcZu+g7U37LJqGTP6OdDmkVeLLFwi35ToaOnqoJrA2gAx6F2QP+5TSYOLKr8t976Fy6pvaWp4dc3uqA7yL440N/W4WzrraAJwg+WagDJnUA1Q/53yGoHntt5kES9FAffJbljT/M+7f9uULLCazR/pvmUtgKa0pPnZN/siM0AgramsgE0VKPwWm/2QkU9Gxfjpx/0b6KwJaP7yfoPrKIFwk8RI/1i+QGW3F+ONjj9bNb8v5ePDOAPuAsVKHLQN2475zXOvHqW/7gNDsOQKMYvOry0EMfWDklKsJVSehqJyIKwYTXty3rwV2DrgX+3oN5zvVLRw/JMdJLiSjHPkaHNNWayN8YGU+NwpRFng+xgl0QUaGtVuzrpk18W4OhOu2fJIflZMfkFI8b4zACvsrLJSs0G+B8++oRSVEqr+WK3MR0Q+te+pvjPQj4MoG5Bv9LwEw6QAcyZev9jdSSnOOcCj6D4GpNu5fEEYPgnxaYhNAOqZ9SUyhDvfr9G8aWvPYv5bkK64v1+8n5fOHtlN2H0ReYIV2ykgQ0dyWn2U+UT22l9fg/1ozH5wFkXQQKZFLwizQIYqImHIiCloek2bKV5Y7Rj62eu8DGzOdMcedgo9WNFmXovJlQhTQzyrfDF389ym99tbWoMbARO4TKC8aeA+LHfsymgbeADLv3/blC3wNzAbmQ8jBCCxz0m5pQkbedr8ut2Hyql7nPNJ7gKKR+zf/Hbr99Q40dZ6u3r8h+TbjfDjuhLzdaDVcJ5sw033Fxwe0dU3SFGzlpSxF85GRtLTPEP2VwvqMh7u1NJnz7FJOuqPkKgihWeC4kU9s7md5TjmB/FgZ2Am87wCe23xXjVffVwZ/rrhMaWAl5/ksX5ZxXL4jg3ZSqgms6FroyBeRLn1tcX1gkTq/9jektZgoX/k6MgKrqbnAGKYqMyBgmUzdRPCKmnmhjlbEZfpl5pmW1mkRdJL8EMa6PBH5eutKzj/3yYQ7mWqexP72QQvbL6vaV0fr5oHaxxXXtZScs9dILzuug/rYj3Rji8+ZQqyl/SZHAUlsyjyG9HXn5h8GNqlrFQTWJuAQILSfiEQi5+7CHxXtU5r2a30z6uaJXJ9MEROOAHMNrCH1bJ9L5sIx+WY8v8Xa1WaFvhWEju7N7RPBUt+69JuCMW4HlrPv3/blex7Y08jMvZ40sAjkl8pAPrEsTzqDN9RMBy3f3T+C9KqOaRzljKPo4JgHXb5/A3UD5m5hU7m4byedx2MJjE8ymvHz5Y83HvWM6zI0KWXQBEay//+EiANp9ufV018mtBNvxyEl1zkIzMTWhyYFQQzdAFLotBFOTDLVyojosjI69iIXkpkilXltx0gfQnmhzEknzcBDBkRgeVpSWr6ijlg7DoE1sevtiQP3Jkm5QkUh5OiQRDQ4kSQpnL1PWnhl2oSwmCApswXn/pKfhYBHjNj18TXU9g1Wl+4jL/rhCZRVsmg8HLO8j2yurga+nIx8eV74Rc2ZK+e8JAMrGwP/MJPkRk0Hp4BngaVENhnhRJEI2S/WRTht2eQQeZwmcNsz2L+rwUis+vlsUcfuBE6b/HWIfB0Jl9twP5bSucU5Uj/zyH8AKHKex6sE1oFDpj11gKL9UV5KrZzbcj3RN8DnE20B2xdjNAIrNxy8bstrbBewJOXrrx2/DeXJenZMbWidc+rkOc/R82Vaox38v1Ek8moWY/2o/fs3X77ARyUI7Mk9R9kHFlL2QZXyEqjczyPyivq01GD1uE/UXwKebOD+Df2mtLV+u0oGtXr9+fLVGlIZ/pukn51J+p8KEDyUxrSX4teh++Y+Y6r3WhYhuZlJzH1lCkXrkVWlk88OVAMaN1RfkBTc/ifgThwHHdbrdQwyaBcwD3hRAOvkldLIsn3SqhKmgn7dul+s71Fva4Ao1hpXen0W5APLNRkMy5dfWqmuH4UwSGQD8cieHf1i1JJ9OvvAcqO6sfy5TkDjRqyTBjSwXO3DbcA5uyYiTYQfK1rfCcJP2MX6/lf4z4C5XPlOkOx7ARhPTr6ej0XWbGOykGVV+poKP5nj9sa1r24EjifSiAirGpiQApw8I7VYs8rqcP9snvgV6k8N/sAN8tkE+XxajpR5qPDDJ90WhMFrh8s/AmZy54A1sMiROpNGOiKhgdu75+H+nTI+B7fjMXwBiHuv0WipH/vy1dC+kAKRAsOO3sPPViNYQBB19b9IIhcfBObbvX/z5Yv0LNLb9FzkO3E3wslA+UYsRUF9UTRC5KdyL3rhSexvGXRjK3rW729v/Z4rsQVIG0G8hBxhi/qCbIkRYmKMQQ0tfd7AvBhEPVE3sx0j/VBfVb3wCA0qQJh9iXzK45TLtR+dN5HOxK9b1wch9BCIoUXyUyWIJ6pL5oaWz+WSwOI+jBRbxv5LSIcxEkrX9eaNCCyWn78fJjzJVw6VM4GlryNnrhoIp9u6DX9WXcA1IRwZiOABSk9zSUSEY60ZIsMCGlh587xizgRn0sBSKGKrGy1KaBNZXc5nXzvPA8Ns+eab5GwGzkxKvnzdvLa4Ls8hawmSbMY4fqaN+xfk0BB4AzDSyoiqhDqpxU7byZzQYH3U2tt5iBijdsAY+fcAWb4Tc+5JyGoXZLKoTNAZymyVQPmaPAD8tbSA4+15pLmZEIJEOkTaTCtwzQRFFEJysk4EF7ep77MZImtn2Zj43KyJ9Z8PsD/boEl/IXx73pEIbCFfFZBGBbQR+6J9cK3aeLntcglTaXEPtvu/h7X9Z5MPqQbu38blux+YakrrBsTQh0YmaeKJtaWQx8cEIsQ4j/vgestI/w5MNXX/NjDPwbWef96OaJw1NVe6r5jvG0aOg/N8f1HaTK7D/mqKi2nXo5JVDhuBseNbJURAxAkMVwUXkH62zgGjpthlkEEPgwxa9AgqJpIiYI2tOH7TYfw54No21U4hA4pCKOQv5EugPgnCiXsLBFJh4HYiX7bRm45qGnWCGdUmvRiFUMtMm4aWvg89Nj00kAmhML2OmYv7GohzOPcB9uentUxTGz4WLzAJSlP2DLADx0WOfEMkA5OaM0BytpsvX+1c19ro54Us+wL7ozbuX5BCtyVn6ey7CqmMHGhpbZ/qC39XqQ6bHRq+Bkr1zMzybeoTClcA37pmVwCZ3DrauwFH/6RB6uTb+dgkdQykD23O2glGIQTeIcLKh/Z/xX1xv3v8PrlcOZJfk3bYO0g3ZLy8ZpmwJLcarwJjIV/WrvXIdTb7ZjLdQGvaib5Kzz3XrNoZY0rfQt6wZT8/RdC884n27998+SI9ifQ6cd0ZjssdH1ivK2ft5GTdS4moojzqx4mAaOkp1Ls56/5tYMt5Pjci3+DW5fs3S775LzacKsFH04DmVswkKk4mFYG+CGI+sjWFRJ7ux7RnrgKOx1VldR1fQ0Z87WDzEC5b/Tr+MkDXr+Qi59VMCJ8BMbUsiCPWolLaU4RQOz7msbyJ8ul8jT5d1zMhZLlr+XJZhACLa2DlrpPLVEU4z4n7X3yNmvIihFkPlXv+QhwiqCQNrFaufTtwvuSXCwNpDgrTQneu3PvE5tz2D1t01va3SgbA6QbkC9CcUjueI2f++Zm0RP6KmvN9tRFE0TtEOnkRCGtaVZbnOHw3IoxIKVF35ZjaLAPPAA3MiwwC8CSwWCOj+EWR10LKk5HICF4UUBF4hl+Ij5tPutBWOATWFPAP0n4iR+0G3+zP8WVlbbgumxgarB2NyVKATBL5/MCr2B8OWt3YzyFwxpcvQGVuHV4rypxcRucFvHvAyrg9tzkBbEf9ojG/Ofmmg1uBb5u4fxuW7zLwkqN91YQJIZNI7K8KqTALBDwfWFZm+XYeK+M+6Lz7UTYc9HPr8///oq/XVoj8mLpcPkNaNKQOVzQ1HkGsZWx5YwyRdBbW/B8r4dfX5FPCAz3kna/qtG/H6gsGm418DVydEbZbppUGFrBojtm9CIEAlfvHF9gHFte31IevzXUG6d1IhV+n3DVpGliQzXFhGhaSr0FHKjQQgaXkDNhxnx7iHduKixpYRErYsU8cqPVix14fjPYJrOK/L9juV27h8ysnmlJKnf73AsNc+V7CnExhLAcbki/Pnfapx6nva+wze+FonMDaAyw5pJLUpuKog4oEY3NEa2d5XrRCtD2L46va/ENdvbxCJkeRavlymSYx5fqgc0XwTPbsMIn1BAihMZFUgKMJJUkuDfZblUDRBlU/NG7OX8Lx4114yYT8ngOWMz7yCq1xEanb+Z+tTeJCeH7Q4S1pw70CjNu9f/PbQGbfIZ3LXsOawNpLUQT5WJv/va7q1gipNdZ3ybTzSO/sI5GyToS1dO2xFzitQZVBfoVMcSK+uXSZJrdUG6+uKBMy4DaBPrLOi4fqjSVUW+nHUqnJInW/Yog/imFfR76PnMeAKJFZREjAiwQW+bkyQouOUQeQvrCsPhFQbJ5oxBf1Z+VsTvgJsCE/Aikf858LJwohrYOIfAHXz41ac6aBpZ9F8etd18DyNbBIvr7mjG/SM1KEl9CmaY3A4vsAOACwLydBzlAd52WFSV9AfG0uV/1P7aRAF80TejuA5Ybka8eijkOUWzmZi6zOVxvzBDJoA0ihL10n7IqM0oSV7pPNFbkPPn4F/U63tZYgn5d8eQr/aPJe5DXBcNrQvUbr8EdgNGkfIyB9doHkOQd4kfyItOI67PfKYHUM5L/K9qkfa0fn5frWj523uradXfAjCbleDbl+w/J1IilbvjzW64rKqZ9SnIfGxffJCRxv7qi/ziSDFQL7TOv3b758x8ATbcwVyKEX2YyPtamYuNL1jHiyfgUZZvWpP+rzA6RX9MiH7HrbRtu2rzZW5Gkqae2uGLlk0OSdHjO1JWhySY0zYhoZHDu3NefD72mywRB3YEhw2ouU23+NNDD/mthyCKx7gPmwv6rdfj73VSO/7NgQMDek/D3a/C0ePVNFIdRfxil1oZ34E8iEMEYC6/rrX05oK8yEUETNc6PwKT9QddKLzwO0QWDpyFVbV85NZnCUGsipuOcb0MpEFDaaI9T/HrimrS+EyTT980bk66Q0j3bsv/Tw82WcAoNsaEHzaggi6DFgqeaIXfm94roG1qzy+7GUncZ7Wl3W70/A7UADmudEIGyrzFCB2Ac0ItG1BmRcA4Ojrpa25haQ90gpiONL9INVgvA5JvxesXYW+7XiPO6DNawMgXzhtL1OtJ1EemVXTGEgx78BSyZfx6ogEk1QaFMFoB22+1gEHkO7rv6XKapnMca3v437twH5HgSuaMN/Mkig3b/lc4p9VzERZflk5mdljgZWLaW+jEyjejauJeCB37vGy8ycrjf+sbs6tzKKn9pXgpmgxkJhiE9CRlvZTrQNtOf8JsdV/Vgl3yTzynlyymNzIKGqXya4D3/Ot/q/r7l1DvgbjoMaffENhNM2kEA/J3KpbtpnMMLKLef2F4iwov5JS4vGQG3pHF9g/8oGzGfZhBAElpAv9oV8aW0JR8/OuciJe+a9n+l0scjQVJV95phey7HFTZJvNnkI+cb/bLMWBdXhKISxOcyfU4ypwBiexvgWefxa45Q115wXdl773J7xBjCMytc5VmvhEYxlsSn56rkE2E+KX9/mcB64ro37F0RRCQLoKyaYKJog5wOyXUTrivO5H8b7aDuM+CSNBrhIQQD2AWN33eiXVq2lmOoKCK0PIp8Po5xJGP3xUq+9PZUfrAOHOMqgHVM+O1HXjtV53yv3sYc1v5Cq8XyiPtzGHSbrflgWRqJAnl+VuWZm2mcsUtVGahL5dX97jc6p9z6lLBB9TupzmfYlxrcDON3G/Tth+c4D9wIBSyd/Xz0rQAJdSyZ7EbAGldLSSvuWJ9oysWb9fYt0Q1P3r5jT7Odz0/JVz72u3r8Tfj5rQUacO2e83BWTUTHrBIPYt/NcNHX5xNOksjztnJ3r6R/Y0HkZ7wIbG5p/wDaQP7MggX6sEU3Vfv0YoLIEOlZaWQbrNw4jsJbQ79NIRSj9SUUhFKQma0r5cNaYimLJBFY+gZ4RPSRsvphBJkUJryJ6b6h+LkYhTGDtIaHt6USgi4XBt3NaFEJnfpqSL847i3G8HdAgpDz559zmiOfK7/886j6A42FEvnoe+Ppxnp+alC9fH8mf6lB7rjMGXmrr/gUB9DL5thIp+8ESdQlWbj6tDKyVJXGHuHdiZD771bsLWCxrchbRJj2T84BGhvOS62uVslnvEtKduX5phRbWoz5xJIitXOyZcD0mwh4JzEUoWmrG/+a7gHMlafM5EWbVBz2qpwks65ue/zwm0kRNsLpjYEfGO9wkI7gVzpxvBL5o//7Nly/2P1B+FDM0+6keiKSiiuznRATU0QItbR583mXgaewPm+YA8uaZ85uVr966fP829nyOs2Lxich3qB533N7AohPsZa5AOT9PyLpt+iqw4NrWA/Tw104T+YWE1HATyL6c6nmmZ2PgxjZtcUEEfVzXsvLN/kxDqlaf6zKsLPXBdUnji9MK3Mcx4KocIlmup+TEPV++VZl++eR+rC0RWFlrI05m5KkF67bifKG2kx7zRQ2sGhxTugSH3PE0M3WEJoMRWPnzHJdvZa4HnHO/sgtCT5D8brQ+3d+KKeHVE12T/MX82eblC1A5ry+er98lC4+izfVt3L8gfrYCP3mRA1N+SgE/SqC1oX4ckorq2z6dg/oi7a1PkG5q4pmTgswcZHISII1cfQ/pj2bU3i/T5R8BM4MGN5BDW0FOnU+md6zlxP6xEtgflaUG31eV9e3lsb8spf1VG99PSK8bdGyDjGch0/d8Vxq8Dn1H7dze4JGvzgch5XrD/3j4BTA16OiW/CjeCyy3fv/my/c80u2DFjcQQBWB9favzfto31Iy8bNywMz+KB+otfXP5UQ+BBx/Wj8A1wzWt/UtTtJo5s3JF+0bYDSD/TbFsjap0ZFRXogXjFngqEMgCNJAfRkXzrij5+J6+/LmO14f5M/9RgYRecUaUwkot/yUCt9YniYWRxusaXwhpfaUvgpMRV7K6Vhr9B0PRA4U9fz6ei1JE8Ii14SsB/bpbY+NTQhr5AQRE1Ijgp2pcl0mQ9uMQqj/fGPcDyGdtzEJbRFVHoisJkwmPnBernOjkRY4RxWK/USj8uXw8JbnEIV0TibUl5BvWh/N+r7aAALoLcAhiAgR5+zWj0deGZikUudkDa1FpI8iLSZMFgwhjwchu/OC6NWOsbXDZxzLIDXabNVwCvm3Nu0IFyTPDLAfhI9DXolIgkg5j9oSgUXH5mOL2li5N456vYS3kLehi791lXkxcJbWnBNdO+KnjTV/6Nj7/dRaqlz39MrvY4e35Efxm9bvXyBHvsAYeIX+gzZOYFUaWNt3IZ13fFgZUM7HgpQiX1pO31Sf+7HUyhNeG3RvKzrim6rL7xyNjrmYlPZFVKA5Np2BvFh92uJtRf0M9bpA/eD5k++rx8sUEtiJTEIvB7VUfN1gwoG/pnPkjoTfd0Z8Arg54uQ+vm64H5BDW0H+nKCog7ZPGlRGHgnH7VZmxwBpXTlEF7X1844jbxva5983SDma5aoGFslXrRsmOyxvjW35XEZgKflG18i6A3dNYDl+hvw8xw+FMBUlIJ+jEI5a/IPumz+8jXF4Y9TXwuubCR8VmZPLzgMPYH+Y/X+Co8XtK5uWr75OQMwRO5L/FnmzA2wtEFi3AWdI68rRopJ+qzxH7ERUUVvRhzM29tH1IzA7YafZc6saIiIKm4x2KqIqc11fq8uNEErH+1BnJvZbEa8DoqcA0XMv0nnSgKJ9gIkiOmZNKp+ccvxvcV3/2M5h+/Mo3z2BeSsaDFbyRiAyKkffjXyUEH4CyaRNtDe4gSqK5s2xdJtylcB+Alhs//61tmH5JgIbuL4BIoTbsR+szcAXZApoRBETWKaZRftEZFFftE91HSfwVl4/15nky6uR+zeUn1+n6Og4s+/ftp/PhSHXlEIPlPfjJBDtNyJgPleMxDMEoy/qcejr1DJjfxI34MF7LBQljvcTAj6LfPhf2fk8T2U4w3flrNqB/JkGXgUBNCan6gBrWtkxEVB2nMAEmO+cPcH1oeUQXXbe94AZReByvl6nFIXQIDStCKqNNgkhAitDY1S078FXlMYihCkCy+7pwNdmVzOJypmAINKndQ0snhu7N04BdD1M3PoRG3Xb1Ibm1yV4TmB/m5BvlMDa1o58Q76OeB4Z54E9bdxTIH6mQfocXCGImBAyOFpUli8iFbIZoCasUiqcwae6VP488qcmqIH1nMlXgdeaNh3MiQTnk67J99tVja4l1sL61CGjhAN20qgiuG32rNWBe9jh+wGkU5OKgN7Qh4lrgB+YHCGo/0J6vcbXpaU+8XUG6WiSkebD/ej7/2rgVDv3ryoPnXuM+s/8of/rENEPoGh/FInQK2fyKoG1tPR5XMKMyTDDu8Csus4e/X9u5Lxdvn+zzht9mQ+QKYUoz/LNosaeM4l5woprksXTePsI6Zjsyf9OZh10TBBRnoLmK6reb7+8nAA2RV6uldwiMgMBtA047fuuQkrEVSi1/qjfNbYhkInjAtJt4ftQz6k5cR/F/mDxlyzt1NpSgnTiLtLAmsm/bxWBlvvMiMs3//pwj99MmkJEPjgO3lkzhs3DPL96TOoAwol7i/KtTNOAhdq1E7GjozOWNI/efQTQPCfU63yIOtN5v1vmHwb9vd+SfPkcVeqcl545jE9QdkXT9y9Ingo7QVwtkmkfk1OA448q5QOUJ8isBGqP1PG75Wld8Vh/QP3rkaefU9qX3gg4SlEpWcNOa61YGz7mNaRNj35fM30MvAgMRfCjQERY7UsWxNDdIIqWfl+jyognLqvt0zHXpzJNeOm+Kixg/24xLwnesU7V3Ko+IOspyPhZpMuleI6nfSelesqJOJ9L5Dtmbi8DdL2BNPD+GFRuADDGCi+2f//yOaR8Oe87pGXg/p38ekY0P5BC3xtRRFpPpB2V6jpkFGlnURn1Y/lepEID93MW+3fk3r8ibeX53ODzqrP370Svt6GtaN45cn5EMF2u85paUKKeJGVkP6z2XGlfLXoaVNrXlQ7X6/stivRDPxoLSB8SxGnjftFA/jwPjJk8qjtXx7Htk5YUtbFjMilkAos0wLy2Vr+WD3yB/dnIdYd8YPnytX3HBCquzcf9ag2seKCJjn1F6eI5WQOLye569KOQKV3Qz9MEfGBN+rmC692Acf2T1q02IWRyamSgvtRLD5cvIe9Zu1eynO3eD5xvR758LUyU0przNNLOId3Wxr0E0mcEoucIEUIEJpY0iMAy7S32kaXbWxtt3mjlbyEdZmleYC1CZnshk7HUsKBUrx/W/BMkcgxfos9RK89n1sJ6EwTQmLSkmMQiJ+4AaWRpMsry6+dMoLYyIuIY2AvMtPZ8jm9FzTwcZAWtOYXgmitD/em2OMcRpFu6/F+j+t0Gfmrv/mVw3xplMs1H2/y5yXfofifwM5FEgK+BVXfsziQW4BNQTn90Xqec2n8FrPl/SYefGV3d6Fr7MNdFByah4FS3yTHhaaSt7qcQaK0tHqqVL5Z/CX9CITVoxiW20+ZinwObGyBbQxuInzmQQYcB8nFlaQL5wjL4EQyJnCJ4/dmYpDP3edS9H2lgLgIElpaxTvPbGoG1vtHWNIElzMIszyFYZFvhT6rsiBN38umx6tPnZOjFRkTck8SPchoMJDONGzPlPkQf37QiX0licyrW5HtJY6YN31cPg0xaJAKrGTBx1fx5zwNbc+YIsrnBXl4bxEgdX1KfDwz+oA3E0HUgf44T0URpgijTOFCH5Yfbp+PjXYw8KJ57DwFGtLayZrPxGNDZF3Vc4wzG9xYwzr9/W8fhchTwo9isQ/cZkE0vs7YUg4mk2n6C5TO4LZ2X6yoCawm4d7C+rW/eNjnfUvlOy9uyudRj0VEa8/xp6U2Ze0Yd0eOP++70pdnVjqIy4WdEhhI2KI0sA5uZLGH/VjHnDa1JbvPLqinhsRpRJIgqJrJYI8v6qpVxfe3ryur4mlvfAnMZmpVUT0QhJAhNLdrX0ARW7P614/WvNXECy6Acr5JmnvRToTUyuklgpT/nu2oRrBQpJeYyEEZcOXo/AsxmRFt8ojX5RuZKE93HgWvbkD1Io80gd07/boS/GLHE7VMe5Yt2QquKzAXFWD4GNl7iWpoC3g+QvISAlmPeSy+bLX0mI3s2T2LtBhbWTjb9nllhqus6YhekGOpz/wdISythHnV2903jAPK+AvhIBqAIki6Wssl5GXk2cv7Xg45vGOMOYLn9+1e01/JdAG4fdG3bd8uHwLKn+cQEVcLrwgG8lQuCy8ro/EyUGUwLa8v6/+0/xVa0TlTF7RU1USTqUhtVFiUtApHKDBmRASdHAPrjrrSYNAnA8E0FKZXt/PR3f4wOAMPI9TdmJmtO3e8FETRP2k58zCaEdXDkQoMfvdA7Ji0uPmc6HiN9bHL+2lIUQjMhDGpaMbQzXgGhgRW93nUCa81aRjcD0lS4FBo5pbXRIat7ooFlUQmxNuNf3bWvE55T3ZelS0ifQv7UJWjMlGj7Vcvy5VQRe+xfcRnp3+2aG9W8GgIvgOQZR8kpTiXZZXV8U0NLOZ+jGHL/Bh7TWWA38opLeXmFPM55mnZxIqsdLY30cfDe1jVb2JRwGkTQXpBDy0YiESlFxwkUSdAxGRQmh1SH+6uXL6NsL9INgx5uiXA5HyJOAs98sdYj55kH/jbo8FZpXwEHmrx/G+z7fWDjoGvbvltK4AtJNhm4jCMREqweHau+udzaLuH4ycH6tr4pwkMcB4gb7iuQ5pp/FV3+YtP2hodwkdScl/0Ib4EoHaP4V3P/vNKx+ymUb+vaFzmQP0NgN/CjEUjCgbrALxntTdMqhOPAdRNcZ1dCVsd/U77CV4/W6IuSpy2ZEOYT5zovTnQXmVEmdb5/XFQaWCZ3R/4Uzprr+H2IsNnW1gisDIf1E5evmUh8S9dL10BlMnor19cmhqWVnUW6M+IjDm2GybdX+/IlojR23hRF7Io27l+QOdtBBp0iTSnbJ7LI8u2Y87kv1p6iOpbHbfg8FSyf2/62I/ivkM468+NpiW+GPA5BPpq85CAABmpvdck/muVTG98HHe8jfcu0rzIDFQGiPtcxAqsAgTWL9A32fSVAdWU7TVrpMYyBt4FpIOAWQ92rWg5ZViLs/+9t0gClSLBcrskpEVnV2snz4vhd1rLV85zxAT4U+Tv9ljwOLLZ3/9Jzw60v5HsyaZ+H79/84GQGh8AqgNmLmlgAa0FpROsCLmEm6tO5fkabspH7N/587p58O3L/tvJ8DkzCZCP5xc3uivwIWvkTF/PMr+vra+P90Dk5MtRVSfuKVJADfoZECHPeL2PqzQmkHry3JBLCn+uGfKAVjinhEBpSd4IE+sElo3YLssozIXR8XZEDeDJjNFAfPKZltHkZ6XRgPdEx+cAS0QbpmCAIUElexQis2MM5/tzrIRGux6yduPt/EoFSadX4+bZ2JIzA6uJcYVz3AGdtrPkoR9H5BUZEDBwGNgSI66vR7lzb8mUIjQU+zzLweFv3L8ic/VrjSpVbGnfebqksA1Cmx6HHdl/wnrgfWNTaEY5MRbkwsw2A+lvG/o2DdrdCaGLNgUw6XNd6IpM+QThRW3LW7pT5fXP+J8Bo0PMN8t8u/La1Bz865k2DDm/JHPPrdu9f2890xr8P6bDTyhH7ts+BDNoLjMkskMwH2SeWkV61Y85np+21+lJji88zBl4G+uTTtk//+Xu1rYm5NORE19MhJA1xvzuiXaObGkeAuCqi8xchFvFQfUFrswgNGfchL80Fucz7SsLExE9INwv5CtKvCXNNywP5U4AYmkO6DzgjTPzq+Rat0I6BC45JoesAHlAaXNYnjeE89m/SzwnN7kNWpoFF8vV9XwXWJuCuP8CJQpghX+e6w8+anpJfOQRWncwO+PAw+FqapfvllMoTgdU90i/5+nmxtEhr6lrYn5TVpTmuUEZ8sBjGyNsLzKwlsiLwVuvyZQ0DOx6J8PG2fwBlm/Plq9uAyLkdWDIzOyaNmJDyCCXqI2BWKPKYhLLzUz1NYmHMPyC9Rs5U+v2API6SfKWWlVMvtAZpX983NoZl7L8MDAdd2qDNBGwB9leRCQEmnRJBhTLLT/XqZoYOccW+sKjflDIxhjEhfRe4Auj9yx7kPw28VK0HgIkkQaAI82cqlxELuXwv+iga/m9QZAYBea79+zcgC1+D60egHPRh23fLEITRfSCHvk7EkW8ayMQSa25xVEJry4QW9SVNEq3/08Adg/Wtk/dvS1u+dkHY/CR+3iJSV9TPEpyqGyf4NDk3STU8PFTngJ/qBJL3QiQ0pAiKQAg4bufjMcb4fGDdiXnN6UOrY4II2gAiaBdIoUNGHJFTdssnf1WOGaCVE6GVQG1TfTqX5VP0wneBqcBcIfWjEGrH/FxObcTaKYUpIRFYWfL179++P/ibILJKc+JOxAKRMpYX9k3Bqe8Dq6tf06ovzhjrV/61+HmldIpPZXrOLD2L8rvWMP47gJ/bly+Vi7kgLCD/XqBxkhgEzhXA+44zdZFHhJFoR2WkZSXq874RWExwaSyhr+eAoSBCh5DF01gzSyxfDbSbrDZF4IUZOIr63Y2c938HrgRB9A6IoyXzZVXB9U/FedpJuzAjJAJsGel+pHOXk9ZDRWIApxv3xzSqEFmzIFhGnde+uhY42vr9m49F4FlgatCX7fXtlUnh1Umr6Wff2TqTSVyXwRpYVO4RV6r/DwbrW5+3oqmO8vMAnZdv+hUnpOJtqV3A5C8ylibbln+Bn5Wab5Kon6F4BMGSyr3+pGnhYaSjjLVG+6pt7hpP2ljTSG9F+gbwDUincxSNEGBtrNqx76Cdyw110sw3S2ScBe5B+yI2V/Uy08DS8s1Zk5r4IgIrW762344pYRtapVECOCsKIZuPWplKR05bxz+fpd3WwBrYR4bbMd5TbPrhz5FpXnEbriccnvt9/IDUfcFEvRngMMbevnzpmlJbr3/W6voYaOX+BfHzAIicxToZRVpVXAYQGUWaUSqaoV/O/Qptryp1Nb/8sQPzwFYRBOB6yO9HQJCvQosli/BS5utuX4+jrOgsufJ/BypNrBngUeAngJy2A+lYRSu0NlzHyWOzxFNIHwdmUH45aQIUWAcVHgPGwcAcDK0ppGEatU8jLTo0z8WAtdf2AuNW718G//5qMuxLpJs7+tJfKG0s4EoQSs8An4NoOg2MTYtKRhIU5BObBNqx5yPLPy+whLIdHZznbsq3m2PO2wTxYqnGQKTSpIvS8JYf5r4jL4lNfdH4DDiGh/Gxv44MlsfpRZSGWn3sG6ge9U1tS69/G8MPwH3I6+OfmP86eQdZtAXpTuAp7L8NEukLpMcuAsfHLgAoT0BeBNZGt99dq2ftrHwv9jdkrrdNwCFPvkD9uLbPZdaG83gt8zpG/vP6q1gnTLWzHbrrZ2z8HNRW1bd1cENNdgaWreUHwWuoBKzf/x4fsS/PYj7EHDYl33L1z/uzSI/aNTlrnlKaD5WvYXP5A/AkMEXzBmCM24Af/jD5evOjr/k74Na25Asy5wMQP8eQHltJEy58mtIEK6vqWh7SdGz71s7quemntX7r57XzANTOzvspldXGwmVA/ZxPu88TAPJ41JNvOub1Sc97KnPWJbVLx4Dz+2Kg8s/R7g+OOqY/OiWTwiGwE9pXXzimfdnQfrUOfIH0TmDojD/7t1JrVut5zPyAM8K6+DitJWddWh4/3/XaKzmPfzcs/RKYbdAqp5By0HO2JRFBLd6/lEd9l3Zs9Vh29zZ//2q3NLnyBZm0CQTR7cCjwBsgjT4DWXQU+8dQtgrs2/H2Cul4eyrnY4O1Rzn1QX3vs7J6++2voc7GLr1r90K+wfu3g8/nTrBv0tQu6lOGEPRLo/f1mGPj01pX8ZT7Tjbl0+VKWNo6UIaUUXIZA+WlaFuugPZTW2pjbQ1DZaKZf0NrOcbXH+eBGKowBUyDLJoBWVTDBaDKvwBYamVU3/qwNglVfTqH9Wf73H4abd15UXlpvVWYduULWJnJWq9NwG9nffNamwKKJuXb0y/FYsv+A1/QPa0g6+r+yoTaMZ5/6HvYdX9jK8/q+tjteenkA1Qu83ify+r32BRQiDG3J189Zp4rrjcNtCZnEDnTwAyInJmVNAHHlgJWJ2Ft+fV+rC5DnbfeJ5dT31TGY7Y6U8ofHMlXrR9Xvnod2rlUfTEGvZaKDn1MHYBgKqABtQEE0tPAd8C47hPrP8DFlH1esQlh2geonmEMfAs8AWwEio59+JV9RuSbtLCmaR2LNaag7wXnmYixdFD7o6D/DK3fv35+GavfVeJEj8GPWDgEUTQNzIAsWgHykNaObR/5OLb8qp2lCVaPgHpWbn1Zf7X9aSD0XO3N87k/2ludfz4XHWA0i/Bx+/0WEQIrwD46ZXlfk3Q/WvaGuE+zvOvVx/ny1/k5pFfsenVf+etbz3P+GHn/MpVv33781jfeio71s76ty3d9W5fL5DbTxroGZNNLIJ2Ok6aU8HnlgsuPAy+i/TXr8l3f1uX7p9/W5fv/7J0xjiRFEEVbX2iFhVaIkyBMjoGBsRZXwuAUGHg4GBwEG3GCdamBNlabM/P378+piYj6Xyptd1dWZWS8mt6uqMjI2SqfQUUDEuqKfcbKhrciWRBQ2pCxCUXd5cAazrCZcCQ2yKu9ofgXZN3aGIvOCwRfjC8TitgIYb/0Pd7ob6LME6TwDd/w3fYEGIWfTgufm7zWVQq/OIJLXx2ZVD8dr389tr+O9+8fAlH37fnaV2strPf3c/x2/Pvu2N7eg2VPjiV8X4CvP3sBxf5Owzd8wzd8F6lFyfGSgyGghOCJdmEZNtKMEuM4GHaD+dbYJ7Ql15nITsla25WtZ1wrODt70Ohvu51s/MP4RjP809HmVfHVJJtXxVeTbH4t4aOA1psjIPXtEXz68Xj9y7H9cWx/P1fj6h7A+ud4/eex/Xy8fnds3x2vvwzfZ5W/hTk2r4qvJtm8Kr4qkYFl3NRyCXWj7BtHYfUwuqoYaXMT9nlZaXqwAE79LHIe0Wb/miDtjE3nzmw22jFuN8dmgS32jo1zG8bXkJHBap638TRJNJwaFr7hG749+NLzFFw4iJ5HyMw6gln/rVz49vj36yMo9f3th4ft9///vW/H59/cs6we2r45Ngz1VUebO9boCd/wDd/wBduBfRu/QXdT6U4ErWdeeULBomlMGNJHB8UPvQQlo8ybcqrXKfTrzPGaeF7GnN9W5RS+4Ru+7fhuuR7IuF1bcHpQUPcJjGxqxzaEb/iGb/iGb/gSvmQHycgwjJVW+NPb6vWymI3EmcZUqb2rIhjZNPRHtDBearPTVvHDGTc6TjtjzLDrzvm+wK6xXYCv1I6MDUWDm2hm02cpfNvYFL7hG32scIvCNwrfK2skXxgROCN66AVrjCgkyHtS+4u3JceTcetBCzcwyANaekHYZSNtSP/+Cpl6H/ya4cfDKJpr14Iy/QuBL70WmG8G8p3yHwyKTmnqqIq+CN/w7Tams3nhAr6YqPCdrfCdrfCdLYevX0W/4Y89MsYXT3uH4ZONgRw9iFlsvHjK5sa1Mj7lvCh4s4XPPW/4tlzF8Ek1WjWyc2ZJFR+Gb/hGURRFURSV14vMwRSmv0G8ycfOAI6WycHt0acCrtq0WiQElhDHASErTBw3HwvhKq+iqLH0fUKYCNNECSfNnxCyw6iNA/l2uDm9FS8a3VEdfRG+4Rv19UVHm1fFV5NsXhVfTbJ5VXw1yeZVBX0FEkggK/dJhdkht+WDwsWeKHZ+qjzBhqsovhZlBMS3T6P0Ofs1/cRxwiksrYxFG9/aLnzDN3xL8X2sD30VXL+eJ9wxqcdoK2Tr/mSs9WuA2xW+4Ru+4Ru+4fuYLysvqcizlvixMH80QQBKjtu6chB2rhxAbIVa5N4o+q7YqrPQ+4d6Lq1/7ltuo/8FrB/P+fLrmjMbzDfBw3pjhPp5samslRW+s1V5jJVWZ+6qyr4K3/CNwvfKquyrM/nqxcL1oAgP9rBsLfXG3G3PfcTHKIKE6HvoUwf91ZPc4IRgl8CftDt3uW4/Uk+kBBKNz/12uq8xkG8VoXE9ryqqPJbwnT2W8K1lHxryxW0VivsmfMM3fMM3fGv6ZgpforMyj/an60PPZOGrEbqw/DHpATslILVzyoCToeMHVfgY1emzQr/0HC/sW5DX2LwKH4byjaIoiuYo3/OzfdXR5lXx1SSbV8VXk2xeFV8Rm820eqf4sdsXlz/X1KhnAXVMm6ZaQa0/4WVg6XOPRU7QjvPZqra67N1r3gwiYXdGluEzXIBvijVH4RuFb31fxde1+YVvbYXvbIXvbLXhCyELAet+vYCXkHVydmqfHwDQ+0bR6QPVUy67CMZ+FPVZbrQ28jWCwFum8DJbjMw1w0/29wqccbD+wjd8w7cUX8c+qCv0Gv3ihGx6qP2QfcaYNIbhG77hG77hG76Er7P6H3eY4UiQfaRIs3YuqXaXX78HxAZ2bgj9g/TDfAuyj/TNeK0iNu/6coD+Wr9ujOw/cs34PIjddD//XPfVYL4FnlI4Ney4/8861vCdzSh8wzd8L81X8LXP17oh8e3Axjq6lafAhG/4hm/4hu8AvuQmTQ2Y6I4lcElb3wFKIEbwkRqUAflcmF6nc/Gmc/mBPWepcG0fDwhZgSA9Yg6BAZaNnNfwlblgA/fPBfg+qsb1s660Qttic/iGb/i2UUc+q+KrSTaviq8m2bwqvppk86r4qrTNVuFkI2BDsyNOeKpor+63bOSc7HjVZrVvcpxhs+ErK6DBWZr1vuAFJzmP3TZznr7Niq8G82VC4anSKJi10s3myn6u5qvwndFvNb5RFEVRFA2UfKNqpNGx82NjDSzdHlPEj7J2ZikZY4S5D4Q5E0y+PmefL0wuKHSTcZf9HYAL8L2yKvskN8rhG/Xl63JHs7qTp2TUFV6gJHzDN3zDN3zDdzmAbQ+C3F6UcCyM97Dg+O1QML0ft9cRmK+KjBlbx+wX76uc9okiK428Kl+WKXpuHRr/OuJ17fT+d53D5a7aEr7hG74l+OpM/IdJELn4fH1/cPnXOjbZgfAN3/AN3/ANX3qsMQD+uT5laf+F5mdq4ex6TFL7/ZlevI3PD+cGsPYHMo0aZnBrThUIumLzNYWhfKMoiqI5yvf7bIXvbIXvbIXvbEHYod2M+0XbeV0dpwaVUsOH2cjeO/W2jOlYcr0emm1HRM4BwpD1C8ZTGa/x9Bl2BJmPDaQt4SuMW/h3eU3eC2Nf9g3nGz2urj9owreGwne2MJjXavPsfmPz7H5j8+x+Y/PsfkfZDK89L/B8VnaEODaYNbYgBd38DA54N+N61pRWnN5P8yT+pJL5c0F47U6ZhPF+n084XzhZUgP5Tr7xSl2i8A3fvmObyLdyXZDq6vDQJXzDNwrfKyp8BcecsLqf8yPJD/K4/W62D+INMMjmjE3PCuI+4Tb7Be1R6A8NYr/n98nfY2e/4SsJDW8wBZ/4fIs+oAnf8A1fLhR66GpcC86xfhu5vc4Rul2+r8I3fMM3fMM3fJXz4hV/cIBC9GtnYdP4/WlJ/HMYPGBcsLRfIximtgXzvTJtzQ/o+McKfN1+/ZpinBF2+eqifKuoylOxLv7qpvCdrfCtsfBKxTF0WBynCpPwreer8A3fajaHbzG+EKY7gdTGoQEZP+Kpy6nVZQW3fPtR6A/qZPFpbAXTMrdkLzUNhHwoFGFSle/tX/bOGMd2tIjCV0doNMEIjUYIjdCo31M/iXAixAJYACEiRAQERGiE2AQBIkKImJCAgIAFELACImKWQAjuebf1bre7+/SZ43ZXlU9J1u1r+/dff332bbtcfxVzBKrt3UIB5BgwGG/ZFkJ+QyHv2vPyvoVv+IZvKb7g/eo2ZTobutiFfYT9tMh4TbB1WfTwDd/wDd/wDV+JrwKFNTRgwIjaMIDqScMVvXmfPPk009N0PuqJ+zkfUO4+W8h/6zrC8IQzbjDyeoHxFWzt9KGPidsPw/h2EhR621JRuo8vfGeP76h80fSNsiDa/+yGYwvf8D2Fb/iGb8mxjeULJ6G7lzx6vU7P8aNHnwmJ2g2wlmMAXmJuzsbo16os6XqJfceHX0yA8HWifPS8Jfo63q9+bAzmu1nk4K7REr7OqBZm7Fw3lxK+4Ru+ZfiCtMH+6TL8N92Gzujw0PAMQfiGb/iGb/iG7w5Vd+wBQFwHw+iKLjB05qHx+oUDM2IFvnOC66PnKuI2U/TTo5X42AynyGqdxtcPkzXCXBW+vA/OF0P5Vn178pSgQcLrKjcDlcYQvuF7FL4orFs1QdHiAeEbvuEbvkeX8DWVgLivPkVPd5Rg60TsPiA/qkh11O1kIzB+fsQJ74foJo/VmN4JL1ea7+037HTaR3fej+LcGchXFt0G3D7NcufBaAPHzoIOKJJ0O3zDN3x7JcCluhXU+Rsf/4AJjsM3fKvpHL7hO5YvLlZCXZ4KKyOfz6rE1+gkkXSoFHZ3K4NO8o4/FNV+GNHooak63yrVVrBBAmbs/RBvbIdil4bTqMI3fMNXHaeeQgIWIz4myG35S08UPCdPTOfwDd/wDd/wDV9+LD0nDcinYShNF7JdGRucJOweXD4ljzAQS/zztoY+MgddZ66bwA9ObiTtvOA6CzyESg+cC7GVbE+yjemMYXzvSFHnWjWn6I2goc6V7V7NVuEbvhVts1mRmSJs73wvmgeto6066hy+s3UO39k6h6/UwDcMDA8fvGk/PBeOUPmP6Ez6JmW6hX2pnnx8PGKOH5PbUuDIE+PrCdEh7Ee5MUfKtv3y8ZK+KRudxXqdMWWY6jqYb3WZ7niLzvdldr/ReXa/ps5+RF9h3apMjak2DSh8wzd8wzd8B/GFGnZvALAVFx76JUcM04G0tXPriGH/UKstqomq/e9+WzUSjrEWwxnhVMpzo+mMXE5OXjkIjEhbaX8M5Rt5Sur/o43UlvCdLXjht7Yocp/jPsj4/XLBXnYO3/AN3/AN3/B96nuVRO9wKgiSB1sj4TVZT2D4bXnEjFhxjdtQrygIRWfDsQnnfCS6yBF4/rXC7a07ofRiCYyFoDPd/6B8J8qE6UEddFlLTxtUsmklXdbS0waVbIpm0yQekw6VxO9KrbGFb/h2lfAN3/DVhSdlF6eNQc1FRQYgrdPF71dzuvG2hJMM3+gXhdoSMZn7zlcUmcMMZbzFbTWJL4qUtbWiMouU0t1uvBdSKOF3+IZv+ErM/HNBiZA39LL1NLfB11dvH77hG77hG77huwVfopDvBKEK2MIHbmS4t6d3eQno/ZtsP08Pj8JxOAgXhHsh821+MQMu/oUL0vYVrjO/wMMB+N4KhrxhQsEKjUKfft/hG77h2zIHR7XxPEeq5wXrItPGE76zxxO+s8cTvmQ8fiO/khqMymLPSkI+rF+jCps33qfaFhnv+bvcFmmbtnu2LVQVLG3TNm3T9mhtcf9zeNuOtuqoc2w1W+fYarbOsdVAneWS8kKOIyF6Z/Oqe3Dy8ii5powKfnKFNmY7shC+XGehqiTpm9mKj9WoKMmYgn/qFTSVio2cBx87GRfZTvhK5y+PLBvGt6Pgufs1fKPWlUn41uurqoSv8GK2iB5bHQvNohlvBOEbvuEbvuEbvu5x4XfCHS9C/iywdeQ7dSiRtmK/3OGgOjSU45L1UBk449AdOHwbZ+jbgrfh4+E24mNjNjXZnxwbEZ0tmw/ke3SJHWZL+M6W6nwxvMrVS7fFIFt11Dl8wzd8++ocvq/J13M26U6Ys6B4DgVwffXjF0mc2u1G947tG+seeUjmnJt6KKz+tgZOMkfjWBD2ww5z+S0787HxduEbvuFbgq/AxMtNKkSgqwKRL2+vn6Mw+cIpehS+4Ru+4Ru+4WvwJQ4ocR3rmCvItwvRD2Rc8rTAdTsOD3zRnYqC/ka0jrao4ye2psfUc5XxtsqFQ+wo9Ev6sH6cOV8l0k+fessZDOT7jf7RFGt7aqhz2oZv2obvEdqG7+y24Tu7bfjObhu+NeysKyA8qJvRUH7FQtceikOAHcfwBkNwDErJ39V2uvOQ897rQlAdqVuem4Lu0lid69CoNCptPwDf6VKpIlunympdJHxnS/geS1B4JkT4hm8kfI8s4cvEyT+1ZQgb/9QTLhtRJ9YcVXJscxvXQ9+H28Mfj6+rytftwxmX3o7r7GwzOJ2eq3P4EgczF2jb/N9ZxXHs6+zb3LeV/zsfvuEbvmX40m2Nk/Qe1VYddY6tZuscW83WObbqrfNmAiPSgoufiB3yfEs9agyqg0eowChEQ8lTOMHtzZN5m1PjoOitRnJxRnpknTFNVtCV96HYxZniq+p8cL4l3lAQQaPIDCK6zkWqq4Rv+IbvB8GAyomtbtwflV5j7GirjjqH72ydw3e2zuP4Qn8DyCMoWB9O5ELhsvUd59OeCs5rdceDtH0vDXWe2taKvnCPq2/3dS7WtqOtOuocvrN1rsYXxncSwedF/O2vs7+vsr2IzuEbvuEbvuF7IL7g0+940nTD0FAiFxp5PvEKx0VBxxm8fvm+afuqbdFQ59duC/FahdgO/kMjLyDhR/hx+yi2EiPuoNgqfMM3fEvylapJ+ukU+FjNCrX8fNMLDsE5n/0HR12n8A3f8A3f8A3f1aeRKB0v4onUSzGiYPQS5H33Hy+aRInhMbsW4VvJ6dhtnnLV8fr9+tEP2H1ajd4v9u/XF9fO4Ru+4duKbyQSiUQikcEC6rlciZ5fivQLIxG84gyDHjmkJy8leuq6ctGrBvK+Ia8notjEsNkOTg5uP0NX8oZcsLlw7TFR+hLzy2Ew3zxoCQ+lBaNdO+YyqybhO1uq860u67HX6rd9Qt5HpZadw7enhO9sCd/iAu2hVk/ErRhFbIOdcyiBjJc4kjw9dmCKLRkZifxlfV0nmNTGT5oPpo/w6fXlM+PrOF8M5ftoP4X/CaFhv9V0Dt/wDd8d2rr3iB5f/xhFdTbb6m3CN3yL2ip8w7eazuG7i/iJuqDcRIptYEWnMeHOLpAx08pqTkSI45QjY7GmlOkV77juzJ4ud8JR4mtP6eUC/+/tHWJD+VaT6m+Tpui8ltk6h+9snTvy7cq449jw3P0G2yB8w7fr2MI3fNvyJY6g9UL2ESJJ5OgFNK/GF2lwQRSTjmPuqHMlO8D43TGj5HazC4zppL5tfPshfMM3fMvwNSP8db7F2uC1H34K2TF8wzd8w7dSm/DdmS9Wn/tUKUPhh2Y1pxS3nS5QcvWQtsKxbd4gOslhjG55T2esRaaKQbCDMdZ9jj+Y72SHHgr9TneMUKku4Ru+U/iiYdJ47G4jvV8UmQISvuEbvuF7K+EbvvYg4Q/C10dNMG86aiA4cqQSmGYybxg5jWCU+TT6Jbq/JEtdYPCw+95hOiyEfeT9B/KNRCKRSKS7dJ1GGgnfSPhOl/AVqgyuRHDg8CghvS2EynlUb/9Be62TkYR7dQxBX6YTFDuwvgWdoJ83/JicL9eJsKB8lX6FfYxcb8zOvL1rZ6XfgXy7VupCs/n2T9o5ldjCN3zDd0AEbakEt0XP/fD9IOFby4bhG77VZDRf8hAnAvPL5UNd7+bVYm2N5PMwoj/At+l2p3bcvmqT7lzwWXKdRHGnjjJ+/vWxfVudC7f7YL5dZeKYIuF7FAnfxwWFpqJ0S9DbQcJ3toTvbAnf2bIpXzy2KNvFSJ9TkYdBZkAMvNAEnTds5+uMhjf1Hc6HatEOnewNtt2Jat2XI9dZdDbC6WOf3ziuc/iGb/iW5MvHo7OBwQ/qPr7O/nT9gjqHb/iGb/iGb/gKYg/MN8gexyNtLRBk6qB9A+o4nfwcWL7OBnOql76OR4ex46lJ9Xm/fCqt3ta3va0z54fBfCORSCRSV/KbPVvCd7aE72wJ39mCDSNc+Bs2xWlTrOognGMaD8V25UdniprBgujo5worVLFh18icQon4UKxixQS+lf5BV+FWRY+70n/sVexaRY+70n/sVexaRY8OVQyrHLtD5HX4nsK38fGr2DN8+x07fO3j+8rAzY0jQIIC1shDpD7Ygyde521fMD8YyHFVBxhcJwixF9MLhpPPcqIJfGFUUuSyfX4sEJ2Nc5DyxVC+kxI+lvjn1ETCd/bYw7fX2HGAMVax1V3poXPHMR9prOE7e6zhO3usJfnCmH4EN6cFcwyQdUJ+C35cvl6PaBIiu6SxEB1B2pPPdVvHoWZW2uN98jGDOBrBufL1gp0l54nOTefLc+Zxp9Bwvkcrhften3l9pdRx+IZvrb5KvfktNNOgmlS1QfiGb9exnSV8h47tLOHLBHt3SB8o+X7cAaPny4EwJj0Ca91Gj1zhup4UB5toYygRV+pxOF/OQ+VojMtwLhL7C3q6FS11u+lVIw/Mt3tY8GOC4v/0Kkn4zpbwnS2d+VZ1ClaS8J0t4Ttbwne2PM5XrCIItgjOHjuXkgEY7Dvpt/LJ/WDb4jpHIhMFhfJ+QV1f6C2N0NayAcI3fMO3Hd+X6gdGW7mvRg5IFK0GHr7hG77hG77H5fuQ+NEe6o2VHJWl6wJhGqMzPRKCvkq+LN95yO0JYTx0TCp7MVIGYs4kqHq4+atUPfziAtxmut5rcaPAhvOd7uSdOKbYYvaYYovZYypxwxydy0hHW3XUeS2x1SSd1xJbTdJ5LQNsZVYl8yvjOXq+cFsY43JsB8dejs4F+kWRC8fS+eX69aMNvPb6tsF8Kz5ookm/R4sqDd870srmle18ZL4PyrBp4B0flDpWDQ7f8A3f8O3S79H4bvqgByMnk51nZ4cHWajVDFnCazE6Ck50DY9k4Tq4EXRKlJnLyjvP9TxjZj9w9+eOVb7ddUAr/RyEb7d/YreCZsd9WHrbqqPOHW0xcUzhO0uO4Ow9soTvbAnf2RK+e4vxMImNPY3YUHfs8DYTm+rk2xLmmGCMAa5dX26amh/xJvBVdIA+1XX7c3SPKL+D8r0vKJTfZ4fo1M11QvG3XuEbvuFbl++945U/Z7r1i+btu/TZdazhW7vf8L2Ruf2O5qtEB4Htv2pr5uOxtun7otiJF3laOlz8R5Jq0++qRCqQwhjbCO/P56Pn0fOTWEu6bM8P4Ru+4VuKL+yp7VxH7JjcXx+Xb1MUvjcO3/AN3/AN3/BdrRMcSL4jzDWqmLgZHL6foF0Y306RRrx/g690HCMqxbEP58sFjJvfh8/BOG/3yq0ChVP43hE0ctAxu8LQDa8UjYKGztLwDd+j8a10o16tD3I8mS8G8wjf8K3WR/iGb/iS4xmG9R4W7dw4fp944belUCoHqvsYeZO4/v42CAvLvQTCDw5P91wU+Z2YDfYoyeo7nTlDYovVmIbyrfIP4NTwH/xk6WirjjqvJbaapPPpFNtEwjcSvkeW8J0t2DSSwvrOBUaUF3Uk7VShEIanFeox+JRM7mwyomHs7eo0CcLbujiMsTvnEdRjG2PGnjZ4d/X2W9dXb7/37s3bq3dXy/Lmw7KsX9Zdfj+vu1iuz9sv118c64vrN28/bsDXE388vj5rrljs/9kFz0+3fgO0HPPzC/6Xn5/d37dYaHR7vkwWDmf2q2t3dc1eXyznbezzk/B9Hb6L7T++ZWrw/c6yfHSw/CLdosbAtp3Ph28vy/cXzj9cPn+6LL9YGP92+fz98vm75fOrZfnZsv1Hy+eXy7ovluWjZrYax3e5L8LN/dHl9XvvHuwTt493b97f162W8294IVuN47sIGuocvuG7P0DPQaBXPVst9CHfdxwQPeTpiEb1MhrJIrIC3cbHCMMpR/jqTjf/fOZ2U/p3uBC2Aks/QlK1MzkvcHZ0fLrczPxlWf55uVxfXXy/ul13s1xsv7rY/7yc97/d9vebG+vifLs/gD128/rRsvzmgtGfVk4sv48/v+e9Old+deot5fk+g82vz0wu2Ky+rz4v/75elkf4/vjUW9ryXWz/g1tOBt+/Lb/Vf1yWn9y8vFjWtSnDfSABeUFxvSy/XJab3+B/LRz/u3z+76Hl+sPnf5blH0ubPyzff74sn4evIb4jenEwPnwdL5y+Mo//3fP913LM1fLXZfkyfPNbN0DntcRWpXTG/b+FaV2rxXm4Y/tsX0WN61UoYdrYE/BBmTXew9r13dXXNzr/fnf1f/bOP+Ky89rjxzLGGCNGxIgx9sR+Y4yoiLgq4opREVF1RVRUVV1XVVVEXHVV1SUqrooYV0WNqKj+kT8iYsQVFVFRERUjIiIiIiJGxYgRY4zxGu7ac56T9zln7f1+z3rXfp9Zzz7rYXn22Wc/+/nx2c85e6+9nrV6bn6bTuQ+mQ/K1yyPVMB3r1aNegeIuAyN4BuQ0g3yHzOO2yx/4c/HRB26pcD5TfKH3bnbkywp35pvn0XntFu7YqXnlPmC7Y7/C8xGzOGMUd+cltuSb7fvZ8G3PN/E9XsZNxNfzq9y/iXLr3n7Ls7JEunYYJ2dBPO1jCu+x7S7tTBcu3Dcmc9B5nQP5+c4/5Ll+pyj4M+SzV35XSfXEvsXef93txRWWcHXzpfHn3jcH+P867bp5XeJ5W782yjrSS+vnmO50XdfxvU93/EOvmXmLzhWzXeozzF/g29FfA0d0ldI9iV7eqiW0PkKcKAMuOk2ThqLdRpmgZlAHvYlczSOxRhmbP3BU/uAsvOdWfhiHthiMb2p+yzd8AIZVGLJfSzp5uwR53wnqfDMFViZXGN5Pi0fsiZKCqy+h6Oz1nNvYAjlUdvM8+6FBY9WKKRWlB5NEsGRRfLtjv1Z8C2eaM41U2BZ+ebK7bllzn0bPL6uE/M5wnx+u/ivXhbBXCXJgvrOWaSiiXl1TP889EKwZUu57pg9nPcBLv/FAOvP+LztLFKkSJFKJOUDGxk0f9oHdCrha8bugwIrpNBYqhQ+Iql4ETgGHKe/HsRxcB9mDuqE7dYoQA31GpRaOnZ2p/d6zThklyyw2kbcFPcqruQ23Pc154845ztzqtRSWLoCBZZUYj3DctjawCUFVsrT9lkna/0nyxekTIElH47aPM8t58Q+WWZhgRV8y/NdKLCEsmI8vp+wfJ+FnPL1pDQt5fOMWE6lZf7XEyvBfDdpxWfB/n3OT9Q2NpPg29x1D4//pYxPzvcrlkeVvw8Hme/L6R6s77//KZYDNYzNFPgup2pezARfn2kjx4ZKlzX6v7KXxceTzZrFrjwzWJ1YOBHYVtev7wfmaOUNyiOuZOBrfmgZmy+2opFLCOXNcf52Hx2X5WkJYQV8a067KrCyh9f8gaXj8vQYCqy2f+nS2Vmkcfnq2bzQLj2sZvxXFY67LDeSfJMFViRDMiqwMo5j801z+sTMZ6rxt5uMCo4TzORv0IqqEdsaeX/LB/PN48vKJOb1O863B9i8qTkfz90zfL7rA+d6q22GLO38j5VI0WZvqcaxqrHNMlUwVoblYRZ/V3ifPTqiPoS+8tykrIf0kfnwWlL0neFhHDpiB9u4jbhuAmNLgBMYR2BNpGgb4gX4wjHXsjesqQb9xtfn6hLCdvnN3Tcsnw5Kk/JheY/lX53zzRNVGAFkdwusYZ9ll1l+zJ8PmhVY8o3+Wac3F5Phu+4Swpx7UmpcbxdzV+RyX9vlUp4IvreGb/KB1TfnbjCr17vACrm0zc52cuj8McuVTAkmzpV+Nw55uwHepJSiyLacvzFoWbXgNWd/OTlzf7uH/V9ZPuTPX3B+ucev5fssJ4LvrUnMoGF+7wzw3U7RJeHYpqjAbwxcK1e5joeDb6Tgu7GpPF/0cA1kvAdgmcjp4JWHhBVNNfSbJjD2s1kdY+0mbTWZAkvKyyx3rSVN7/6G5fDMbyKLfz9LYIy8LMi1vvtoaAlhu2qlMfeT8bhCiZwk84EllqgIBdaIkUDxMZvCdygXTtylRcaH3VzNZLf5m3+fH3Mk+JbkKxVYrVRKX2M5DeqZv7BgC7r0ckEosZJc5H0PjcZ3fKt6Gvtlb9n7KDyenQIx/f8KhdXKvq84f46Pf7xju8v5DvP332F5jOVZ5vs3lrmlTlpCqGlz8DXxlXzmEUGHloD+nfNmjXP8lOUqS99S4pf4PIeCb3m+677Ar+R+N/gGXzVfUMgeWdDiSwZZ+2h8aoF9M6slh7I+meN2kIaNFD1zFWc9L1Lwgn6+gMD2gz4PnteSKyyIRA5EnXRtxFZyIgphlneh1vN6Jsp3T1aihrLWhOtJCqzkBLZvuUkeVe4iy/0sBww+sFasQdwtIZwcX06EfGC1K1aVSS5U5Gw9+EpFxPcWTHf4CgUWemlxIL1c+HhrOFrhb8FvQlGuJkb6slSCN/B79TOW7R0mwkL6Css5lntZDmn60XFluYPlX1leZHmD5bhjf7aT4jukYGS2r3EurGZTkIVfgWjSR/nYTwb+7z/l/LssFHzXS07mAlXY5uAbfBXJsAQOHaON2gfKmeEYH0RJ0ReDU3ar5Zus16BcAn0CSjSgoCoQkVHB2uBny3gew7kMY2PWwsslhHIpybn82A3gW3OiviWEwg9O/7KyD1ge3JMCa3G+8IEFUtkbrD4LrHahwIrkMakUWFsDFljK+fuTbmmRmL/zz285t56dWqKMy10sF/qWlCW53LJCwxpNNqvvVLDe90SAAfG8e5jlnwN+zC6xHBtSSPI18RvOb2Rlc2vr/5xFms1iVUak4OsukeE7kVutujQR7zRKHsP3pFM2je8XwzBWGr4ERF1WYxGj5zO+VSFSwJWyfhi3rD7hsZFLCDN/GrkT4HOrZSbKd+aE95g3xIfaXIEl/KYIJ88fJKsMWqduEYVw+do56/wmoXq+60YhlOz7FVg19Cn4zp24y/mrVmBRpij5h1RwzwM9cH6bszfCs9nEH1SSddTTLNdFNMm5dJx/iXyUVRYx7Ns0db6A/UGW33esByziz3bH9JS7j6+LjzKLrTz/gOWO4Bsp+G5McsmXUEMtZvToAdG+3NCu3AHfkcGiC+7TP1BjZgrlHikUgyDhOg31gvp1167Vmk7H0m7NhMvK/Ya2KueFZJVbYImbpmwJYZ4mxneyf4q9UQhXpJXbb7KcmmAUwsnxBX3dWUIoolBO0gJrY/gmBVbfnL7GfE9rQ+5zuVfE/N25Xo4Gp7KJx/4oy4Vdog3+meXgzGcKvnb+DfP9su1n/yXLQ7xNK2XODVwvl1l+xGU2Mvx+pOAbyR9frDyyL7chIUChAY43+MAaOha3D31vj/gmy1p9YBnqBQmMi44VaR3VIb4K5YUQrcISsIbfWX1ggbkGzov6hvkOLiGUS47ObQhf7wm0FUQhRGHV82hW7IeDt29XLSGUctbjmDhOxr7I+cQsXxB861pCGHx7+GYKLBa0hBCnFKVOnC+d82gBPxpUwGqW0LHml0d2S25KPikfZMY3+nikiKD/Yr2+rG0Ovqp6cRvkUsIn03wWjvv5u1dzKyzevp+Pudr3f57m9m3B1w/fLsX8Db4bxndGSAwOlQs58sLfO7rZtUAl5zfmhjbrroMK/BLRInfSnjESaaMQtskCSzzAJAusCfNdJLKWUbQDnsNuGZqiWOVO3JtdFFfymJdYjqE2JQVWWq4goxAiBaTlZcam8x2qP7fA6uPL+y/gNuHl+MH31vBNUQgHfWDp/B/OLbDE/J3n2yxHbXzld+O6kRhfQYg+I75W/jzmvxvwK9jJH5D1lb2POAhM8DXOb/xS8ThzfqvtUWClfY/OOLVza72XByJUdkuA7wm+/vjG/A2+m8SXtIDksRiYtoEGJ+hG/1X4GDQGo0aBswO2jzNO4/MdP0wqFXDcrb2+qGzEK5zGHqutk7kCC1tgTYyvR2U6jenEfRGt7Nt8zvifnF+S4fiTzMOrP89yGFlgibJpCWFNY1UjX5mkE/cBvhe8ttlJva7b3GZRCBNfgxP35ANLzt9OPmU54uyFxKRTFx2Seb4plIlzPtc5/94s0kYk5n2G2TPzXp+Vb3J+nOUJlsvz70XUwv/ZOul2qWmkSJE2LNHINxJkPBchsfUDOxsHZVXH68P3600LwTnBufQO3TVvjzXLKvUmnrjcOD7M9HyN0TpJee2RwRE52RU+sq6+JYTZ9sttww85uZwEn3Phc1fAtxoniHtdQpgzbefb53n7lyxX0j7pE6tbxsKRjXZTYrXCAkssIXRlbTglviDtLCGUfD9Mc3NJ8n1D36f9x5MPluBbKEkFlnDuvFcF1o+57NVs/ubyCu875JTvJBVozOJECqaR882j0B2Z1ZWCr6av0pn/n7f6fVde5fy/tppBX2nvsbTB11Wqsa/Bd9p9LcKXRrbEoQJrVw0h9UcdD9ovcBqH6GicCjmoJrsTfnvCddmVqpY2YIf147cB7dMoS7XKY+nEfUm+Yfn0W2nEdpLB/X90ztdjInt5qcBqkywUWCx38vaTLF9nkcfyYxfh2p/K3+RKJ+5Z1MqmGgVWf6qjzbD8qhP3Fb7X83nKOYuc222X9wif482k1KxhrJZTHW0G0UWlE3epwMKR7pjxvZx/PjB/r7M8yZ+9jz9VFLADtrXzb9UxGVBKvKtQXt/Bxz/K8tiSNCmX+xf5IWeK4EnxVSqqiefld5nLJwMBWL7h/EYrXQLcYPlRV74CRf/G8p1tRpuD77TbrKqfSlhyKSwhyODwHDhZNzuqJkU/DVH/RFI79AbjoYgWKATyw9u4XdYLHY4BZkoahrDddiUfAR5K5nrFMN4nfWD1LyMR2zKX+/L95yvkO4k/s28VWCvKqSTnWW5nOcD7fz2/6eVj+hlfT5GMDvRZYA1ENjzrXFFRPV+UtlaiEPbzFdZ5clv6TfuE88PBt1SbpQWWsJjMFFgoTD/zu5vzp1mY42Bk0o84P+2Yb80Kzt34PMRyUfy3zuUlxXnOpCXi+VzH0rDFtK80Kb7axAwPJEur3t/rAb5/vamIrCNtNN8NSMF32olMPm80DtyRcgWc12IlRAUszGjDbqa8/jCQk7YNtsGxA3Iq1x6pwGp7lFFtyqUSJNtudnUQfr4SvoYoKAbLVkX9irJCgSWYJQVWinp1hPc/x/m1XZQXX/Axj6elYySiEHZlOhFO3M38SDBQMJoyX5FL/i9I9pJv24i5LfblfNukwAq+RfnKJYQne+UjlgtbDUuWZ/J+O7eiuzbEt1Nm8+dfcX7AmW+yov8f4wcrwi9Zk0XU5ex3dEiBRSCS3RlmeGl1Trcr81/+ny8rsCqynqiC716ilDOv21k+zKwkk/Ty+5LlEf6OhtobfH3x3euzQPANvrXxpaLKBgmSLMondC6khAPnAO2AyjwpIhkd6ItkqFdvkYXHANdLhv6Csba3E/GQguswKH0V9YI2i6SJRoGvl34fWIPKKWlpJZVduZyvgO9gcv6bTus4cRcOYHMFVkrJGmvZYkdGwrrM+QOrFlhtY7DAMvpnrGB5KBUIl0zAB1bORvIV+4QSS1hg8XkOB99SfKUCS/AaiW/6/Dpv3+bsXnXdRJWccyjC5OMs38j/X70FFsulVFZcF+Jz49YCa1J892iVR8zlJ5xfEdeF5Pv7m5bS9aaN47thKfhOOxUdI9KGpNbttztc1jpMR8eC4xTnBvWpoOJwmdYQ56BPo7yt1it4ZFLwh+Ou4DuSo3vMBoyVlS8pxhz6wGrT52zZEcj7lxA656v+bTSULWlVKhVYPUsIV0J338HMX879arRNr3PYB1ko84G1Yn3FMldgkeNxrp4vKts2O1EIV3lKvjm75bmc882XEDof58nyTQqsxG5UvjdY3uD9p1nIOlbOb5ZpFL7j+zd7hFl8JZSSjVKBlSywliwn+/7X5XVybCLKSJd891qW+RxlZq8IhXTGNy09Pe79oTP4LifnbQ6+wddQrw0s2bSIeqsgw3mpQMQh4HcIJrJEMMT91Ef3Azkca3y8njHou/ltPI4sKXMnywlJUQ72ATLH55FRCKUC6irLxVzafDv7PCB/qoQvOXowUyRsgdX2LQtsMgWWDKt/fikst1RifMzSGHxg7ftNySbwRfvbYQusbd63NE9XP7dNtj/bTnP9bZbDwbcEX7yEsF/ZMTx/+34PknXHX3jfnU5vnmvmSwrF0wPM5ouMbc7zvNYCC1rqNUn0PrAo+JZtE7P5zo4VlpCr/P0vmCs57VPw9ZWCr+82eeuTiS9lucLSBTg5xw2hAn5lCmg/cb1ONLCUci8O/RVlbUysilY8H+zX4MjzgcaxWLRf+zd9YDWswBoOpf6dNhPex5K2k+TbLPmxTUV8Dc77VdZvhL431EW5AqtlBZa0qsstsFIZqcR6RzwILys2X+f8FOcfCiu9uZy19kl+r2c1Zb6gLZkPLGEp+ZGYs0nS3O7dn5U5xULBtzzfRRRCufQPLBmU83ch2yzvs/yQ5/BRzhXtU3ynfJlg4WuoByRjXfhcxON/ijl9PGcr5LPcLxnwgXU3c36W8//tkXdyf1jLdfUrsIKvla99/JgNsbwklwKzzOdwC8eCU/D1yXedFHyDb418gUJKt8/wVlTkRmBUtKxMZLHmcqgUsiSyRBF06FDfOn5UQQAB+/xJTtxZhA+sdr59zlF/95sviVypLDTst1xvhJYQSkf8cgnhynLCe/nY94CPszf5u8+XH6CFE3cyR4DUW7PSJvBFZduFT7MmyY4FzoUx/seC763h2ymwsuV/uYLqBu//gPN/cD6XZi4pCINQbCXLuu58tC98YdKzEFwVdTpbGioScziSuAmH3SnK5Cn0IgfXkaLONkK5ubYFVvDdnyT6Ln1hPTPnJKzz3uX8TkdLooIv5ksVL3kLvsEX8wUHQUUVqBjlZGm0XZOKyxjqVUczKmD9Ya+3fFlyFLXJW9kq+G41Yglhruw4N3G+Yp+tv/hYNH+Mv1dSgZXzFD6wRL35zfJ9LJ+zSMf9O9HKtoVT4AZYYKnmDVZ0bCpfYH2dLLB6fdhdwD7jcBuD763hm1tgrfC9lpRbd92UZp4neYKP+2pgLr/CcsjEV5/IcM3B8jjp67UzlNsDfP+UuC5kwfkGM3+Kt8nS37ZJCqz+iKPH1nFBEXy1fO31JgusZxbM8pwlKbBwf4OvT77rtCH4Bt8a+RLyKaRwnm1602hTZOHzVm6pRA7XrgI+1rDn+JhK1/j2JXK6jpr0fZBO3Acc/Z7bAL5kMbUVn+2/pbgu/NAvnbinPMl55nz7UN9TeeLr4Aecfy79sfREQhIWWLDNBPpiijg7db6LbaTAEux6LbD0bQ6+ZflKCyyhNL7Gc/B0X3t5/6EuKuUu8/cnY/PVRpE1+NBUtBfzRf0D3+F+YQXlEzmbFUXT28zyuGqO5HmywErWen2WPMdEuYHzBl89X1kGj49QYPUrod9N/utgW4OvT77rzN/gG3wr5SvgwBswIBAI2AaNLmt1MqafG0s7CljoFGhzGdNO7dhVMFaq8fDS5twCS8qyBdbE+RI+Fv/heLE4a5ukwFqKECgssNDD1EEu8wjn3ywvV8rOJbc7OWvpL+IZfMFYJQXWnL1YBnrBUX+Dr3KstjIn7it8r3GeKbCE4qLl76/0zd+05PBuFhqzzYb95jIO6tpTG5jBCZavM4fruVzjfT9Xtk8uIUwKrB4/asecjN9k+e71fOmF0jOci0ijbf8SQnI8fsHXX3+Dr6/zTZHvsCIKCYpKZ9G8lVZC2TSBso8FLkraT8syZ367PIXQJkdtVrSvXJtzBVbb4wNrQ/hCpdiIv42E243rhQ9CSYE1sPzvPG/fjvqbztPJL7jMpdyXUv8yJukDSxkUhBRRUWGE2SnzHTpGKLAaaYGF/WLiNgffW8M3WWDlczBfQnh6gC21cwuOZ1m2xfydKzSe5/zAWHxl0is1AV8COWyrNZq2vu94XLfm1nJ/SFySLCks/8nb9/SXx/UufGANOIo/htocfE189fXmCqwmU2A1C8l9YGHrkODrk+86ZYJv8K2VL7wJMjh411sp2X09YPC6RE6cuEXy64Auyva+8Z07cZ+/0RNv9855bLOlrBOF8L6UxUsIhxVYQBlymOU/WLbFNcLS40/lbE1jNcWyWwsn7nIJ6QWvbY6yuGynwGpXfNrlCixQ9lTL/Afm7zcs91X08muSZZOi4kxysC/9Us7lbf58r7Je6cT9pHTiXtNYbVLZfAlhK5eWvsv5nd7aHGWjbJSNsjOggBKfsWBH7RaTfLtJPy7rJDrfXo8nJz6R1G0pG30I1+XE4kcc5yjqIO22b9iJu/SBNWG+8LepbPvwcnF0PSwssITT10YosAidP7PgeI7zK8LyKolUYOnf2owZvWbKfFF/28znURLhxN1iNRx8y/PNLLBynixCgdXLN5X/6Y7ySvhBep3zO8bji8fJwVIO0pxPf7+rZ95ZwmU+7PLf71w+Yn4PJQf8IOXnXrHAWs6PrTtPgq+Cr9FyIrfAyudumymwkg8s2Nbg65PvOin4Bt+K+RoctysjCoJjVNZPzqOYmZf7ac5tqNfeZvu4k/Z6tJS1zwM735L9LcB3yDfKsXahwJLLzV5kOZBLu9huUg4kHUvO+aqU6WrG41tmyHZIrofaZq7ASpKxTQosRX/TOY/yOZ/NH4B6806BhVmRjS8erynzBeM3V2Cd7HUEfaFdzOUm5Um2MhHHyO+Db3m+0ol7IxRYSLF9hI97b2DeXuHtn7OQdf4a/I2pmRk4AC4mhmTpL/O4O0WBFb4GM7mYlhueSD4PxXkS85v+DDm/M/2np3OK/Ni6/Q2+LIX6m1tgyYAquQIL9yH4+uS7zrHBN/jWyBdYWCkiCimWEBZ40KaKowGSw2h0M4eRGb0mMluZlU80tp8naYElFFgfcP783D8KS5ZvddJtp+9T3if/vnpj7YyvLqiD3RqO1Baq+pC9tFhCKBQY6/jAwksTX2a5vtXIB6s8CqGi72Ou/6dN4AvcBwgn7pn13Vf5fMXzt5vv4tinOL8t+Bbny1z7nLhLBRZQYv0bM7w0MH+/ZDlhmb+WG27zS0NDQlZzIFdY5GHeSen0/VYsJZQWtSyX+bjXeN/TLI/z/oc5v5/lDH/3A/78JOcvdnN/OahHkrSdW2Ch9gVfPV/LWEkfWPl9WuYDC/Q/+PrkK88jU/ANvrXypUwMyiMFfLAv37YoAEqV1WgVNeOsHUPVBNVfjLhuvQUfOVXqkIKHOhX4Idaf3z5GhBRY+c2RdBYqnP/m23n5PH+N5UAFfGtKsM9CgZUxhD6wsE+s4/zQ82p3roHzn92H/tLElOgjKWCxE3fJSH5uex6Qh/hy/l53DQTfYnylE/dmyIk7roNZH90anr+d/F78ZhuS+QYan488+/7Ya1nmcZDlSZbtpSVj+VyV8/dKUlJ/xnKR5fKS4++Tcm632Il7nij4FitLwgdWzlo4ccf1Bl9XZclRm4Nv8B2Pr0ZBoZUNs1rZD0svcmyVVGObDZPXnKgSqzMav3xaQtgIBdbOdhL5xj8/pv/4VOY1lgNO+aqW0OFte/ttS7elAmvOQsj5NvOBtcdw73ewvJ0rRFI+6MQd+dkysKRN44v+75Z86Ii5mz7n+bLkx8o8KbCCbzG+0om7/P29xvlpxfw9zXJ1gO+llq20eJtsfO3uI+zLLjB3w4tM48MMPk9auvtzlouClcgzaeR3QxazyZr2POdHUB+C77h81xwbypYQCr4saQkh7lvw9cl3HWOF4Bt8a+QrYOv22X3FAFA0ZhhNg6P4UctGpB1Q1qyVlcdF2fJlt5rkA0uE25c3v33HtL1lcplbYHnpL/ods/+e4rK4XnvZ5SiEgud5ltut9TL7e/jaeWf5OhFLCAUDb2NVI19Udu4DSyiTe60lh5XPcju3wAq+5fu7WEIoI8aKJYSwXj7+XDusCPkbbx/R8MX78ENLlO1dDnyQ5WHm8THnN1a4y3kslBy7ynZyB3Cccxf9jbKybLaEUPJNFlje2hxlo2yU3fiyM8rFui5SV0bvXNWBRQ+OpsgSfp+qr6e/rrrqJXNZuwVWWkIoravEm/6BXDqLnktugeWcL1ktOg1vWPblrUqvAqsRFljwvwLVnSw5Pmz1Flgy2YMi0KbwXWcJYfagI+arkGb379oeC6zgW55vboG1zFdGIUQcOgU0l/lI8N2RJ9Nvt4qvpc/2SNYsmC0VaDNog77ezuqVOf2G5fOkyMrmqJSh79tO5ksNX02KsQPoRWTw3Qe+OJGwwOrh24oohCJR8PXNd53zBN/gWyNfAqGZwbH95S3WUJZogI7KbpLPDdhfZ0sBVWUn0OaC/ZUWWCyfsPAN8Y60Xd6kPG0P71+RZifnm6tX+dgDXvoLvgN52XMYfuuoi0rVdkqMJuOR8uTw93ZNW3Fo/7l1QKrv+f3urzM25K2/zOIPaf6xJO4iF9dG2k4yXPYfLMc99XdT+DKTMxmjnO8VltOatqYok7/hfHuA8wWWU4r+QqtWtXN7/XkInadA21Iaub/JL9ZNB+3MjeVj/rzd8epdAiwttba5zNec/4n3fz/7D1C3LfhyKtjfpMD67/x3Otv+O8udfecMvnXwXec8wTf41siXlMIJ71dEzhkxgg9Olftv8pzIWr6ScrX54CrNQ1rqNHc9yvkPtxoWzrNtLM1KLr97gHNyNHaiXtXSQkUCP/KahNsmlxodYLl/gOmDvH3Q6L+QVm6w7+VzPp7Ofy8qs8cAFhR8YSTiBY/7xLzc7XOD53TbLPKbCsvDwbc832Qx28foMZbbVPM3LTVu07zlvI9/q+KLGZFtiTfumzYs+LhtxtGsDPUKBWSygP0Fy7lkUfXWivxfywqrpKh8iOUIHmc8p4Pv/vOVTtzZYrJZnp9pzp5hOTRLKfjWx3ed5/jgG3xr5As6jUErBkM7gFTAfxTt8Viynnd8B7t2Z7aWPhToLxmUmmMvbyVLvYb+0ob1t3a+6t8fzT7Uzv2qN/ob/Y3+Rn9L9heUUWzDc9P+buvvoz30N72MYgUnC+dp+zYWmmJ/N41v9Df6G/2N/lbY3y5hCyuQ0x492lMNliRZog0PsT+YarEKqqhuGrPeCqN8fpsq5gutUPtyKytYt/7tDI2zDAu/oVJwQW3Gub5eCr7BN/i64Ktmp+ePj7FaAjj2N6Kuz8hnFnyDb/ANvsE3+ML2AyUUUGqB783+IPSDVYmz60h1jvWmXSPR332zLBzfh47GQkxfFpeJ/kZ/o7/R32L91e8jhfU/vCcG26KsyGEbcbs2rL/Bd9r9Db7T7m/wnXZ/bw1f1AkoeuflpNUWOnfOPIWH95pSjYqVGq+JGsfKW5tJWY4MdSjaoPu+Ar+CtfQx+Abf4CsTVRCVd9NSjWNVY5tlirGaUptlirGaUptlirEq2Gbs/Z3Ad+A4fbhLBwosUnxHE7iwaknkcQI5TtHf4eR9+SVZTW9NPmPs5QnsH72/pX0OBt/gG3xd8NUcb/cHoq+TSl631qi4pvrt85SCb/ANvsE3+AZfsA+fCInGR4L9DSQG7ETZ5e1BeirKgSmO6xTHKzipLU/xHxWMKDY+A7Lmpdpi9/mD6w2+wTf4uuJLmr72l7E7tgWfwdjhJSHY16z+syFXl9GObfANvsE3+Abf4IvaoACC/V1pO7XuQDp/SCaHjrenmmq1wIp6N7NesA5drxA3RkElkRvqNb5sIH29ss0G59HqeoNv8A2+rvnOxo0MbT/PaHWWr5fGdvkRfINv8A2+wTf4jsQXa8bsiiQM0mH0s1BA+UzBJdIUEpUoW2Kps5Ol1tr/EHLssyf4Bt/gW44vLaTAUkXQJ71lYEX3UKSpP/gG3+AbfIMvp+CrPCGOKkjG8NKkuUms5IYvFDIxXtHvuttc8CEQ+5uxrRe3/5GDfZZ6CR7PomiH2bJF8aaIgm/wDb5u+BrHD7fTcuOv4VjKolDHsbxfsuAbfINv8A2+wTeJwU+BQjRLCLUWWGDbCoKcvpn0krz0KZZn7pIm4sdtSnxhKFtQTpQF54B1GuudFagXnNvSZlxvJrDe4Bt8g++t5mtfWiHq1tVLpgcqe3RuGqleKhehW45V8A2+wTf4Bt/ga1Xc0X54uncYXnoTH6g3PdXIkjqpsL+x9HfkdelaR9K4rF0pbK9X/1ZGwdo+VjJR8A2+wdcNX8t4kGa/vU24zfakZ2hYxplk9ETBN/gG3+AbfIOvWnmF/GKhY7Qe7xXHjhbC0QKv4nWuNSZxfVXme6jWVKMFlme+wEJB//CHosEa3oaolpQjK1tDVLHBc4J2EOof+ozaEHyDb/AtyxeVU1icobHVu8ewL5Uk3HbMA/UJfSdEz5tQ/1Efgm/wDb7BN/gGX8hXcVMDnbw7dhKanc/9Q3iN9UaKFEmfKJMiEVELWZ2QwQcBLGtf+orbjHgF3+AbfMvyHdOPljXKE9pvfUlrX6qJOSjrxv2x95eCb/ANvsE3+AZfBV9xMDoBAVE5+SygsFJcCOYLikJJNWqiCfS91nZHKuD40FDH2FFiqWg77ONE2rYH3+AbfCfDl8YeewuDEm1z1g5yMu7BN/gG3+DrZVy9tGOj+JJFtEsIFeZp5FzBINq/zxc1OR2HwbQB0SS9Xps1pk3qr2lpNRo7uw8eexhi0/ns1i8Ej9WHRKbgG3yDryu+hrZAZnors/IvN8nA2fim397fVcbBN/gG3+AbfIOvogxeJqjwi6UApgGHkxOtas2+ejzXS0msiTZQWVIL/+DLSRnNlYwPn3ituv7B0h76t/xLDlq3/uAbfIOvG74Exh7Up3BGr+8nKc4DfZdo/Yug84Pypa3yqJPgG3yDb/ANvsFXUa8shOAAMVtgOV1ORiOdg5y1SV2PE9PJSJG8JzI/WI9vWkzou0KRywic31AfSIY2B9/gG3xd8YXsFWNETpaZU+n7o6FxcngvGnyDb/ANvsF3w/latXmEgBpBE962X6zOHMrvOpmcRF8ctc0T94EVaTMTKd72kKGs6besSL24LDltc/ANvsHXJ18YTVKpOCMp+DhUtmyb7fWC70kb4KmSsQq+wddbm4Nv8A2+WAGGG64Q5Q0Hzp0s+1skcr6E8WbZCS67rDnVbC0YqZyTQjJbhditIWajWXAk0ZYdPWqtPvocITbBN/gG31vMVx+Byv6SVpHGLqNgYe6z4foiy1gE3+AbfINv8A2+cAz34lB9j9pNMg3w+MeRc0UAobZv0FI+LxZYtA9lyLG/NKqUkye+JX6bZkaFPzmb74pkvbHBxwdfFyn4Bt/iPhCNN+d25WT5/zUqwdORj8vgG3yDb/ANvhPgS3tcn0hS7A+FeT5B6xNCnxVlVeWdLl2kyhRpRZVBlTgnpwkpSkfvu8Z81xDtjKzRP8A2+F6vnLXNfdxWQ7tgncE3+AZfN3z7Gdkd2tM6/NFxqLyWn2IJiYq7vm/4OhI54BV8g2/wDb7BN/hCbuBguIwQgBz8fkzTulEjC9lDWJJzRUPNydt4erfkW04xJh76Qp04mg9eIq6upZh3zDX4Bt/gWw9fuKTU+obeyX8bochQlqUqTqL/Bt/gG3yDb/DdPL6z/2fvXJTjVm4gqur//+iknLKSG1rubfVoFkMeVLkkLTkEMGfNB4gBosBUEEn7eFAK/EXe6JsGZq39smnIctCLHKD7SdlMd+KroFBxtea9+W4kxR6XrmP3erRtOVLuk+ALX/i+l29QKLbKQPtuUfmi07aM7XIsAv4yx4xZJbzhC1/4whe+8G34KqhxZccUTquILu5aDqeBQYMnCHOLnCQKUnVtOnB/cfF6jU4VegM7rPgOKX6M2jRp+MIXvu/km98TJvVazd/Lv09ubK73ytLoNXzzef7uclT4whe+8IUvfB1fE6y6iCzMTHTDpUepjRqSgVVIb/OBzPVNO3XDQJ4GZiNO4RuvnS/nRW8qNq8m66SwWW849wq+8IXvKL5prU0Vb4m1YclqbbM5jhzf3uarXvjCF77whS98K77hG0QFWVrRBA4uuvwn0eGZRToogDCp091/9N1P1yTdHw/jK2ODirHmHB1nUWhgPSI3Vq/+hC984Xsc3xNeME7vGh3s17/AgS984Qtf+MJ31RzoJ/75ifKTc3gXQh1k65R5QM6bw8m2TZHgDUMl6ruV9V3dNuwnM6/W7tY++MIXvmP4Kj3vOtuMTdqUaS5nU+aTl8Jfayt84Qtf+MIXvsv5hillcoGweK1nXzRUBfhmqZDM8VPx8+rh68CAhf3+DFxmquDzKIB8WBagvst32NuTgq+RIIvC6d7uk+ek1f4urYO4fq4FX/jCdwxfoye51/Vtvcsariq4W1aGv3bY63V6gS984Qtf+MLX8C0ysbrCXHrw0jgdYOPHsEy4k+Zqytz/W8bWiXqC2GB7mzERZzf4fRQEjmv7na5gW2CPuSia5VnwhS98R/GtOxsVgcBdGXgqs+FUPOBkBYlDgS984Qtf+ML3Fb5WaVoDy9wMGmdqsN72voOh7Lb9wTftDzb1Nt8kmLe1KP+BwaETbQ6ky/Z055f6gpePV5qFYcYnXWrVrNEvLqihv9dt8IUvfDfz7TtZy7E04+pOTAHniIMf67835n6//K56LvCFL3zhC1/4BnyDNYtxdpYPjLmfB2ZkaeAyr085aGnaaZl1X4lunM2kB3YXXcVXXeezvui007XK5vJBX8VD73Kb4Qtf+I7haxhVSy4VM+tLHWi9zf0Sl8zmPosAvvCFL3zhC9+EbxDQujo3LIBlgJY3joU8MFNpGUPDJOC5x4ckK3BYh41Pm4foPZlvapeifTNRfJHOfVNa4NJs2x0Ul/FX8IUvfMfw/dLmDftVKwaK47Y2K+Sjgo/Slu7whS984Qtf+L7im9LUrTQN3e+TF0MdHOD5tOFB2SlfchoS/DpB7piBhVwkSJ+t6+/4TIrOdm+na0KRHMdsrzvCOJvhC1/4juJ7ub80ugsu7UsWHyzM9V+3Fd9Nw9vpz+uvwRe+8IUvfOFb8DWTHRZxD1PBtKRDoAehDTWw6jo5QzJJJhek11ccBs6NtXlwAO/kDKxJfPXKS4KyELyiAtB9VoqKtf1RxktRMDPWm9QlgC984ftOvp6Z+VuO28ps/oKZjI9mPosO17kNMvzcvAm+8IUvfOELX7MtuaHyjh2QwfH/x5u0bE7JfgULDa2BpaEML/qpgXWUbdP4fjRFE8O6NoobXPgLngqbFwX1/VwWNutFvYIvfOE7gq/5PONbZNSp0dd8B4usw61dwZMGBvCFL3zhC1/4muO81qkmKegeG+Z/qiu+tj7I1lb/H9rNTQPHvjq/OiBAdFJBeg3JALsbX30zkKzV81alFve61PrW25Rzgi984TuObzPnemMtSiX+JduHZvC/xAO+8IUvfOEL35eOFSwN3NCF8GKwDswU0ZCOfZM66U0LkEw6cUy0eZovk+dKSQHE5GexvNiMDdKBuzdJWmVz+gYpfxnzdao1fOEL37F8TTaX0dd1fVI81ovy8Tmjfq76hx/4whe+8IUvfHNG/mZBQUtDt4+GFE432/KbvWH1pP5q6w261unDiw6p6zQ5cPY5dmAtqhP5RjVzgnFKU4Tr/Xu9Co5RFb0OuCnhDV/4wncvX8+4rzXaBQJ9sM6MLWzu9HbM+3kepBe+8IUvfOF7Bl9fMyEp5h4Ug7dODq2l9e022sOzSIwsT+XXYVk9f7bx/rpjWw7tsLlNf3FhLVJ4rR5FLfT7ejgqeah4ERHVDoIvfOE7km8aQFMS4FsaSC2lyBjccX3Wwuug4Atf+MIXvvA1fH3gyQW3HJQ0Guq2vze7yE/uwcsenegGSwI1rKD/CXN1os1T+Jo3JmEr3jzbQuvSf/M2v8VcKunE1j+w58vb4Qtf+I7gqybw1XRLLHQHAcClXa7U+u9bzPuuV/CFL3zhC1/41nx9AMtnZZn927eXOjDDI9Y1JNp6UnBBP+nvDTLGTs8auwtf50de/P1qq+r5y+1TwV3tcZy/TQFu+MIXvkfxVeFH9Xlvh5+DcF7ULvXIxq3/vsIXvvCFL3zhaz63XWX0yvbAGRmAuzoJauFYHR5oOM3WE4upf1uGdd6c6O90vub8mW3zxajzphkukzbJ7Cj8DXwyNnqbVGz7LYIvfOH7Pr5pUM7pKu5vAx9TPd7nHf5mevzbfXedhC984Qtf+ML3ss0YZgYaZQbaho57GrRGdMPSwn1+9lz6ulkDgyb/K3pIQGbiXE20WZe/i7Xlacptb6OvZbhp3b4amy+2d3WKBF/4wncM3y/9NJz6t9T5HKrw2dmv5mGieDhKx8j5CV/4whe+8IWvERnj7Bs6pXWtjIObAjB+Qotg3t4ubL3o8IAKMjPYg7jzpheffpzXotFgmy/7N3qbsQfMFXzhO83mN/P19VkHj/3j3A3390Sbmat728xc3dtm5ureNgdjgwhj24q6jhB60aDi01qVzTQ4yKWfsnlQdpkPuHrRBn93dgzUYH+n8f2T6MCgoZZ/t/pxGtRBE77wnSx35vvyC9Rg+aOarLFi7Bab+7nyeopOVIIvfOELX/jC1+rNCrT7t4PGoXhiEkgbblrtl/vADKy/y4yMHx1eX+lEXif6O42viqYVatvJt8dz9gVr6Df42x0vtQ++8IXvdr5+n35feft8J6fyoSnn4v1VYEt4nPylOHzhC1/4whe+JV8fxDLbzb5+jeTKjB6js5LguMqP0S97HLL08Cdt1pDOeLv20/4ufJ7vsO6Bk/l23cv6QK8KmxX8vexi3HeX8/ubjrtOBF/4wncUX62vX9q3BfcM+9qhITM1817Mt1Jb4Atf+MIXvvB1fJWkmvnPfJX7fJu3tRh70Z2OTfW6YF/xhdMmvQr1frR6W75L/5PnerVM7/5MQB2g9zS+ajJHioBheIFf/2Bf+Ku1AYF8nuELX/iO46sV81CMa/Qq2KfW29vW+wJf+MIXvvCF7yq+cssH4+WCRppUu/4mrI8UPrRQtt7gm5Io7YYljFrdmXJQNlPNtyhU/Ck341vNVS/9+bEIyuc6jJTctHI5OnzhC98xfC0PM9byTf2vuXndSl+4piz7lul5gBm+8IUvfOEL34BvkIEULik0WUJ2n+b3pAV2oUvBTWFs8yG/m+9Sr6uPuPdjr+IzDYfY3I7VK+uVBzGawvfjAH9tNupBNr/IxI+F70ib4Qvfy7Zad35+lx/rfyYsjd7V/upd/sIXvvCFL3zha/Rdtqv89ynB53XmRXKcA4pBnySLePXZbwOzlE7Ut7wG1uDMvg068np/Zj87JtDrlx/nnFV2mtXKi3f1dsu/aBF84QvfEXyLAvvpfPWdavPxvc2D7oFfshm+8IUvfOELX8s3KdReZGRcDL5hp7nkWBry0H2av1qsVwP9/cfYB/j78TB/m8L9GhTwvOge+n2eFnSGL3yn+HIHvlpVvPbNn30K/uIv/uIv/uIv/prPzMFscMs50LSZNGN1cAbH9P2mZrX8tcvRINu//K7ekJtWjr8ZXzu+9bVY1mnnvWh/uzVo7rJA7L45X8EXvvAdw9ceJxhjJJ0nP/9lAxx55jnfsDyAyk6ggi984Qtf+MI35OtTwpNlhk0V/bJ4soqHzmhs/8Cd23p4tks1dkAGltHb779L7xB/p2Vgdf56hmq5F8fYqNeflw/xF77whe98vnFx2wOy5DfobYO26/2FL3zhC1/4wjfQ23V4WZ555ceqAbmhEOzy9P1BSwb1phOEBi6zWGWDBnchjHTC14pvANF3eNWKOlxmvNveB9778XrRT6X1guALX/iO4RsU8g3bj/fcZebYjO2bD6TNhrI39N7fojOz4Atf+MIXvvD1fH3nQCW1stKCnU33ujaTqx17sXlPDR2Z383YbHxvs//OBP6+IfOr939IptvHw/x9I19/YSjTkZW8iIgv3t5uBTr1A/5qib95hrDgC1/4juK7OFC4PiNv4bVM6+uyedt3+wtf+MIXvvCFr50rE6D6cntidLVvJhpWKP2XDMq0OVmYH+QkUZkmrA1pyjJ2yNlc6P3o2gCvn+fkGPCFL3zfzlf9XPoukIMasbxs89CmJi/ZDF/4whe+8IWvGedvStLf2/bLRdX6j4FjCeDMWeo2fQnlE5eMwvd6LhRjGctYxjLWjA2bCDGWsYxlLGMZy9h7jHXBJ6+86CjoAkIHtKS2N1abI61qxkY27rdZPzR3emDAUUOPdye+wXLs7Pyxao158NJCgd7ovG/svuo1kr+AyVv4whe+8B3Dd2U9Lq3u1ljMg9qaYavn6gY2wxe+8D3XZvjCV6+kpCsrNNZ3IQyd1ZDsi9+iG2SZTKyv1C4fkP09F+3ghL+38Vdp4eE1x8jHNsWSD/dXD/MXvvf29wl8f4uGvyya/vJpusD33gLfewt87y1v5au2YHuSeRU4rCEPn98JxuhB/wFO9FWH2Plbrw4JzH5njG7MV+bcVzWgKB7enU4VNXO8n15U2OyzWfpClIIvfOE7hu/K7H0tGq/N10qVf3uehaRF+uELX/jCF77wdeMV/HSGyzvoA2SB8SqWwMl17Kkzybxevy3PVFO4zevq7V4/rq9ZpsAOFbrXnSDXd+fUit89Oz/upnwHBOcCG6txOdP13zMvByxThy984XuRredjleULtPKBqbj/U6unsblZMgJf+MIXvvCFr5mvZW2jVbRc3CFaCtRv7wHmvumgDCotyHiblqmlYXN8otyNr72IFUty8jG5n0p/Nnr32Jw3E4EvfOE7ju+qt89KGxv1b/z7e73BtShTzp8CX/jCF77whW/A197gKf/nDctu0vy2A+pXTXyIRxAklA0Pkj819mOI3o8Dbf78CV/4PszmyXwV3FNexib614+92niA3svYZJ7hO14vfOELX/iewDfoMOj/1o8UOM5EQ4q6/1UGLWk4SXRTrhP5Tp+rk2wuHiSXZ52oKXq9Z2xvs9ff2wxf+MJ3NF8Fx4yDdem+K4N179IbjKnmGb7whS984Qtfo3dNplU+id7Yg5aafVd0kK3vDkrogd0svpLpzE7U+1+Z42e1BKp5I9Oeu/z1xBeOdHqaxiB+rL/GwRe+8H07X6V+JnoKVs1yUKVj+iUtnq8/bn/Ngy984Qtf+ML35f1NFC/oyBNkaeVgPbgcjvplQf4/yfBAmA6q0/SU4AZyL7GB/eAiHByjC+wbPRqYCevfAl1F8IUvfI/kqw11RZpmJJ5/3mxEjR3JPXWgR6uassAXvvCFL3zha/Qoybqy+xr4TWqfhmeF6B2BnAOzzjTkGKctbTttSd2pWXJqxg7qZBYsYyp8ic/xfrwLHrT+Rj77mgKCL3zhO4LvRYImRXWTjoJ5nd23/pj9ZwUzwRe+8IUvfOFrPrdLtPoU8/VfOA3tVqY/Ajv3oXuyzScGg57G6cTv9D/GDml17zNB/N8KbJBPXfaZuGVwQS/oltk/4OLn7avt8IUvfDfy9aKCdeGzYbn4QcvoLefY22X02KWh8IUvfOELX/jWfJPsq68/H7E8blIB9F9zNLD2ldz2gUGJKQXcT8xmOtHmu/OV+5nZ2F/Yi7kp6/j0rJqmIYnN8IUvfEfylWFQ1VxNloQk+2V+91lzxVwZqVuuC77whS984QvfiG9gSFC0PZ+0wCENyKDQDZZLIQiyQYpuq2pr/zRdXveO7W12dRoH+gtf+MK34GvGKrCpXIXg37QPtDnSewOb4Qtf+J5rM3zh6xUHKefLo5YHZAG9Khq6jE4HLv3TDWpgnaTz1AysiXOtH66Zp0Cf+g6vud4gg1cH2PxpA3zhC98xfGX2KYONfluuty9IH9isRTZ/7LIZvvCFL3zhC1+7zRhmaymUxdx1QA2sL20YZMsvGVZsflpQ5lXdGuqz/rZtWMByYuB4L9/+YigzJvY56XxW6KsLOgf7FvNt/DUve+ALX/iO4LvqPO9Z5bo01EfvuxcNvh+CL3zhC1/4PoPvL1HyzxwjdUxDJs/J9Afx6X6fVtPplHmd5O+Jc6U9x+07rCapz7s6sBTdyQp/1/oQBAMEX/jCdzxfpbpe9X1wXVGlPh50DYcvfOELX/jC97rzgoJiWui02gyUYqwa+4c+4OuwKOxkmZi9NpXvifw1iJfrWrL+3LP+/K76HJuJ0t+NHsEXvvAdyzeYh7XLHM2Y1H71WQDenoJtw1rBWMEXvvCFL3zha+0JCrXbFolJ4MtN0qClSac/kN8l64YMrDPkxLn6ts0Du43W3UjSZURFtkbVbSWxI/DJ8oQvfP8g8N3PV2Z7tMRxcD3WItut6iapnJMX+MIXvvCFL3xLvn5Czb5ltNP/HJb5YSEOzWaaEvCb9DCwK5tJD+Q7mfMWvu7cGXR0dcu3VWSfGI5O73Xfpk5ROja4GdDCAvuCL3zh+16+xkc7p2as4ejZv6TbM1Ci13x3jJ7AJjNXbq6dD/CFL3zhC1/4Gr7mhi3+599opvsWBb9qadIID6yBNSUIMs0+BCmkeCgsUn6HjTUPpP5C19989MuW4Atf+I7kW2V/xVy9aMP9TXSPXdY006bu0oIvfOELX/jC12w3E2n+JXCLANY76s/oQUGUk/zRYfae1sXPCt/HDQGu8mTvlnS7tzWD6/g50Xd/whe+8P2LzOa7OYM974A18Pqv4m+1x3I2wRe+8IUvfOFrdAdv1damvWtxlFXDspT0huCbDuxgeOeg1F39QiK+fYfCKvuzt0eFzSsLQmpZhkt/4Rd84Qvf9/FNWZn5r1cI5GO8nUZHsKwjsS+3OfDXzbXgC1/4whe+8DU+fDGoWOMZF3H3zmvQg6e5WTviofl0vZUdNyji+0tuXHD8bnz1YsaENrSk9Z/3eq++LZZQr5K5gi984XsMXyVcqyDb/ntSDaq7qdaXdDkMfOELX/jCF77OXi00SAW41bWjNOSh+SlyQh0rDe1MMXW+njRXP22zwlo8SvX2BZS93rY1v/G38C+7yPqxvqgmfOEL33182xcTeeHf9Q83Rm+qS+6YScOmRm+SDQhf+MIXvvCFb83X11rwGVoJoGCi1HYDHPwgvPr4eleQ4OB6GwjMts1hcr50Y9rijWFHFoXLjuR+zy7cfh/nQ+JLko4OX/jCdwTfgHPB3HwPDM9IX/DgEAVLA91yc++7auX/R+ELX/jCF77wdZ8Z481EmX/GAW0owNoXcev16EHBAb263+AlhFN8Prmg+4XXwYEzbayFpbww4/5zmLfZb2uXkuc2+4tkajN84QvfN/PN3yxr1T3IAY1/jM3FXG2wG77whS984QtfM1cm2hbXgOi78QwuVn6xcWAnOg0JgJQ2ewapro2BRYU26xCbf6KVu27MN8i28MdruCWpyoVeyzbL4Nhvszs+fOH7r/bOKMeRGwaig7r/ofMXZNHrlGtKLVPtJ2CwtrspknpObFMUCd8xfDccD1/Wbl2NzcP1nmgzfOE71Wb4whe+nq9PTy/+whS1q8yhWUwaWPj8BJ0a+h/wxLpfJ9Qbg2+x49DVlOntDWxXsDMjo6c88uRlLs+L1Gb4whe+I/i+GIb54k3V3nbPakOrc8vF6+1rwcEXvvCFL3zha3x1Qaf8HGZQ+yA6p5kANDYsLMzWZ9bU+nsbfj58v9LiuEOOqWlpx4r12VtKbF7IV4GPGhLxX843WIc2W1Erg2cLA/Vxpm/oZ88p1yH4whe+I/gWvI2fhn3BS7d00Oo7fmtRBrIam+ELX/jCF77wNfqMgwtrYLVvNDfX4FpJ1uYhR6J2ZqLpoT6eljF3GcMCnf8/ZvpYBLE2tKMtizYuPPqt22oK9RsFgi984XskXzeUMX7tx6AuvFq/+ePlVjZegi984Qtf+MI34Oszm8xrWfp4/0Wmj1r2UFTMo2EZJfpY8M4PDbP59kYAQ+eK9BwQzKr4dvr6D5IDiupPCVJqVScY+MIXvv8ZM/maucy/y+px9GwL5tqQFa41/vrfE/CFL3zhC1/4pnz9jXl6mhIHh32ZisYr4IcEnjRwrj98H/a+eJevDvnhkAwdNu8EvnqjBb42FqtXyyHJuh1U1+1XNQTgC1/4juQrX4rAb4w5toax3QReuWvfFt03OlOeWtmdEr7whS984Qtfz/d6QYGhMso1uNB5F5h6MQZmu/zF/qNsXjmHCpt1iN7K5gO7XU7m27aO1y/mUhtoj/Xm9QPUfIAZXe3xc73LB77whe9+voHc0ppabm0GfIbd1kp+yDrDF77whS984avXZw39az6i2Rer1sF1ht7SNeRM7fSjXX/4++W1sr5hPJHvnRmoWiW7NiMl70S7wt/C5kgGvvCF7xi+Mn4rYWZeM3qzHf/QfxkOaXdI3di45Krb6xV84Qtf+MIXvu/wfemEc8zJeMP9PctaaO6vR6EDftRr5/0HZBRd5j88Ww2b59kcdEYNUm2NbLurEmSymHmcfXkKtDmzb+csumMKvvCF736+Zb1VOX+czqZTY38k0mcKNkdaHP/gGK3e4Q9f+MIXvvCFb8XXFW93fy6l/bcZWMO62Ew7pjcpU0XFfWV9olH+TWLyKb6Cr/UlbzffD+U/vP24+aiUVqeFFywEX/jCdwzfunhu8T31luHt6DdLWr5poBK+8IUvfOEL3+V8XTTxcj3Y0XNRwP3ZTX3wa1gG1uRgin6pV4MCQdPOTT+d73/HU/m+fLy67k9iQ3BNiR9GfllAsC+k6bnBF77wHck35mE2Zq18Wv/VbfIavdbHpAyIX4t8nbvN8Ot88IUvfOELX/gG8xnYFqqHH+j4+cIaWP+uwYF1giYFJp40WNezh/lB3e+s5Nkl/gPMzHWRCWrlxB9KwdH2wmZftBq+8IXvOL7Gb6PT/HiI2Oc730pOHHSdt7xd/n3oZfxz7y984Qtf+MIXvu9uRiqPGF6vO3Bpuv7BQYELyIF1oE4JjGhABpbajhKHZGCdkPl1Gl91Aej8w/qQgHdhr1mHYK2G2A9f+MI345tvfvaNg1QU9bU2tj7cfOxdzb3OZvjCF77whS98Q755Kpl5zRgS7i76oaEFm79t6CE6nmTvCeulg2y92D4wCFt1P2v0Or57g709L2czfOEL39F8f6tDiZ8bAqeB3X3m3wEbX/CFL3zhC1/4+hSxoKVhkdHgZL3cjTuFGlTIXXfX2hpWu8r6O6j75C16N3fM1MGZflP5akHNG7W7Lwl745uVLxkom79vgex0whe+8B3L13YyzDpq9zvhVUepvkV5f1zV3yfjQ9UoAL7whS984QvfZYGMbPH9GHJsZ+fOnwYWfJ8SqHhrrYYFU8jyKzqADQpg7QhsqUjXDeZIZHKGAdv0x7EKf3evleALX/h+lm9RLL7yoSmgb+Tra6Ffipj0GzeCL3zhC1/4wncF3yCa6AtuFUXcTSSvHD14tYGVbe2j82sq7Or05rI6tMbTx2T7wHLflv2gtbqMQZ0zVTxv9GlHwDkv1nx93uj181/tgC984TuCb9ENsmCzv+GHVti6f47rgC984Qtf+MK38DdN9fLpdH20Ma+CPygDyw0NOV42NePltzvIU3w9IavIjG22a1gtLG3Ibix2MorX1x8LkmFYZVv0NufdZl7dC1/4wncsX8Mj+56ZdLA0upTIeiZ5cV2n2z1ObDb32dfgC1/4whe+8E35hqlqflfNzHExZmC2kLtfC+bXB7NBNPBIlw7PsqkLlQ+sH6b2x8YXZmDJrP+eJhS9j6pt9o+Vy/ZrlQY/4Atf+I7ma2St/XKv7d64C3Qp9E3Bj4iiG5Uf8IUvfOELX/gWfK83t39BEU8LJQ36HJD1Mq2G0yTf3plPw9dC7fWB7HWTrA58r69qFKEi4Fy36a9rHXq7lBbHXpzNopRbwg6+8IXvKL7Jfbr3cf+jJ7Rf7vUy60+5zX2WPXzhC1/4whe+5nEejPL3ekgGXNiVsK9bVcDX7iyTwobqjVfIrLRZq3aS92Qw9Xp3Zg4OW+en8FX3YzbvXBakFdfHhApb5das2H2q19ldhy984fspvn7XOqjF5WxRr/fK8wCbjeyrv1wvfOE7fK3gC99pNsPXpG65Bflx1/yb5rWDQ7vt7RneBz3ER716/UEco/f0kNpQWnWcA75JQcM+KyGdv6gnsKo1sJzv6495eb/cWsAXvvDdw7f/rMjX6fW/o2tHXmxt2ce+93UvBV/4whe+8IWv0XcRCoq7xxlX64/eePAyst6+XFZ76yj5+2LZPlCmDZlmyzN3mvm322bGSh8Hs5jMV2lqcf74ymLoY/zFX/zF34X+XucbaGdtzyvfvsxf+D7bX/g+21/4Ptvfz/Ft6l8FGVg20+vQDCsNyk6a7q+Gr/fy+kwH1rxqhg7JlNzJVxtsCIsq590+1n1Q980nUr1JLcakkxt84Qvfz/AtShTEOv3oZQ3f8Gi6t6FobV51q3z3PQtf+MIXvvCF72UkxgcglNQ9CJzQAcftjK4IoNrrA/W+skXhvFqThZTfg170Bve3uyJK73nxWDv04i/+4i/+7vB3WFYaj3nMYx7zmMc83vzYBKqC1+/pwiV33dx/W/e0Idk6J2bo/G1oYI2zhKkOyOT7zRB8E70+82C3L8GPSAVZHFZHkYEhpyfvppavy5sbMoIvfOG7l2/xnbCa31/3DJP7d8xveGzJuIcvfOELX/jCt+BrMmKyDB5lX4b8l8nk3OkQWb2TyodsJuv4OIbIIjtA1h6PQRZZZJFF1sr+BN8bg05InayZa6deHbhWJ9oM32fbDN9n2wzfc202Rdut4uvzxZXsdWC9qH91PrCTYm1z3blgTle5ag0GdRycZPOT+Ea7KX0mq892MPOotznX69fKM2xsHrRW8IUvfI3N+3ar+85QAfvC5qaGmd88Tvm19WXgC1/4whe+8DWv+8BVMJkSWCFIDSyUreyevHtiYZM2zFvorexS8Vql4yG24O9Gf4NdjUBHsDMSy/Y2F7KtzT93+gtf+MJ3FN//GxpS+iHQZZ5XMr0NOxoWwBe+8IUvfOEbGRyliPnOg8oDGz3QgfV0Cj1dp59BNZGMXM/tg/JapT/s5qCB2Ux/2Ds88/HDfH3A6+4fdIW8LdzsbO9syO0LMlYsD/jCF76j+KY8dFdDkDSDrQsC+s/d4L1ff9dwtqfvXfjCF77whS98zT1+VywAkSyO2kyl4rmxtw6q6EMBIfVBtf029amY/ZoPkn3HLw2y+a/2wdcUQDZNMpp70Ite9KL3C/TaduVBIXpzj5nzd3p/Wr1f5i98n+0vfJ/tL3yf7e92vpeL5s/cZxyxkcQ8GDasw9/NNl8hD62TdY8dvb8aln02acRB6IHdKE/nq3BeBY02As72upwP6ZGizYFW+Wt+3eELX/iO4Btw72yv+fqh6j2YM5fj3uvO1wm+8IUvfOEL32U1sJxRfXtIP3bXdhqYgVXbO6geWDB/cfZ3/7FTHShbzNXb/GC+erfuTJCurKZ2j5vT79L0tXs2+/uT++v9hC984buHb1FTdfl3i6Yl+Eo7v8xf+D7bX/g+21/4Ptvfj/H1RuRdCFXXc/BDB3UbPEXPbTY0EePt67B/R16B3g3R9npoaL2uT/BVwrs4ph10VFme1ahEb9htTRkLz8XoEHzhC98j+C6vTej8G9SpOpDf9XncNzCCL3zhC1/4wvddvnKZWPFzb5CaIqCZs+tl3VzDs6ieJDulztFqWR1o88+QQOM0WSXHfqqii71eFbKr/f0ZbrPgC1/4fpyvbvycVSBrBzZ7+1irR9oM32fbDN9n2zyab1TfykTjoo6GZVRVw47IvbNDqB0tPwcGB0634V+eQ+pCnbTWT8rA0godTSv6hfXxFNhVH6NMMj+SY0Oe41WmzD4RfOEL3xF8DaP7OiGv0pNuAi/UqT4bzrNLbYYvfOELX/jC1/FN2x3KGKt3v4AMK7x+arYJg8GYP3R5vEdOdYv7Pg1YxXyVvxs2AQRf+MJ3FF+Z4F5dU6vgX1xL+fV6zfXb/YUvfOELX/jC95XeLAPLt0tUtbD+dQ0tTr5bVk72wOyt6Vk6BCmfvVY32tzXtfGyvU1FBopWrkVSW2hD97KL//CFL3xH8dWiGh0y8rZGbPhcxg45f39psxbwURFodfYIvvCFL3zhC1/H1wibibyMjPKiFbQ5krg5QyL5opz+m8tfx8261Pvr5RpGRSvwyl9zvb7vbh2Bv/WcD+VrdQQfBPFcG/hW/68wegM+HRP4whe+x/ENdnHNZmzor3mezKlU17s/fg7x9682wxe+8D3CX/jC99N8c0BBxM7J6YAudPedYe31aWUGViqz+7jB6rUbmo2njXo1LJPqSXzVBhqbmjnp3MV95fXc59JmlYwFX/jCdwxfGSb5LraXyXfsPec8gOnn82uV61UQAI3XGb7whS984QtfK5OnvF3/ojeDBy1qYDFYawbjvqBldO9629TIDl4r+MJ3ms1P5stgMBgMBuMLxz/HozmF5ZSunwAAAABJRU5ErkJggg=="
        id="b"
        width={1200}
        height={484}
      />
    </defs>
  </svg>
);
export const UserIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={204}
    height={37}
    fill="none"
    {...props}
  >
    <circle cx={18.5} cy={18.5} r={18.5} fill="#000" />
    <path
      fill="#000"
      d="M58.462 3.93h2.516l3.587 9.911 3.587-9.911h2.516V16h-1.836V7.16l-3.247 8.823h-2.04L60.298 7.16V16h-1.836V3.93Zm18.694 12.274c-.86 0-1.615-.193-2.26-.578-.647-.385-1.15-.935-1.514-1.649-.35-.714-.527-1.547-.527-2.499 0-.952.176-1.785.527-2.499.363-.714.867-1.264 1.513-1.649.646-.385 1.4-.578 2.261-.578.85 0 1.598.198 2.244.595a3.812 3.812 0 0 1 1.513 1.649c.352.703.527 1.53.527 2.482 0 .952-.175 1.785-.527 2.499a3.942 3.942 0 0 1-1.513 1.649c-.646.385-1.394.578-2.244.578Zm0-1.564c.76 0 1.35-.278 1.768-.833.431-.555.646-1.332.646-2.329 0-.997-.215-1.774-.646-2.329-.419-.555-1.008-.833-1.768-.833-.759 0-1.354.278-1.785.833-.43.555-.646 1.332-.646 2.329 0 .997.216 1.774.646 2.329.431.555 1.026.833 1.785.833Zm6.005-10.71h1.802v4.335c.226-.51.572-.89 1.037-1.139.464-.25 1.003-.374 1.615-.374.963 0 1.711.317 2.244.952.532.623.799 1.45.799 2.482V16h-1.802v-5.338c0-.805-.142-1.405-.425-1.802-.284-.397-.714-.595-1.292-.595-.669 0-1.202.21-1.598.629-.386.42-.578 1.02-.578 1.802V16H83.16V3.93Zm10.044 3.026h1.802V16h-1.802V6.956Zm-.034-3.111h1.887v1.802H93.17V3.845ZM100.408 16c-.861 0-1.496-.193-1.904-.578-.408-.397-.612-1.02-.612-1.87V8.435h-1.377V6.956h1.377V4.831h1.802v2.125h2.397v1.479h-2.397v4.981c0 .408.085.697.255.867.181.159.465.238.85.238h1.292V16h-1.683Zm-37.56 19.272c-.952 0-1.785-.17-2.499-.51a4.308 4.308 0 0 1-1.683-1.462c-.408-.635-.646-1.366-.714-2.193l1.887-.119c.113.85.425 1.502.935 1.955.51.442 1.213.663 2.108.663.793 0 1.4-.147 1.819-.442.43-.295.646-.725.646-1.292 0-.363-.085-.669-.255-.918-.17-.26-.487-.499-.952-.714-.453-.227-1.116-.448-1.989-.663-.986-.238-1.762-.499-2.329-.782-.567-.295-.98-.646-1.241-1.054-.25-.42-.374-.946-.374-1.581 0-.691.164-1.298.493-1.819.34-.533.827-.946 1.462-1.241.635-.295 1.377-.442 2.227-.442 1.337 0 2.403.363 3.196 1.088.805.714 1.275 1.66 1.411 2.839l-1.87.102c-.102-.725-.391-1.298-.867-1.717-.465-.43-1.1-.646-1.904-.646-.691 0-1.241.164-1.649.493-.408.317-.612.742-.612 1.275 0 .363.08.657.238.884.17.215.459.408.867.578.42.17 1.031.351 1.836.544 1.519.351 2.595.822 3.23 1.411.646.59.969 1.343.969 2.261 0 .714-.187 1.337-.561 1.87-.363.521-.878.924-1.547 1.207-.657.283-1.417.425-2.278.425Zm6.201-12.342h1.802v4.335c.227-.51.573-.89 1.037-1.139.465-.25 1.003-.374 1.615-.374.964 0 1.712.317 2.244.952.533.623.8 1.45.8 2.482V35h-1.803v-5.338c0-.805-.141-1.405-.425-1.802-.283-.397-.714-.595-1.292-.595-.668 0-1.2.21-1.598.629-.385.42-.578 1.02-.578 1.802V35H69.05V22.93Zm9.729 3.026h1.649l.05 1.717c.17-.59.432-1.02.783-1.292.351-.283.81-.425 1.377-.425h.867v1.615h-.867c-.691 0-1.207.17-1.547.51-.34.34-.51.867-.51 1.581V35h-1.802v-9.044Zm6.508 0h1.802V35h-1.802v-9.044Zm-.034-3.111h1.887v1.802h-1.887v-1.802Zm3.482 3.111h1.921l2.465 7.208 2.465-7.208h1.938L94.225 35h-2.193l-3.298-9.044Zm12.649 9.248c-.952 0-1.706-.215-2.261-.646-.555-.442-.833-1.048-.833-1.819 0-.77.232-1.377.697-1.819.465-.442 1.196-.76 2.193-.952l3.111-.595c0-1.394-.646-2.091-1.938-2.091-1.122 0-1.802.504-2.04 1.513l-1.87-.119c.17-.907.595-1.62 1.275-2.142.691-.521 1.57-.782 2.635-.782 1.213 0 2.136.329 2.771.986.646.646.969 1.558.969 2.737v3.519c0 .215.04.368.119.459.079.08.204.119.374.119h.323V35c-.113.034-.334.051-.663.051-.533 0-.946-.113-1.241-.34-.295-.227-.482-.595-.561-1.105-.227.476-.618.861-1.173 1.156-.555.295-1.184.442-1.887.442Zm.306-1.428c.793 0 1.422-.227 1.887-.68.476-.453.714-1.048.714-1.785v-.578l-2.635.51c-.533.102-.918.26-1.156.476-.227.215-.34.499-.34.85 0 .385.13.686.391.901.272.204.652.306 1.139.306Zm10.441 1.428c-1.235 0-2.204-.278-2.907-.833-.702-.555-1.088-1.298-1.156-2.227l1.87-.085c.17 1.088.901 1.632 2.193 1.632.578 0 1.026-.09 1.343-.272a.941.941 0 0 0 .493-.867c0-.238-.056-.425-.17-.561-.113-.147-.323-.272-.629-.374-.306-.113-.759-.221-1.36-.323-.895-.159-1.598-.357-2.108-.595s-.872-.527-1.088-.867c-.215-.34-.323-.765-.323-1.275 0-.85.318-1.53.952-2.04.635-.51 1.525-.765 2.669-.765 1.1 0 1.972.278 2.618.833.646.555 1.037 1.27 1.173 2.142l-1.853.102c-.09-.487-.306-.867-.646-1.139-.328-.283-.765-.425-1.309-.425-.566 0-.997.113-1.292.34-.294.215-.442.51-.442.884 0 .397.148.691.442.884.306.193.833.351 1.581.476.93.147 1.661.34 2.193.578.533.227.907.51 1.122.85.227.329.34.748.34 1.258 0 .827-.345 1.479-1.037 1.955-.68.476-1.569.714-2.669.714Zm8.698-.204c-.861 0-1.496-.193-1.904-.578-.408-.397-.612-1.02-.612-1.87v-5.117h-1.377v-1.479h1.377v-2.125h1.802v2.125h2.397v1.479h-2.397v4.981c0 .408.085.697.255.867.181.159.465.238.85.238h1.292V35h-1.683Zm6.105.204c-.952 0-1.706-.215-2.261-.646-.556-.442-.833-1.048-.833-1.819 0-.77.232-1.377.697-1.819.464-.442 1.195-.76 2.193-.952l3.111-.595c0-1.394-.646-2.091-1.938-2.091-1.122 0-1.802.504-2.04 1.513l-1.87-.119c.17-.907.595-1.62 1.275-2.142.691-.521 1.569-.782 2.635-.782 1.212 0 2.136.329 2.771.986.646.646.969 1.558.969 2.737v3.519c0 .215.039.368.119.459.079.08.204.119.374.119h.323V35c-.114.034-.335.051-.663.051-.533 0-.947-.113-1.241-.34-.295-.227-.482-.595-.561-1.105-.227.476-.618.861-1.173 1.156-.556.295-1.185.442-1.887.442Zm.306-1.428c.793 0 1.422-.227 1.887-.68.476-.453.714-1.048.714-1.785v-.578l-2.635.51c-.533.102-.918.26-1.156.476-.227.215-.34.499-.34.85 0 .385.13.686.391.901.272.204.651.306 1.139.306Zm5.656-7.82h1.921l2.465 7.208 2.465-7.208h1.938L138.386 35h-2.193l-3.298-9.044Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m189 15 7 7 7-7"
    />
  </svg>
);
export const SortIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#475467"
      fillRule="evenodd"
      d="M8.013 5.714a.857.857 0 1 1 0-1.714.857.857 0 0 1 0 1.714Zm0 3.143a.857.857 0 1 1 0-1.714.857.857 0 0 1 0 1.714Zm-.857 2.286a.857.857 0 1 0 1.715 0 .857.857 0 0 0-1.715 0ZM10.857 5.714a.857.857 0 1 1 0-1.714.857.857 0 0 1 0 1.714Zm0 3.143a.857.857 0 1 1 0-1.714.857.857 0 0 1 0 1.714ZM10 11.143a.857.857 0 1 0 1.714 0 .857.857 0 0 0-1.714 0ZM5.158 5.714a.857.857 0 1 1 0-1.714.857.857 0 0 1 0 1.714Zm0 3.143a.857.857 0 1 1 0-1.714.857.857 0 0 1 0 1.714ZM4.3 11.143a.857.857 0 1 0 1.714 0 .857.857 0 0 0-1.714 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export const SettingsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={31}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M21.075 12.916c-1.357 0-1.912-.96-1.238-2.137a1.423 1.423 0 0 0-.524-1.943l-1.298-.742a1.252 1.252 0 0 0-1.71.45l-.082.142c-.675 1.178-1.785 1.178-2.468 0l-.083-.142a1.23 1.23 0 0 0-1.695-.45l-1.297.742a1.431 1.431 0 0 0-.525 1.95c.683 1.17.128 2.13-1.23 2.13A1.43 1.43 0 0 0 7.5 14.341v1.32c0 .78.637 1.425 1.425 1.425 1.357 0 1.912.96 1.23 2.138a1.423 1.423 0 0 0 .525 1.942l1.297.742a1.252 1.252 0 0 0 1.71-.45l.083-.142c.675-1.177 1.785-1.177 2.468 0l.082.143a1.252 1.252 0 0 0 1.71.45l1.297-.743c.683-.39.915-1.268.525-1.942-.682-1.178-.127-2.138 1.23-2.138a1.43 1.43 0 0 0 1.425-1.425v-1.32a1.44 1.44 0 0 0-1.432-1.425ZM15 17.44A2.442 2.442 0 0 1 12.562 15 2.442 2.442 0 0 1 15 12.564 2.442 2.442 0 0 1 17.438 15 2.442 2.442 0 0 1 15 17.439Z"
    />
  </svg>
);

export const PeopleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={34}
    fill="none"
    {...props}
  >
    <rect width={33} height={33} x={0.5} y={0.5} fill="#99E2FC" rx={16.5} />
    <rect width={33} height={33} x={0.5} y={0.5} stroke="#000" rx={16.5} />
    <circle cx={17} cy={11.5} r={5.75} stroke="#000" strokeWidth={1.5} />
    <path stroke="#000" strokeWidth={1.5} d="m5.5 29 4.5-9h13.528l4.972 9" />
  </svg>
);
export const NextIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m2.5 2 6 5.996L2.5 14"
    />
  </svg>
);
export const BottomIcon = (props) => (
  <div style={{ marginBottom: "3px" }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={11}
      fill="none"
      {...props}
    >
      <path
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M2 2.5l5.996 6L14 2.5"
      />
    </svg>
  </div>
);
export const RightIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#000000"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m6.61 1.313 8.188 8.838L6.61 19M.112 10.024h14.43"
    />
  </svg>
);
export const RightArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m6.299 1.306 5.578 6.69L6.3 14.694M.72 8H12"
    />
  </svg>
);
export const LeftArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.833}
      d="M17.417 11H4.583M11 17.417 4.583 11 11 4.583"
    />
  </svg>
);

export const NotificationIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={2.333}
      d="M20 12.586v4.44M20.026 6.667a8.877 8.877 0 0 0-8.88 8.88v2.8c0 .906-.373 2.266-.84 3.04l-1.693 2.826c-1.04 1.747-.32 3.694 1.6 4.334a31.12 31.12 0 0 0 19.64 0 2.96 2.96 0 0 0 1.6-4.334l-1.693-2.826c-.467-.774-.84-2.147-.84-3.04v-2.8c-.014-4.88-4.014-8.88-8.894-8.88Z"
    />
    <path
      stroke="#27272A"
      strokeMiterlimit={10}
      strokeWidth={2.333}
      d="M24.44 29.093c0 2.44-2 4.44-4.44 4.44a4.448 4.448 0 0 1-3.133-1.306c-.8-.8-1.307-1.92-1.307-3.134"
    />
  </svg>
);
export const UnreadNotificationIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={2.333}
      d="M16 8.588v4.44M16.026 2.667a8.877 8.877 0 0 0-8.88 8.88v2.8c0 .906-.373 2.266-.84 3.04l-1.693 2.826c-1.04 1.747-.32 3.694 1.6 4.334a31.12 31.12 0 0 0 19.64 0 2.96 2.96 0 0 0 1.6-4.334l-1.693-2.826c-.467-.774-.84-2.147-.84-3.04v-2.8c-.014-4.88-4.014-8.88-8.894-8.88Z"
    />
    <path
      stroke="#27272A"
      strokeMiterlimit={10}
      strokeWidth={2.333}
      d="M20.44 25.094c0 2.44-2 4.44-4.44 4.44a4.448 4.448 0 0 1-3.133-1.307c-.8-.8-1.307-1.92-1.307-3.133"
    />
  </svg>
);
export const NotificationDotIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={34}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M16.71 33.42c9.229 0 16.71-7.481 16.71-16.71C33.42 7.481 25.939 0 16.71 0 7.481 0 0 7.481 0 16.71c0 9.229 7.481 16.71 16.71 16.71Z"
    />
    <path
      fill="#fff"
      d="M16.71 5.07c-3.84 0-6.97 3.12-6.97 6.97v2.95l-3.21 7.83h20.35l-3.21-7.83M23.68 14.99v-2.95c0-3.84-3.12-6.97-6.97-6.97M19.53 24.12v2.12H13.9v-2.12h5.63Z"
    />
  </svg>
);
export const ExportIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#000"
        fillRule="evenodd"
        d="M4.875 1.5A3.375 3.375 0 0 0 1.5 4.875v1.529c0 .818.377 1.547.97 2.024l.584.47-.94 1.169-.584-.47A4.09 4.09 0 0 1 0 6.404V4.875a4.875 4.875 0 0 1 9.245-2.163c.108.218.267.288.356.288h2.649a3.75 3.75 0 0 1 2.463 6.578l-.565.492-.986-1.13.566-.493A2.25 2.25 0 0 0 12.25 4.5H9.601c-.806 0-1.41-.538-1.7-1.122A3.375 3.375 0 0 0 4.875 1.5ZM8.75 13.44l1.97-1.97.53-.53L12.31 12l-.53.53-3.073 3.074a1 1 0 0 1-1.414 0L4.22 12.53 3.69 12l1.06-1.06.53.53 1.97 1.97V7h1.5v6.44Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const CalenderIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    cursor="pointer"
    {...props}
  >
    <path
      fill="#111"
      d="M5.31 25.216c-1.056 0-1.956-.192-2.7-.576a6.028 6.028 0 0 1-1.89-1.548l1.404-1.314c.444.54.93.948 1.458 1.224.54.276 1.152.414 1.836.414.804 0 1.41-.18 1.818-.54.408-.36.612-.846.612-1.458 0-.492-.144-.882-.432-1.17-.288-.288-.798-.504-1.53-.648l-1.116-.198c-1.224-.228-2.142-.63-2.754-1.206-.612-.576-.918-1.368-.918-2.376 0-.552.102-1.05.306-1.494.216-.456.51-.834.882-1.134a4.104 4.104 0 0 1 1.386-.72 6.108 6.108 0 0 1 1.818-.252c.948 0 1.77.168 2.466.504.696.324 1.29.798 1.782 1.422l-1.422 1.26a3.698 3.698 0 0 0-1.188-1.008c-.468-.252-1.05-.378-1.746-.378-.72 0-1.278.144-1.674.432-.396.288-.594.708-.594 1.26 0 .528.162.924.486 1.188.324.252.828.444 1.512.576l1.116.234c1.26.24 2.178.648 2.754 1.224.588.576.882 1.368.882 2.376 0 .588-.102 1.122-.306 1.602a3.41 3.41 0 0 1-.9 1.242c-.384.336-.858.6-1.422.792-.564.18-1.206.27-1.926.27Zm6.852-13.536h1.962v5.508h.09a3.12 3.12 0 0 1 .918-1.26c.42-.336.99-.504 1.71-.504.96 0 1.704.318 2.232.954.54.624.81 1.518.81 2.682V25h-1.962v-5.706c0-1.452-.588-2.178-1.764-2.178a2.74 2.74 0 0 0-.756.108 1.98 1.98 0 0 0-.648.288c-.192.132-.348.3-.468.504a1.478 1.478 0 0 0-.162.702V25h-1.962V11.68Zm14.113 13.536a4.536 4.536 0 0 1-1.782-.342 3.781 3.781 0 0 1-1.35-.972 4.623 4.623 0 0 1-.864-1.548 6.404 6.404 0 0 1-.306-2.034c0-.744.102-1.416.306-2.016.204-.612.492-1.128.864-1.548a3.687 3.687 0 0 1 1.35-.99 4.536 4.536 0 0 1 1.782-.342c.648 0 1.236.114 1.764.342.54.228.996.558 1.368.99.372.42.66.936.864 1.548.204.6.306 1.272.306 2.016s-.102 1.422-.306 2.034a4.623 4.623 0 0 1-.864 1.548c-.372.42-.828.744-1.368.972a4.405 4.405 0 0 1-1.764.342Zm0-1.62c.672 0 1.212-.204 1.62-.612.408-.42.612-1.044.612-1.872v-1.584c0-.828-.204-1.446-.612-1.854-.408-.42-.948-.63-1.62-.63-.672 0-1.212.21-1.62.63-.408.408-.612 1.026-.612 1.854v1.584c0 .828.204 1.452.612 1.872.408.408.948.612 1.62.612Zm5.43-7.956h1.907l.954 3.924.846 3.546h.054l.972-3.546 1.134-3.924h1.764l1.152 3.924.99 3.546h.054l.828-3.546.972-3.924h1.818L42.63 25h-2.214l-1.224-4.266-.756-2.628H38.4l-.738 2.628L36.42 25h-2.16l-2.556-9.36Zm16.304-1.674c-.408 0-.708-.096-.9-.288-.18-.192-.27-.438-.27-.738v-.306c0-.3.09-.546.27-.738.192-.192.492-.288.9-.288.408 0 .702.096.882.288.18.192.27.438.27.738v.306c0 .3-.09.546-.27.738-.18.192-.474.288-.882.288Zm-.99 1.674h1.962V25H47.02v-9.36ZM51.783 25v-9.36h1.962v1.548h.09a3.12 3.12 0 0 1 .918-1.26c.42-.336.99-.504 1.71-.504.96 0 1.704.318 2.232.954.54.624.81 1.518.81 2.682V25h-1.962v-5.688c0-1.464-.588-2.196-1.764-2.196a2.74 2.74 0 0 0-.756.108 1.98 1.98 0 0 0-.648.288c-.192.132-.348.3-.468.504a1.518 1.518 0 0 0-.162.72V25h-1.962Zm18.65.882c0 .972-.373 1.704-1.117 2.196-.744.492-1.956.738-3.636.738-.768 0-1.422-.054-1.962-.162-.528-.096-.966-.24-1.314-.432-.336-.192-.582-.426-.738-.702a1.905 1.905 0 0 1-.234-.954c0-.516.138-.918.414-1.206.288-.288.684-.486 1.188-.594v-.198c-.708-.228-1.062-.708-1.062-1.44 0-.48.162-.846.486-1.098.324-.264.714-.45 1.17-.558V21.4c-.552-.264-.978-.63-1.278-1.098-.288-.48-.432-1.038-.432-1.674 0-.96.318-1.734.954-2.322.648-.588 1.572-.882 2.772-.882.66 0 1.224.096 1.692.288v-.252c0-.42.096-.744.288-.972.204-.24.516-.36.936-.36H70v1.584h-1.908v.378c.42.276.744.636.972 1.08.228.432.342.918.342 1.458 0 .948-.324 1.716-.972 2.304-.648.576-1.572.864-2.772.864-.456 0-.864-.048-1.224-.144-.24.084-.45.204-.63.36a.7.7 0 0 0-.27.576c0 .252.114.432.342.54.228.108.552.162.972.162h2.304c1.152 0 1.986.234 2.502.702.516.456.774 1.086.774 1.89Zm-1.837.216a.923.923 0 0 0-.378-.774c-.24-.192-.684-.288-1.332-.288h-3.168c-.432.252-.648.612-.648 1.08 0 .384.15.69.45.918.312.24.834.36 1.566.36h1.224c1.524 0 2.286-.432 2.286-1.296Zm-2.934-5.724c.576 0 1.02-.126 1.332-.378.324-.264.486-.666.486-1.206v-.36c0-.54-.162-.936-.486-1.188-.312-.264-.756-.396-1.332-.396-.576 0-1.026.132-1.35.396-.312.252-.468.648-.468 1.188v.36c0 .54.156.942.468 1.206.324.252.774.378 1.35.378Zm99.476-3.132h-1.422V15.64h1.422v-1.548c0-.756.198-1.344.594-1.764.396-.432.99-.648 1.782-.648h1.548v1.602H167.1v2.358h1.962v1.602H167.1V25h-1.962v-7.758Zm9.233 7.974a4.536 4.536 0 0 1-1.782-.342 3.781 3.781 0 0 1-1.35-.972 4.623 4.623 0 0 1-.864-1.548 6.404 6.404 0 0 1-.306-2.034c0-.744.102-1.416.306-2.016.204-.612.492-1.128.864-1.548a3.687 3.687 0 0 1 1.35-.99 4.536 4.536 0 0 1 1.782-.342c.648 0 1.236.114 1.764.342.54.228.996.558 1.368.99.372.42.66.936.864 1.548.204.6.306 1.272.306 2.016s-.102 1.422-.306 2.034a4.623 4.623 0 0 1-.864 1.548c-.372.42-.828.744-1.368.972a4.405 4.405 0 0 1-1.764.342Zm0-1.62c.672 0 1.212-.204 1.62-.612.408-.42.612-1.044.612-1.872v-1.584c0-.828-.204-1.446-.612-1.854-.408-.42-.948-.63-1.62-.63-.672 0-1.212.21-1.62.63-.408.408-.612 1.026-.612 1.854v1.584c0 .828.204 1.452.612 1.872.408.408.948.612 1.62.612ZM180.859 25v-9.36h1.962v1.8h.09c.132-.48.408-.9.828-1.26s1.002-.54 1.746-.54h.522v1.89h-.774c-.78 0-1.38.126-1.8.378-.408.252-.612.624-.612 1.116V25h-1.962Zm11.145 0v-9.36h1.962v1.548h.09a3.12 3.12 0 0 1 .918-1.26c.42-.336.99-.504 1.71-.504.96 0 1.704.318 2.232.954.54.624.81 1.518.81 2.682V25h-1.962v-5.688c0-1.464-.588-2.196-1.764-2.196a2.74 2.74 0 0 0-.756.108 1.98 1.98 0 0 0-.648.288c-.192.132-.348.3-.468.504a1.518 1.518 0 0 0-.162.72V25h-1.962Zm14.113.216a4.536 4.536 0 0 1-1.782-.342 3.781 3.781 0 0 1-1.35-.972 4.623 4.623 0 0 1-.864-1.548 6.404 6.404 0 0 1-.306-2.034c0-.744.102-1.416.306-2.016.204-.612.492-1.128.864-1.548a3.687 3.687 0 0 1 1.35-.99 4.536 4.536 0 0 1 1.782-.342c.648 0 1.236.114 1.764.342.54.228.996.558 1.368.99.372.42.66.936.864 1.548.204.6.306 1.272.306 2.016s-.102 1.422-.306 2.034a4.623 4.623 0 0 1-.864 1.548c-.372.42-.828.744-1.368.972a4.405 4.405 0 0 1-1.764.342Zm0-1.62c.672 0 1.212-.204 1.62-.612.408-.42.612-1.044.612-1.872v-1.584c0-.828-.204-1.446-.612-1.854-.408-.42-.948-.63-1.62-.63-.672 0-1.212.21-1.62.63-.408.408-.612 1.026-.612 1.854v1.584c0 .828.204 1.452.612 1.872.408.408.948.612 1.62.612Zm12.374-.144h-.09c-.204.552-.54.984-1.008 1.296-.456.312-.996.468-1.62.468-1.188 0-2.106-.426-2.754-1.278-.648-.864-.972-2.07-.972-3.618s.324-2.748.972-3.6c.648-.864 1.566-1.296 2.754-1.296.624 0 1.164.156 1.62.468.468.3.804.732 1.008 1.296h.09V11.68h1.962V25h-1.962v-1.548Zm-2.124.072c.6 0 1.104-.144 1.512-.432.408-.3.612-.69.612-1.17v-3.204c0-.48-.204-.864-.612-1.152-.408-.3-.912-.45-1.512-.45-.684 0-1.23.222-1.638.666-.408.432-.612 1.008-.612 1.728v1.62c0 .72.204 1.302.612 1.746.408.432.954.648 1.638.648Zm10.563 1.692c-.672 0-1.272-.114-1.8-.342a3.781 3.781 0 0 1-1.35-.972 4.623 4.623 0 0 1-.864-1.548 6.773 6.773 0 0 1-.288-2.034c0-.744.096-1.416.288-2.016.204-.612.492-1.128.864-1.548a3.687 3.687 0 0 1 1.35-.99c.528-.228 1.128-.342 1.8-.342.684 0 1.284.12 1.8.36.528.24.966.576 1.314 1.008.348.42.606.912.774 1.476.18.564.27 1.17.27 1.818v.738h-6.426v.306c0 .72.21 1.314.63 1.782.432.456 1.044.684 1.836.684.576 0 1.062-.126 1.458-.378a3.295 3.295 0 0 0 1.008-1.026l1.152 1.134c-.348.576-.852 1.038-1.512 1.386-.66.336-1.428.504-2.304.504Zm0-8.262c-.336 0-.648.06-.936.18a2.17 2.17 0 0 0-.72.504 2.347 2.347 0 0 0-.45.774c-.108.3-.162.63-.162.99v.126h4.356v-.18c0-.72-.186-1.296-.558-1.728-.372-.444-.882-.666-1.53-.666ZM237.117 25v-1.656h1.71v-9.252h-1.71v-1.656h5.472v1.656h-1.728v9.252h1.728V25h-5.472Zm8.029-12.564h4.446c.804 0 1.53.132 2.178.396.66.264 1.218.66 1.674 1.188.468.516.828 1.17 1.08 1.962.252.78.378 1.692.378 2.736 0 1.044-.126 1.962-.378 2.754-.252.78-.612 1.434-1.08 1.962a4.36 4.36 0 0 1-1.674 1.17c-.648.264-1.374.396-2.178.396h-4.446V12.436Zm4.446 10.764c.936 0 1.692-.294 2.268-.882.576-.588.864-1.452.864-2.592V17.71c0-1.14-.288-2.004-.864-2.592-.576-.588-1.332-.882-2.268-.882h-2.412V23.2h2.412Zm12.131 1.8v-1.692h3.528v-9.396h-.144l-2.916 3.114-1.242-1.116 3.204-3.474h3.096v10.872h3.06V25h-8.586Zm18.947 0h-8.532v-1.944l4.014-3.582c.636-.576 1.122-1.122 1.458-1.638.348-.528.522-1.08.522-1.656v-.234c0-.612-.186-1.092-.558-1.44-.36-.348-.852-.522-1.476-.522-.348 0-.654.054-.918.162a2.01 2.01 0 0 0-.666.414c-.192.18-.354.39-.486.63a3.96 3.96 0 0 0-.288.774l-1.782-.684c.132-.396.312-.774.54-1.134.228-.372.516-.702.864-.99a4.042 4.042 0 0 1 1.224-.684c.48-.168 1.038-.252 1.674-.252.636 0 1.206.096 1.71.288.504.18.924.438 1.26.774.348.324.612.714.792 1.17.18.456.27.954.27 1.494 0 .504-.078.972-.234 1.404-.156.432-.372.84-.648 1.224s-.6.75-.972 1.098a34.5 34.5 0 0 1-1.152 1.062l-2.952 2.538h6.336V25Zm5.771-7.398c.78 0 1.356-.162 1.728-.486.372-.336.558-.762.558-1.278v-.126c0-.576-.18-1.014-.54-1.314-.36-.312-.846-.468-1.458-.468-.6 0-1.11.138-1.53.414-.42.264-.774.636-1.062 1.116l-1.35-1.17c.192-.276.408-.54.648-.792.24-.252.522-.468.846-.648a4.3 4.3 0 0 1 1.098-.45c.408-.12.876-.18 1.404-.18.588 0 1.134.072 1.638.216.504.144.936.36 1.296.648.36.276.642.618.846 1.026.204.396.306.846.306 1.35 0 .396-.066.756-.198 1.08-.12.324-.294.612-.522.864-.216.24-.474.438-.774.594-.288.156-.594.27-.918.342v.09c.36.072.696.192 1.008.36.324.156.606.366.846.63.24.252.426.558.558.918.144.348.216.75.216 1.206 0 .552-.108 1.056-.324 1.512a3.396 3.396 0 0 1-.918 1.152 4.139 4.139 0 0 1-1.404.756 6.289 6.289 0 0 1-1.836.252c-.588 0-1.104-.066-1.548-.198a4.83 4.83 0 0 1-1.188-.486 5.384 5.384 0 0 1-.9-.72 7.09 7.09 0 0 1-.666-.846l1.494-1.17c.156.252.318.486.486.702.18.204.378.384.594.54.228.144.48.258.756.342.288.084.612.126.972.126.768 0 1.356-.18 1.764-.54.408-.372.612-.882.612-1.53v-.126c0-.648-.216-1.14-.648-1.476-.432-.336-1.044-.504-1.836-.504h-1.332v-1.728h1.278ZM298.98 25v-2.448h-5.832v-1.746l5.094-8.37h2.664v8.514h1.71v1.602h-1.71V25h-1.926Zm-4.104-4.05h4.104v-6.66h-.126l-3.978 6.66Zm17.579-6.75h-5.58l-.324 4.446h.126c.144-.252.294-.474.45-.666.156-.204.336-.378.54-.522.204-.144.438-.252.702-.324a3.1 3.1 0 0 1 .936-.126c.54 0 1.038.09 1.494.27.468.18.87.438 1.206.774.348.336.618.75.81 1.242.192.48.288 1.026.288 1.638 0 .624-.102 1.2-.306 1.728-.192.528-.48.984-.864 1.368a4.142 4.142 0 0 1-1.422.882c-.552.204-1.182.306-1.89.306a5.12 5.12 0 0 1-1.494-.198 4.56 4.56 0 0 1-1.152-.486 5.096 5.096 0 0 1-.864-.72 8.344 8.344 0 0 1-.648-.846l1.476-1.17c.156.252.318.48.486.684.168.204.36.384.576.54.216.156.456.276.72.36.276.084.588.126.936.126.744 0 1.314-.204 1.71-.612.408-.408.612-.972.612-1.692v-.216c0-.72-.204-1.284-.612-1.692-.396-.408-.966-.612-1.71-.612-.54 0-.972.102-1.296.306-.324.204-.6.432-.828.684l-1.674-.234.468-7.002h7.128V14.2Zm7.085 11.016c-.696 0-1.32-.114-1.872-.342a3.917 3.917 0 0 1-1.386-.972 4.623 4.623 0 0 1-.864-1.548c-.204-.6-.306-1.278-.306-2.034 0-.912.138-1.77.414-2.574.276-.804.63-1.542 1.062-2.214.432-.672.912-1.266 1.44-1.782.54-.528 1.068-.966 1.584-1.314h2.7a32.346 32.346 0 0 0-1.908 1.494c-.564.48-1.056.972-1.476 1.476a8.627 8.627 0 0 0-1.062 1.602 8.657 8.657 0 0 0-.648 1.854l.126.036c.132-.252.282-.486.45-.702.18-.228.384-.426.612-.594.24-.168.51-.3.81-.396a3.43 3.43 0 0 1 1.044-.144c.528 0 1.014.09 1.458.27.456.18.846.444 1.17.792.336.336.594.744.774 1.224.192.48.288 1.014.288 1.602a4.57 4.57 0 0 1-.324 1.746c-.204.516-.498.96-.882 1.332a4.176 4.176 0 0 1-1.404.882c-.54.204-1.14.306-1.8.306Zm0-1.656c.732 0 1.302-.192 1.71-.576.408-.396.612-.972.612-1.728v-.252c0-.756-.204-1.326-.612-1.71-.408-.396-.978-.594-1.71-.594s-1.302.198-1.71.594c-.408.384-.612.954-.612 1.71v.252c0 .756.204 1.332.612 1.728.408.384.978.576 1.71.576Z"
    />
    <path
      fill="#1773BE"
      d="M79.458 17.512c.72 0 1.248-.144 1.584-.432.348-.3.522-.678.522-1.134v-.126c0-.516-.168-.918-.504-1.206-.324-.3-.774-.45-1.35-.45-.552 0-1.044.132-1.476.396-.42.264-.786.636-1.098 1.116l-1.512-1.368a7.55 7.55 0 0 1 .702-.81c.264-.264.564-.486.9-.666a4.566 4.566 0 0 1 1.134-.45 5.72 5.72 0 0 1 1.422-.162 5.96 5.96 0 0 1 1.728.234c.528.144.978.36 1.35.648a2.905 2.905 0 0 1 1.188 2.394c0 .408-.066.774-.198 1.098-.12.324-.294.606-.522.846-.216.24-.474.438-.774.594a3.97 3.97 0 0 1-.918.324v.108c.36.072.702.186 1.026.342.324.156.6.366.828.63.24.252.426.552.558.9.144.348.216.744.216 1.188 0 .552-.114 1.056-.342 1.512a3.264 3.264 0 0 1-.936 1.17 4.536 4.536 0 0 1-1.458.756 6.61 6.61 0 0 1-1.89.252c-.612 0-1.152-.066-1.62-.198a4.64 4.64 0 0 1-1.242-.504 4.67 4.67 0 0 1-.918-.738 5.94 5.94 0 0 1-.684-.9l1.746-1.332c.144.252.3.486.468.702.168.204.36.384.576.54.216.156.462.276.738.36.276.084.588.126.936.126.696 0 1.23-.168 1.602-.504.372-.336.558-.798.558-1.386v-.126c0-.576-.204-1.014-.612-1.314-.396-.3-.972-.45-1.728-.45h-1.242v-1.98h1.242ZM95.363 25h-8.712v-2.196l3.942-3.456c.672-.588 1.164-1.116 1.476-1.584.312-.48.468-.996.468-1.548v-.234c0-.552-.18-.972-.54-1.26-.36-.3-.798-.45-1.314-.45-.648 0-1.14.186-1.476.558a3.12 3.12 0 0 0-.72 1.314l-2.052-.792c.132-.42.318-.816.558-1.188.24-.384.54-.72.9-1.008a4.442 4.442 0 0 1 1.296-.684c.492-.168 1.056-.252 1.692-.252.66 0 1.248.096 1.764.288.516.18.948.438 1.296.774.36.336.63.732.81 1.188.192.456.288.954.288 1.494 0 .528-.084 1.008-.252 1.44a5.493 5.493 0 0 1-.684 1.242 8.644 8.644 0 0 1-1.008 1.116c-.384.348-.792.702-1.224 1.062l-2.646 2.178h6.138V25Zm10.349.216c-.696 0-1.32-.114-1.872-.342a4.122 4.122 0 0 1-1.386-.99 4.623 4.623 0 0 1-.864-1.548c-.204-.612-.306-1.296-.306-2.052 0-.744.096-1.416.288-2.016.204-.6.492-1.11.864-1.53a3.653 3.653 0 0 1 1.368-.99c.54-.24 1.152-.36 1.836-.36.732 0 1.368.126 1.908.378.54.252.984.594 1.332 1.026a4.3 4.3 0 0 1 .774 1.512c.18.564.27 1.17.27 1.818v.756h-6.246v.234c0 .684.192 1.236.576 1.656.384.408.954.612 1.71.612.576 0 1.044-.12 1.404-.36.372-.24.702-.546.99-.918l1.242 1.386c-.384.54-.912.966-1.584 1.278-.66.3-1.428.45-2.304.45Zm-.036-8.1c-.612 0-1.098.204-1.458.612-.36.408-.54.936-.54 1.584v.144h3.852v-.162c0-.648-.162-1.17-.486-1.566-.312-.408-.768-.612-1.368-.612ZM111.951 25v-9.396h2.304v1.566h.09c.192-.504.492-.924.9-1.26.42-.348.996-.522 1.728-.522.972 0 1.716.318 2.232.954.516.636.774 1.542.774 2.718V25h-2.304v-5.706c0-.672-.12-1.176-.36-1.512-.24-.336-.636-.504-1.188-.504-.24 0-.474.036-.702.108a1.82 1.82 0 0 0-.594.288c-.168.12-.306.276-.414.468-.108.18-.162.396-.162.648V25h-2.304Zm13.516 0c-.792 0-1.398-.204-1.818-.612-.408-.42-.612-1.014-.612-1.782V17.44h-1.386v-1.836h.72c.348 0 .582-.078.702-.234.132-.168.198-.414.198-.738V13.03h2.07v2.574h1.926v1.836h-1.926v5.724h1.782V25h-1.656Zm3.799 0v-9.396h2.304v1.944h.09c.06-.252.15-.492.27-.72a2.333 2.333 0 0 1 1.224-1.062c.288-.108.618-.162.99-.162h.504v2.178h-.72c-.78 0-1.368.114-1.764.342-.396.228-.594.6-.594 1.116V25h-2.304Zm8.218-10.764c-.48 0-.828-.108-1.044-.324-.204-.216-.306-.492-.306-.828v-.36c0-.336.102-.612.306-.828.216-.216.564-.324 1.044-.324.468 0 .81.108 1.026.324.216.216.324.492.324.828v.36c0 .336-.108.612-.324.828-.216.216-.558.324-1.026.324Zm-1.152 1.368h2.304V25h-2.304v-9.396Zm8.773 9.612c-.696 0-1.32-.114-1.872-.342a4.122 4.122 0 0 1-1.386-.99 4.623 4.623 0 0 1-.864-1.548c-.204-.612-.306-1.296-.306-2.052 0-.744.096-1.416.288-2.016.204-.6.492-1.11.864-1.53a3.653 3.653 0 0 1 1.368-.99c.54-.24 1.152-.36 1.836-.36.732 0 1.368.126 1.908.378.54.252.984.594 1.332 1.026a4.3 4.3 0 0 1 .774 1.512c.18.564.27 1.17.27 1.818v.756h-6.246v.234c0 .684.192 1.236.576 1.656.384.408.954.612 1.71.612.576 0 1.044-.12 1.404-.36.372-.24.702-.546.99-.918l1.242 1.386c-.384.54-.912.966-1.584 1.278-.66.3-1.428.45-2.304.45Zm-.036-8.1c-.612 0-1.098.204-1.458.612-.36.408-.54.936-.54 1.584v.144h3.852v-.162c0-.648-.162-1.17-.486-1.566-.312-.408-.768-.612-1.368-.612Zm9.353 8.1c-.9 0-1.656-.15-2.268-.45a5.342 5.342 0 0 1-1.62-1.278l1.404-1.368c.348.396.726.708 1.134.936.42.228.9.342 1.44.342.552 0 .948-.096 1.188-.288.252-.192.378-.456.378-.792 0-.276-.09-.492-.27-.648-.168-.168-.462-.282-.882-.342l-.936-.126c-1.02-.132-1.8-.42-2.34-.864-.528-.456-.792-1.116-.792-1.98 0-.456.084-.864.252-1.224.168-.372.408-.684.72-.936a3.112 3.112 0 0 1 1.116-.594 4.766 4.766 0 0 1 1.476-.216 6 6 0 0 1 1.206.108c.36.06.684.156.972.288.288.12.552.276.792.468.24.18.474.384.702.612l-1.35 1.35a3.564 3.564 0 0 0-.99-.72 2.778 2.778 0 0 0-1.26-.288c-.504 0-.87.09-1.098.27a.87.87 0 0 0-.324.702c0 .312.09.552.27.72.192.156.51.27.954.342l.954.126c2.028.288 3.042 1.212 3.042 2.772a2.864 2.864 0 0 1-1.062 2.232 3.924 3.924 0 0 1-1.224.63 5.38 5.38 0 0 1-1.584.216Z"
    />
    <rect width={112} height={35} x={834.87} y={0.5} fill="#fff" rx={3.5} />
    <rect
      width={112}
      height={35}
      x={834.87}
      y={0.5}
      stroke="#E5E7EB"
      rx={3.5}
    />
    <path
      stroke="#5C5C5C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M857.47 22.74v-9.48c0-.9-.38-1.26-1.34-1.26h-2.42c-.96 0-1.34.36-1.34 1.26v9.48c0 .9.38 1.26 1.34 1.26h2.42c.96 0 1.34-.36 1.34-1.26ZM864.37 22.74v-9.48c0-.9-.38-1.26-1.34-1.26h-2.42c-.954 0-1.34.36-1.34 1.26v9.48c0 .9.38 1.26 1.34 1.26h2.42c.96 0 1.34-.36 1.34-1.26Z"
    />
    <path
      fill="#5C5C5C"
      d="M879.242 23.668c-1.279 0-2.282-.43-3.01-1.288-.728-.868-1.092-2.123-1.092-3.766 0-.821.093-1.545.28-2.17.187-.625.457-1.153.812-1.582.355-.43.784-.751 1.288-.966a4.26 4.26 0 0 1 1.722-.336c.849 0 1.559.187 2.128.56.579.373 1.031.924 1.358 1.652l-1.33.728c-.168-.467-.429-.835-.784-1.106-.345-.28-.803-.42-1.372-.42-.756 0-1.349.257-1.778.77-.429.513-.644 1.223-.644 2.128v1.484c0 .905.215 1.615.644 2.128.429.513 1.022.77 1.778.77.588 0 1.064-.15 1.428-.448.373-.308.649-.7.826-1.176l1.274.77c-.327.71-.784 1.265-1.372 1.666-.588.401-1.307.602-2.156.602Zm7.949 0c-.504 0-.966-.089-1.386-.266a2.934 2.934 0 0 1-1.05-.756 3.607 3.607 0 0 1-.672-1.204 4.971 4.971 0 0 1-.238-1.582c0-.579.079-1.101.238-1.568.159-.476.383-.877.672-1.204a2.861 2.861 0 0 1 1.05-.77c.42-.177.882-.266 1.386-.266.504 0 .961.089 1.372.266.42.177.775.434 1.064.77.289.327.513.728.672 1.204.159.467.238.99.238 1.568 0 .579-.079 1.106-.238 1.582a3.607 3.607 0 0 1-.672 1.204 2.91 2.91 0 0 1-1.064.756 3.428 3.428 0 0 1-1.372.266Zm0-1.26c.523 0 .943-.159 1.26-.476.317-.327.476-.812.476-1.456v-1.232c0-.644-.159-1.125-.476-1.442-.317-.327-.737-.49-1.26-.49s-.943.163-1.26.49c-.317.317-.476.798-.476 1.442v1.232c0 .644.159 1.13.476 1.456.317.317.737.476 1.26.476Zm6.601 1.092c-.523 0-.915-.13-1.176-.392-.252-.27-.378-.644-.378-1.12V13.14h1.526v9.114h1.008V23.5h-.98Zm6.848-1.204h-.056a2.51 2.51 0 0 1-.266.518 1.677 1.677 0 0 1-.406.448c-.159.121-.355.22-.588.294a2.484 2.484 0 0 1-.784.112c-.756 0-1.344-.243-1.764-.728-.411-.485-.616-1.18-.616-2.086V16.22h1.526v4.438c0 1.13.466 1.694 1.4 1.694.196 0 .387-.023.574-.07.186-.056.35-.135.49-.238a1.09 1.09 0 0 0 .35-.392c.093-.159.14-.345.14-.56V16.22h1.526v7.28h-1.526v-1.204Zm3.711 1.204v-7.28h1.526v1.204h.07c.074-.187.163-.364.266-.532.112-.168.242-.313.392-.434.158-.13.34-.229.546-.294.214-.075.462-.112.742-.112.494 0 .933.121 1.316.364.382.243.662.616.84 1.12h.042c.13-.41.382-.76.756-1.05.373-.29.854-.434 1.442-.434.728 0 1.292.247 1.694.742.401.485.602 1.18.602 2.086v4.62h-1.526v-4.438c0-.56-.108-.98-.322-1.26-.215-.29-.556-.434-1.022-.434-.196 0-.383.028-.56.084a1.392 1.392 0 0 0-.476.224 1.207 1.207 0 0 0-.322.392 1.15 1.15 0 0 0-.126.546V23.5h-1.526v-4.438c0-1.13-.444-1.694-1.33-1.694-.187 0-.374.028-.56.084a1.392 1.392 0 0 0-.476.224 1.14 1.14 0 0 0-.336.392 1.15 1.15 0 0 0-.126.546V23.5h-1.526Zm12.345 0v-7.28h1.526v1.204h.07c.159-.392.397-.719.714-.98.327-.261.77-.392 1.33-.392.747 0 1.326.247 1.736.742.42.485.63 1.18.63 2.086v4.62h-1.526v-4.424c0-1.139-.457-1.708-1.372-1.708-.196 0-.392.028-.588.084a1.553 1.553 0 0 0-.504.224c-.149.103-.27.233-.364.392a1.18 1.18 0 0 0-.126.56V23.5h-1.526Zm10.432.168c-.691 0-1.27-.121-1.736-.364a3.802 3.802 0 0 1-1.218-1.008l.98-.896c.27.327.569.583.896.77.336.177.723.266 1.162.266.448 0 .779-.084.994-.252.224-.177.336-.42.336-.728 0-.233-.08-.43-.238-.588-.15-.168-.416-.275-.798-.322l-.672-.084c-.747-.093-1.335-.308-1.764-.644-.42-.345-.63-.854-.63-1.526 0-.355.065-.667.196-.938.13-.28.312-.513.546-.7a2.56 2.56 0 0 1 .854-.448 3.767 3.767 0 0 1 1.106-.154c.653 0 1.185.103 1.596.308.42.205.793.49 1.12.854l-.938.896a2.353 2.353 0 0 0-.742-.574 2.078 2.078 0 0 0-1.036-.252c-.42 0-.733.084-.938.252a.825.825 0 0 0-.294.658c0 .28.088.49.266.63.177.14.462.243.854.308l.672.084c.802.121 1.386.36 1.75.714.373.345.56.812.56 1.4 0 .355-.07.677-.21.966-.131.28-.322.523-.574.728a2.727 2.727 0 0 1-.91.476 3.946 3.946 0 0 1-1.19.168Z"
    />
    <rect width={128} height={36} x={960} fill="#1773BE" rx={4} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M984.75 11v7.69l1.97-1.97.53-.53 1.061 1.06-.531.53-3.073 3.074a1 1 0 0 1-1.414 0l-3.073-3.074-.531-.53 1.061-1.06.53.53 1.97 1.97V11h1.5Zm4.75 8.25v4.25h-11v-5H977V24a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5.5h-1.5v.75Z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M1001.2 23.5v-9.772h6.26v1.4h-4.67v2.716h4.24v1.4h-4.24V22.1h4.67v1.4h-6.26Zm7.38 0 2.56-3.682-2.49-3.598h1.76l1.64 2.534h.04l1.68-2.534h1.63l-2.5 3.584 2.54 3.696h-1.77l-1.68-2.646h-.04l-1.75 2.646h-1.62Zm8.23-7.28h1.53v1.204h.07c.16-.439.42-.775.77-1.008.36-.243.79-.364 1.27-.364.93 0 1.64.336 2.15 1.008.5.663.75 1.596.75 2.8 0 1.204-.25 2.142-.75 2.814-.51.663-1.22.994-2.15.994-.48 0-.91-.121-1.27-.364a2.078 2.078 0 0 1-.77-1.008h-.07V26.3h-1.53V16.22Zm3.18 6.132c.53 0 .96-.168 1.28-.504.31-.345.47-.798.47-1.358v-1.26c0-.56-.16-1.008-.47-1.344-.32-.345-.75-.518-1.28-.518-.46 0-.86.117-1.17.35-.32.224-.48.523-.48.896v2.492c0 .373.16.677.48.91.31.224.71.336 1.17.336Zm7.97 1.316c-.51 0-.97-.089-1.39-.266-.41-.177-.76-.43-1.05-.756a3.603 3.603 0 0 1-.67-1.204 4.942 4.942 0 0 1-.24-1.582c0-.579.08-1.101.24-1.568.16-.476.38-.877.67-1.204.29-.336.64-.593 1.05-.77.42-.177.88-.266 1.39-.266.5 0 .96.089 1.37.266.42.177.77.434 1.06.77.29.327.52.728.67 1.204.16.467.24.99.24 1.568 0 .579-.08 1.106-.24 1.582-.15.467-.38.868-.67 1.204-.29.327-.64.579-1.06.756-.41.177-.87.266-1.37.266Zm0-1.26c.52 0 .94-.159 1.26-.476.31-.327.47-.812.47-1.456v-1.232c0-.644-.16-1.125-.47-1.442-.32-.327-.74-.49-1.26-.49-.53 0-.95.163-1.26.49-.32.317-.48.798-.48 1.442v1.232c0 .644.16 1.13.48 1.456.31.317.73.476 1.26.476ZM1033 23.5v-7.28h1.53v1.4h.07c.1-.373.32-.7.64-.98.33-.28.78-.42 1.36-.42h.41v1.47h-.61c-.6 0-1.07.098-1.4.294-.31.196-.47.485-.47.868V23.5H1033Zm7.43 0c-.53 0-.93-.135-1.2-.406-.27-.28-.41-.672-.41-1.176v-4.452h-1.13V16.22h.61c.26 0 .43-.056.52-.168.1-.112.16-.294.16-.546v-1.274h1.37v1.988h1.52v1.246h-1.52v4.788h1.41V23.5h-1.33Zm10.19.168c-1.28 0-2.28-.43-3.01-1.288-.73-.868-1.09-2.123-1.09-3.766 0-.821.09-1.545.28-2.17.18-.625.45-1.153.81-1.582.35-.43.78-.751 1.29-.966.51-.224 1.08-.336 1.72-.336.85 0 1.56.187 2.13.56.57.373 1.03.924 1.35 1.652l-1.33.728a2.325 2.325 0 0 0-.78-1.106c-.35-.28-.8-.42-1.37-.42-.76 0-1.35.257-1.78.77-.43.513-.64 1.223-.64 2.128v1.484c0 .905.21 1.615.64 2.128.43.513 1.02.77 1.78.77.59 0 1.06-.15 1.43-.448.37-.308.64-.7.82-1.176l1.28.77c-.33.71-.79 1.265-1.38 1.666-.58.401-1.3.602-2.15.602Zm8.13 0c-.82 0-1.52-.15-2.1-.448-.57-.299-1.06-.7-1.47-1.204l1.09-1.022c.35.42.72.737 1.14.952.42.215.89.322 1.42.322.63 0 1.1-.14 1.42-.42.31-.28.47-.658.47-1.134 0-.383-.11-.686-.33-.91-.23-.224-.62-.392-1.19-.504l-.87-.154c-.95-.177-1.67-.49-2.14-.938-.48-.448-.72-1.064-.72-1.848 0-.43.08-.817.24-1.162a2.5 2.5 0 0 1 .69-.882c.3-.243.66-.43 1.08-.56.42-.13.89-.196 1.41-.196.74 0 1.38.13 1.92.392.54.252 1 .62 1.38 1.106l-1.1.98a2.815 2.815 0 0 0-.93-.784c-.36-.196-.81-.294-1.35-.294-.56 0-1 .112-1.31.336-.3.224-.46.55-.46.98 0 .41.13.719.38.924.25.196.64.345 1.18.448l.86.182c.98.187 1.7.504 2.15.952.45.448.68 1.064.68 1.848 0 .457-.08.873-.24 1.246-.16.373-.39.695-.7.966-.3.261-.66.467-1.1.616-.44.14-.94.21-1.5.21Zm7.58-.168-3.2-9.772h1.64l1.55 4.83.94 3.402h.05l.96-3.402 1.55-4.83h1.6l-3.25 9.772h-1.84Z"
    />
    <rect width={129} height={35} x={692.87} y={0.5} fill="#fff" rx={3.5} />
    <rect
      width={129}
      height={35}
      x={692.87}
      y={0.5}
      stroke="#E5E7EB"
      rx={3.5}
    />
    <path
      stroke="#5C5C5C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
      d="M722.37 16.666h-12m8.667-5.333V14m-5.334-2.667V14m-.133 10.666h5.6c1.12 0 1.68 0 2.108-.218.376-.191.682-.497.874-.874.218-.428.218-.988.218-2.108v-5.6c0-1.12 0-1.68-.218-2.108a2.003 2.003 0 0 0-.874-.874c-.428-.218-.988-.218-2.108-.218h-5.6c-1.12 0-1.68 0-2.108.218a2.003 2.003 0 0 0-.874.874c-.218.428-.218.988-.218 2.108v5.6c0 1.12 0 1.68.218 2.108.192.377.498.683.874.874.428.218.988.218 2.108.218Z"
    />
    <path
      fill="#5C5C5C"
      d="M733.574 13.728h3.458c.625 0 1.19.103 1.694.308a3.33 3.33 0 0 1 1.302.924c.364.401.644.91.84 1.526.196.607.294 1.316.294 2.128s-.098 1.526-.294 2.142c-.196.607-.476 1.115-.84 1.526a3.396 3.396 0 0 1-1.302.91 4.455 4.455 0 0 1-1.694.308h-3.458v-9.772Zm3.458 8.372c.728 0 1.316-.229 1.764-.686.448-.457.672-1.13.672-2.016V17.83c0-.887-.224-1.559-.672-2.016-.448-.457-1.036-.686-1.764-.686h-1.876V22.1h1.876Zm11.321 1.4c-.402 0-.71-.112-.924-.336a1.56 1.56 0 0 1-.392-.882h-.07c-.14.457-.397.803-.77 1.036-.374.233-.826.35-1.358.35-.756 0-1.34-.196-1.75-.588-.402-.392-.602-.92-.602-1.582 0-.728.261-1.274.784-1.638.532-.364 1.306-.546 2.324-.546h1.316v-.616c0-.448-.122-.793-.364-1.036-.243-.243-.621-.364-1.134-.364-.43 0-.78.093-1.05.28-.271.187-.5.425-.686.714l-.91-.826c.242-.41.583-.747 1.022-1.008.438-.27 1.012-.406 1.722-.406.942 0 1.666.22 2.17.658.504.439.756 1.069.756 1.89v3.654h.77V23.5h-.854Zm-3.08-.994c.476 0 .868-.103 1.176-.308.308-.215.462-.5.462-.854v-1.05h-1.288c-1.055 0-1.582.327-1.582.98v.252c0 .327.107.574.322.742.224.159.527.238.91.238Zm7.404.994c-.532 0-.933-.135-1.204-.406-.27-.28-.406-.672-.406-1.176v-4.452h-1.134V16.22h.616c.252 0 .425-.056.518-.168.103-.112.154-.294.154-.546v-1.274h1.372v1.988h1.526v1.246h-1.526v4.788h1.414V23.5h-1.33Zm5.899.168a3.5 3.5 0 0 1-1.4-.266 2.934 2.934 0 0 1-1.05-.756 3.607 3.607 0 0 1-.672-1.204 5.278 5.278 0 0 1-.224-1.582c0-.579.075-1.101.224-1.568.159-.476.383-.877.672-1.204a2.861 2.861 0 0 1 1.05-.77 3.5 3.5 0 0 1 1.4-.266c.532 0 .999.093 1.4.28.411.187.751.448 1.022.784.271.327.471.71.602 1.148.14.439.21.91.21 1.414v.574h-4.998v.238c0 .56.163 1.022.49 1.386.336.355.812.532 1.428.532.448 0 .826-.098 1.134-.294.308-.196.569-.462.784-.798l.896.882c-.271.448-.663.807-1.176 1.078-.513.261-1.111.392-1.792.392Zm0-6.426c-.261 0-.504.047-.728.14a1.687 1.687 0 0 0-.56.392 1.831 1.831 0 0 0-.35.602c-.084.233-.126.49-.126.77v.098h3.388v-.14c0-.56-.145-1.008-.434-1.344-.289-.345-.686-.518-1.19-.518Zm9.926 6.258h-1.582v-9.772h4.214c.877 0 1.568.266 2.072.798.504.523.756 1.237.756 2.142 0 .7-.164 1.283-.49 1.75-.318.457-.789.78-1.414.966l2.114 4.116h-1.764l-1.96-3.948h-1.946V23.5Zm2.52-5.278c.401 0 .714-.103.938-.308.224-.215.336-.518.336-.91v-.672c0-.392-.112-.69-.336-.896-.224-.215-.537-.322-.938-.322h-2.52v3.108h2.52Zm10.157 5.278c-.401 0-.709-.112-.924-.336a1.567 1.567 0 0 1-.392-.882h-.07c-.14.457-.397.803-.77 1.036-.373.233-.826.35-1.358.35-.756 0-1.339-.196-1.75-.588-.401-.392-.602-.92-.602-1.582 0-.728.261-1.274.784-1.638.532-.364 1.307-.546 2.324-.546h1.316v-.616c0-.448-.121-.793-.364-1.036s-.621-.364-1.134-.364c-.429 0-.779.093-1.05.28a2.507 2.507 0 0 0-.686.714l-.91-.826a2.86 2.86 0 0 1 1.022-1.008c.439-.27 1.013-.406 1.722-.406.943 0 1.666.22 2.17.658.504.439.756 1.069.756 1.89v3.654h.77V23.5h-.854Zm-3.08-.994c.476 0 .868-.103 1.176-.308.308-.215.462-.5.462-.854v-1.05h-1.288c-1.055 0-1.582.327-1.582.98v.252c0 .327.107.574.322.742.224.159.527.238.91.238Zm5.43.994v-7.28h1.526v1.204h.07c.158-.392.396-.719.714-.98.326-.261.77-.392 1.33-.392.746 0 1.325.247 1.736.742.42.485.63 1.18.63 2.086v4.62h-1.526v-4.424c0-1.139-.458-1.708-1.372-1.708-.196 0-.392.028-.588.084a1.534 1.534 0 0 0-.504.224 1.21 1.21 0 0 0-.364.392 1.18 1.18 0 0 0-.126.56V23.5h-1.526Zm14.505.686c0 .756-.29 1.325-.868 1.708-.579.383-1.522.574-2.828.574a7.909 7.909 0 0 1-1.526-.126c-.411-.075-.752-.187-1.022-.336a1.47 1.47 0 0 1-.574-.546 1.475 1.475 0 0 1-.182-.742c0-.401.107-.714.322-.938.224-.224.532-.378.924-.462v-.154c-.551-.177-.826-.55-.826-1.12 0-.373.126-.658.378-.854a2.23 2.23 0 0 1 .91-.434V20.7a2.346 2.346 0 0 1-.994-.854c-.224-.373-.336-.807-.336-1.302 0-.747.247-1.349.742-1.806.504-.457 1.222-.686 2.156-.686.513 0 .952.075 1.316.224v-.196c0-.327.074-.579.224-.756.158-.187.401-.28.728-.28h1.12v1.232h-1.484v.294c.326.215.578.495.756.84.177.336.266.714.266 1.134 0 .737-.252 1.335-.756 1.792-.504.448-1.223.672-2.156.672-.355 0-.672-.037-.952-.112-.187.065-.35.159-.49.28a.545.545 0 0 0-.21.448c0 .196.088.336.266.42.177.084.429.126.756.126h1.792c.896 0 1.544.182 1.946.546.401.355.602.845.602 1.47Zm-1.428.168a.718.718 0 0 0-.294-.602c-.187-.15-.532-.224-1.036-.224h-2.464c-.336.196-.504.476-.504.84a.85.85 0 0 0 .35.714c.242.187.648.28 1.218.28h.952c1.185 0 1.778-.336 1.778-1.008Zm-2.282-4.452c.448 0 .793-.098 1.036-.294.252-.205.378-.518.378-.938v-.28c0-.42-.126-.728-.378-.924-.243-.205-.588-.308-1.036-.308-.448 0-.798.103-1.05.308-.243.196-.364.504-.364.924v.28c0 .42.121.733.364.938.252.196.602.294 1.05.294Zm7.619 3.766a3.5 3.5 0 0 1-1.4-.266 2.934 2.934 0 0 1-1.05-.756 3.607 3.607 0 0 1-.672-1.204 5.278 5.278 0 0 1-.224-1.582c0-.579.075-1.101.224-1.568.159-.476.383-.877.672-1.204a2.861 2.861 0 0 1 1.05-.77 3.5 3.5 0 0 1 1.4-.266c.532 0 .999.093 1.4.28.411.187.751.448 1.022.784.271.327.471.71.602 1.148.14.439.21.91.21 1.414v.574h-4.998v.238c0 .56.163 1.022.49 1.386.336.355.812.532 1.428.532.448 0 .826-.098 1.134-.294.308-.196.569-.462.784-.798l.896.882c-.271.448-.663.807-1.176 1.078-.513.261-1.111.392-1.792.392Zm0-6.426c-.261 0-.504.047-.728.14a1.687 1.687 0 0 0-.56.392 1.831 1.831 0 0 0-.35.602c-.084.233-.126.49-.126.77v.098h3.388v-.14c0-.56-.145-1.008-.434-1.344-.289-.345-.686-.518-1.19-.518Z"
    />
  </svg>
);
export const DashboardIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={31}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M15 9.31c4.98 0 9.024 4.024 9.024 8.982 0 1.071-.875 1.94-1.95 1.94H7.927c-1.077 0-1.95-.871-1.95-1.94 0-4.958 4.044-8.982 9.024-8.982Z"
    />
    <path
      fill="#fff"
      d="M15.409 20.08a.662.662 0 0 1-.334-.09.663.663 0 0 1-.243-.91l2.15-3.71a.67.67 0 0 1 1.225.162.651.651 0 0 1-.067.505l-2.151 3.71a.67.67 0 0 1-.58.332Z"
    />
    <path
      fill="#000"
      d="M17.563 15.169a.535.535 0 0 1 .466.804l-2.152 3.71a.54.54 0 0 1-.986-.129.533.533 0 0 1 .055-.407l2.15-3.71a.54.54 0 0 1 .467-.268Zm0-.258a.797.797 0 0 0-.691.397l-2.152 3.71a.791.791 0 0 0 .691 1.19.798.798 0 0 0 .692-.396l2.15-3.71a.791.791 0 0 0-.69-1.19Z"
    />
    <path
      fill="#fff"
      d="M15.008 21.561a1.49 1.49 0 0 0 1.494-1.486 1.49 1.49 0 0 0-1.494-1.487 1.49 1.49 0 0 0-1.493 1.487 1.49 1.49 0 0 0 1.493 1.486Z"
    />
    <path
      fill="#000"
      d="M15.008 18.717c.753 0 1.364.608 1.364 1.358 0 .75-.61 1.357-1.364 1.357a1.361 1.361 0 0 1-1.364-1.357c0-.75.61-1.358 1.364-1.358Zm0-.258a1.62 1.62 0 0 0-1.623 1.616 1.62 1.62 0 0 0 1.623 1.615 1.62 1.62 0 0 0 1.623-1.616 1.62 1.62 0 0 0-1.623-1.615Z"
    />
  </svg>
);
export const RTCDetailIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      clipPath="url(#a)"
    >
      <path d="M10.49 2.23 5.5 4.1c-1.15.43-2.09 1.79-2.09 3.02v7.43c0 1.18.78 2.73 1.73 3.44l4.3 3.21c1.41 1.06 3.73 1.06 5.14 0l4.3-3.21c.95-.71 1.73-2.26 1.73-3.44V7.12c0-1.23-.94-2.59-2.09-3.02l-4.99-1.87c-.85-.31-2.21-.31-3.04 0Z" />
      <path strokeMiterlimit={10} d="M12 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
      <path
        strokeMiterlimit={10}
        d="M12.25 10.25v.93c0 .35-.18.68-.49.86l-.76.46"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const RTCDetailIconActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g fill="#27272A" clipPath="url(#a)">
      <path d="M12 8.25c-1.79 0-3.25 1.46-3.25 3.25s1.46 3.25 3.25 3.25 3.25-1.46 3.25-3.25S13.79 8.25 12 8.25Zm1 2.93c0 .61-.33 1.19-.85 1.5l-.77.46c-.12.07-.25.11-.39.11-.25 0-.5-.13-.64-.36-.21-.36-.1-.82.26-1.03l.76-.46c.08-.05.12-.13.12-.21v-.93a.755.755 0 0 1 1.51-.01v.93Z" />
      <path d="m18.54 4.17-5.5-2.06c-.57-.21-1.5-.21-2.07 0l-5.5 2.06c-1.06.4-1.92 1.64-1.92 2.77v8.1c0 .81.53 1.88 1.18 2.36l5.5 4.11c.97.73 2.56.73 3.53 0l5.5-4.11c.65-.49 1.18-1.55 1.18-2.36v-8.1c.01-1.13-.85-2.37-1.9-2.77ZM12 16.25c-2.62 0-4.75-2.13-4.75-4.75S9.38 6.75 12 6.75s4.75 2.13 4.75 4.75-2.13 4.75-4.75 4.75Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const MetersIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.75}
      d="M21 7v10c0 3-1.5 5-5 5H8c-3.5 0-5-2-5-5V7c0-3 1.5-5 5-5h8c3.5 0 5 2 5 5Z"
    />
    <path stroke="#27272A" strokeWidth={1.75} d="M3 10h18" />
    <circle cx={7.125} cy={18.125} r={1.125} fill="#27272A" />
    <circle cx={12.125} cy={18.125} r={1.125} fill="#27272A" />
    <circle cx={16.875} cy={18.125} r={1.125} fill="#27272A" />
    <circle cx={7.125} cy={14.125} r={1.125} fill="#27272A" />
    <circle cx={12.125} cy={14.125} r={1.125} fill="#27272A" />
    <circle cx={16.875} cy={14.125} r={1.125} fill="#27272A" />
  </svg>
);
export const MetersIconActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#1773BA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.75}
      d="M21 7v10c0 3-1.5 5-5 5H8c-3.5 0-5-2-5-5V7c0-3 1.5-5 5-5h8c3.5 0 5 2 5 5Z"
    />
    <path stroke="#1773BA" strokeWidth={1.75} d="M3 10h18" />
    <path fill="#1773BA" d="M8 2C4.5 2 3 4 3 7v3h18V7c0-3-1.5-5-5-5H8Z" />
    <path stroke="#1773BA" strokeWidth={1.75} d="M3 10h18" />
    <circle cx={7.125} cy={18.125} r={1.125} fill="#1773BA" />
    <circle cx={12.125} cy={18.125} r={1.125} fill="#1773BA" />
    <circle cx={16.875} cy={18.125} r={1.125} fill="#1773BA" />
    <circle cx={7.125} cy={14.125} r={1.125} fill="#1773BA" />
    <circle cx={12.125} cy={14.125} r={1.125} fill="#1773BA" />
    <circle cx={16.875} cy={14.125} r={1.125} fill="#1773BA" />
  </svg>
);
export const CommandsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      clipPath="url(#a)"
    >
      <path d="M9 13c-.66.33-1.21.82-1.62 1.43-.23.35-.23.79 0 1.14.41.61.96 1.1 1.62 1.43M15.21 13c.66.33 1.21.82 1.62 1.43.23.35.23.79 0 1.14-.41.61-.96 1.1-1.62 1.43" />
      <path d="M9 22h6c5 0 7-2 7-7V9c0-5-2-7-7-7H9C4 2 2 4 2 9v6c0 5 2 7 7 7ZM2.23 8.01 21.45 8" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const CommandsIconActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g fill="#1773BA" clipPath="url(#a)">
      <path d="M21 10H3c-.55 0-1 .45-1 1v5.19c0 .2.01.4.03.6.2 3.08 2.1 4.98 5.18 5.18.2.02.4.03.6.03h8.38c.2 0 .4-.01.6-.03 3.08-.2 4.98-2.1 5.18-5.18.02-.2.03-.4.03-.6V11c0-.55-.45-1-1-1ZM8 16.15c.34.5.8.91 1.33 1.18.38.18.53.63.34 1.01-.13.26-.4.41-.67.41-.11 0-.23-.03-.33-.08-.78-.38-1.44-.97-1.91-1.68-.4-.6-.4-1.38 0-1.98.47-.71 1.13-1.3 1.91-1.68.37-.19.82-.04 1 .33.19.38.04.83-.34 1.01-.53.27-.99.68-1.33 1.18-.06.09-.06.21 0 .3Zm9.45.84c-.48.71-1.14 1.3-1.91 1.68a.742.742 0 0 1-1-.33.745.745 0 0 1 .33-1.01c.54-.27 1-.68 1.33-1.18a.24.24 0 0 0 0-.3c-.33-.5-.79-.91-1.33-1.18a.745.745 0 0 1-.33-1.01c.18-.37.63-.52 1-.33.77.38 1.43.97 1.91 1.68.4.6.4 1.38 0 1.98ZM22 7.81V8c0 .55-.45 1-1 1L3 9.01c-.55 0-1-.45-1-1v-.2c0-.2.01-.4.03-.6.2-3.08 2.1-4.98 5.18-5.18.2-.02.4-.03.6-.03h8.38c.2 0 .4.01.6.03 3.08.2 4.98 2.1 5.18 5.18.02.2.03.4.03.6Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const MeterDataIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.75}
      clipPath="url(#a)"
    >
      <path d="M8 12.2h7M8 16.2h4.38M10 6h4c2 0 2-1 2-2 0-2-1-2-2-2h-4C9 2 8 2 8 4s1 2 2 2Z" />
      <path d="M16 4.02c3.33.18 5 1.41 5 5.98v6c0 4-1 6-6 6H9c-5 0-6-2-6-6v-6c0-4.56 1.67-5.8 5-5.98" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const MeterDataIconActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g fill="#27272A" clipPath="url(#a)">
      <path d="M14.35 2h-4.7c-1.04 0-1.89.84-1.89 1.88v.94c0 1.04.84 1.88 1.88 1.88h4.71c1.04 0 1.88-.84 1.88-1.88v-.94C16.24 2.84 15.39 2 14.35 2Z" />
      <path d="M17.24 4.82c0 1.59-1.3 2.89-2.89 2.89h-4.7c-1.59 0-2.89-1.3-2.89-2.89 0-.56-.6-.91-1.1-.65a4.472 4.472 0 0 0-2.37 3.95v9.41C3.29 19.99 5.3 22 7.76 22h8.48c2.46 0 4.47-2.01 4.47-4.47V8.12c0-1.71-.96-3.2-2.37-3.95-.5-.26-1.1.09-1.1.65Zm-4.86 12.13H8c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.38c.41 0 .75.34.75.75s-.34.75-.75.75Zm2.62-4H8c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const MeterData = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#333"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
      d="M12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 0V5.333A1.334 1.334 0 0 0 10.667 4h-2M4 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 0v8"
      opacity={0.8}
    />
  </svg>
);
export const EventsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#fff"
      d="M17 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM17 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM13 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM7 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM7 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M7 1.75a.75.75 0 0 1 .75.75v.763c.662-.013 1.391-.013 2.193-.013h4.113c.803 0 1.532 0 2.194.013V2.5a.75.75 0 0 1 1.5 0v.827c.26.02.506.045.739.076 1.172.158 2.121.49 2.87 1.238.748.749 1.08 1.698 1.238 2.87.153 1.14.153 2.595.153 4.433v2.112c0 1.838 0 3.294-.153 4.433-.158 1.172-.49 2.121-1.238 2.87-.749.748-1.698 1.08-2.87 1.238-1.14.153-2.595.153-4.433.153H9.944c-1.838 0-3.294 0-4.433-.153-1.172-.158-2.121-.49-2.87-1.238-.748-.749-1.08-1.698-1.238-2.87-.153-1.14-.153-2.595-.153-4.433v-2.112c0-1.838 0-3.294.153-4.433.158-1.172.49-2.121 1.238-2.87.749-.748 1.698-1.08 2.87-1.238.233-.031.48-.056.739-.076V2.5A.75.75 0 0 1 7 1.75ZM5.71 4.89c-1.005.135-1.585.389-2.008.812-.423.423-.677 1.003-.812 2.009-.023.17-.042.35-.058.539h18.336c-.016-.19-.035-.369-.058-.54-.135-1.005-.389-1.585-.812-2.008-.423-.423-1.003-.677-2.009-.812-1.027-.138-2.382-.14-4.289-.14h-4c-1.907 0-3.261.002-4.29.14ZM2.75 12c0-.854 0-1.597.013-2.25h18.474c.013.653.013 1.396.013 2.25v2c0 1.907-.002 3.262-.14 4.29-.135 1.005-.389 1.585-.812 2.008-.423.423-1.003.677-2.009.812-1.027.138-2.382.14-4.289.14h-4c-1.907 0-3.261-.002-4.29-.14-1.005-.135-1.585-.389-2.008-.812-.423-.423-.677-1.003-.812-2.009-.138-1.027-.14-2.382-.14-4.289v-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export const RoutingsIcon = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1520_121103)">
      <path
        d="M2.07 4.6C2.87 1.14 8.08 1.14 8.87 4.6C9.34 6.63 8.05 8.35 6.93 9.42C6.11 10.2 4.82 10.19 4 9.42C2.89 8.35 1.6 6.63 2.07 4.6Z"
        stroke="#27272A"
        strokeWidth="1.75"
      />
      <path
        d="M15.07 16.6C15.87 13.14 21.11 13.14 21.91 16.6C22.38 18.63 21.09 20.35 19.96 21.42C19.14 22.2 17.84 22.19 17.02 21.42C15.89 20.35 14.6 18.63 15.07 16.6Z"
        stroke="#27272A"
        strokeWidth="1.75"
      />
      <path
        d="M12 5H14.68C16.53 5 17.39 7.29 16 8.51L8.01 15.5C6.62 16.71 7.48 19 9.32 19H12"
        stroke="#27272A"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.48622 5.5H5.49777"
        stroke="#27272A"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4862 17.5H18.4978"
        stroke="#27272A"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1520_121103">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const RoutingsIconActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#27272A"
      d="M8.88 4.6c-.8-3.46-6.01-3.47-6.81 0-.47 2.03.82 3.75 1.94 4.82.82.77 2.11.77 2.93 0 1.12-1.07 2.4-2.79 1.94-4.82ZM5.51 6.2c-.55 0-1-.45-1-1s.44-1 .99-1h.01c.56 0 1 .45 1 1s-.44 1-1 1ZM21.91 16.6c-.8-3.46-6.03-3.47-6.84 0-.47 2.03.82 3.75 1.95 4.82.82.77 2.12.77 2.94 0 1.13-1.07 2.42-2.79 1.95-4.82Zm-3.38 1.6c-.55 0-1-.45-1-1s.44-1 .99-1h.01c.55 0 1 .45 1 1s-.45 1-1 1ZM12 19.75H9.32c-1.16 0-2.17-.7-2.57-1.78-.41-1.08-.11-2.27.76-3.04l7.99-6.99c.48-.42.49-.99.35-1.38-.15-.39-.53-.81-1.17-.81H12c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.68c1.16 0 2.17.7 2.57 1.78.41 1.08.11 2.27-.76 3.04L8.5 16.06c-.48.42-.49.99-.35 1.38.15.39.53.81 1.17.81H12c.41 0 .75.34.75.75s-.34.75-.75.75Z"
    />
  </svg>
);
export const VeeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.75}
      d="M21 7v10c0 3-1.5 5-5 5H8c-3.5 0-5-2-5-5V7c0-3 1.5-5 5-5h8c3.5 0 5 2 5 5Z"
    />
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="m14 14 2 2"
    />
    <path
      stroke="#27272A"
      strokeWidth={1.75}
      d="M15 11.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
    />
  </svg>
);
export const VeeIconActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#27272A"
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.75}
      d="M21 7v10c0 3-1.5 5-5 5H8c-3.5 0-5-2-5-5V7c0-3 1.5-5 5-5h8c3.5 0 5 2 5 5Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M8.875 11.5a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0ZM11.5 7.125a4.375 4.375 0 1 0 2.413 8.025l1.468 1.469a.875.875 0 1 0 1.238-1.238l-1.469-1.468a4.375 4.375 0 0 0-3.65-6.788Z"
      clipRule="evenodd"
    />
  </svg>
);
export const ReportsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      clipPath="url(#a)"
    >
      <path d="M22.002 10v5c0 5-2 7-7 7H9C4 22 2 20 2 15V9c0-5 2-7 7-7h5.001" />
      <path d="M22.002 10h-4c-3 0-4-1-4-4V2l8 8ZM7 13h6.001M7 17h4" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24.002v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const ReportsIconActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g fill="#1773BE" clipPath="url(#a)">
      <path d="M15.803 2.21c-.41-.41-1.12-.13-1.12.44v3.49c0 1.46 1.24 2.67 2.75 2.67.95.01 2.27.01 3.4.01.57 0 .87-.67.47-1.07-1.44-1.45-4.02-4.06-5.5-5.54Z" />
      <path d="M20.503 10.19h-2.89c-2.37 0-4.3-1.93-4.3-4.3V3c0-.55-.45-1-1-1h-4.24c-3.08 0-5.571 2-5.571 5.57v8.86c0 3.57 2.49 5.57 5.57 5.57h7.861c3.08 0 5.57-2 5.57-5.57v-5.24c0-.55-.45-1-1-1Zm-9 7.56h-4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75Zm2-4h-6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.002 0h24.002v24H.002z" />
      </clipPath>
    </defs>
  </svg>
);

export const HESRawDataIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={31}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M20.931 6.5H10.463c-.59 0-1.068.469-1.068 1.047v14.799c0 .578.478 1.047 1.068 1.047h10.47c.59 0 1.068-.469 1.068-1.047v-14.8c0-.577-.478-1.046-1.069-1.046Z"
    />
    <path
      fill="#000"
      d="M19.54 7.723H9.07a.94.94 0 0 0-.949.93v14.799c0 .513.425.93.95.93H19.54a.94.94 0 0 0 .95-.93v-14.8a.94.94 0 0 0-.95-.93Z"
    />
    <path
      fill="#fff"
      d="M19.54 7.84c.458 0 .83.364.83.812v14.802a.822.822 0 0 1-.83.813H9.07a.822.822 0 0 1-.83-.813V8.652c0-.448.372-.813.83-.813H19.54Zm0-.235H9.07c-.59 0-1.069.47-1.069 1.047v14.802c0 .577.48 1.046 1.069 1.046H19.54c.59 0 1.069-.47 1.069-1.046V8.652a1.06 1.06 0 0 0-1.069-1.047Z"
    />
    <path
      fill="#000"
      d="M17.396 11.683a.942.942 0 0 1-.95-.93V7.89l3.874 3.794h-2.924Z"
    />
    <path
      fill="#fff"
      d="m16.569 8.169 3.466 3.394h-2.639a.822.822 0 0 1-.83-.813V8.166m-.236-.56v3.147c0 .577.48 1.046 1.069 1.046h3.213L16.33 7.605Z"
    />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M10.156 9.958h4.139M10.156 11.743h4.139M10.156 13.528h8.301M10.156 15.31h8.301M10.156 17.096h8.301M10.156 18.88h8.301M10.156 20.666h8.301M10.156 22.451h8.301"
    />
  </svg>
);
export const UserManagementIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
      d="M8 10.333H5c-.93 0-1.396 0-1.774.115a2.666 2.666 0 0 0-1.778 1.778c-.115.378-.115.844-.115 1.774m9.334-2L12 13.333l2.667-2.666M9.667 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
      opacity={0.8}
    />
  </svg>
);
export const NMSDashboard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.75}
      d="M5 10h2c2 0 3-1 3-3V5c0-2-1-3-3-3H5C3 2 2 3 2 5v2c0 2 1 3 3 3ZM17.001 10h2c2 0 3-1 3-3V5c0-2-1-3-3-3h-2c-2 0-3 1-3 3v2c0 2 1 3 3 3ZM17.001 22h2c2 0 3-1 3-3v-2c0-2-1-3-3-3h-2c-2 0-3 1-3 3v2c0 2 1 3 3 3ZM5 22h2c2 0 3-1 3-3v-2c0-2-1-3-3-3H5c-2 0-3 1-3 3v2c0 2 1 3 3 3Z"
    />
  </svg>
);
export const NMSDashboardActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#1773BE"
      d="M7.24 2h-1.9C3.15 2 2 3.15 2 5.33v1.9c0 2.18 1.15 3.33 3.33 3.33h1.9c2.18 0 3.33-1.15 3.33-3.33v-1.9C10.57 3.15 9.42 2 7.24 2ZM18.671 2h-1.9c-2.18 0-3.33 1.15-3.33 3.33v1.9c0 2.18 1.15 3.33 3.33 3.33h1.9c2.18 0 3.33-1.15 3.33-3.33v-1.9c0-2.18-1.15-3.33-3.33-3.33ZM18.671 13.43h-1.9c-2.18 0-3.33 1.15-3.33 3.33v1.9c0 2.18 1.15 3.33 3.33 3.33h1.9c2.18 0 3.33-1.15 3.33-3.33v-1.9c0-2.18-1.15-3.33-3.33-3.33ZM7.24 13.43h-1.9C3.15 13.43 2 14.58 2 16.76v1.9C2 20.85 3.15 22 5.33 22h1.9c2.18 0 3.33-1.15 3.33-3.33v-1.9c.01-2.19-1.14-3.34-3.32-3.34Z"
    />
  </svg>
);

export const VayuProfileActiveIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.85 15.1C4.7 14.45 5.65 13.9375 6.7 13.5625C7.75 13.1875 8.85 13 10 13C11.15 13 12.25 13.1875 13.3 13.5625C14.35 13.9375 15.3 14.45 16.15 15.1C16.7333 14.4167 17.1875 13.6417 17.5125 12.775C17.8375 11.9083 18 10.9833 18 10C18 7.78333 17.2208 5.89583 15.6625 4.3375C14.1042 2.77917 12.2167 2 10 2C7.78333 2 5.89583 2.77917 4.3375 4.3375C2.77917 5.89583 2 7.78333 2 10C2 10.9833 2.1625 11.9083 2.4875 12.775C2.8125 13.6417 3.26667 14.4167 3.85 15.1ZM10 11C9.01667 11 8.1875 10.6625 7.5125 9.9875C6.8375 9.3125 6.5 8.48333 6.5 7.5C6.5 6.51667 6.8375 5.6875 7.5125 5.0125C8.1875 4.3375 9.01667 4 10 4C10.9833 4 11.8125 4.3375 12.4875 5.0125C13.1625 5.6875 13.5 6.51667 13.5 7.5C13.5 8.48333 13.1625 9.3125 12.4875 9.9875C11.8125 10.6625 10.9833 11 10 11ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C10.8833 18 11.7167 17.8708 12.5 17.6125C13.2833 17.3542 14 16.9833 14.65 16.5C14 16.0167 13.2833 15.6458 12.5 15.3875C11.7167 15.1292 10.8833 15 10 15C9.11667 15 8.28333 15.1292 7.5 15.3875C6.71667 15.6458 6 16.0167 5.35 16.5C6 16.9833 6.71667 17.3542 7.5 17.6125C8.28333 17.8708 9.11667 18 10 18ZM10 9C10.4333 9 10.7917 8.85833 11.075 8.575C11.3583 8.29167 11.5 7.93333 11.5 7.5C11.5 7.06667 11.3583 6.70833 11.075 6.425C10.7917 6.14167 10.4333 6 10 6C9.56667 6 9.20833 6.14167 8.925 6.425C8.64167 6.70833 8.5 7.06667 8.5 7.5C8.5 7.93333 8.64167 8.29167 8.925 8.575C9.20833 8.85833 9.56667 9 10 9Z"
      fill="#1773BA"
    />
  </svg>
);
export const VayuProfileIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.85 15.1C4.7 14.45 5.65 13.9375 6.7 13.5625C7.75 13.1875 8.85 13 10 13C11.15 13 12.25 13.1875 13.3 13.5625C14.35 13.9375 15.3 14.45 16.15 15.1C16.7333 14.4167 17.1875 13.6417 17.5125 12.775C17.8375 11.9083 18 10.9833 18 10C18 7.78333 17.2208 5.89583 15.6625 4.3375C14.1042 2.77917 12.2167 2 10 2C7.78333 2 5.89583 2.77917 4.3375 4.3375C2.77917 5.89583 2 7.78333 2 10C2 10.9833 2.1625 11.9083 2.4875 12.775C2.8125 13.6417 3.26667 14.4167 3.85 15.1ZM10 11C9.01667 11 8.1875 10.6625 7.5125 9.9875C6.8375 9.3125 6.5 8.48333 6.5 7.5C6.5 6.51667 6.8375 5.6875 7.5125 5.0125C8.1875 4.3375 9.01667 4 10 4C10.9833 4 11.8125 4.3375 12.4875 5.0125C13.1625 5.6875 13.5 6.51667 13.5 7.5C13.5 8.48333 13.1625 9.3125 12.4875 9.9875C11.8125 10.6625 10.9833 11 10 11ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C10.8833 18 11.7167 17.8708 12.5 17.6125C13.2833 17.3542 14 16.9833 14.65 16.5C14 16.0167 13.2833 15.6458 12.5 15.3875C11.7167 15.1292 10.8833 15 10 15C9.11667 15 8.28333 15.1292 7.5 15.3875C6.71667 15.6458 6 16.0167 5.35 16.5C6 16.9833 6.71667 17.3542 7.5 17.6125C8.28333 17.8708 9.11667 18 10 18ZM10 9C10.4333 9 10.7917 8.85833 11.075 8.575C11.3583 8.29167 11.5 7.93333 11.5 7.5C11.5 7.06667 11.3583 6.70833 11.075 6.425C10.7917 6.14167 10.4333 6 10 6C9.56667 6 9.20833 6.14167 8.925 6.425C8.64167 6.70833 8.5 7.06667 8.5 7.5C8.5 7.93333 8.64167 8.29167 8.925 8.575C9.20833 8.85833 9.56667 9 10 9Z"
      fill="#000000FF"
    />
  </svg>
);

export const VayuBulkUploadIcon = (props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.33485 9.19163C8.66181 9.32706 8.875 9.64612 8.875 10V16C8.875 16.4833 8.48325 16.875 8 16.875C7.51675 16.875 7.125 16.4833 7.125 16V12.1125L6.61872 12.6187C6.27701 12.9605 5.72299 12.9605 5.38128 12.6187C5.03957 12.277 5.03957 11.723 5.38128 11.3813L7.38128 9.38131C7.63153 9.13106 8.00788 9.0562 8.33485 9.19163Z"
      fill="#1773BE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.38128 9.38128C7.72299 9.03957 8.27701 9.03957 8.61872 9.38128L10.6187 11.3813C10.9604 11.723 10.9604 12.277 10.6187 12.6187C10.277 12.9604 9.72299 12.9604 9.38128 12.6187L7.38128 10.6187C7.03957 10.277 7.03957 9.72299 7.38128 9.38128Z"
      fill="#1773BE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.24372 3.24372C2.3631 4.12434 1.875 5.5863 1.875 8V14C1.875 16.4137 2.3631 17.8757 3.24372 18.7563C4.12434 19.6369 5.5863 20.125 8 20.125H14C16.4137 20.125 17.8757 19.6369 18.7563 18.7563C19.6369 17.8757 20.125 16.4137 20.125 14V9C20.125 8.51675 20.5168 8.125 21 8.125C21.4832 8.125 21.875 8.51675 21.875 9V14C21.875 16.5863 21.3631 18.6243 19.9937 19.9937C18.6243 21.3631 16.5863 21.875 14 21.875H8C5.4137 21.875 3.37566 21.3631 2.00628 19.9937C0.636901 18.6243 0.125 16.5863 0.125 14V8C0.125 5.4137 0.636901 3.37566 2.00628 2.00628C3.37566 0.636901 5.4137 0.125 8 0.125H13C13.4832 0.125 13.875 0.516751 13.875 1C13.875 1.48325 13.4832 1.875 13 1.875H8C5.5863 1.875 4.12434 2.3631 3.24372 3.24372Z"
      fill="#1773BE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.6652 0.191631C12.9921 0.0561976 13.3685 0.131059 13.6187 0.381307L21.6187 8.38131C21.869 8.63156 21.9438 9.00791 21.8084 9.33487C21.673 9.66184 21.3539 9.87503 21 9.87503H17C15.4515 9.87503 14.1408 9.62823 13.2563 8.74374C12.3718 7.85925 12.125 6.5485 12.125 5.00003V1.00003C12.125 0.646121 12.3382 0.327064 12.6652 0.191631ZM13.875 3.11246V5.00003C13.875 6.45155 14.1282 7.1408 14.4937 7.50631C14.8592 7.87182 15.5485 8.12503 17 8.12503H18.8876L13.875 3.11246Z"
      fill="#1773BE"
    />
  </svg>
);
export const VayuCommandsIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.6 15.6L11 14.175L8.825 12L11 9.825L9.6 8.4L6 12L9.6 15.6ZM14.4 15.6L18 12L14.4 8.4L13 9.825L15.175 12L13 14.175L14.4 15.6ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H5V19Z"
      fill="#000000FF"
    />
  </svg>
);
export const VayuCommandsActiveIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.6 15.6L11 14.175L8.825 12L11 9.825L9.6 8.4L6 12L9.6 15.6ZM14.4 15.6L18 12L14.4 8.4L13 9.825L15.175 12L13 14.175L14.4 15.6ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H5V19Z"
      fill="#1773BA"
    />
  </svg>
);
export const VayuDownloadDataIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9 10.125C9.48325 10.125 9.875 10.5168 9.875 11V14.8876L10.3813 14.3813C10.723 14.0396 11.277 14.0396 11.6187 14.3813C11.9604 14.723 11.9604 15.277 11.6187 15.6187L9.61872 17.6187C9.36847 17.869 8.99212 17.9438 8.66515 17.8084C8.33819 17.673 8.125 17.3539 8.125 17V11C8.125 10.5168 8.51675 10.125 9 10.125Z"
      fill="#27272A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.38128 14.3813C6.72299 14.0396 7.27701 14.0396 7.61872 14.3813L9.61872 16.3813C9.96043 16.723 9.96043 17.277 9.61872 17.6187C9.27701 17.9604 8.72299 17.9604 8.38128 17.6187L6.38128 15.6187C6.03957 15.277 6.03957 14.723 6.38128 14.3813Z"
      fill="#27272A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.24372 4.24372C3.3631 5.12434 2.875 6.5863 2.875 9V15C2.875 17.4137 3.3631 18.8757 4.24372 19.7563C5.12434 20.6369 6.5863 21.125 9 21.125H15C17.4137 21.125 18.8757 20.6369 19.7563 19.7563C20.6369 18.8757 21.125 17.4137 21.125 15V10C21.125 9.51675 21.5168 9.125 22 9.125C22.4832 9.125 22.875 9.51675 22.875 10V15C22.875 17.5863 22.3631 19.6243 20.9937 20.9937C19.6243 22.3631 17.5863 22.875 15 22.875H9C6.4137 22.875 4.37566 22.3631 3.00628 20.9937C1.6369 19.6243 1.125 17.5863 1.125 15V9C1.125 6.4137 1.6369 4.37566 3.00628 3.00628C4.37566 1.6369 6.4137 1.125 9 1.125H14C14.4832 1.125 14.875 1.51675 14.875 2C14.875 2.48325 14.4832 2.875 14 2.875H9C6.5863 2.875 5.12434 3.3631 4.24372 4.24372Z"
      fill="#27272A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.6652 1.19163C13.9921 1.0562 14.3685 1.13106 14.6187 1.38131L22.6187 9.38131C22.869 9.63156 22.9438 10.0079 22.8084 10.3349C22.673 10.6618 22.3539 10.875 22 10.875H18C16.4515 10.875 15.1408 10.6282 14.2563 9.74374C13.3718 8.85925 13.125 7.5485 13.125 6.00003V2.00003C13.125 1.64612 13.3382 1.32706 13.6652 1.19163ZM14.875 4.11246V6.00003C14.875 7.45155 15.1282 8.1408 15.4937 8.50631C15.8592 8.87182 16.5485 9.12503 18 9.12503H19.8876L14.875 4.11246Z"
      fill="#27272A"
    />
  </svg>
);

export const VayuDownArrowIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.3813 8.38128C11.723 8.03957 12.277 8.03957 12.6187 8.38128L18.6187 14.3813C18.9604 14.723 18.9604 15.277 18.6187 15.6187C18.277 15.9604 17.723 15.9604 17.3813 15.6187L12 10.2374L6.61872 15.6187C6.27701 15.9604 5.72299 15.9604 5.38128 15.6187C5.03957 15.277 5.03957 14.723 5.38128 14.3813L11.3813 8.38128Z"
      fill="#27272A"
    />
  </svg>
);

export const VayuUpArrowIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.38128 8.38128C5.72299 8.03957 6.27701 8.03957 6.61872 8.38128L12 13.7626L17.3813 8.38128C17.723 8.03957 18.277 8.03957 18.6187 8.38128C18.9604 8.72299 18.9604 9.27701 18.6187 9.61872L12.6187 15.6187C12.277 15.9604 11.723 15.9604 11.3813 15.6187L5.38128 9.61872C5.03957 9.27701 5.03957 8.72299 5.38128 8.38128Z"
      fill="#27272A"
    />
  </svg>
);
export const VayuDownloadDataActiveIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19ZM12.28 15.78L10.28 17.78C10.21 17.85 10.12 17.91 10.03 17.94C9.94 17.98 9.85 18 9.75 18C9.65 18 9.56 17.98 9.47 17.94C9.39 17.91 9.31 17.85 9.25 17.79C9.24 17.78 9.23 17.78 9.23 17.77L7.23 15.77C6.94 15.48 6.94 15 7.23 14.71C7.52 14.42 8 14.42 8.29 14.71L9 15.44V11.25C9 10.84 9.34 10.5 9.75 10.5C10.16 10.5 10.5 10.84 10.5 11.25V15.44L11.22 14.72C11.51 14.43 11.99 14.43 12.28 14.72C12.57 15.01 12.57 15.49 12.28 15.78Z"
      fill="#1773BE"
    />
    <path
      d="M17.4297 8.80999C18.3797 8.81999 19.6997 8.81999 20.8297 8.81999C21.3997 8.81999 21.6997 8.14999 21.2997 7.74999C19.8597 6.29999 17.2797 3.68999 15.7997 2.20999C15.3897 1.79999 14.6797 2.07999 14.6797 2.64999V6.13999C14.6797 7.59999 15.9197 8.80999 17.4297 8.80999Z"
      fill="#1773BE"
    />
  </svg>
);
export const VayuUserIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 2.875C9.72183 2.875 7.875 4.72183 7.875 7C7.875 9.27818 9.72183 11.125 12 11.125C14.2782 11.125 16.125 9.27818 16.125 7C16.125 4.72183 14.2782 2.875 12 2.875ZM6.125 7C6.125 3.75533 8.75533 1.125 12 1.125C15.2447 1.125 17.875 3.75533 17.875 7C17.875 10.2447 15.2447 12.875 12 12.875C8.75533 12.875 6.125 10.2447 6.125 7Z"
      fill="#27272A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.53516 22C2.53516 17.4873 6.95347 14.125 12.0002 14.125C17.0468 14.125 21.4651 17.4873 21.4651 22C21.4651 22.4832 21.0734 22.875 20.5901 22.875C20.1069 22.875 19.7151 22.4832 19.7151 22C19.7151 18.7727 16.4335 15.875 12.0002 15.875C7.56684 15.875 4.28516 18.7727 4.28516 22C4.28516 22.4832 3.89341 22.875 3.41016 22.875C2.92691 22.875 2.53516 22.4832 2.53516 22Z"
      fill="#27272A"
    />
  </svg>
);
export const VayuUserActiveIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
      fill="#1773BE"
    />
    <path
      d="M12.0002 14.5C6.99016 14.5 2.91016 17.86 2.91016 22C2.91016 22.28 3.13016 22.5 3.41016 22.5H20.5902C20.8702 22.5 21.0902 22.28 21.0902 22C21.0902 17.86 17.0102 14.5 12.0002 14.5Z"
      fill="#1773BE"
    />
  </svg>
);
export const VayuUserGroupsIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.9101 2.875C16.9633 2.875 16.2051 3.63325 16.2051 4.58C16.2051 5.48863 16.9009 6.22047 17.7832 6.28246C17.8639 6.27585 17.9462 6.27585 18.0269 6.28246C18.9073 6.22054 19.607 5.48987 19.6151 4.5769C19.6134 3.63935 18.8536 2.875 17.9101 2.875ZM14.4551 4.58C14.4551 2.66675 15.9968 1.125 17.9101 1.125C19.8255 1.125 21.3651 2.67896 21.3651 4.58V4.58625H21.3651C21.3517 6.45166 19.883 7.96736 18.0318 8.03443C17.9895 8.03596 17.9471 8.03442 17.9051 8.02983C17.863 8.03442 17.8207 8.03596 17.7784 8.03443C15.9282 7.96739 14.4551 6.45137 14.4551 4.58Z"
      fill="#27272A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.7891 8.72815C18.3345 8.45743 20.1019 8.71366 21.3939 9.57094L21.3955 9.57199C22.2829 10.1636 22.8426 11.0311 22.8426 12.01C22.8426 12.989 22.2829 13.8564 21.3955 14.4481C20.1127 15.3065 18.3661 15.5616 16.8252 15.303C16.3486 15.2229 16.0272 14.7717 16.1072 14.2952C16.1872 13.8186 16.6384 13.4971 17.115 13.5771C18.3134 13.7783 19.586 13.5538 20.4231 12.993L20.4247 12.992L20.4247 12.992C20.9473 12.6436 21.0926 12.2711 21.0926 12.01C21.0926 11.7491 20.9474 11.3768 20.4255 11.0286C19.5774 10.4663 18.2853 10.2427 17.0911 10.4519C16.6151 10.5353 16.1616 10.217 16.0782 9.74101C15.9948 9.26501 16.3131 8.81154 16.7891 8.72815Z"
      fill="#27272A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.605 4.58C2.605 2.67896 4.14455 1.125 6.06 1.125C7.97326 1.125 9.515 2.66675 9.515 4.58C9.515 6.45137 8.04185 7.96739 6.19169 8.03443C6.14938 8.03596 6.10704 8.03442 6.065 8.02983C6.02296 8.03442 5.98063 8.03596 5.93832 8.03443C4.08707 7.96736 2.61835 6.45167 2.60503 4.58625L2.60498 4.58H2.605ZM4.35501 4.57688C4.36311 5.48986 5.06275 6.22054 5.94316 6.28246C6.02388 6.27585 6.10614 6.27585 6.18686 6.28246C7.06914 6.22047 7.765 5.48863 7.765 4.58C7.765 3.63325 7.00675 2.875 6.06 2.875C5.11651 2.875 4.35669 3.63935 4.35501 4.57688Z"
      fill="#27272A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.54451 11.0286C4.39257 10.4663 5.68469 10.2427 6.87895 10.4519C7.35495 10.5353 7.80843 10.217 7.89181 9.74101C7.9752 9.26501 7.65692 8.81154 7.18092 8.72815C5.63556 8.45743 3.8681 8.71366 2.57615 9.57094L2.57615 9.57094L2.57458 9.57199C1.68713 10.1636 1.12744 11.0311 1.12744 12.01C1.12744 12.9887 1.6868 13.8559 2.57379 14.4475C3.85658 15.3064 5.60359 15.5617 7.14481 15.303C7.62139 15.2229 7.94287 14.7717 7.86286 14.2952C7.78285 13.8186 7.33165 13.4971 6.85507 13.5771C5.65661 13.7783 4.38402 13.5538 3.54689 12.993L3.5453 12.992C3.02275 12.6436 2.87744 12.2711 2.87744 12.01C2.87744 11.7491 3.02261 11.3768 3.54451 11.0286Z"
      fill="#27272A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9096 10.345C10.9628 10.345 10.2046 11.1032 10.2046 12.05C10.2046 12.9586 10.9005 13.6904 11.7827 13.7524C11.8648 13.7457 11.9484 13.7458 12.0304 13.7528C12.9019 13.6981 13.6064 12.9659 13.6146 12.0469C13.6129 11.1093 12.8531 10.345 11.9096 10.345ZM8.45459 12.05C8.45459 10.1367 9.99634 8.59497 11.9096 8.59497C13.825 8.59497 15.3646 10.1489 15.3646 12.05V12.0562H15.3646C15.3513 13.916 13.8868 15.4506 12.0249 15.5046C11.9847 15.5058 11.9445 15.5042 11.9046 15.4998C11.8625 15.5044 11.8202 15.5059 11.7779 15.5044C9.92774 15.4374 8.45459 13.9213 8.45459 12.05Z"
      fill="#27272A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0035 16.11C13.1907 16.11 14.4251 16.4053 15.3951 17.0519C16.2825 17.6436 16.8422 18.511 16.8422 19.49C16.8422 20.4687 16.2828 21.336 15.3957 21.9276C14.4219 22.5787 13.1878 22.8775 11.9997 22.8775C10.8116 22.8775 9.57759 22.5787 8.60378 21.9276C7.71667 21.336 7.15723 20.4687 7.15723 19.49C7.15723 18.511 7.71691 17.6436 8.60436 17.0519L8.60647 17.0505L8.60647 17.0505C9.58028 16.4054 10.816 16.11 12.0035 16.11ZM9.57404 18.5087C9.05234 18.8569 8.90723 19.2291 8.90723 19.49C8.90723 19.751 9.05254 20.1236 9.57509 20.4719L9.57614 20.4726C10.2022 20.8914 11.078 21.1275 11.9997 21.1275C12.9215 21.1275 13.7972 20.8914 14.4233 20.4726L14.4244 20.4719C14.9469 20.1236 15.0922 19.751 15.0922 19.49C15.0922 19.2289 14.9469 18.8564 14.4244 18.508C13.8043 18.0947 12.9288 17.86 12.0035 17.86C11.079 17.86 10.2002 18.0943 9.57404 18.5087Z"
      fill="#27272A"
    />
  </svg>
);
export const VayuUserGroupsActiveIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.53 7.77C17.46 7.76 17.39 7.76 17.32 7.77C15.77 7.72 14.54 6.45 14.54 4.89C14.54 3.3 15.83 2 17.43 2C19.02 2 20.32 3.29 20.32 4.89C20.31 6.45 19.08 7.72 17.53 7.77Z"
      fill="#1773BE"
    />
    <path
      d="M20.7901 14.7C19.6701 15.45 18.1001 15.73 16.6501 15.54C17.0301 14.72 17.2301 13.81 17.2401 12.85C17.2401 11.85 17.0201 10.9 16.6001 10.07C18.0801 9.86998 19.6501 10.15 20.7801 10.9C22.3601 11.94 22.3601 13.65 20.7901 14.7Z"
      fill="#1773BE"
    />
    <path
      d="M6.44016 7.77C6.51016 7.76 6.58016 7.76 6.65016 7.77C8.20016 7.72 9.43016 6.45 9.43016 4.89C9.43016 3.29 8.14016 2 6.54016 2C4.95016 2 3.66016 3.29 3.66016 4.89C3.66016 6.45 4.89016 7.72 6.44016 7.77Z"
      fill="#1773BE"
    />
    <path
      d="M6.55012 12.85C6.55012 13.82 6.76012 14.74 7.14012 15.57C5.73012 15.72 4.26012 15.42 3.18012 14.71C1.60012 13.66 1.60012 11.95 3.18012 10.9C4.25012 10.18 5.76012 9.88998 7.18012 10.05C6.77012 10.89 6.55012 11.84 6.55012 12.85Z"
      fill="#1773BE"
    />
    <path
      d="M12.1203 15.87C12.0403 15.86 11.9503 15.86 11.8603 15.87C10.0203 15.81 8.55029 14.3 8.55029 12.44C8.56029 10.54 10.0903 9 12.0003 9C13.9003 9 15.4403 10.54 15.4403 12.44C15.4303 14.3 13.9703 15.81 12.1203 15.87Z"
      fill="#1773BE"
    />
    <path
      d="M8.87029 17.94C7.36029 18.95 7.36029 20.61 8.87029 21.61C10.5903 22.76 13.4103 22.76 15.1303 21.61C16.6403 20.6 16.6403 18.94 15.1303 17.94C13.4203 16.79 10.6003 16.79 8.87029 17.94Z"
      fill="#1773BE"
    />
  </svg>
);

export const NMSNodesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M19.002 16V6.5c0-1.1-.9-2-2-2H11.5"
    />
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="m14.001 2-3 2.5 3 2.5M19.001 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM5 8v9.5c0 1.1.9 2 2 2h5.5"
    />
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="m10.001 22 3-2.5-3-2.5M5 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
    />
  </svg>
);
export const NMSNodesIconActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#1773BE"
      d="M19.732 16.1c0-.03.02-.06.02-.1V6.5c0-1.52-1.23-2.75-2.75-2.75h-3.93l1.41-1.17c.32-.27.36-.74.1-1.06a.758.758 0 0 0-1.06-.1l-3.001 2.5a.761.761 0 0 0 0 1.16l3 2.5c.14.12.31.17.48.17a.75.75 0 0 0 .48-1.33l-1.41-1.17h3.93c.69 0 1.25.56 1.25 1.25V16c0 .04.02.07.02.1-1.3.33-2.27 1.5-2.27 2.9 0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.4-.97-2.57-2.27-2.9ZM13.48 18.92l-3-2.5a.75.75 0 0 0-1.06.1.75.75 0 0 0 .1 1.06l1.41 1.17H7c-.69 0-1.25-.56-1.25-1.25V8c0-.04-.02-.07-.02-.1C7.03 7.57 8 6.4 8 5c0-1.66-1.34-3-3-3S2 3.34 2 5c0 1.4.97 2.57 2.27 2.9 0 .03-.02.06-.02.1v9.5c0 1.52 1.23 2.75 2.75 2.75h3.93l-1.41 1.17c-.32.27-.36.74-.1 1.06.15.18.36.27.58.27.17 0 .34-.06.48-.17l3-2.5c.17-.14.271-.35.271-.58 0-.23-.1-.43-.27-.58Z"
    />
  </svg>
);
export const NMSGatewayIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#27272A"
      d="M20.001 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM20.001 6.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM20.001 22.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM4 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z"
    />
    <path
      fill="#27272A"
      d="M19.001 12.75c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-7.25V7c0-1.58.67-2.25 2.25-2.25h5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-5c-2.42 0-3.75 1.33-3.75 3.75v4.25H5c-.411 0-.751.34-.751.75s.34.75.75.75h5.25V17c0 2.42 1.33 3.75 3.75 3.75h5.001c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-5c-1.58 0-2.25-.67-2.25-2.25v-4.25H19Z"
    />
  </svg>
);
export const NMSGatewayIconActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#1773BE"
      d="M20.002 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM20.002 6.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM20.002 22.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM4 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z"
    />
    <path
      fill="#1773BE"
      d="M19.002 12.75c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-7.25V7c0-1.58.67-2.25 2.25-2.25h5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-5c-2.42 0-3.751 1.33-3.751 3.75v4.25h-5.25c-.41 0-.75.34-.75.75s.34.75.75.75h5.25V17c0 2.42 1.33 3.75 3.75 3.75h5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-5c-1.58 0-2.25-.67-2.25-2.25v-4.25h7.25Z"
    />
  </svg>
);
export const NMSMapsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#27272A"
      fillRule="evenodd"
      d="M12 8.065a2.245 2.245 0 1 0 0 4.49 2.245 2.245 0 0 0 0-4.49ZM8.005 10.31a3.995 3.995 0 1 1 7.99 0 3.995 3.995 0 0 1-7.99 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#27272A"
      fillRule="evenodd"
      d="M12.003 2.875c-3.37-.002-6.652 1.95-7.53 5.809-1.041 4.601 1.808 8.608 4.524 11.225a4.318 4.318 0 0 0 5.995.001l.002-.001c2.725-2.617 5.574-6.614 4.532-11.216-.873-3.858-4.153-5.816-7.523-5.818Zm9.23 5.432c-1.086-4.802-5.201-7.18-9.229-7.182-4.027-.003-8.145 2.37-9.237 7.17v.002c-1.259 5.558 2.212 10.17 5.016 12.873v.001a6.069 6.069 0 0 0 8.424 0c2.814-2.703 6.284-7.306 5.026-12.864Z"
      clipRule="evenodd"
    />
  </svg>
);
export const NMSMapsActiveIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#1773BE"
      fillRule="evenodd"
      d="M12 8.065a2.245 2.245 0 1 0 0 4.49 2.245 2.245 0 0 0 0-4.49ZM8.005 10.31a3.995 3.995 0 1 1 7.99 0 3.995 3.995 0 0 1-7.99 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#1773BE"
      fillRule="evenodd"
      d="M12.003 2.875c-3.37-.002-6.652 1.95-7.53 5.809-1.041 4.601 1.808 8.608 4.524 11.225a4.318 4.318 0 0 0 5.995.001l.002-.001c2.725-2.617 5.574-6.614 4.532-11.216-.873-3.858-4.153-5.816-7.523-5.818Zm9.23 5.432c-1.086-4.802-5.201-7.18-9.229-7.182-4.027-.003-8.145 2.37-9.237 7.17v.002c-1.259 5.558 2.212 10.17 5.016 12.873v.001a6.069 6.069 0 0 0 8.424 0c2.814-2.703 6.284-7.306 5.026-12.864Z"
      clipRule="evenodd"
    />
  </svg>
);

export const NMSTopologysIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#27272A"
      d="M20.252 16.312a3.133 3.133 0 0 0-1.627.462l.013-.007-2.02-1.837a5.354 5.354 0 0 0 .865-2.935 5.38 5.38 0 0 0-1.019-3.159l.012.016 2.296-2.296a3.1 3.1 0 0 0 1.479.38h.001a3.188 3.188 0 1 0-3.188-3.187c.004.543.145 1.052.39 1.496l-.009-.016-2.296 2.296a5.255 5.255 0 0 0-3.108-1.008c-.652 0-1.275.118-1.85.333l.036-.012-.483-.878a3.168 3.168 0 1 0-1.618.905l-.021.004.482.875a5.336 5.336 0 0 0-1.906 5.535l-.008-.037-.5.213a3.17 3.17 0 1 0 .764 2.064V15.5a3.112 3.112 0 0 0-.034-.338l.002.018.5-.212a5.426 5.426 0 0 0 7.953 1.331l-.011.009 2.027 1.841a3.117 3.117 0 0 0-.311 1.348 3.188 3.188 0 1 0 3.188-3.187v.002ZM6.142 3.75a1.313 1.313 0 1 1 2.627 0 1.313 1.313 0 0 1-2.626 0ZM3.75 16.815a1.312 1.312 0 1 1 .001-2.624 1.312 1.312 0 0 1 0 2.624ZM20.252 2.437a1.313 1.313 0 1 1-.001 2.626 1.313 1.313 0 0 1 0-2.626ZM8.393 12v-.002a3.605 3.605 0 0 1 6.156-2.549l.001.002A3.606 3.606 0 1 1 8.393 12Zm11.858 8.812a1.313 1.313 0 1 1 .001-2.626 1.313 1.313 0 0 1 0 2.626Z"
    />
  </svg>
);
export const NMSTopologysIconActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={23}
    fill="none"
    {...props}
  >
    <path
      fill="#1773BE"
      d="M20.252 16.313a3.134 3.134 0 0 0-1.627.462l.013-.007-2.02-1.837a5.354 5.354 0 0 0 .865-2.935 5.38 5.38 0 0 0-1.019-3.159l.012.016 2.296-2.296a3.1 3.1 0 0 0 1.479.38h.001a3.188 3.188 0 1 0-3.188-3.187c.004.543.145 1.052.39 1.496l-.009-.016-2.296 2.296a5.255 5.255 0 0 0-3.108-1.008c-.652 0-1.275.118-1.85.333l.036-.013-.483-.877a3.168 3.168 0 1 0-1.618.905l-.021.004.482.875A5.336 5.336 0 0 0 6.68 13.28l-.008-.037-.5.213a3.17 3.17 0 1 0 .764 2.064V15.5a3.11 3.11 0 0 0-.034-.337l.002.018.5-.213a5.426 5.426 0 0 0 7.953 1.332l-.011.008 2.027 1.841a3.116 3.116 0 0 0-.311 1.348 3.189 3.189 0 1 0 3.188-3.187v.002ZM8.393 12.001v-.002a3.605 3.605 0 0 1 6.156-2.549l.001.002a3.606 3.606 0 1 1-6.157 2.55Z"
    />
  </svg>
);
export const NMSNetworkPlanningIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M2.29 7.78v9.73c0 1.9 1.35 2.68 2.99 1.74l2.35-1.34c.51-.29 1.36-.32 1.89-.05l5.251 2.63c.53.26 1.38.24 1.89-.05l4.33-2.48c.55-.32 1.01-1.1 1.01-1.74V6.49c0-1.9-1.35-2.68-2.99-1.74l-2.35 1.34c-.51.29-1.36.32-1.89.05l-5.25-2.62c-.53-.26-1.38-.24-1.89.05L3.3 6.05c-.56.32-1.011 1.1-1.011 1.73ZM8.56 4v13M15.731 6.62V20"
    />
  </svg>
);
export const NMSNetworkPlanningActiveIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#1773BE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M2.29 7.78v9.73c0 1.9 1.35 2.68 2.99 1.74l2.35-1.34c.51-.29 1.36-.32 1.89-.05l5.251 2.63c.53.26 1.38.24 1.89-.05l4.33-2.48c.55-.32 1.01-1.1 1.01-1.74V6.49c0-1.9-1.35-2.68-2.99-1.74l-2.35 1.34c-.51.29-1.36.32-1.89.05l-5.25-2.62c-.53-.26-1.38-.24-1.89.05L3.3 6.05c-.56.32-1.011 1.1-1.011 1.73ZM8.56 4v13M15.731 6.62V20"
    />
  </svg>
);
export const NMSReportIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M22.002 10v5c0 5-2 7-7 7H9C4 22 2 20 2 15V9c0-5 2-7 7-7h5.001"
    />
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M22.002 10h-4C15.001 10 14 9 14 6V2l8 8ZM7.001 13h6M7.001 17h4"
    />
  </svg>
);
export const GatewayManagementIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={31}
    fill="none"
    {...props}
  >
    <path fill="#000" d="M21.855 6.635H8.145v15.849h13.71V6.634Z" />
    <path
      fill="#fff"
      d="M21.71 6.769v15.58H8.29V6.77h13.42ZM22 6.5H8v16.118h14V6.5Z"
    />
    <path fill="#000" d="M8.146 22.505V6.658l11.988 1.84V24.34L8.146 22.505Z" />
    <path
      fill="#fff"
      d="m8.29 6.817 11.698 1.794v15.572L8.291 22.39V6.817ZM8 6.5v16.118L20.279 24.5V8.382L8 6.5Z"
    />
    <path fill="#000" d="m12.634 13.89-1.75.579L12.3 15.56" />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="m12.634 13.89-1.75.579L12.3 15.56"
    />
    <path fill="#000" d="m15.062 16.9 1.75-.579-1.416-1.089" />
    <path
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="m15.062 16.9 1.75-.579-1.416-1.089M15.062 13.184l-2.28 4.097"
    />
  </svg>
);
export const SettingIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)" opacity={0.6}>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M10.75 5.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Zm0-4.75c1.398 0 2.572.956 2.905 2.25H16v1.5H13.655a3.001 3.001 0 0 1-5.81 0H0V3h7.845A3.001 3.001 0 0 1 10.75.75ZM15.25 13H16v-1.5H8.155a3.001 3.001 0 0 0-5.81 0H0V13H2.345a3.001 3.001 0 0 0 5.81 0h7.095ZM7 12.251v-.002a1.75 1.75 0 1 0 0 .002Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const LogOutIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)" opacity={0.6}>
      <path
        fill="#000000FF"
        fillRule="evenodd"
        d="M2.5 13.5h4.25V15H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h4.75v1.5H2.5v11Zm9.94-6.25-1.97-1.97-.53-.53L11 3.69l.53.53 3.074 3.073a1 1 0 0 1 0 1.414L11.53 11.78l-.53.53-1.06-1.06.53-.53 1.97-1.97H5v-1.5h7.44Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#000000FF" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const UpIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m1 6.11 5.996-5 6.004 5M7 11.11V1M1 14.661h12"
    />
  </svg>
);
export const DownIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={15}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m13 5-5.996 5L1 5M7 0v10.11M1 13.661h12"
    />
  </svg>
);

export const RTCReportsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
      d="M9.333 1.513v2.753c0 .374 0 .56.073.703a.667.667 0 0 0 .291.291c.143.073.33.073.703.073h2.754M6 10h4m-.667-8.667H5.867c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874c-.218.428-.218.988-.218 2.108v6.933c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.427.218.988.218 2.108.218h4.266c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108V5.333l-4-4Z"
      opacity={0.8}
    />
  </svg>
);
export const PauseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#5C5C5C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M7.47 12.74V3.26c0-.9-.38-1.26-1.34-1.26H3.71c-.96 0-1.34.36-1.34 1.26v9.48c0 .9.38 1.26 1.34 1.26h2.42c.96 0 1.34-.36 1.34-1.26ZM14.37 12.74V3.26c0-.9-.38-1.26-1.34-1.26h-2.42c-.954 0-1.34.36-1.34 1.26v9.48c0 .9.38 1.26 1.34 1.26h2.42c.96 0 1.34-.36 1.34-1.26Z"
    />
  </svg>
);

export const MeterActionUnCollapseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={9}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M1.41 14.75 0 13.33 5.83 7.5 0 1.66 1.41.25 8.66 7.5l-7.25 7.25Z"
    />
  </svg>
);
export const SearchIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={22}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={2}
      d="M15.667 8c0 3.838-3.214 7-7.243 7-4.028 0-7.242-3.162-7.242-7s3.214-7 7.242-7c4.029 0 7.243 3.162 7.243 7Z"
    />
    <path
      stroke="#000"
      strokeWidth={2}
      d="M0-1h11.487"
      transform="matrix(.71759 .69647 -.71759 .69647 13.576 14)"
    />
  </svg>
);
export const FormControlDownIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={13}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m20 1-9.494 10L1 1"
    />
  </svg>
);
export const FormControlUpIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={13}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m1 12 9.494-10L20 12"
    />
  </svg>
);
export const MeterActionCollapseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={10}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M0 2.08 1.42.67 7.25 6.5 13.09.67l1.41 1.41-7.25 7.25L0 2.08Z"
    />
  </svg>
);
export const MeterEventsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={38}
    height={39}
    fill="none"
    {...props}
  >
    <path fill="#FFD3D3" d="M.5 1h37v37H.5z" />
    <path stroke="#000" d="M.5 1h37v37H.5z" />
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M19 17v7M19 24.483v1.4M9.035 28l9.966-17 9.965 17H9.036Z"
    />
  </svg>
);
export const MeterDetailUpIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="m19.87 14.18-8.52-8.52-8.52 8.52L0 11.35 11.35 0 22.7 11.35l-2.83 2.83Z"
    />
  </svg>
);
export const MeterDetailDownIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="m3.13.82 8.52 8.52L20.17.82 23 3.65 11.65 15 .3 3.65 3.13.82Z"
    />
  </svg>
);
export const UpdateIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={43}
    fill="none"
    {...props}
  >
    <path fill="#F6F6F6" d="M.5 1h41v41H.5z" />
    <path stroke="#000" d="M.5 1h41v41H.5z" />
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M31.287 31.67H10M13.21 24.427l-.68 4.763 4.763-.68 10.886-12.928-4.763-4.082-10.205 12.927Z"
    />
  </svg>
);
export const MeterNoApplyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    {...props}
  >
    <path fill="#82FF88" d="M.5.5h41v41H.5z" />
    <path stroke="#000" d="M.5.5h41v41H.5z" />
    <path stroke="#000" strokeWidth={2} d="m11.66 21.459 7 6L30.34 14.54" />
  </svg>
);
export const FirstPageIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={14}
    fill="none"
    {...props}
  >
    <path stroke="#000" strokeWidth={2} d="M7 13 2 7l5-6M12 13 7 7l5-6" />
  </svg>
);
export const NavigateBeforeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    cursor={"pointer"}
    {...props}
  >
    <path fill="#F6F6F6" d="M.5.5h23v23H.5z" />
    <path stroke="#000" d="M.5.5h23v23H.5z" />
    <path stroke="#000" strokeWidth={2} d="m14.5 18-5-6 5-6" />
  </svg>
);

export const NavigateBeforeDisableIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    style={{ cursor: "not-allowed" }}
    {...props}
  >
    <path fill="#F6F6F6" d="M.5.5h23v23H.5z" />
    <path stroke="#777" d="M.5.5h23v23H.5z" />
    <path stroke="#777" strokeWidth={2} d="m14.5 18-5-6 5-6" />
  </svg>
);

export const NavigateNextIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    cursor={"pointer"}
    {...props}
  >
    <path fill="#F6F6F6" d="M.5.5h23v23H.5z" />
    <path stroke="#000" d="M.5.5h23v23H.5z" />
    <path stroke="#000" strokeWidth={2} d="m9.5 6 5 6-5 6" />
  </svg>
);
export const NavigateNextDisableIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    style={{ cursor: "not-allowed" }}
    {...props}
  >
    <path fill="#F6F6F6" d="M.5.5h23v23H.5z" />
    <path stroke="#777" d="M.5.5h23v23H.5z" />
    <path stroke="#777" strokeWidth={2} d="m9.5 6 5 6-5 6" />
  </svg>
);
export const LastPageIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={14}
    fill="none"
    {...props}
  >
    <path stroke="#000" strokeWidth={2} d="m1 1 5 6-5 6M6 1l5 6-5 6" />
  </svg>
);

export const SearchFiltersIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={172}
    height={128}
    fill="none"
    {...props}
  >
    <circle cx={86} cy={64} r={64} fill="#E3EEFB" />
    <circle cx={20} cy={20} r={6} fill="#E3EEFB" />
    <circle cx={17} cy={112} r={8} fill="#E3EEFB" />
    <circle cx={160} cy={36} r={8} fill="#E3EEFB" />
    <circle cx={149} cy={9} r={5} fill="#E3EEFB" />
    <g filter="url(#a)">
      <rect width={56} height={56} x={58} y={36} fill="#1773BE" rx={28} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m96.5 74.5-4.083-4.083m2.916-7c0 5.477-4.44 9.916-9.916 9.916-5.477 0-9.917-4.44-9.917-9.916 0-5.477 4.44-9.917 9.917-9.917 5.477 0 9.916 4.44 9.916 9.917Z"
      />
    </g>
    <defs>
      <filter
        id="a"
        width={72}
        height={72}
        x={50}
        y={28}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={4} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_639_537"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_639_537"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export const ColumnsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#09090B"
      fillRule="evenodd"
      d="M6.245 2.5H14.5v10a1 1 0 0 1-1 1H6.245v-11Zm-1.25 0H1.5v10a1 1 0 0 0 1 1h2.495v-11ZM0 1h16v11.5a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 0 12.5V1Z"
      clipRule="evenodd"
    />
  </svg>
);
export const PayloadIcon = (props: any) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_682_19456)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.5 4.875C1.5 3.01104 3.01104 1.5 4.875 1.5C6.20018 1.5 7.34838 2.26364 7.901 3.37829C8.1902 3.96162 8.79547 4.5 9.60112 4.5H12.25C13.4926 4.5 14.5 5.50736 14.5 6.75C14.5 7.42688 14.202 8.03329 13.7276 8.44689L13.1622 8.93972L14.1479 10.0704L14.7133 9.57758C15.5006 8.89123 16 7.8785 16 6.75C16 4.67893 14.3211 3 12.25 3H9.60112C9.51183 3 9.35322 2.93049 9.2449 2.71201C8.44888 1.1064 6.79184 0 4.875 0C2.18261 0 0 2.18261 0 4.875V6.40385C0 7.69502 0.598275 8.84699 1.52982 9.59656L2.11415 10.0667L3.0545 8.89808L2.47018 8.42791C1.87727 7.95083 1.5 7.22166 1.5 6.40385V4.875ZM7.29289 7.39645C7.68342 7.00592 8.31658 7.00592 8.70711 7.39645L11.7803 10.4697L12.3107 11L11.25 12.0607L10.7197 11.5303L8.75 9.56066V15.25V16H7.25V15.25V9.56066L5.28033 11.5303L4.75 12.0607L3.68934 11L4.21967 10.4697L7.29289 7.39645Z"
        fill="#545454"
      />
    </g>
    <defs>
      <clipPath id="clip0_682_19456">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const TimeTravelledIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#545454"
        fillRule="evenodd"
        d="M5.35 2.062a6.453 6.453 0 0 1 1.974-.527L7.169.043a7.953 7.953 0 0 0-2.43.65l.612 1.37Zm3.327-.527a6.501 6.501 0 1 1-7.142 7.142l-1.492.154A8.001 8.001 0 1 0 8.83.043l-.154 1.492ZM2.74 4.18a6.542 6.542 0 0 1 1.44-1.44l-.882-1.214a8.042 8.042 0 0 0-1.771 1.771l1.213.883ZM1.535 7.323c.072-.696.254-1.36.527-1.972L.693 4.739a7.953 7.953 0 0 0-.65 2.43l1.492.154ZM8.75 4.75V4h-1.5v3.875a1 1 0 0 0 .4.8l1.9 1.425.6.45.9-1.2-.6-.45-1.7-1.275V4.75Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const SourceEndPointIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#545454"
        fillRule="evenodd"
        d="M11.525 10.263 8 13.858l-3.525-3.595c-1.967-2.004-1.967-5.267 0-7.272a4.912 4.912 0 0 1 7.05 0c1.967 2.005 1.967 5.268 0 7.272Zm1.071 1.05L9.051 14.93 8 16l-1.05-1.071-3.546-3.615C.865 8.726.865 4.529 3.404 1.94a6.412 6.412 0 0 1 9.192 0c2.539 2.588 2.539 6.785 0 9.373ZM9 6.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM8 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const RecievedOnIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#545454"
        fillRule="evenodd"
        d="M14.5 8a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM8.75 4.75V4h-1.5v3.875a1 1 0 0 0 .4.8l1.9 1.425.6.45.9-1.2-.6-.45-1.7-1.275V4.75Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const CalendarIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#000"
        fillRule="evenodd"
        d="M5.5.5V2h5V.5H12V2h3.5v11.5A2.5 2.5 0 0 1 13 16H3a2.5 2.5 0 0 1-2.5-2.5V2H4V.5h1.5ZM2 3.5h12V6H2V3.5Zm0 4v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-6H2Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const RawDataIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#545454"
        fillRule="evenodd"
        d="M1.5 6.5a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm5-6.5a6.5 6.5 0 1 0 4.035 11.596l3.435 3.434.53.53 1.06-1.06-.53-.53-3.434-3.435A6.5 6.5 0 0 0 6.5 0Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const NMSIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m8 6 13 .001m-13 6h13m-13 6h13M3.5 6h.01m-.01 6h.01m-.01 6h.01M4 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm0 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
    />
  </svg>
);
export const NMSDashboardIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    viewBox="0 -0.5 25 25"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.918 10H7.082A1.57 1.57 0 0 0 5.5 11.556v5.89A1.569 1.569 0 0 0 7.082 19h2.836a1.569 1.569 0 0 0 1.582-1.555v-5.889a1.569 1.569 0 0 0-1.582-1.555ZM9.918 4H7.082A1.54 1.54 0 0 0 5.5 5.495v1.014A1.54 1.54 0 0 0 7.082 8h2.836A1.54 1.54 0 0 0 11.5 6.508V5.494A1.54 1.54 0 0 0 9.918 4ZM15.082 13h2.835a1.57 1.57 0 0 0 1.583-1.555V5.557A1.569 1.569 0 0 0 17.918 4h-2.836A1.57 1.57 0 0 0 13.5 5.557v5.888A1.569 1.569 0 0 0 15.082 13ZM15.082 19h2.835a1.54 1.54 0 0 0 1.583-1.492v-1.014A1.54 1.54 0 0 0 17.918 15h-2.836a1.54 1.54 0 0 0-1.582 1.493v1.013A1.54 1.54 0 0 0 15.082 19Z"
      clipRule="evenodd"
    />
  </svg>
);
export const NMSLinksIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M15.197 3.355c1.673-1.68 4.25-1.816 5.757-.305 1.506 1.512 1.37 4.1-.303 5.78l-2.424 2.433M10.047 14c-1.507-1.512-1.37-4.1.302-5.779L12.5 6.062"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M13.954 10c1.506 1.512 1.37 4.1-.303 5.779l-2.424 2.433-2.424 2.433c-1.673 1.68-4.25 1.816-5.757.305-1.506-1.512-1.37-4.1.303-5.78l2.424-2.433"
    />
  </svg>
);
export const NMSMapIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5.7 15c-1.666.635-2.7 1.52-2.7 2.5 0 1.933 4.03 3.5 9 3.5s9-1.567 9-3.5c0-.98-1.034-1.865-2.7-2.5M12 9h.01M18 9c0 4.064-4.5 6-6 9-1.5-3-6-4.936-6-9a6 6 0 1 1 12 0Zm-5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    />
  </svg>
);
export const NMSBackIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M19 12H5M12 19l-7-7 7-7"
    />
  </svg>
);
export const NMSTopologyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 -1 24 24"
    {...props}
  >
    <path
      fill="#fff"
      d="M8 1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-2v3h7a2 2 0 0 1 2 2v3h-2v-3h-7v3h-2v-3H4v3H2v-3a2 2 0 0 1 2-2h7V6H9a1 1 0 0 1-1-1V1zM0 17a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-4zM10 16a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4zM19 16a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4z"
    />
  </svg>
);
export const ThreeDotsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    className="bi bi-three-dots-vertical"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#333"
      d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
    />
  </svg>
);

export const EyeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    {...props}
  >
    <path fill="#fff" d="M.5.5h41v41H.5z" />
    <path stroke="#000" d="M.5.5h41v41H.5z" />
    <path
      stroke="#000"
      d="M21 12c-8 0-13.333 6-15 9 1.667 3 7 9 15 9s13.333-6 15-9c-1.667-3-7-9-15-9Z"
    />
    <ellipse cx={21} cy={21} stroke="#000" rx={7} ry={6} />
    <circle cx={21} cy={21} r={3} fill="#000" />
  </svg>
);
export const EyesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#ff0000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    />
    <path
      stroke="#ff0000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12.001 5C7.524 5 3.733 7.943 2.46 12c1.274 4.057 5.065 7 9.542 7 4.478 0 8.268-2.943 9.542-7-1.274-4.057-5.064-7-9.542-7Z"
    />
  </svg>
);
export const InfoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={19}
    fill="none"
    {...props}
  >
    <path stroke="#000" d="M9.5 17a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z" />
    <path
      fill="#000"
      d="M10.17 7.36a.465.465 0 0 1-.343-.137.546.546 0 0 1-.123-.356.6.6 0 0 1 .206-.453.65.65 0 0 1 .452-.192c.147 0 .265.046.357.137a.45.45 0 0 1 .137.33c0 .173-.069.329-.206.466a.658.658 0 0 1-.48.206ZM9.06 12.93c-.339 0-.577-.096-.714-.288a1.189 1.189 0 0 1-.205-.686c0-.137.013-.274.04-.412.037-.146.078-.278.124-.397l.92-2.345a.559.559 0 0 0 .04-.192.39.39 0 0 0-.068-.234 7.161 7.161 0 0 0-.096-.15l.754-.028c.137-.009.233.01.288.055.064.037.096.082.096.137 0 .055-.032.156-.096.302l-1.138 2.674-.083.178c-.045.11-.073.183-.082.22a7.713 7.713 0 0 1-.069.329v.11c0 .119.028.22.083.301.064.083.169.124.315.124a.77.77 0 0 0 .316-.082.917.917 0 0 0 .26-.165 4.73 4.73 0 0 0 .672-.933c.229-.393.44-.781.631-1.165.037-.092.082-.137.137-.137.046 0 .069.032.069.096a.525.525 0 0 1-.041.164l-.343.713a6.8 6.8 0 0 1-.494.85 3.176 3.176 0 0 1-.603.686c-.22.183-.458.275-.714.275Z"
    />
  </svg>
);
export const NMSInfoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={19}
    fill="none"
    {...props}
  >
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.313}
      d="M9 17c4.125 0 7.5-3.375 7.5-7.5S13.125 2 9 2 1.5 5.375 1.5 9.5 4.875 17 9 17ZM9 6.5v3.75M8.996 12.5h.006"
    />
  </svg>
);
export const EditIcon = (props) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z"
      stroke="#000000"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13"
      stroke="#000000"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const RequestDataIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={19}
    viewBox="0 0 512 512"
    {...props}
  >
    <title>{"ionicons-v5-d"}</title>
    <circle
      cx={128}
      cy={416}
      r={48}
      style={{
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 32
      }}
    />
    <path
      d="M128 144v224M288 160l-64-64 64-64"
      style={{
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 32
      }}
    />
    <circle
      cx={128}
      cy={96}
      r={48}
      style={{
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 32
      }}
    />
    <circle
      cx={384}
      cy={416}
      r={48}
      style={{
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 32
      }}
    />
    <path
      d="M240 96h84a60 60 0 0 1 60 60v212"
      style={{
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 32
      }}
    />
  </svg>
);

export const ConnectIcons = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    className="icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="#5c5c5c"
      d="M214.192 770.757c-12.267 0-24.606-1.612-36.778-4.872-37.442-10.028-68.692-34.357-87.982-68.51l-6.396-11.333c-39.31-69.589-15.768-158.979 52.473-199.258L423.311 316.93c33.067-19.523 71.682-24.81 108.622-14.913 37.441 10.028 68.677 34.365 87.967 68.518l6.382 11.297c39.316 69.618 15.781 159.015-52.458 199.286l-25.467 15.024-30.368-51.444 25.466-15.032c40.411-23.848 54.231-76.977 30.813-118.445l-6.381-11.296c-11.348-20.084-29.601-34.357-51.415-40.199-21.354-5.725-43.649-2.633-62.792 8.65l-287.802 169.86c-40.411 23.848-54.231 76.977-30.82 118.438L141.453 668c11.334 20.064 29.596 34.336 51.415 40.178 21.354 5.71 43.655 2.654 62.785-8.657l64.28-37.939 30.368 51.445-64.28 37.937c-22.179 13.099-46.843 19.793-71.829 19.793z"
    />
    <path
      fill="#5c5c5c"
      d="M528.854 726.86c-12.267 0-24.613-1.612-36.794-4.87-37.434-10.028-68.67-34.365-87.959-68.518l-6.39-11.312c-39.309-69.603-15.774-158.994 52.458-199.266l25.467-15.03c14.229-8.379 32.534-3.661 40.907 10.539 8.387 14.206 3.668 32.526-10.539 40.905l-25.467 15.031c-40.402 23.847-54.222 76.985-30.806 118.444l6.382 11.312c11.341 20.069 29.594 34.343 51.408 40.184 21.347 5.733 43.655 2.654 62.8-8.657L858.124 485.77c40.411-23.847 54.231-76.977 30.813-118.43l-6.396-11.332c-11.333-20.064-29.588-34.329-51.401-40.17-21.347-5.718-43.657-2.647-62.8 8.649l-64.28 37.937c-14.222 8.417-32.52 3.683-40.906-10.537-8.387-14.207-3.668-32.527 10.539-40.906l64.28-37.938c33.067-19.532 71.624-24.833 108.628-14.923 37.435 10.036 68.679 34.365 87.961 68.518l6.395 11.326c39.316 69.589 15.783 158.98-52.466 199.259l-287.8 169.852c-22.186 13.091-46.85 19.785-71.837 19.785z"
    />
  </svg>
);

export const DisConnectIcons = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    className="icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="#5c5c5c"
      d="M832.6 191.4c-84.6-84.6-221.5-84.6-306 0l-96.9 96.9 51 51 96.9-96.9c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204l-96.9 96.9 51.1 51.1 96.9-96.9c84.4-84.6 84.4-221.5-.1-306.1zM446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l96.9-96.9-51.1-51.1-96.9 96.9c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l96.9-96.9-51-51-96.8 97zM260.3 209.4a8.03 8.03 0 0 0-11.3 0L209.4 249a8.03 8.03 0 0 0 0 11.3l554.4 554.4c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L260.3 209.4z"
    />
  </svg>
);
export const BarsIcons = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#333"
      d="M19 12.75H5a.75.75 0 1 1 0-1.5h14a.75.75 0 1 1 0 1.5ZM19 8.25H5a.75.75 0 0 1 0-1.5h14a.75.75 0 1 1 0 1.5ZM19 17.25H5a.75.75 0 1 1 0-1.5h14a.75.75 0 1 1 0 1.5Z"
    />
  </svg>
);
export const DashboardStarIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={173}
    height={114}
    fill="none"
    style={{ marginBottom: "-16px" }}
    {...props}
  >
    <path
      fill="#000"
      d="M0 113.25s17.712-84.439 158.322-90.88c0 0-127.827 20.03-129.44 90.88H0Z"
    />
    <path
      fill="#000"
      d="m152.052 0 3.427 11.603a5.513 5.513 0 0 0 5.424 3.942L173 15.222l-9.98 6.845a5.486 5.486 0 0 0-2.067 6.372l4.043 11.401-9.597-7.37a5.492 5.492 0 0 0-6.704 0l-9.597 7.37 4.042-11.402a5.5 5.5 0 0 0-2.067-6.37l-9.98-6.846 12.097.323a5.501 5.501 0 0 0 5.424-3.942L152.042 0h.01Z"
    />
  </svg>
);
export const DashboardMeterIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={58}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M31.324 0H8.676C3.884 0 0 3.799 0 8.484v41.032C0 54.202 3.884 58 8.676 58h22.648C36.116 58 40 54.202 40 49.516V8.484C40 3.8 36.116 0 31.324 0Z"
    />
  </svg>
);
export const DashboardRocketIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={67}
    height={83}
    fill="none"
    {...props}
  >
    <g fill="#000" clipPath="url(#a)">
      <path d="m11.94 36.95 35.7 26.29 7.16-8.92-4.25-11.01S69.86 21.33 66.53.03c0 0-18.51-2.01-36.62 29.62l-12.82-1.52-5.15 8.82ZM19.26 47.12 0 55.4l12.89 2.3L0 76.42l19.26-9.08-2.71 15.32 11.67-13.15 3.39 12.34 5.49-20.76-17.84-13.97Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h66.91v82.66H0z" />
      </clipPath>
    </defs>
  </svg>
);
export const PinEventIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={43}
    height={42}
    fill="none"
    {...props}
  >
    <path fill="#99E2FC" d="M1 .5h41v41H1z" />
    <path stroke="#000" d="M1 .5h41v41H1z" />
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M30.5 7.438h-19M14.25 6.688v19M27.75 25.688v-19M21.25 25.313v11M11.5 24.938h19"
    />
  </svg>
);
export const CloseIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    {/* <path fill="#fff" d="M.5.5h41v41H.5z" />
  <path stroke="#000" d="M.5.5h41v41H.5z" /> */}
    <path stroke="#000" strokeWidth={2} d="M18 6 6 18M6 6l12 12" />
  </svg>
);
export const NMSUploadIcon = (props: any) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.50016 14.1665V9.1665L5.8335 10.8332"
      stroke="#1773BE"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.5 9.1665L9.16667 10.8332"
      stroke="#1773BE"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.3332 8.33317V12.4998C18.3332 16.6665 16.6665 18.3332 12.4998 18.3332H7.49984C3.33317 18.3332 1.6665 16.6665 1.6665 12.4998V7.49984C1.6665 3.33317 3.33317 1.6665 7.49984 1.6665H11.6665"
      stroke="#1773BE"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.3332 8.33317H14.9998C12.4998 8.33317 11.6665 7.49984 11.6665 4.99984V1.6665L18.3332 8.33317Z"
      stroke="#1773BE"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const FileFormatIcon = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1432_303275)">
      <path
        d="M3.23213 1.04014e-05C3.07595 -0.000657214 2.92129 0.0308203 2.77779 0.0924848C2.6343 0.154149 2.50502 0.244682 2.39801 0.35845C2.17932 0.582927 2.05176 0.880598 2.04005 1.19377V22.6956C2.03934 22.8519 2.07075 23.0067 2.13232 23.1504C2.1939 23.2941 2.28433 23.4236 2.39801 23.5309C2.50619 23.6432 2.63569 23.7327 2.77893 23.7943C2.92216 23.8558 3.07624 23.8881 3.23213 23.8894H20.7244C20.8806 23.8899 21.0352 23.8584 21.1787 23.7968C21.3222 23.7351 21.4515 23.6446 21.5585 23.5309C21.6704 23.4222 21.7597 23.2925 21.8211 23.1491C21.8825 23.0057 21.915 22.8516 21.9165 22.6956V6.76681L15.1577 1.04014e-05H3.23213Z"
        fill="#1ABF74"
      />
      <path
        d="M21.916 6.7668H16.3509C15.6988 6.7512 15.1737 6.22596 15.1572 5.57304V0L21.916 6.7668Z"
        fill="#76D9AC"
      />
      <path
        d="M5.81577 8.55909H10.9842C11.1373 8.55112 11.2814 8.48468 11.387 8.37347C11.4925 8.26226 11.5512 8.11479 11.5512 7.96149C11.5513 7.80815 11.4925 7.66063 11.387 7.54939C11.2814 7.43816 11.1372 7.37171 10.984 7.36377H5.81577C5.66266 7.37171 5.51844 7.43814 5.4129 7.54935C5.30736 7.66056 5.24856 7.80805 5.24865 7.96137C5.24856 8.11469 5.30736 8.26218 5.4129 8.37339C5.51844 8.4846 5.66266 8.55103 5.81577 8.55897V8.55909ZM5.81577 12.5394H18.1398C18.2181 12.5393 18.2956 12.5238 18.368 12.4938C18.4403 12.4638 18.5061 12.4198 18.5614 12.3644C18.6168 12.309 18.6607 12.2432 18.6906 12.1708C18.7205 12.0984 18.7359 12.0208 18.7358 11.9425C18.7359 11.8642 18.7205 11.7866 18.6906 11.7142C18.6607 11.6418 18.6168 11.576 18.5614 11.5206C18.5061 11.4652 18.4403 11.4212 18.368 11.3912C18.2956 11.3611 18.2181 11.3457 18.1398 11.3456H5.81577C5.73744 11.3457 5.65988 11.3611 5.58753 11.3912C5.51519 11.4212 5.44946 11.4652 5.39411 11.5206C5.33876 11.576 5.29487 11.6418 5.26495 11.7142C5.23503 11.7866 5.21966 11.8642 5.21973 11.9425C5.21966 12.0208 5.23503 12.0984 5.26495 12.1708C5.29487 12.2432 5.33876 12.309 5.39411 12.3644C5.44946 12.4198 5.51519 12.4638 5.58753 12.4938C5.65988 12.5238 5.73744 12.5393 5.81577 12.5394ZM18.1398 15.3258H5.81577C5.66266 15.3337 5.51844 15.4001 5.4129 15.5113C5.30736 15.6226 5.24856 15.7701 5.24865 15.9234C5.24853 16.0767 5.30732 16.2242 5.41286 16.3355C5.5184 16.4467 5.66263 16.5131 5.81577 16.5211H18.1398C18.2929 16.5131 18.4371 16.4467 18.5426 16.3355C18.6482 16.2243 18.707 16.0768 18.7069 15.9235C18.707 15.7702 18.6482 15.6227 18.5426 15.5115C18.4371 15.4003 18.2929 15.3338 18.1398 15.3259V15.3258Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1432_303275">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DashboardFlashIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={59}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M7.991 0H41.1l-7.446 21.654H48L7.991 59l5.246-24.631H0L7.991 0Z"
    />
  </svg>
);
export const DashboardDotIcon = (props: any) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6.5" cy="7" r="6.5" fill="black" />
  </svg>
);
export const PencilIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={31}
    height={31}
    fill="none"
    {...props}
  >
    <path fill="#F6F6F6" d="M1 1h29v29H1z" />
    <path stroke="#000" d="M1 1h29v29H1zM23.5 23.08h-16" />
    <path
      stroke="#000"
      d="m9.914 17.636-.512 3.58 3.58-.511 8.182-9.717-3.58-3.068-7.67 9.716Z"
    />
  </svg>
);
export const UpdatesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      d="M16.5 16.08H.5M2.914 10.636l-.512 3.58 3.58-.511 8.182-9.717L10.584.92l-7.67 9.716Z"
    />
  </svg>
);
export const DeleteIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={31}
    height={31}
    fill="none"
    {...props}
  >
    <path fill="#fff" d="M1 1h29v29H1z" />
    <path stroke="#000" d="M1 1h29v29H1zM23.121 9.286H7.883" />
    <path stroke="#000" d="m11.895 9.405.902-1.905h5.413l.903 1.905" />
    <path stroke="#000" d="M9.488 9.023 10.29 23.5h10.426l.802-14.477" />
  </svg>
);
export const RightArrowIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={14}
    fill="none"
    {...props}
  >
    <path stroke="#000" strokeWidth={2} d="m1.5 1 5 6-5 6" />
  </svg>
);
export const LeftArrowIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={14}
    fill="none"
    {...props}
  >
    <path stroke="#000" strokeWidth={2} d="m6.5 13-5-6 5-6" />
  </svg>
);

export const DownArrowIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={13}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m20 1-9.494 10L1 1"
    />
  </svg>
);

export const TickIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={16}
    fill="none"
    {...props}
  >
    <path stroke="#000" strokeWidth={2} d="m.66 8.459 7 6L19.34 1.54" />
  </svg>
);
export const ClearIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    viewBox="0 0 32 32"
    {...props}
  >
    <path d="m7.004 23.087 7.08-7.081-7.07-7.071L8.929 7.02l7.067 7.069L23.084 7l1.912 1.913-7.089 7.093 7.075 7.077-1.912 1.913-7.074-7.073L8.917 25z" />
  </svg>
);
export const RightTableIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={15}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m6.008.806 5.578 6.69-5.578 6.698M.43 7.499h11.28"
    />
  </svg>
);
export const RefreshIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="square"
      strokeWidth={1.5}
      d="M2.6 3.998c.666-.667 2.6-2 5-2 3 0 6.5 2 6.5 6.5s-3.5 6.5-6.5 6.5-6.5-2.5-6.5-6.5"
    />
    <path
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m5.231 5.31-3.629-.646L2.029 1"
    />
  </svg>
);
export const ClockIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="square"
      strokeWidth={1.5}
      d="M8.188 8.783c.946-.953 3.688-2.858 7.092-2.858 4.255 0 9.22 2.858 9.22 9.288S19.535 24.5 15.28 24.5c-4.255 0-9.22-3.572-9.22-9.287"
    />
    <path
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m11.92 10.658-5.147-.922.605-5.236"
    />
    <path stroke="#000" strokeWidth={1.5} d="M15.4 9.378v6.76l3.5 3.24" />
  </svg>
);
export const PlusIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 12h12m-6-6v12"
    />
  </svg>
);
export const RemoveIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 12h12"
    />
  </svg>
);

export const NoRecordsFoundIcon = (props) => (
  <svg
    width="39"
    height="38"
    viewBox="0 0 39 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1" y="0.5" width="37" height="37" fill="#FFD3D3"></rect>
    <rect x="1" y="0.5" width="37" height="37" stroke="black"></rect>
    <path d="M19.499 16.9492V23.3975" stroke="black" stroke-width="1.5"></path>
    <path
      d="M19.499 23.9844L19.499 25.1568"
      stroke="black"
      stroke-width="1.5"
    ></path>
    <path
      d="M9.53418 27.5L19.4997 10.5L29.4652 27.5H9.53418Z"
      stroke="black"
      stroke-width="1.5"
    ></path>
  </svg>
);

export const UploadIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={350} // New width
    height={350} // Adjust height if necessary
    viewBox="0 0 374 400" // Add or adjust this line
    fill="none"
    style={{ marginTop: "15px" }}
    {...props}
  >
    <path fill="#F1F2F2" d="M.5.5h373v399H.5z" />
    <path stroke="#000" d="M.5.5h373v399H.5z" />
    <path fill="#D1EEFA" stroke="#000" d="M122.5 128.5h152v102h-152z" />
    <path
      fill="#FFD3D3"
      stroke="#000"
      d="M275 161c-59.659 9.032-87.524 50.43-94 70h94v-70Z"
    />
    <path fill="#99E2FC" stroke="#000" d="M209.5 128.5h65v15h-65z" />
    <path fill="#D1EEFA" stroke="#000" d="M99.5 109.5h152v102h-152z" />
    <path
      fill="#5FCAE7"
      stroke="#000"
      d="M224.582 149 190 176.623l31.5 34.877h30V177l-26.918-28Z"
    />
    <circle cx={195.5} cy={135.5} r={9} fill="#82FF88" stroke="#000" />
    <path
      fill="#5FCAE7"
      stroke="#000"
      d="m150 131.5-50.5 48v32h122l-71.5-80Z"
    />
    <path
      fill="#000"
      d="M120.907 276.35h3.42c1.67 0 2.955.465 3.855 1.395.9.92 1.35 2.235 1.35 3.945 0 1.7-.445 3.01-1.335 3.93-.88.92-2.14 1.38-3.78 1.38h-3.51v-10.65Zm3.42 9.165c2.35 0 3.525-1.275 3.525-3.825 0-1.3-.295-2.265-.885-2.895-.58-.64-1.46-.96-2.64-.96h-1.8v7.68h1.8Zm6.742-6.495h1.455l.045 1.515c.15-.52.38-.9.69-1.14.31-.25.715-.375 1.215-.375h.765v1.425h-.765c-.61 0-1.065.15-1.365.45-.3.3-.45.765-.45 1.395V287h-1.59v-7.98Zm7.817 8.16c-.84 0-1.505-.19-1.995-.57-.49-.39-.735-.925-.735-1.605 0-.68.205-1.215.615-1.605.41-.39 1.055-.67 1.935-.84l2.745-.525c0-1.23-.57-1.845-1.71-1.845-.99 0-1.59.445-1.8 1.335l-1.65-.105c.15-.8.525-1.43 1.125-1.89.61-.46 1.385-.69 2.325-.69 1.07 0 1.885.29 2.445.87.57.57.855 1.375.855 2.415v3.105c0 .19.035.325.105.405.07.07.18.105.33.105h.285V287c-.1.03-.295.045-.585.045-.47 0-.835-.1-1.095-.3-.26-.2-.425-.525-.495-.975-.2.42-.545.76-1.035 1.02-.49.26-1.045.39-1.665.39Zm.27-1.26c.7 0 1.255-.2 1.665-.6.42-.4.63-.925.63-1.575v-.51l-2.325.45c-.47.09-.81.23-1.02.42-.2.19-.3.44-.3.75 0 .34.115.605.345.795.24.18.575.27 1.005.27Zm9.348 3.51c-.94 0-1.715-.21-2.325-.63-.6-.41-.985-.965-1.155-1.665l1.65-.105c.11.36.305.63.585.81.29.18.705.27 1.245.27 1.36 0 2.04-.565 2.04-1.695v-1.155c-.2.41-.51.735-.93.975-.41.24-.875.36-1.395.36-.66 0-1.255-.16-1.785-.48-.52-.33-.925-.79-1.215-1.38-.29-.59-.435-1.26-.435-2.01 0-.75.145-1.42.435-2.01.29-.59.69-1.05 1.2-1.38a3.206 3.206 0 0 1 1.755-.495c.56 0 1.055.13 1.485.39.44.26.755.61.945 1.05v-1.26h1.545v7.35c0 .97-.325 1.72-.975 2.25-.65.54-1.54.81-2.67.81Zm-.03-4.185c.64 0 1.145-.23 1.515-.69.38-.46.57-1.09.57-1.89 0-.76-.19-1.36-.57-1.8-.38-.45-.885-.675-1.515-.675-.64 0-1.14.225-1.5.675-.36.45-.54 1.065-.54 1.845s.18 1.4.54 1.86c.37.45.87.675 1.5.675Zm11.843 1.935c-.84 0-1.505-.19-1.995-.57-.49-.39-.735-.925-.735-1.605 0-.68.205-1.215.615-1.605.41-.39 1.055-.67 1.935-.84l2.745-.525c0-1.23-.57-1.845-1.71-1.845-.99 0-1.59.445-1.8 1.335l-1.65-.105c.15-.8.525-1.43 1.125-1.89.61-.46 1.385-.69 2.325-.69 1.07 0 1.885.29 2.445.87.57.57.855 1.375.855 2.415v3.105c0 .19.035.325.105.405.07.07.18.105.33.105h.285V287c-.1.03-.295.045-.585.045-.47 0-.835-.1-1.095-.3-.26-.2-.425-.525-.495-.975-.2.42-.545.76-1.035 1.02-.49.26-1.045.39-1.665.39Zm.27-1.26c.7 0 1.255-.2 1.665-.6.42-.4.63-.925.63-1.575v-.51l-2.325.45c-.47.09-.81.23-1.02.42-.2.19-.3.44-.3.75 0 .34.115.605.345.795.24.18.575.27 1.005.27Zm6.166-6.9h1.455l.045 1.38c.2-.52.51-.91.93-1.17.43-.26.925-.39 1.485-.39.87 0 1.535.28 1.995.84.47.56.705 1.29.705 2.19V287h-1.59v-4.65c0-.72-.125-1.26-.375-1.62-.24-.37-.63-.555-1.17-.555-.57 0-1.03.19-1.38.57-.34.38-.51.915-.51 1.605V287h-1.59v-7.98Zm11.537 8.16c-.68 0-1.275-.17-1.785-.51-.5-.34-.885-.82-1.155-1.44-.27-.63-.405-1.37-.405-2.22 0-.84.135-1.575.405-2.205.27-.63.655-1.115 1.155-1.455.51-.34 1.105-.51 1.785-.51.55 0 1.04.115 1.47.345.43.23.75.55.96.96v-3.795h1.59V287h-1.47l-.045-1.2c-.22.43-.555.77-1.005 1.02-.44.24-.94.36-1.5.36Zm.42-1.38c.64 0 1.135-.245 1.485-.735.35-.49.525-1.175.525-2.055 0-.89-.175-1.575-.525-2.055-.35-.49-.845-.735-1.485-.735-.65 0-1.165.25-1.545.75-.38.49-.57 1.17-.57 2.04 0 .85.19 1.53.57 2.04.39.5.905.75 1.545.75Zm12.398 1.38c-.68 0-1.275-.17-1.785-.51-.5-.34-.885-.82-1.155-1.44-.27-.63-.405-1.37-.405-2.22 0-.84.135-1.575.405-2.205.27-.63.655-1.115 1.155-1.455.51-.34 1.105-.51 1.785-.51.55 0 1.04.115 1.47.345.43.23.75.55.96.96v-3.795h1.59V287h-1.47l-.045-1.2c-.22.43-.555.77-1.005 1.02-.44.24-.94.36-1.5.36Zm.42-1.38c.64 0 1.135-.245 1.485-.735.35-.49.525-1.175.525-2.055 0-.89-.175-1.575-.525-2.055-.35-.49-.845-.735-1.485-.735-.65 0-1.165.25-1.545.75-.38.49-.57 1.17-.57 2.04 0 .85.19 1.53.57 2.04.39.5.905.75 1.545.75Zm5.664-6.78h1.455l.045 1.515c.15-.52.38-.9.69-1.14.31-.25.715-.375 1.215-.375h.765v1.425h-.765c-.61 0-1.065.15-1.365.45-.3.3-.45.765-.45 1.395V287h-1.59v-7.98Zm8.809 8.16c-.76 0-1.425-.17-1.995-.51a3.488 3.488 0 0 1-1.335-1.455c-.31-.63-.465-1.365-.465-2.205 0-.84.155-1.575.465-2.205.32-.63.765-1.115 1.335-1.455.57-.34 1.235-.51 1.995-.51.75 0 1.41.175 1.98.525.58.34 1.025.825 1.335 1.455.31.62.465 1.35.465 2.19 0 .84-.155 1.575-.465 2.205a3.478 3.478 0 0 1-1.335 1.455c-.57.34-1.23.51-1.98.51Zm0-1.38c.67 0 1.19-.245 1.56-.735.38-.49.57-1.175.57-2.055 0-.88-.19-1.565-.57-2.055-.37-.49-.89-.735-1.56-.735s-1.195.245-1.575.735c-.38.49-.57 1.175-.57 2.055 0 .88.19 1.565.57 2.055.38.49.905.735 1.575.735Zm5.474-6.78h1.5l.03 1.215c.23-.45.555-.795.975-1.035.42-.24.9-.36 1.44-.36.75 0 1.38.185 1.89.555.52.37.905.87 1.155 1.5s.375 1.335.375 2.115c0 .77-.13 1.47-.39 2.1-.25.63-.63 1.135-1.14 1.515-.51.37-1.14.555-1.89.555-.52 0-.99-.11-1.41-.33a2.29 2.29 0 0 1-.945-.93v3.33h-1.59v-10.23Zm3.66 6.78c.64 0 1.14-.245 1.5-.735.37-.5.555-1.185.555-2.055 0-.87-.185-1.55-.555-2.04-.36-.5-.86-.75-1.5-.75-.65 0-1.16.24-1.53.72-.36.47-.54 1.16-.54 2.07 0 .91.18 1.605.54 2.085.37.47.88.705 1.53.705Zm9.967-7.29c0-.68.19-1.21.57-1.59.38-.38.955-.57 1.725-.57h1.41v1.305h-1.2c-.61 0-.915.315-.915.945v.525h1.995v1.29h-1.995V287h-1.59v-6.585h-1.11v-1.29h1.11v-.615Zm5.415.51h1.59V287h-1.59v-7.98Zm-.03-2.745h1.665v1.59h-1.665v-1.59ZM236.11 287c-.55 0-.98-.14-1.29-.42-.31-.28-.465-.705-.465-1.275l.015-8.955h1.59v8.805c0 .36.18.54.54.54h.645V287h-1.035Zm5.911.18c-.76 0-1.425-.17-1.995-.51a3.49 3.49 0 0 1-1.32-1.47c-.31-.63-.465-1.36-.465-2.19 0-.83.15-1.56.45-2.19.31-.63.745-1.115 1.305-1.455.57-.35 1.23-.525 1.98-.525.73 0 1.37.17 1.92.51.55.33.975.815 1.275 1.455.31.63.465 1.385.465 2.265v.405h-5.73c.04.77.245 1.355.615 1.755.37.39.875.585 1.515.585.46 0 .845-.105 1.155-.315.32-.22.545-.52.675-.9l1.65.105c-.21.75-.63 1.35-1.26 1.8-.62.45-1.365.675-2.235.675Zm1.92-4.905c-.04-.69-.235-1.21-.585-1.56-.35-.35-.81-.525-1.38-.525-.57 0-1.035.18-1.395.54-.36.36-.585.875-.675 1.545h4.035Zm6.513 4.905c-1.09 0-1.945-.245-2.565-.735-.62-.49-.96-1.145-1.02-1.965l1.65-.075c.15.96.795 1.44 1.935 1.44.51 0 .905-.08 1.185-.24a.831.831 0 0 0 .435-.765c0-.21-.05-.375-.15-.495-.1-.13-.285-.24-.555-.33-.27-.1-.67-.195-1.2-.285-.79-.14-1.41-.315-1.86-.525-.45-.21-.77-.465-.96-.765-.19-.3-.285-.675-.285-1.125 0-.75.28-1.35.84-1.8.56-.45 1.345-.675 2.355-.675.97 0 1.74.245 2.31.735.57.49.915 1.12 1.035 1.89l-1.635.09c-.08-.43-.27-.765-.57-1.005-.29-.25-.675-.375-1.155-.375-.5 0-.88.1-1.14.3-.26.19-.39.45-.39.78 0 .35.13.61.39.78.27.17.735.31 1.395.42.82.13 1.465.3 1.935.51.47.2.8.45.99.75.2.29.3.66.3 1.11 0 .73-.305 1.305-.915 1.725-.6.42-1.385.63-2.355.63Z"
    />
  </svg>
);

export const NotFound = () => (
  <svg
    width="39"
    height="38"
    viewBox="0 0 39 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="0.5" width="37" height="37" fill="#FFD3D3" />
    <rect x="1" y="0.5" width="37" height="37" stroke="black" />
    <path d="M19.499 16.9492V23.3975" stroke="black" strokeWidth="1.5" />
    <path d="M19.499 23.9844L19.499 25.1568" stroke="black" strokeWidth="1.5" />
    <path
      d="M9.53418 27.5L19.4997 10.5L29.4652 27.5H9.53418Z"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);

export const LogoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={38}
    fill="none"
    {...props}
  >
    <path
      fill="#0081FF"
      d="M15.181 33H13.46v-4.835c0-.663.17-1.297.508-1.861a3.457 3.457 0 0 1 1.425-1.311l3.217-1.607.762 1.494-3.217 1.607a1.88 1.88 0 0 0-.72.69c-.17.297-.268.635-.254.973V33Z"
    />
    <path
      fill="#0081FF"
      d="M19.823 15.295h-1.68V33h1.68V15.295ZM3.879 27.207l-1.171-1.17 3.414-3.426a3.567 3.567 0 0 1 1.68-.944 3.421 3.421 0 0 1 1.918.084l3.414 1.17-.522 1.593-3.414-1.17a1.833 1.833 0 0 0-1.03-.042 1.82 1.82 0 0 0-.889.507l-3.414 3.37.014.028Z"
    />
    <path
      fill="#0081FF"
      d="M18.52 16.808 6.015 29.331l1.188 1.185L19.71 17.993l-1.188-1.185ZM8.098 19.354l-1.608-3.2a1.924 1.924 0 0 0-.677-.747 1.859 1.859 0 0 0-.974-.282H0v-1.663h4.84c.648 0 1.297.183 1.847.521a3.422 3.422 0 0 1 1.298 1.424l1.609 3.214-1.496.747v-.014Z"
    />
    <path
      fill="#0081FF"
      d="M17.706 18.142H0v1.677h17.706v-1.677ZM10.13 13.11l-1.58-.522 1.171-3.411c.113-.324.127-.677.043-1.015a1.863 1.863 0 0 0-.494-.874L5.855 3.862l1.171-1.17 3.415 3.426c.465.465.79 1.043.945 1.677a3.413 3.413 0 0 1-.085 1.917l-1.156 3.398h-.015Z"
    />
    <path
      fill="#0081FF"
      d="M3.668 5.991 2.482 7.175l12.515 12.518 1.199-1.184L3.668 5.99ZM14.391 9.6l-.747-1.495 3.202-1.607c.31-.155.564-.395.748-.677.183-.296.282-.634.282-.972V.014h1.665v4.835c0 .648-.183 1.297-.522 1.86a3.333 3.333 0 0 1-1.425 1.297l-3.217 1.607.014-.014Z"
    />
    <path
      fill="#0081FF"
      d="M14.857 0h-1.68v17.705h1.68V0ZM24.52 11.433a3.68 3.68 0 0 1-1.17-.17l-3.415-1.17.523-1.593 3.414 1.17c.31.085.649.1.973.015.31-.085.607-.24.847-.466l3.499-3.425 1.17 1.17-3.498 3.44c-.62.62-1.453.986-2.342 1.029Z"
    />
    <path
      fill="#0081FF"
      d="M25.795 2.477 13.288 15l1.188 1.185L26.984 3.662l-1.189-1.185ZM32.999 19.538h-4.84a3.555 3.555 0 0 1-1.848-.522 3.423 3.423 0 0 1-1.298-1.424l-1.664-3.214 1.495-.76 1.665 3.2c.155.31.395.563.677.746.297.183.635.282.974.282h4.839v1.692Z"
    />
    <path
      fill="#0081FF"
      d="M33 13.166H15.294v1.678H33v-1.678ZM26.017 30.307l-3.415-3.425a3.563 3.563 0 0 1-.945-1.678 3.413 3.413 0 0 1 .085-1.917l1.17-3.411 1.58.521-1.142 3.426a1.774 1.774 0 0 0-.042 1.015c.07.338.254.634.494.888l3.428 3.425-1.2 1.17-.013-.014Z"
    />
    <path
      fill="#0081FF"
      d="m18.003 13.293-1.2 1.184 12.53 12.518 1.184-1.184-12.514-12.518Z"
    />
  </svg>
);

export const LessThen = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 512 512"
  >
    <g>
      <path
        d="M206.3 249.3l83.2-73.9c4.7-4.2 11.8-3.9 16.2.6 4.7 4.8 4.4 12.5-.6 17l-70.8 62.6 70.7 62.2c5.1 4.5 5.6 12.4 1.1 17.5s-12.2 5.5-17.3 1.1l-82.3-72.1c-4.7-3.9-4.7-11-.2-15z"
        fill="#000000"
      />
    </g>
  </svg>
);

export const ClientIcon = () => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      width="26"
      height="24"
      x="0"
      y="0"
      viewBox="0 0 218.581 218.581"
      // style="enable-background:new 0 0 512 512"
      // xml:space="preserve"
    >
      <g>
        <path
          d="M162.184 81.401c-3.403 13.011-11.344 15.877-15.581 16.452-2.61 5.218-8.347 15.882-14.086 21.24-2.294 2.141-5.275 3.948-8.86 5.371-4.577 1.816-9.411 2.737-14.366 2.737s-9.789-.921-14.366-2.737c-3.584-1.422-6.566-3.229-8.86-5.371-5.74-5.357-11.477-16.022-14.087-21.24-4.236-.575-12.177-3.44-15.58-16.452-1.82-6.958-1.354-12.63 1.386-16.859a13.16 13.16 0 0 1 4.046-4.004c.004-1.389.062-3.128.223-5.106-2.461-3.42-5.807-10.799-1.663-22.743 4.38-12.627 14.283-14.577 19.063-14.746 1.616-3.004 4.669-7.269 10.213-11.19C95.82 2.398 103.856 0 112.293 0c10.382 0 20.829 3.654 30.211 10.567 15.211 11.208 13.908 36.07 13.535 40.584.552 3.784.705 7.066.712 9.386a13.16 13.16 0 0 1 4.046 4.004c2.74 4.23 3.206 9.901 1.387 16.86zm44.486 96.889v35.291a5 5 0 0 1-5 5H16.911a5 5 0 0 1-5-5V178.29c0-14.458 8.674-27.27 22.098-32.64l43.715-17.486a4.999 4.999 0 0 1 6.558 2.942l10.99 30.383 2.176-6.256-3.462-8.463a5.001 5.001 0 0 1 4.628-6.893h21.354a5 5 0 0 1 4.628 6.893l-3.462 8.463 2.176 6.256 10.99-30.383a4.996 4.996 0 0 1 2.655-2.861 5.008 5.008 0 0 1 3.903-.081l43.715 17.486c13.424 5.37 22.097 18.182 22.097 32.64zm-26.616 3.837a5 5 0 0 0-5-5h-33.57a5 5 0 0 0-5 5v15.59a5 5 0 0 0 5 5h33.57a5 5 0 0 0 5-5v-15.59z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  </>
);
export const NMSRefreshIcon = (props) => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        stroke="#27272A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        d="M9.11 5.08c.87-.26 1.83-.43 2.89-.43 4.79 0 8.67 3.88 8.67 8.67s-3.88 8.67-8.67 8.67-8.67-3.88-8.67-8.67c0-1.78.54-3.44 1.46-4.82M7.87 5.32 10.76 2M7.87 5.32l3.37 2.46"
      />
    </svg>
  </>
);
export const NMSRightIcon = (props) => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        stroke="#27272A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        d="M5 12h14M12 5l7 7-7 7"
      />
    </svg>
  </>
);
export const NMSSearchIcon = (props) => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={21}
      height={20}
      fill="none"
      {...props}
    >
      <path
        stroke="#27272A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.75}
        d="M9.667 15.833a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333ZM18 17.5l-3.625-3.625"
      />
    </svg>
  </>
);
export const NMSFiltersIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.75}
      d="M6.3 2.45h15.4a2.34 2.34 0 0 1 2.333 2.334V7.35c0 .934-.583 2.1-1.166 2.684l-5.017 4.433c-.7.583-1.167 1.75-1.167 2.683v5.017c0 .7-.466 1.633-1.05 1.983L14 25.2c-1.517.934-3.617-.116-3.617-1.983v-6.183c0-.817-.466-1.867-.933-2.45L5.017 9.917c-.584-.583-1.05-1.633-1.05-2.333V4.9c0-1.4 1.05-2.45 2.333-2.45ZM12.752 2.45 7 11.667"
    />
  </svg>
);
export const NMSFiltersApplyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <rect width={40} height={40} fill="#ECF4FA" rx={20} />
    <path
      fill="#1773BE"
      d="M30.033 10.784v2.566c0 .934-.583 2.1-1.167 2.684l-5.016 4.433c-.7.583-1.167 1.75-1.167 2.683v5.017c0 .7-.467 1.633-1.05 1.983L20 31.2c-1.517.933-3.617-.116-3.617-1.983v-6.183c0-.817-.467-1.867-.933-2.45l-.549-.572a1.16 1.16 0 0 1-.14-1.424l5.974-9.59c.21-.338.583-.548.991-.548H27.7a2.34 2.34 0 0 1 2.333 2.334ZM18.075 10.235l-4.141 6.639a1.169 1.169 0 0 1-1.832.186l-1.085-1.143c-.583-.583-1.05-1.633-1.05-2.333V10.9c0-1.4 1.05-2.45 2.333-2.45h4.784c.91 0 1.47 1.004.991 1.785Z"
    />
    <circle cx={34} cy={5} r={3.5} fill="#1773BE" />
  </svg>
);
export const NMSThreeDotsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14 15.167a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333ZM14 7a1.167 1.167 0 1 0 0-2.333A1.167 1.167 0 0 0 14 7ZM14 23.333A1.167 1.167 0 1 0 14 21a1.167 1.167 0 0 0 0 2.333Z"
    />
  </svg>
);
export const NMSRefreshFilterIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M16.628 11.927A11.687 11.687 0 0 1 20 11.425 10.113 10.113 0 0 1 30.115 21.54 10.113 10.113 0 0 1 20 31.655 10.112 10.112 0 0 1 9.885 21.54c0-2.077.63-4.014 1.703-5.623M15.182 12.206l3.371-3.873M15.182 12.207l3.931 2.87"
    />
  </svg>
);
export const NMSDownIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#27272A"
      fillRule="evenodd"
      d="M5.381 8.381a.875.875 0 0 1 1.238 0L12 13.763l5.381-5.382A.875.875 0 1 1 18.62 9.62l-6 6a.875.875 0 0 1-1.238 0l-6-6a.875.875 0 0 1 0-1.238Z"
      clipRule="evenodd"
    />
  </svg>
);

export const NMSArrowDownIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#27272A"
      fillRule="evenodd"
      d="M5.381 8.381a.875.875 0 0 1 1.238 0L12 13.763l5.381-5.382A.875.875 0 1 1 18.62 9.62l-6 6a.875.875 0 0 1-1.238 0l-6-6a.875.875 0 0 1 0-1.238Z"
      clipRule="evenodd"
    />
  </svg>
);
export const NMSArrowUpIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#27272A"
      fillRule="evenodd"
      d="M11.381 8.381a.875.875 0 0 1 1.238 0l6 6a.875.875 0 1 1-1.238 1.238L12 10.237 6.619 15.62A.875.875 0 0 1 5.38 14.38l6-6Z"
      clipRule="evenodd"
    />
  </svg>
);
export const ChevronLeftIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="m11 17-5-5 5-5M18 17l-5-5 5-5"
    />
  </svg>
);
export const ChevronRightIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="m13 17 5-5-5-5M6 17l5-5-5-5"
    />
  </svg>
);

export const NMSMaximiseIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.778 5.12134L13.1211 10.7782"
        stroke="#27272A"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7778 5.12134L19.1313 9.01042"
        stroke="#27272A"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7778 5.12126L14.8887 4.7677"
        stroke="#27272A"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.12109 18.7781L10.778 13.1213"
        stroke="#27272A"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.12113 18.7782L4.76758 14.8892"
        stroke="#27272A"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.12109 18.7781L9.01018 19.1317"
        stroke="#27272A"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NMSMinimiseIcon = (props) => {
  return (
    <svg
      className="svg-icon"
      stroke="#27272A"
      style={{
        width: "1em",
        height: "1em",
        verticalAlign: "middle",
        fill: "currentColor",
        overflow: "hidden"
      }}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        stroke="#27272A"
        d="M449.92 543.36C449.92 520.96 431.36 512 410.24 512L97.92 512c-17.92 0-32 14.08-32 32 0 17.92 14.08 32 32 32l242.56 0-267.52 267.52c-12.16 12.16-12.16 31.36 0 43.52 12.16 12.16 31.36 12.16 43.52 0l269.44-269.44 0 246.4c0 17.92 14.08 32 32 32 17.92 0 32-14.08 32-32l0-320M865.92 384 622.72 384l267.52-267.52c12.16-12.16 12.16-31.36 0-43.52-12.16-12.16-31.36-12.16-43.52 0L577.92 342.4 577.92 96C577.92 78.08 563.2 64 545.92 64c-17.92 0-32 14.08-32 32l0 320c0 0.64 0.64 1.28 0.64 1.92 0 8.32 2.56 16.64 8.96 22.4C531.2 448.64 542.72 451.2 552.96 448l312.32 0c17.92 0 32-14.08 32-32C897.92 398.08 883.2 384 865.92 384z"
      />
    </svg>
  );
};

export const NMSLeftArrowIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <path
      stroke="#27272A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M19 12.5H5M12 19.5l-7-7 7-7"
    />
  </svg>
);

export const BlueRightIcon = (props: any) => (
  <svg
    width="6"
    height="11"
    viewBox="0 0 6 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.285961 0.535961C0.542243 0.27968 0.957757 0.27968 1.21404 0.535961L5.71404 5.03596C5.97032 5.29224 5.97032 5.70776 5.71404 5.96404L1.21404 10.464C0.957757 10.7203 0.542243 10.7203 0.285961 10.464C0.0296796 10.2078 0.0296796 9.79224 0.285961 9.53596L4.32192 5.5L0.285961 1.46404C0.0296796 1.20776 0.0296796 0.792243 0.285961 0.535961Z"
      fill="#1773BE"
    />
  </svg>
);

export const NMSRightArrowBlueIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      stroke="#1773BE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.458}
      d="M4.167 10.5h11.667M10 4.667l5.833 5.833L10 16.333"
    />
  </svg>
);
export const NMSExceptionalNodesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={63}
    height={73}
    fill="none"
    {...props}
  >
    <circle cx={31.25} cy={31.25} r={31.25} fill="#E9E1FD" opacity={0.6} />
    <circle cx={31.622} cy={31.622} r={24.182} fill="#DED0FE" opacity={0.6} />
    <circle cx={31.247} cy={31.247} r={17.857} fill="#BFA4FE" opacity={0.8} />
    <g filter="url(#a)">
      <mask
        id="b"
        width={16}
        height={18}
        x={22.833}
        y={23.5}
        fill="#000"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M22.833 23.5h16v18h-16z" />
        <path
          fillRule="evenodd"
          d="M35.129 36.398a6.799 6.799 0 1 0-8.994 0h-1.153c.534 0 .897 0 1.191.034a6.799 6.799 0 0 0 1.95 1.188c.19.233.41.529.702.922l1.206 1.623c.331.447.87.447 1.201 0l1.206-1.623c.292-.393.512-.69.701-.922a6.797 6.797 0 0 0 1.951-1.188c.295-.034.658-.034 1.194-.034h-1.155Z"
          clipRule="evenodd"
        />
      </mask>
      <path
        fill="#FFC2BF"
        fillRule="evenodd"
        d="M35.129 36.398a6.799 6.799 0 1 0-8.994 0h-1.153c.534 0 .897 0 1.191.034a6.799 6.799 0 0 0 1.95 1.188c.19.233.41.529.702.922l1.206 1.623c.331.447.87.447 1.201 0l1.206-1.623c.292-.393.512-.69.701-.922a6.797 6.797 0 0 0 1.951-1.188c.295-.034.658-.034 1.194-.034h-1.155Z"
        clipRule="evenodd"
      />
      <path
        fill="#E63D46"
        d="M36.284 36.898h.296v-1h-.296v1Zm-11.601 0h.296v-1h-.296v1Zm10.446-.5-.662-.75-1.982 1.75h2.644v-1Zm-8.994 0v1h2.644l-1.983-1.75-.661.75Zm.038.034.656-.755-.234-.204-.308-.035-.114.994Zm1.95 1.188.776-.631-.164-.202-.242-.096-.37.929Zm.702.922-.803.597.803-.597Zm1.206 1.623.802-.596-.802.596Zm1.201 0 .803.596-.803-.596Zm1.206-1.623.803.597.015-.02.014-.022-.832-.555Zm0 0-.803-.596-.015.02-.014.021.832.555Zm.701-.922-.369-.93-.242.097-.165.202.776.631Zm1.951-1.188-.113-.994-.308.035-.235.204.656.755Zm1.34-5.133a5.783 5.783 0 0 1-1.963 4.35l1.324 1.498a7.782 7.782 0 0 0 2.64-5.848h-2ZM30.633 25.5a5.799 5.799 0 0 1 5.799 5.799h2a7.799 7.799 0 0 0-7.8-7.799v2Zm-5.799 5.799a5.799 5.799 0 0 1 5.799-5.799v-2a7.799 7.799 0 0 0-7.799 7.799h2Zm1.963 4.35a5.783 5.783 0 0 1-1.963-4.35h-2a7.782 7.782 0 0 0 2.64 5.849l1.323-1.5Zm-.661-.251h-1.153v2h1.153v-2Zm-1.153 2c.558 0 .853.001 1.077.027l.228-1.987c-.365-.042-.794-.04-1.305-.04v2Zm3.51-.708a5.798 5.798 0 0 1-1.663-1.013l-1.312 1.51a7.798 7.798 0 0 0 2.238 1.362l.738-1.858Zm-1.144 1.56c.172.213.377.488.674.889l1.606-1.193c-.288-.387-.522-.703-.729-.957l-1.551 1.262Zm.674.889 1.206 1.622 1.605-1.193-1.205-1.622-1.606 1.193Zm1.206 1.622c.323.436.821.739 1.403.739.583 0 1.08-.303 1.404-.739l-1.605-1.193c-.009.012.054-.068.201-.068.148 0 .21.08.202.069l-1.605 1.192Zm2.807 0 1.206-1.622-1.606-1.193-1.205 1.623 1.605 1.192Zm1.235-1.664-1.664-1.11 1.664 1.11Zm-.03.042c.298-.4.503-.676.675-.888l-1.552-1.262c-.206.254-.44.57-.728.957l1.606 1.193Zm1.194-3.462c-.49.426-1.052.77-1.664 1.014l.738 1.859a7.797 7.797 0 0 0 2.238-1.364l-1.312-1.51Zm.77 1.748c.225-.026.52-.027 1.08-.027v-2c-.512 0-.942-.002-1.307.04l.227 1.987Zm1.08-2.027h-1.155v2h1.155v-2Z"
        mask="url(#b)"
      />
      <path
        stroke="#E63D46"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.496}
        d="M32.616 32.43v-2.69a.568.568 0 0 0-.567-.567h-1.558"
      />
      <path
        stroke="#E63D46"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.496}
        d="m31.2 28.465-.85.708.85.708M32.617 34.13a.85.85 0 1 0 0-1.7.85.85 0 0 0 0 1.7ZM28.65 30.165v2.691c0 .312.254.567.566.567h1.558"
      />
      <path
        stroke="#E63D46"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.496}
        d="m30.066 34.13.85-.708-.85-.708M28.65 30.165a.85.85 0 1 0 0-1.7.85.85 0 0 0 0 1.7Z"
      />
    </g>
    <defs>
      <filter
        id="a"
        width={49.592}
        height={51.994}
        x={5.836}
        y={20.101}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={13.598} />
        <feGaussianBlur stdDeviation={8.498} />
        <feColorMatrix values="0 0 0 0 0.196487 0 0 0 0 0.196487 0 0 0 0 0.279476 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          mode="multiply"
          result="effect1_dropShadow_7022_247988"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={8.498} />
        <feGaussianBlur stdDeviation={4.249} />
        <feColorMatrix values="0 0 0 0 0.196487 0 0 0 0 0.196487 0 0 0 0 0.279476 0 0 0 0.1 0" />
        <feBlend
          in2="effect1_dropShadow_7022_247988"
          mode="multiply"
          result="effect2_dropShadow_7022_247988"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_7022_247988"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export const NMSMainGatewayIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={53}
    height={62}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <mask id="b" fill="#fff">
        <path
          fillRule="evenodd"
          d="M36.643 50.059c9.465-3.861 16.136-13.157 16.136-24.01 0-14.316-11.604-25.92-25.92-25.92C12.545.129.94 11.733.94 26.049c0 10.854 6.673 20.15 16.14 24.01.771.926 1.664 2.128 2.895 3.785l4.595 6.186c1.265 1.704 3.317 1.704 4.582 0l4.596-6.186c1.231-1.657 2.124-2.86 2.896-3.785Z"
          clipRule="evenodd"
        />
      </mask>
      <path
        fill="#FFB700"
        fillRule="evenodd"
        d="M36.643 50.059c9.465-3.861 16.136-13.157 16.136-24.01 0-14.316-11.604-25.92-25.92-25.92C12.545.129.94 11.733.94 26.049c0 10.854 6.673 20.15 16.14 24.01.771.926 1.664 2.128 2.895 3.785l4.595 6.186c1.265 1.704 3.317 1.704 4.582 0l4.596-6.186c1.231-1.657 2.124-2.86 2.896-3.785Z"
        clipRule="evenodd"
      />
      <path
        fill="#FFE880"
        d="m36.643 50.059-1.224-3-.748.305-.517.62 2.489 2.075Zm-19.565 0 2.49-2.074-.518-.62-.748-.305-1.224 3Zm2.896 3.785-2.601 1.932.004.006.005.006 2.592-1.944Zm0 0 2.6-1.932-.004-.006-.004-.006-2.592 1.944Zm4.595 6.186-2.6 1.932 2.6-1.932Zm4.582 0 2.601 1.932-2.6-1.932Zm4.596-6.186-2.46-2.108-.074.085-.067.091 2.6 1.932Zm0 0 2.46 2.109.073-.086.068-.09-2.601-1.933ZM49.539 26.05c0 9.492-5.831 17.629-14.12 21.01l2.448 6c10.642-4.341 18.153-14.795 18.153-27.01h-6.48ZM26.86 3.369c12.526 0 22.68 10.154 22.68 22.68h6.48c0-16.105-13.055-29.16-29.16-29.16v6.48ZM4.18 26.049c0-12.526 10.155-22.68 22.68-22.68v-6.48C10.756-3.111-2.3 9.944-2.3 26.049h6.48Zm14.123 21.01c-8.29-3.38-14.123-11.518-14.123-21.01H-2.3c0 12.216 7.512 22.67 18.156 27.011l2.447-6Zm-3.712 5.075c.7.84 1.53 1.956 2.783 3.642l5.201-3.864c-1.208-1.627-2.164-2.915-3.007-3.927l-4.977 4.15Zm2.792 3.654 5.184-3.888-5.184 3.888Zm-.01-.012 4.596 6.186 5.202-3.864-4.595-6.186-5.202 3.864Zm4.596 6.186c1.144 1.54 2.88 2.586 4.892 2.586 2.012 0 3.749-1.046 4.892-2.586l-5.202-3.864c-.066.09-.085.08-.023.047a.712.712 0 0 1 .333-.077c.15 0 .268.04.334.077.062.034.042.042-.024-.047l-5.202 3.864Zm9.784 0 4.596-6.186-5.202-3.864-4.596 6.186 5.202 3.864Zm4.455-6.01-4.92-4.216 4.92 4.217Zm.14-.176c1.254-1.687 2.085-2.803 2.785-3.643l-4.978-4.149c-.843 1.012-1.799 2.3-3.008 3.928l5.202 3.864Z"
        mask="url(#b)"
      />
      <path
        fill="#27272A"
        d="M35.5 28.299a2.43 2.43 0 1 0 0-4.86 2.43 2.43 0 0 0 0 4.86ZM35.5 19.659a2.43 2.43 0 1 0 0-4.86 2.43 2.43 0 0 0 0 4.86ZM35.5 36.939a2.43 2.43 0 1 0 0-4.86 2.43 2.43 0 0 0 0 4.86ZM18.22 28.299a2.43 2.43 0 1 0 0-4.86 2.43 2.43 0 0 0 0 4.86Z"
      />
      <path
        fill="#27272A"
        d="M34.42 26.679c.443 0 .81-.367.81-.81a.816.816 0 0 0-.81-.81h-7.83v-4.59c0-1.707.724-2.43 2.43-2.43h5.4c.443 0 .81-.367.81-.81a.816.816 0 0 0-.81-.81h-5.4c-2.614 0-4.05 1.436-4.05 4.05v4.59H19.3a.816.816 0 0 0-.81.81c0 .442.367.81.81.81h5.67v4.59c0 2.613 1.436 4.05 4.05 4.05h5.4c.443 0 .81-.367.81-.81a.816.816 0 0 0-.81-.81h-5.4c-1.706 0-2.43-.724-2.43-2.43v-4.59h7.83Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.94.129h51.84v61.179H.94z" />
      </clipPath>
    </defs>
  </svg>
);
export const NMSMapGatewayIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={38}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <mask id="b" fill="#fff">
        <path
          fillRule="evenodd"
          d="M22.186 30.93c5.68-2.317 9.682-7.895 9.682-14.407 0-8.589-6.963-15.552-15.552-15.552C7.726.971.764 7.934.764 16.523c0 6.513 4.003 12.091 9.684 14.407.462.556.998 1.277 1.736 2.27l2.758 3.712c.759 1.023 1.99 1.022 2.749 0l2.757-3.711c.74-.995 1.275-1.716 1.738-2.272Z"
          clipRule="evenodd"
        />
      </mask>
      <path
        fill="#FFB700"
        fillRule="evenodd"
        d="M22.186 30.93c5.68-2.317 9.682-7.895 9.682-14.407 0-8.589-6.963-15.552-15.552-15.552C7.726.971.764 7.934.764 16.523c0 6.513 4.003 12.091 9.684 14.407.462.556.998 1.277 1.736 2.27l2.758 3.712c.759 1.023 1.99 1.022 2.749 0l2.757-3.711c.74-.995 1.275-1.716 1.738-2.272Z"
        clipRule="evenodd"
      />
      <path
        fill="#FFE880"
        d="m22.186 30.93-.734-1.8-.449.182-.31.373 1.493 1.244Zm-11.739 0 1.494-1.244-.31-.373-.45-.183-.733 1.8Zm1.737 2.27-1.56 1.16.032.044.035.041 1.493-1.244Zm0 0 1.556-1.166-.03-.04-.032-.038-1.494 1.245Zm0 0 1.561-1.159-.005-.007-1.556 1.167Zm2.758 3.712-1.56 1.16 1.56-1.16Zm2.749 0-1.56-1.159 1.56 1.16Zm2.757-3.711 1.56 1.159-1.56-1.16Zm9.476-16.678c0 5.695-3.5 10.578-8.472 12.606l1.468 3.6c6.386-2.604 10.892-8.876 10.892-16.206h-3.888ZM16.316 2.915c7.515 0 13.608 6.093 13.608 13.608h3.888c0-9.662-7.834-17.496-17.496-17.496v3.888ZM2.708 16.523c0-7.515 6.092-13.608 13.608-13.608V-.973C6.653-.973-1.18 6.861-1.18 16.523h3.888ZM11.18 29.13c-4.973-2.028-8.473-6.91-8.473-12.607H-1.18c0 7.33 4.507 13.603 10.893 16.207l1.468-3.6Zm-2.227 3.045c.42.504.918 1.173 1.67 2.185l3.12-2.319c-.724-.976-1.297-1.748-1.803-2.355l-2.987 2.489Zm1.737 2.27 2.987-2.489-2.987 2.49Zm-.062-.078 3.11-2.333-3.11 2.333Zm-.005-.007 2.757 3.712 3.121-2.319-2.757-3.712-3.121 2.319Zm2.757 3.712c.686.923 1.728 1.551 2.935 1.551s2.25-.628 2.936-1.551l-3.121-2.319c-.04.054-.052.048-.015.028a.427.427 0 0 1 .2-.046c.09 0 .16.024.2.046.038.02.026.026-.014-.028l-3.12 2.319Zm5.87 0 2.758-3.712-3.121-2.319-2.758 3.712 3.122 2.319Zm2.758-3.712c.752-1.012 1.25-1.682 1.67-2.186l-2.986-2.49c-.506.608-1.08 1.38-1.805 2.357l3.12 2.319Z"
        mask="url(#b)"
      />
      <path
        fill="#27272A"
        d="M21.501 17.873a1.458 1.458 0 1 0 0-2.915 1.458 1.458 0 0 0 0 2.915ZM21.501 12.69a1.458 1.458 0 1 0 0-2.917 1.458 1.458 0 0 0 0 2.916ZM21.501 23.057a1.458 1.458 0 1 0 0-2.916 1.458 1.458 0 0 0 0 2.916ZM11.132 17.873a1.458 1.458 0 1 0 0-2.916 1.458 1.458 0 0 0 0 2.916Z"
      />
      <path
        fill="#27272A"
        d="M20.853 16.901a.49.49 0 0 0 .486-.486.49.49 0 0 0-.486-.486h-4.699v-2.754c0-1.024.434-1.458 1.459-1.458h3.24a.49.49 0 0 0 .486-.486.49.49 0 0 0-.486-.486h-3.24c-1.569 0-2.43.862-2.43 2.43v2.754H11.78a.49.49 0 0 0-.486.486c0 .266.22.486.486.486h3.402v2.754c0 1.569.862 2.43 2.43 2.43h3.24a.49.49 0 0 0 .487-.486.49.49 0 0 0-.486-.486h-3.24c-1.024 0-1.459-.434-1.459-1.458v-2.754h4.699Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.764.971h31.104V37.68H.764z" />
      </clipPath>
    </defs>
  </svg>
);
export const NMSLocationOnlineIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#000"
        fillOpacity={0.8}
        fillRule="evenodd"
        d="M27.579 26.308a14.65 14.65 0 0 0 4.971-11.014C32.55 7.184 25.976.61 17.865.61 9.755.609 3.18 7.184 3.18 15.294A14.65 14.65 0 0 0 8.15 26.308H5.662c1.154 0 1.936 0 2.573.073a14.687 14.687 0 0 0 4.212 2.567c.41.503.884 1.142 1.516 1.992l2.603 3.505c.717.965 1.88.965 2.596 0l2.604-3.505c.632-.85 1.106-1.489 1.515-1.991a14.682 14.682 0 0 0 4.215-2.568c.637-.073 1.421-.073 2.577-.073H27.58Z"
        clipRule="evenodd"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.071}
        d="M22.15 17.74v-5.813c0-.673-.552-1.224-1.225-1.224H17.56"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.071}
        d="m19.09 9.174-1.835 1.53 1.836 1.529M22.15 21.412a1.836 1.836 0 1 0 0-3.672 1.836 1.836 0 0 0 0 3.672ZM13.583 12.845v5.813c0 .673.55 1.224 1.224 1.224h3.366"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.071}
        d="m16.643 21.411 1.835-1.53-1.835-1.53M13.582 12.845a1.836 1.836 0 1 0 0-3.671 1.836 1.836 0 0 0 0 3.67Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.58.889h34.56v34.56H.58z" />
      </clipPath>
    </defs>
  </svg>
);
export const NMSMapOnlineIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={22}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#000"
        fillOpacity={0.8}
        fillRule="evenodd"
        d="M16.147 15.479a8.811 8.811 0 1 0-11.656 0H2.997c.692 0 1.162 0 1.544.044a8.81 8.81 0 0 0 2.527 1.54c.245.301.53.685.91 1.195l1.562 2.103c.43.58 1.127.58 1.557 0l1.562-2.103c.38-.51.664-.893.91-1.195a8.809 8.809 0 0 0 2.528-1.54c.383-.044.853-.044 1.547-.044h-1.497Z"
        clipRule="evenodd"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.642}
        d="M12.889 10.338V6.85a.736.736 0 0 0-.735-.734h-2.02"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.642}
        d="m11.054 5.198-1.102.918 1.102.918M12.89 12.54a1.101 1.101 0 1 0 0-2.202 1.101 1.101 0 0 0 0 2.203ZM7.749 7.4v3.489c0 .404.33.734.734.734h2.02"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.642}
        d="m9.585 12.54 1.101-.917-1.101-.918M7.749 7.401a1.101 1.101 0 1 0 0-2.203 1.101 1.101 0 0 0 0 2.203Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.147.427h20.736v20.736H.147z" />
      </clipPath>
    </defs>
  </svg>
);
export const NMSLocationOfflineIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={35}
    fill="none"
    {...props}
  >
    <path
      fill="#CF1322"
      fillRule="evenodd"
      d="M24.978 25.748a14.65 14.65 0 0 0 4.972-11.014c0-8.11-6.575-14.685-14.686-14.685C7.154.049.58 6.623.58 14.734a14.65 14.65 0 0 0 4.972 11.014H3.06c1.154 0 1.937 0 2.573.073a14.682 14.682 0 0 0 4.213 2.567c.409.502.883 1.141 1.515 1.992l2.604 3.505c.717.965 1.879.965 2.596 0l2.604-3.505c.631-.85 1.106-1.49 1.514-1.992a14.685 14.685 0 0 0 4.215-2.567c.637-.073 1.422-.073 2.578-.073h-2.495Z"
      clipRule="evenodd"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.071}
      d="M19.55 17.18v-5.813c0-.673-.551-1.224-1.224-1.224H14.96"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.071}
      d="m16.49 8.614-1.836 1.53 1.836 1.529M19.55 20.851a1.836 1.836 0 1 0 0-3.671 1.836 1.836 0 0 0 0 3.671ZM10.982 12.285v5.813c0 .673.551 1.223 1.224 1.223h3.366"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.071}
      d="m14.042 20.851 1.836-1.53-1.836-1.53M10.982 12.285a1.836 1.836 0 1 0 0-3.672 1.836 1.836 0 0 0 0 3.672Z"
    />
  </svg>
);
export const NMSMapOfflineIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={22}
    fill="none"
    {...props}
  >
    <path
      fill="#CF1322"
      fillRule="evenodd"
      d="M15.187 16.143a8.811 8.811 0 1 0-11.656 0H2.037c.692 0 1.162 0 1.544.044a8.81 8.81 0 0 0 2.527 1.54c.245.301.53.685.91 1.195l1.562 2.103c.43.58 1.127.58 1.557 0l1.563-2.103a37.4 37.4 0 0 1 .908-1.195 8.811 8.811 0 0 0 2.53-1.54c.382-.044.852-.044 1.546-.044h-1.497Z"
      clipRule="evenodd"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.642}
      d="M11.93 11.002V7.514a.736.736 0 0 0-.734-.734h-2.02"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.642}
      d="m10.095 5.862-1.102.918 1.102.918M11.93 13.205a1.101 1.101 0 1 0 0-2.203 1.101 1.101 0 0 0 0 2.203ZM6.79 8.065v3.488c0 .404.33.734.734.734h2.02"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.642}
      d="m8.626 13.205 1.101-.918-1.101-.918M6.79 8.065a1.101 1.101 0 1 0 0-2.203 1.101 1.101 0 0 0 0 2.203Z"
    />
  </svg>
);
export const NMSUserIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#27272A"
      fillRule="evenodd"
      d="M16 3.833a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm-7.834 5.5a7.833 7.833 0 1 1 15.667 0 7.833 7.833 0 0 1-15.666 0ZM3.38 29.334c0-6.017 5.891-10.5 12.62-10.5 6.73 0 12.62 4.483 12.62 10.5a1.167 1.167 0 0 1-2.333 0c0-4.304-4.376-8.167-10.287-8.167-5.91 0-10.286 3.863-10.286 8.166a1.167 1.167 0 0 1-2.334 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export const NMSNotificationRightIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#1773BE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.458}
      d="M4.167 10h11.667M10 4.167 15.833 10 10 15.834"
    />
  </svg>
);
export const NMSNotificationTickIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    {...props}
  >
    <path fill="#D7FAE0" d="M0 0h48v48H0z" />
    <path
      fill="#00AB56"
      d="M24.4 12c-6.613 0-12 5.387-12 12 0 6.611 5.387 12 12 12 6.611 0 12-5.389 12-12 0-6.613-5.389-12-12-12Zm5.735 9.24-6.804 6.804a.9.9 0 0 1-1.272 0l-3.396-3.396a.905.905 0 0 1 0-1.273.905.905 0 0 1 1.272 0l2.76 2.76 6.168-6.168a.905.905 0 0 1 1.272 0 .905.905 0 0 1 0 1.273Z"
    />
  </svg>
);
export const NMSNotificationErrorIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    {...props}
  >
    <path fill="#FFDBD8" d="M0 0h48v48H0z" />
    <path
      fill="#E63D46"
      d="m36.112 28.703-7.68-13.824C27.4 13.02 25.972 12 24.4 12s-3 1.02-4.032 2.88l-7.68 13.824c-.972 1.764-1.08 3.456-.3 4.788.78 1.332 2.316 2.064 4.332 2.064h15.36c2.016 0 3.552-.732 4.332-2.064.78-1.332.672-3.036-.3-4.788ZM23.5 20.4c0-.492.408-.9.9-.9.492 0 .9.408.9.9v6c0 .492-.408.9-.9.9a.907.907 0 0 1-.9-.9v-6Zm1.752 10.452-.18.144a.909.909 0 0 1-.216.108.724.724 0 0 1-.228.072 1.47 1.47 0 0 1-.228.024c-.072 0-.156-.012-.24-.024a.763.763 0 0 1-.216-.072.909.909 0 0 1-.216-.108l-.18-.144A1.262 1.262 0 0 1 23.2 30c0-.312.132-.624.348-.852l.18-.144a.909.909 0 0 1 .216-.108.763.763 0 0 1 .216-.072c.156-.036.324-.036.468 0a.724.724 0 0 1 .228.072c.072.024.144.06.216.108l.18.144c.216.228.348.54.348.852 0 .312-.132.624-.348.852Z"
    />
  </svg>
);
